import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from '@vue/composition-api';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type ReactiveFunction<TParam> = () => TParam;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  ISODate: any;
  ISODateTime: any;
  ISOTime: any;
  JSON: any;
  PhoneNumber: any;
  Time: any;
  TimeDeltaMinutes: any;
  Upload: any;
  Void: any;
};

export type AddRoomInput = {
  excludedServicesIds?: InputMaybe<Array<Scalars['Int']>>;
  preferredEmployeesIds?: InputMaybe<Array<Scalars['Int']>>;
  room: RoomInputWithPracticeBranch;
};

export type Address = {
  __typename?: 'Address';
  apartmentNumber?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  county?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISODateTime'];
  houseNumber: Scalars['String'];
  id: Scalars['Int'];
  street: Scalars['String'];
  zipCode: Scalars['String'];
};

export type AppPaymentConfig = {
  __typename?: 'AppPaymentConfig';
  isEnabled: Scalars['Boolean'];
  paymentMethods: Array<PaymentMethod>;
  practice: Practice;
};

export type AppPaymentConfigInput = {
  isEnabled: Scalars['Boolean'];
  methods: Array<PaymentMethodInput>;
};

export type Attachment = {
  __typename?: 'Attachment';
  addedBy: Employee;
  category: AttachmentCategoryEnum;
  createdAt: Scalars['ISODateTime'];
  id: Scalars['Int'];
  name: Scalars['String'];
  url: Scalars['String'];
};

/** An enumeration. */
export enum AttachmentCategoryEnum {
  Gdpr = 'GDPR',
  Others = 'OTHERS'
}

export type AttachmentsGroupInput = {
  category: AttachmentCategoryEnum;
  files: Array<Scalars['Upload']>;
};

export type AvailableSlots = {
  __typename?: 'AvailableSlots';
  date: Scalars['String'];
  /** Generate a random UUID. */
  id: Scalars['String'];
  serviceId: Scalars['Int'];
  serviceName: Scalars['String'];
  slots: Array<Scalars['ISODateTime']>;
  therapistId: Scalars['Int'];
};

export type Avatar = {
  __typename?: 'Avatar';
  contentType: Scalars['String'];
  url: Scalars['String'];
};

export type AvatarInput = {
  file: Scalars['Upload'];
};

export type BillingInfo = {
  __typename?: 'BillingInfo';
  bank?: Maybe<Scalars['String']>;
  bankAccount?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['PhoneNumber']>;
  postCode?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  taxNo?: Maybe<Scalars['String']>;
};

export type BillingInfoFromVatId = {
  __typename?: 'BillingInfoFromVatId';
  city: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  postCode: Scalars['String'];
  street: Scalars['String'];
};

export type BillingInfoInput = {
  bank?: InputMaybe<Scalars['String']>;
  bankAccount?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  email?: Scalars['String'];
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['PhoneNumber']>;
  postCode?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  taxNo?: InputMaybe<Scalars['String']>;
};

export type BookMeetingPayload = {
  date: Scalars['ISODateTime'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phoneNumber: Scalars['PhoneNumber'];
  practiceBranchId: Scalars['Int'];
  practiceId: Scalars['Int'];
  serviceId: Scalars['Int'];
  therapistId: Scalars['Int'];
};

/** BookMeetingResponse(success: bool) */
export type BookMeetingResponse = {
  __typename?: 'BookMeetingResponse';
  success: Scalars['Boolean'];
};

/** An enumeration. */
export enum CancellationTimeEum {
  Days_7 = 'DAYS_7',
  Days_14 = 'DAYS_14',
  Days_21 = 'DAYS_21'
}

/** An enumeration. */
export enum CollisionReason {
  Patient = 'PATIENT',
  Room = 'ROOM',
  Therapist = 'THERAPIST',
  Unknown = 'UNKNOWN'
}

export type ComparisonItem = {
  __typename?: 'ComparisonItem';
  current: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  prev: Scalars['Int'];
  price?: Maybe<Scalars['Int']>;
};

export type ConfirmMeetingPayload = {
  meetingRequestId: Scalars['Int'];
  patientId?: InputMaybe<Scalars['Int']>;
  roomId: Scalars['Int'];
};

/** An enumeration. */
export enum ConfirmationStatusEnum {
  Accepted = 'ACCEPTED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

/** An enumeration. */
export enum ConsiderationTypeEnum {
  Holidays = 'HOLIDAYS'
}

export type ContactDetails = {
  __typename?: 'ContactDetails';
  email: Scalars['String'];
  id: Scalars['Int'];
  phone: Scalars['PhoneNumber'];
};

export type Couple = {
  __typename?: 'Couple';
  coupleName: Scalars['String'];
  createdAt: Scalars['ISODateTime'];
  deactivatedOn?: Maybe<Scalars['ISODateTime']>;
  deletedAt?: Maybe<Scalars['ISODateTime']>;
  id: Scalars['Int'];
  lastEditedBy?: Maybe<User>;
  patients: Array<Patient>;
  smsNotificationsActive: Scalars['Boolean'];
  therapists: Array<Employee>;
};

export type CoupleInput = {
  coupleName?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['ISODateTime']>;
  deletedAt?: InputMaybe<Scalars['ISODateTime']>;
  patients?: InputMaybe<Array<Scalars['Int']>>;
  smsNotificationsActive?: InputMaybe<Scalars['Boolean']>;
  therapists?: InputMaybe<Array<Scalars['Int']>>;
};

export type CouplePagination = {
  __typename?: 'CouplePagination';
  count: Scalars['Int'];
  data: Array<Couple>;
  pageTotals: Scalars['JSON'];
  totals: Scalars['JSON'];
};

export type CreateEmployeeInput = {
  acronym?: InputMaybe<Scalars['String']>;
  availableInOnlineRegistration?: InputMaybe<Scalars['Boolean']>;
  color: Scalars['String'];
  email: Scalars['String'];
  invitationUuid: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['PhoneNumber']>;
  practiceBranchId: Scalars['Int'];
  preferredRoomIds?: InputMaybe<Array<Scalars['Int']>>;
  roles: Array<Scalars['String']>;
  userName: Scalars['String'];
  userSurname: Scalars['String'];
};

export type CreateGuardianInput = {
  address: GuardianAddressInput;
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  patientId: Scalars['Int'];
  phoneNumber?: InputMaybe<Scalars['PhoneNumber']>;
};

export type CreatePracticeInput = {
  billingAddress: PracticeAddress;
  billingInfo?: InputMaybe<BillingInfoInput>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  name: Scalars['String'];
  phoneNumber: Scalars['PhoneNumber'];
};

export type DatePeriod = {
  __typename?: 'DatePeriod';
  end: Scalars['Date'];
  start: Scalars['Date'];
};

export type DayOccupancy = {
  __typename?: 'DayOccupancy';
  count: Scalars['Int'];
  date: Scalars['ISODateTime'];
};

/** An enumeration. */
export enum DaysBeforeEnum {
  OneDay = 'ONE_DAY',
  ThreeDays = 'THREE_DAYS',
  TwoDays = 'TWO_DAYS'
}

export type DeletedExpenses = {
  __typename?: 'DeletedExpenses';
  deleted: Scalars['Int'];
  success: Scalars['Boolean'];
};

export type DemoSmsInput = {
  phoneNumber: Scalars['PhoneNumber'];
  practiceBranchId?: InputMaybe<Scalars['Int']>;
  templateType: SmsTemplateTypeEnum;
};

export type DemoSmsResponse = {
  __typename?: 'DemoSMSResponse';
  details?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  quota: Scalars['Int'];
  status: Scalars['String'];
  text: Scalars['String'];
};

export type EditEmployeeInput = {
  employee: EmployeeInput;
  preferredRoomIds?: InputMaybe<Array<Scalars['Int']>>;
  roles: Array<Scalars['String']>;
  userName: Scalars['String'];
  userSurname: Scalars['String'];
};

export type EditGdprConfigInput = {
  documentCategory: Scalars['String'];
  documentCategoryChild: Scalars['String'];
  practiceBranchId: Scalars['Int'];
  sendAutomatedGdprMails: Scalars['Boolean'];
};

export type EditGuardianInput = {
  address: GuardianAddressInput;
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  guardianId: Scalars['Int'];
  lastName: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['PhoneNumber']>;
};

export type EditPatientInput = {
  address?: InputMaybe<PatientAddressInput>;
  attachments?: InputMaybe<AttachmentsGroupInput>;
  billingInfo?: InputMaybe<BillingInfoInput>;
  birthday?: InputMaybe<Scalars['ISODateTime']>;
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  idNumber?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['PhoneNumber']>;
  practiceId?: InputMaybe<Scalars['Int']>;
  secondPhoneNumber?: InputMaybe<Scalars['PhoneNumber']>;
  smsNotificationsActive?: InputMaybe<Scalars['Boolean']>;
  therapistId?: InputMaybe<Scalars['Int']>;
  therapistIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type EditPracticeAddress = {
  apartmentNumber: Scalars['String'];
  city: Scalars['String'];
  country: Scalars['String'];
  county: Scalars['String'];
  houseNumber: Scalars['String'];
  street: Scalars['String'];
  zipCode: Scalars['String'];
};

export type EditPracticeInput = {
  billingAddress?: InputMaybe<EditPracticeAddress>;
  billingInfo?: InputMaybe<BillingInfoInput>;
  email?: InputMaybe<Scalars['String']>;
  invoiceConfig?: InputMaybe<InvoiceConfigInput>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['PhoneNumber']>;
  servicesPerTherapist?: InputMaybe<Scalars['Boolean']>;
  shortName?: InputMaybe<Scalars['String']>;
};

export type EditRoomInput = {
  excludedServicesIds?: InputMaybe<Array<Scalars['Int']>>;
  preferredEmployeesIds?: InputMaybe<Array<Scalars['Int']>>;
  room: RoomInput;
};

export type EditServiceInput = {
  assignedTo?: InputMaybe<Array<Scalars['Int']>>;
  availableInOnlineRegistration?: InputMaybe<Scalars['Boolean']>;
  availableOnline?: InputMaybe<Scalars['Boolean']>;
  comments?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['TimeDeltaMinutes']>;
  name?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
};

export type EditWorkTimeExceptionInput = {
  dates?: InputMaybe<Array<Scalars['ISODate']>>;
  endDate?: InputMaybe<Scalars['Date']>;
  startDate?: InputMaybe<Scalars['Date']>;
  workTimes?: InputMaybe<Array<WorkTimeInput>>;
};

export type Employee = {
  __typename?: 'Employee';
  acceptedInvitation: Scalars['Boolean'];
  acronym?: Maybe<Scalars['String']>;
  availableInOnlineRegistration: Scalars['Boolean'];
  color?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lastName: Scalars['String'];
  phoneNumber?: Maybe<Scalars['PhoneNumber']>;
  practiceBranch: PracticeBranch;
  practiceBranchId: Scalars['Int'];
  practiceId: Scalars['Int'];
  preferredRoom: Array<Room>;
  roles: Array<Role>;
  user?: Maybe<User>;
};

export type EmployeeInput = {
  acronym?: InputMaybe<Scalars['String']>;
  availableInOnlineRegistration?: InputMaybe<Scalars['Boolean']>;
  color: Scalars['String'];
  email: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['PhoneNumber']>;
  practiceBranchId: Scalars['Int'];
};

export type EmployeeInvitationInfo = {
  __typename?: 'EmployeeInvitationInfo';
  invitedEmail: Scalars['String'];
  practiceName: Scalars['String'];
};

export type EmployeeInvitationInput = {
  id: Scalars['Int'];
};

export type EmployeePagination = {
  __typename?: 'EmployeePagination';
  count: Scalars['Int'];
  data: Array<Employee>;
  pageTotals: Scalars['JSON'];
  totals: Scalars['JSON'];
};

export type EmployeeStatistics = {
  __typename?: 'EmployeeStatistics';
  meetingsCancelled: Scalars['Int'];
  meetingsHeld: Scalars['Int'];
  meetingsHeldRate: Scalars['Int'];
  meetingsScheduled: Scalars['Int'];
  servicesBreakdown: ServicesBreakdown;
};

export type Event = {
  __typename?: 'Event';
  amount: Scalars['Float'];
  attachments: Array<EventAttachments>;
  cancelled: Scalars['Boolean'];
  couple?: Maybe<Couple>;
  duration: Scalars['TimeDeltaMinutes'];
  end: Scalars['ISODateTime'];
  groupPresence?: Maybe<EventGroupPresence>;
  groupPresenceName?: Maybe<Scalars['String']>;
  hasInvoice: Scalars['Boolean'];
  hasNote: Scalars['Boolean'];
  id: Scalars['Int'];
  invoice?: Maybe<Invoice>;
  locked: Scalars['Boolean'];
  name: Scalars['String'];
  nextEvent?: Maybe<Scalars['Int']>;
  note?: Maybe<Scalars['String']>;
  paidOn?: Maybe<Scalars['ISODate']>;
  participants?: Maybe<Array<EventParticipants>>;
  period?: Maybe<EventPeriod>;
  periodId?: Maybe<Scalars['Int']>;
  prevEvent?: Maybe<Scalars['Int']>;
  room: Room;
  roomId: Scalars['Int'];
  secretNote?: Maybe<Scalars['String']>;
  serviceIds: Array<Scalars['Int']>;
  serviceName: Scalars['String'];
  serviceNameWithPrice: Scalars['String'];
  services: Array<ServiceType>;
  shifted: Scalars['Boolean'];
  start: Scalars['ISODateTime'];
  status: EventPayment;
  therapistColor: Scalars['String'];
  therapistIds: Array<Scalars['Int']>;
  therapists: Array<Employee>;
};

export type EventAttachments = {
  __typename?: 'EventAttachments';
  createdAt: Scalars['ISODateTime'];
  id: Scalars['Int'];
  name: Scalars['String'];
  url: Scalars['String'];
};

export type EventCollision = {
  __typename?: 'EventCollision';
  event: Event;
  reason: Array<CollisionReason>;
};

export type EventEditAttributes = {
  attachments?: InputMaybe<AttachmentsGroupInput>;
  deletedAt?: InputMaybe<Scalars['ISODateTime']>;
  duration?: InputMaybe<Scalars['TimeDeltaMinutes']>;
  groupPresence?: InputMaybe<EventGroupPresences>;
  lock?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  participants?: InputMaybe<Array<NewEventParticipantsInput>>;
  room?: InputMaybe<Scalars['Int']>;
  secretNote?: InputMaybe<Scalars['String']>;
  services?: InputMaybe<Array<Scalars['Int']>>;
  start?: InputMaybe<Scalars['ISODateTime']>;
  therapists?: InputMaybe<Array<Scalars['Int']>>;
};

export type EventGroupPresence = {
  __typename?: 'EventGroupPresence';
  name: Scalars['String'];
  value: Scalars['String'];
};

/** An enumeration. */
export enum EventGroupPresences {
  DidNotHappen = 'DID_NOT_HAPPEN',
  Holiday = 'HOLIDAY',
  MeetingCancelled = 'MEETING_CANCELLED',
  MeetingCancelledByMe = 'MEETING_CANCELLED_BY_ME',
  MeetingTookPlace = 'MEETING_TOOK_PLACE',
  OnePartyCancelled = 'ONE_PARTY_CANCELLED',
  OutsideWorkingHours = 'OUTSIDE_WORKING_HOURS'
}

export type EventInput = {
  coupleId?: InputMaybe<Scalars['Int']>;
  duration: Scalars['TimeDeltaMinutes'];
  name: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  patients: Array<Scalars['Int']>;
  roomId: Scalars['Int'];
  secretNote?: InputMaybe<Scalars['String']>;
  services: Array<Scalars['Int']>;
  start: Scalars['ISODateTime'];
  therapistIds: Array<Scalars['Int']>;
};

export type EventOutput = {
  __typename?: 'EventOutput';
  collisions?: Maybe<Array<EventCollision>>;
  event?: Maybe<Event>;
  success: Scalars['Boolean'];
};

export type EventPagination = {
  __typename?: 'EventPagination';
  count: Scalars['Int'];
  data: Array<Event>;
  pageTotals: Scalars['JSON'];
  totals: Scalars['JSON'];
};

export type EventParticipants = {
  __typename?: 'EventParticipants';
  id: Scalars['Int'];
  patient?: Maybe<Patient>;
  payment: EventPayment;
  paymentMethod?: Maybe<EventPatientPaymentMethod>;
  paymentMethodName?: Maybe<Scalars['String']>;
  /** @deprecated Transitioned to just payment enum */
  paymentName?: Maybe<EventPayment>;
  presence?: Maybe<EventPresence>;
  presenceName?: Maybe<Scalars['String']>;
};

export type EventPatientPaymentMethod = {
  __typename?: 'EventPatientPaymentMethod';
  name: Scalars['String'];
  value: Scalars['String'];
};

/** An enumeration. */
export enum EventPayment {
  AwaitingPayment = 'AWAITING_PAYMENT',
  Paid = 'PAID',
  PaymentNotRequired = 'PAYMENT_NOT_REQUIRED',
  Unknown = 'UNKNOWN',
  Unpaid = 'UNPAID'
}

/** An enumeration. */
export enum EventPaymentMethods {
  BankTransfer = 'BANK_TRANSFER',
  Cash = 'CASH',
  CreditCard = 'CREDIT_CARD',
  Other = 'OTHER',
  Przelewy24 = 'PRZELEWY24'
}

export type EventPeriod = {
  __typename?: 'EventPeriod';
  coupleId?: Maybe<Scalars['Int']>;
  dows: Array<Scalars['Int']>;
  duration: Scalars['TimeDeltaMinutes'];
  end?: Maybe<Scalars['ISODateTime']>;
  id: Scalars['Int'];
  interval: Scalars['Int'];
  name: Scalars['String'];
  participants: Array<EventParticipants>;
  room: Room;
  services: Array<ServiceType>;
  start: Scalars['ISODateTime'];
  therapists: Array<Employee>;
};

export type EventPeriodInput = {
  coupleId?: InputMaybe<Scalars['Int']>;
  dows: Array<Scalars['Int']>;
  duration: Scalars['TimeDeltaMinutes'];
  end?: InputMaybe<Scalars['ISODateTime']>;
  interval: Scalars['Int'];
  name: Scalars['String'];
  patients: Array<Scalars['Int']>;
  roomId: Scalars['Int'];
  services: Array<Scalars['Int']>;
  start: Scalars['ISODateTime'];
  therapistIds: Array<Scalars['Int']>;
};

export type EventPresence = {
  __typename?: 'EventPresence';
  name: Scalars['String'];
  value: Scalars['String'];
};

/** An enumeration. */
export enum EventPresences {
  DidNotHappen = 'DID_NOT_HAPPEN',
  Holiday = 'HOLIDAY',
  MeetingCancelledByMe = 'MEETING_CANCELLED_BY_ME',
  OnTime = 'ON_TIME',
  Others = 'OTHERS',
  OutsideWorkingHours = 'OUTSIDE_WORKING_HOURS',
  PatientCancelledNotPayable = 'PATIENT_CANCELLED_NOT_PAYABLE',
  PatientCancelledPayable = 'PATIENT_CANCELLED_PAYABLE'
}

export type EventSeriesEditAttributes = {
  duration?: InputMaybe<Scalars['TimeDeltaMinutes']>;
  force?: Scalars['Boolean'];
  room?: InputMaybe<Scalars['Int']>;
  services?: InputMaybe<Array<Scalars['Int']>>;
  start?: InputMaybe<Scalars['ISODateTime']>;
  therapists?: InputMaybe<Array<Scalars['Int']>>;
};

export type ExpenseInput = {
  amount: Scalars['Float'];
  date: Scalars['Date'];
  name: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  practiceBranchId: Scalars['Int'];
  recurringPeriod?: InputMaybe<RecurringExpenseEnum>;
};

export type ExpensesEditAttributes = {
  amount?: InputMaybe<Scalars['Float']>;
  date?: InputMaybe<Scalars['Date']>;
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  recurring?: InputMaybe<RecurringExpenseInput>;
};

export type ExpensesResult = {
  __typename?: 'ExpensesResult';
  count: Scalars['Int'];
  expenses: Array<PracticeExpense>;
};

export type ExternalInvoice = {
  __typename?: 'ExternalInvoice';
  buyerCity?: Maybe<Scalars['String']>;
  buyerEmail?: Maybe<Scalars['String']>;
  buyerName?: Maybe<Scalars['String']>;
  buyerPostCode?: Maybe<Scalars['String']>;
  buyerStreet?: Maybe<Scalars['String']>;
  buyerTaxNo?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  issueDate: Scalars['ISODate'];
  number: Scalars['String'];
  paid?: Maybe<Scalars['Float']>;
  paymentTo: Scalars['ISODate'];
  paymentToKind: Scalars['String'];
  paymentType?: Maybe<ExternalInvoicePaymentType>;
  priceGross?: Maybe<Scalars['Float']>;
  sellDate: Scalars['ISODate'];
  sellerBank?: Maybe<Scalars['String']>;
  sellerBankAccount?: Maybe<Scalars['String']>;
  sellerCity?: Maybe<Scalars['String']>;
  sellerCountry?: Maybe<Scalars['String']>;
  sellerEmail?: Maybe<Scalars['String']>;
  sellerName?: Maybe<Scalars['String']>;
  sellerPhone?: Maybe<Scalars['String']>;
  sellerPostCode?: Maybe<Scalars['String']>;
  sellerStreet?: Maybe<Scalars['String']>;
  sellerTaxNo?: Maybe<Scalars['String']>;
  status: ExternalInvoiceStatus;
  unpaid?: Maybe<Scalars['Float']>;
  viewUrl: Scalars['String'];
};

/** An enumeration. */
export enum ExternalInvoiceKind {
  Bill = 'BILL',
  Vat = 'VAT'
}

/** An enumeration. */
export enum ExternalInvoicePaymentType {
  Barter = 'BARTER',
  BillOfExchange = 'BILL_OF_EXCHANGE',
  Card = 'CARD',
  Cash = 'CASH',
  CashOnDelivery = 'CASH_ON_DELIVERY',
  Cheque = 'CHEQUE',
  Compensation = 'COMPENSATION',
  LetterOfCredit = 'LETTER_OF_CREDIT',
  Off = 'OFF',
  Paypal = 'PAYPAL',
  Payu = 'PAYU',
  Transfer = 'TRANSFER'
}

/** An enumeration. */
export enum ExternalInvoiceStatus {
  Issued = 'ISSUED',
  Paid = 'PAID',
  Partial = 'PARTIAL',
  Rejected = 'REJECTED',
  Sent = 'SENT'
}

export type FavoriteTherapist = {
  __typename?: 'FavoriteTherapist';
  acronym?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  fullName: Scalars['String'];
  id: Scalars['Int'];
};

export type FloatRangeInput = {
  max: Scalars['Float'];
  min: Scalars['Float'];
};

export type GdprConfigType = {
  __typename?: 'GDPRConfigType';
  documentCategory: Scalars['String'];
  documentCategoryChild: Scalars['String'];
  id?: Maybe<Scalars['Int']>;
  practiceBranchId: Scalars['Int'];
  sendAutomatedGdprMails: Scalars['Boolean'];
};

export type GdprDocumentType = {
  __typename?: 'GDPRDocumentType';
  documentType: Scalars['String'];
  isSigned: Scalars['Boolean'];
  openedDate?: Maybe<Scalars['ISODateTime']>;
  patient: Patient;
  patientToken: Scalars['String'];
  practiceName: Scalars['String'];
  signedDate?: Maybe<Scalars['ISODateTime']>;
};

export type Groups = {
  __typename?: 'Groups';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type Guardian = {
  __typename?: 'Guardian';
  address?: Maybe<GuardianAddress>;
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  id: Scalars['Int'];
  lastName: Scalars['String'];
  patient: Patient;
  phoneNumber?: Maybe<Scalars['PhoneNumber']>;
};

export type GuardianAddress = {
  __typename?: 'GuardianAddress';
  apartmentNumber?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  houseNumber?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  street?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type GuardianAddressInput = {
  apartmentNumber?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  houseNumber?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type HolidayEditInput = {
  employeeId?: InputMaybe<Scalars['Int']>;
  end?: InputMaybe<Scalars['DateTime']>;
  holidayReasonId?: InputMaybe<Scalars['Int']>;
  note?: InputMaybe<Scalars['String']>;
  practiceBranchId?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['DateTime']>;
};

export type HolidayInput = {
  employeeId?: InputMaybe<Scalars['Int']>;
  end: Scalars['DateTime'];
  holidayReasonId: Scalars['Int'];
  note?: InputMaybe<Scalars['String']>;
  practiceBranchId?: InputMaybe<Scalars['Int']>;
  start: Scalars['DateTime'];
};

/** An enumeration. */
export enum HolidayKindEnum {
  National = 'NATIONAL',
  Personal = 'PERSONAL',
  Practice = 'PRACTICE',
  PracticeBranch = 'PRACTICE_BRANCH'
}

export type HolidayReasonType = {
  __typename?: 'HolidayReasonType';
  descriptionEn?: Maybe<Scalars['String']>;
  descriptionPl?: Maybe<Scalars['String']>;
  kind: HolidayKindEnum;
  nameEn: Scalars['String'];
  namePl: Scalars['String'];
};

export type HolidayType = {
  __typename?: 'HolidayType';
  employee?: Maybe<Employee>;
  end: Scalars['ISODate'];
  id: Scalars['Int'];
  note: Scalars['String'];
  practiceBranch?: Maybe<PracticeBranch>;
  reason: HolidayReasonType;
  requestConsideration: RequestConsiderationType;
  start: Scalars['ISODate'];
};

export type HolidayTypePagination = {
  __typename?: 'HolidayTypePagination';
  count: Scalars['Int'];
  data: Array<HolidayType>;
  pageTotals: Scalars['JSON'];
  totals: Scalars['JSON'];
};

/** An enumeration. */
export enum HoursBeforeEnum {
  H24 = 'H24',
  H48 = 'H48',
  H72 = 'H72'
}

export type IncomeStatistics = {
  __typename?: 'IncomeStatistics';
  income: Scalars['Float'];
  lostIncome: Scalars['Float'];
  prevIncome: Scalars['Float'];
  previousPeriodDates: DatePeriod;
  unpaidIncome: Scalars['Float'];
};

export type Invoice = {
  __typename?: 'Invoice';
  addClientTax: Scalars['Boolean'];
  clientBillingInfo: BillingInfo;
  externalId: Scalars['Int'];
  externalInvoice?: Maybe<ExternalInvoice>;
  id: Scalars['Int'];
  issueDate: Scalars['ISODate'];
  kind: Scalars['String'];
  lineItems: Array<InvoiceLineItem>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  number: Scalars['String'];
  patientEmails: Array<Scalars['String']>;
  paymentTo: Scalars['ISODate'];
  practiceBranch: PracticeBranch;
  sellDate: Scalars['ISODate'];
  sentTo: Array<InvoiceSentTo>;
  status: ExternalInvoiceStatus;
  totalPriceGross: Scalars['Float'];
  totalPriceNet: Scalars['Float'];
  totalPriceTax: Scalars['Float'];
  viewUrl?: Maybe<Scalars['String']>;
};

export type InvoiceConfig = {
  __typename?: 'InvoiceConfig';
  active: Scalars['Boolean'];
  apiToken?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  practice: Practice;
  subdomain: Scalars['String'];
};

export type InvoiceConfigInput = {
  active?: Scalars['Boolean'];
  apiToken?: InputMaybe<Scalars['String']>;
  subdomain?: InputMaybe<Scalars['String']>;
};

export type InvoiceEvent = {
  __typename?: 'InvoiceEvent';
  count: Scalars['Int'];
  events: Array<Event>;
};

export type InvoiceEvents = {
  __typename?: 'InvoiceEvents';
  paid: InvoiceEvent;
  unpaid: InvoiceEvent;
};

export type InvoiceInput = {
  addClientTax?: InputMaybe<Scalars['Boolean']>;
  client?: InputMaybe<BillingInfoInput>;
  issueDate: Scalars['ISODate'];
  kind: ExternalInvoiceKind;
  lineItems: Array<InvoiceLineItemInput>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  number: Scalars['String'];
  patientId?: InputMaybe<Scalars['Int']>;
  payment: ExternalInvoicePaymentType;
  paymentTo: Scalars['ISODate'];
  practiceBranchId: Scalars['Int'];
  salesDate: Scalars['ISODate'];
  seller?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ExternalInvoiceStatus>;
};

export type InvoiceLineItem = {
  __typename?: 'InvoiceLineItem';
  events: Array<Event>;
  externalId: Scalars['Int'];
  id: Scalars['Int'];
  itemPrice: Scalars['Float'];
  name: Scalars['String'];
  quantity: Scalars['Int'];
  tax: Scalars['Float'];
  taxFree: Scalars['Boolean'];
  taxNotApplicable: Scalars['Boolean'];
  totalPriceGross: Scalars['Float'];
  totalPriceNet: Scalars['Float'];
  totalPriceTax: Scalars['Float'];
};

export type InvoiceLineItemInput = {
  eventIds?: InputMaybe<Array<Scalars['Int']>>;
  itemPrice: Scalars['Float'];
  name: Scalars['String'];
  quantity?: InputMaybe<Scalars['Int']>;
  tax: Scalars['Float'];
  taxFree?: InputMaybe<Scalars['Boolean']>;
  taxNotApplicable?: InputMaybe<Scalars['Boolean']>;
};

export type InvoiceLineItemUpdateInput = {
  Delete?: InputMaybe<Scalars['Boolean']>;
  eventIds?: InputMaybe<Array<Scalars['Int']>>;
  itemPrice?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  tax?: InputMaybe<Scalars['Float']>;
  taxFree?: InputMaybe<Scalars['Boolean']>;
  taxNotApplicable?: InputMaybe<Scalars['Boolean']>;
};

export type InvoicePagination = {
  __typename?: 'InvoicePagination';
  count: Scalars['Int'];
  data: Array<Invoice>;
  pageTotals: Scalars['JSON'];
  totals: Scalars['JSON'];
};

export type InvoiceSendInput = {
  invoiceId: Scalars['Int'];
  sendCopyToMe?: InputMaybe<Scalars['Boolean']>;
  sendTo: Array<Scalars['String']>;
};

export type InvoiceSentTo = {
  __typename?: 'InvoiceSentTo';
  emails: Array<Scalars['String']>;
  id: Scalars['Int'];
  sentAt: Scalars['ISODateTime'];
};

/** An enumeration. */
export enum InvoiceTab {
  All = 'ALL',
  Open = 'OPEN',
  Past = 'PAST'
}

export type InvoiceUpdateInput = {
  addClientTax?: InputMaybe<Scalars['Boolean']>;
  client?: InputMaybe<BillingInfoInput>;
  issueDate?: InputMaybe<Scalars['ISODate']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  payment?: InputMaybe<ExternalInvoicePaymentType>;
  paymentTo?: InputMaybe<Scalars['ISODate']>;
  salesDate?: InputMaybe<Scalars['ISODate']>;
  status?: InputMaybe<ExternalInvoiceStatus>;
};

export type InvoicingAccountDeleteResponseType = {
  __typename?: 'InvoicingAccountDeleteResponseType';
  code: Scalars['String'];
  message: Scalars['String'];
};

/** An enumeration. */
export enum MeetingRequestResult {
  Confirmed = 'CONFIRMED',
  Rejected = 'REJECTED',
  Unknown = 'UNKNOWN'
}

export type MeetingRequestType = {
  __typename?: 'MeetingRequestType';
  confirmedAt?: Maybe<Scalars['ISODateTime']>;
  createdAt: Scalars['ISODateTime'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['Int'];
  lastName: Scalars['String'];
  lookalikePatients: Array<Patient>;
  phoneNumber: Scalars['String'];
  practiceBranch: PracticeBranch;
  rejectedAt?: Maybe<Scalars['ISODateTime']>;
  rejectedBy?: Maybe<Employee>;
  service: ServiceType;
  start: Scalars['ISODateTime'];
  therapist: Employee;
};

export type MeetingRequestTypePagination = {
  __typename?: 'MeetingRequestTypePagination';
  count: Scalars['Int'];
  data: Array<MeetingRequestType>;
  pageTotals: Scalars['JSON'];
  totals: Scalars['JSON'];
};

export type MeetingStatistics = {
  __typename?: 'MeetingStatistics';
  meetingsCancelled: ComparisonItem;
  meetingsHeld: ComparisonItem;
  meetingsSheduled: ComparisonItem;
  patientsNumbers: ComparisonItem;
  therapiesFinished: ComparisonItem;
  therapiesNew: ComparisonItem;
};

export type Mutation = {
  __typename?: 'Mutation';
  addBillingInfo: BillingInfo;
  addCouple: Couple;
  addExpense: ExpensesResult;
  addHoliday: HolidayType;
  addPatient: Patient;
  addPatientEducatorNotes: Scalars['Int'];
  addPatientPsychotherapyNotes: Scalars['Int'];
  addPatientSiNotes: Scalars['Int'];
  addPatientSpeechtherapyNotes: Scalars['Int'];
  addPeriodicEvent: EventPeriod;
  addPrzelewy24Config: Przelewy24Config;
  addRoom: Room;
  addSingleEvent: Event;
  addSingleEventWithCollisions: EventOutput;
  addWorktimeException: WorkTimeExceptionType;
  addWorktimePreset: Scalars['Boolean'];
  bookMeeting: BookMeetingResponse;
  changeEventIntoEventSeries: Scalars['Boolean'];
  confirmMeeting: BookMeetingResponse;
  createEmployee: Scalars['Boolean'];
  createExpoToken: Scalars['Boolean'];
  createGuardian: Scalars['Boolean'];
  createInvoice: Invoice;
  createPractice: Practice;
  createPrzelewy24Transaction: Przelewy24OrderRegister;
  createService: ServiceType;
  deactivateEmployee: Scalars['Boolean'];
  deactivateGuardian: Scalars['Boolean'];
  deactivateRooms: Scalars['Boolean'];
  deactivateServices: Scalars['Boolean'];
  deleteAttachments: Scalars['Int'];
  deleteEventAttachment: Scalars['Boolean'];
  deleteEventSeries: Scalars['Boolean'];
  deleteInvoice: Scalars['Boolean'];
  deleteInvoiceConfig: InvoicingAccountDeleteResponseType;
  deleteMeetings: Scalars['Boolean'];
  deletePracticeLogo: Scalars['Boolean'];
  deleteUserAvatar: Scalars['Boolean'];
  editBillingInfo: BillingInfo;
  editCouple: Scalars['Boolean'];
  editEmployee: Scalars['Boolean'];
  editEvent: Event;
  editEventPaymentStatuses?: Maybe<Scalars['Void']>;
  editEventSeries: Scalars['Boolean'];
  editEventWithCollisions: EventOutput;
  editExpense: Scalars['Boolean'];
  editFavoriteTherapists: Scalars['Boolean'];
  editGdprConfig: Scalars['Boolean'];
  editGuardian: Scalars['Boolean'];
  editHoliday: HolidayType;
  editOrCreateAppPaymentConfig: AppPaymentConfig;
  editPatient: Scalars['Boolean'];
  editPatientEducatorNotes: Scalars['Int'];
  editPatientPsychotherapyNotes: Scalars['Int'];
  editPatientSiNotes: Scalars['Int'];
  editPatientSpeechtherapyNotes: Scalars['Int'];
  editPractice: Scalars['Boolean'];
  editRequestConsideration: RequestConsiderationType;
  editRoom: Scalars['Boolean'];
  editService: Scalars['Boolean'];
  editUserSettings: Scalars['Boolean'];
  editWorktimeConfig: WorkTimeConfigType;
  editWorktimeException: WorkTimeExceptionType;
  finishCoupleTherapy: Scalars['Boolean'];
  finishPatientTherapy: Scalars['Boolean'];
  generateEmployeeReport: ReportResult;
  generateIncomeReport: Scalars['Boolean'];
  generateMeetingHistoryReport: ReportResult;
  markGdprDocumentAsOpened: Scalars['ISODateTime'];
  markGdprDocumentAsSigned: Scalars['ISODateTime'];
  purchaseSmsPacket: Przelewy24OrderRegister;
  reactivateCoupleTherapy: Scalars['Boolean'];
  reactivatePatientTherapy: Scalars['Boolean'];
  rejectMeetings: Scalars['Boolean'];
  removeBillingInfo: Scalars['Boolean'];
  removeExpenses: DeletedExpenses;
  removeHolidays: Scalars['Int'];
  removeWorktimeException: Scalars['Boolean'];
  removeWorktimePreset: Scalars['Boolean'];
  sendDemoSms: DemoSmsResponse;
  sendEmployeeInvitation: Scalars['Boolean'];
  sendGdprEmail: Scalars['Boolean'];
  sendInvoices: Scalars['Boolean'];
  setPracticeLogo: Scalars['Boolean'];
  setUserAvatar: Scalars['Boolean'];
  shiftEventSeries: Scalars['Boolean'];
  synchronizeInvoice: Invoice;
  updateInvoice: Invoice;
  updateInvoiceLineItem: Invoice;
  updateOrCreateInvoiceConfig: InvoiceConfig;
  updateOrCreateWebhooks: WebhooksType;
  updateRequestConsiderationStatuses: Scalars['Int'];
  updateSmsConfig: SmsConfig;
  updateSmsTemplate: SmsTemplateOrError;
  upsertOnlineRegistrationConfig: OnlineRegistrationConfigType;
};


export type MutationAddBillingInfoArgs = {
  model: Scalars['String'];
  patientId?: InputMaybe<Scalars['Int']>;
  payload: BillingInfoInput;
};


export type MutationAddCoupleArgs = {
  payload: CoupleInput;
};


export type MutationAddExpenseArgs = {
  expenseInput: ExpenseInput;
  generateHistory?: Scalars['Boolean'];
};


export type MutationAddHolidayArgs = {
  holidayInput: HolidayInput;
};


export type MutationAddPatientArgs = {
  patientInput: PatientInput;
};


export type MutationAddPatientEducatorNotesArgs = {
  payload: PatientEducatorInput;
};


export type MutationAddPatientPsychotherapyNotesArgs = {
  payload: PatientPsychotherapyInput;
};


export type MutationAddPatientSiNotesArgs = {
  payload: PatientSiInput;
};


export type MutationAddPatientSpeechtherapyNotesArgs = {
  payload: PatientSpeechTherapyInput;
};


export type MutationAddPeriodicEventArgs = {
  eventInput: EventPeriodInput;
};


export type MutationAddPrzelewy24ConfigArgs = {
  payload: Przelewy24ConfigInput;
};


export type MutationAddRoomArgs = {
  payload: AddRoomInput;
};


export type MutationAddSingleEventArgs = {
  eventInput: EventInput;
};


export type MutationAddSingleEventWithCollisionsArgs = {
  collisionLimit?: InputMaybe<Scalars['Int']>;
  eventInput: EventInput;
};


export type MutationAddWorktimeExceptionArgs = {
  exceptionInput: WorkTimeExceptionInput;
};


export type MutationAddWorktimePresetArgs = {
  presetInput: WorkTimePresetInput;
};


export type MutationBookMeetingArgs = {
  booking: BookMeetingPayload;
};


export type MutationChangeEventIntoEventSeriesArgs = {
  dows: Array<Scalars['Int']>;
  end?: InputMaybe<Scalars['ISODateTime']>;
  eventId: Scalars['Int'];
  interval: Scalars['Int'];
};


export type MutationConfirmMeetingArgs = {
  payload: ConfirmMeetingPayload;
};


export type MutationCreateEmployeeArgs = {
  payload: CreateEmployeeInput;
};


export type MutationCreateExpoTokenArgs = {
  employeeId: Scalars['Int'];
  token: Scalars['String'];
};


export type MutationCreateGuardianArgs = {
  payload: CreateGuardianInput;
};


export type MutationCreateInvoiceArgs = {
  payload: InvoiceInput;
};


export type MutationCreatePracticeArgs = {
  payload: CreatePracticeInput;
};


export type MutationCreatePrzelewy24TransactionArgs = {
  payload: Przelewy24OrderInput;
};


export type MutationCreateServiceArgs = {
  payload: ServiceInput;
};


export type MutationDeactivateEmployeeArgs = {
  employeeId: Scalars['Int'];
};


export type MutationDeactivateGuardianArgs = {
  deactivatedAt?: InputMaybe<Scalars['ISODateTime']>;
  guardianId: Scalars['Int'];
};


export type MutationDeactivateRoomsArgs = {
  roomIds: Array<Scalars['Int']>;
};


export type MutationDeactivateServicesArgs = {
  serviceIds: Array<Scalars['Int']>;
};


export type MutationDeleteAttachmentsArgs = {
  attachmentIds: Array<Scalars['Int']>;
};


export type MutationDeleteEventAttachmentArgs = {
  attachmentId: Scalars['Int'];
};


export type MutationDeleteEventSeriesArgs = {
  afterDate: Scalars['ISODateTime'];
  eventPeriodId: Scalars['Int'];
};


export type MutationDeleteInvoiceArgs = {
  invoiceId: Scalars['Int'];
};


export type MutationDeleteInvoiceConfigArgs = {
  deleteAccountOnFakturownia: Scalars['Boolean'];
};


export type MutationDeleteMeetingsArgs = {
  meetingRequestIds: Array<Scalars['Int']>;
};


export type MutationEditBillingInfoArgs = {
  id: Scalars['Int'];
  payload: BillingInfoInput;
};


export type MutationEditCoupleArgs = {
  coupleId: Scalars['Int'];
  payload: CoupleInput;
};


export type MutationEditEmployeeArgs = {
  employeeId: Scalars['Int'];
  payload: EditEmployeeInput;
};


export type MutationEditEventArgs = {
  eventId: Scalars['Int'];
  payload: EventEditAttributes;
};


export type MutationEditEventPaymentStatusesArgs = {
  eventIds: Array<Scalars['Int']>;
  paidOn?: InputMaybe<Scalars['ISODate']>;
  paymentMethod?: InputMaybe<EventPaymentMethods>;
  paymentStatus: EventPayment;
};


export type MutationEditEventSeriesArgs = {
  eventId: Scalars['Int'];
  payload: EventSeriesEditAttributes;
};


export type MutationEditEventWithCollisionsArgs = {
  collisionLimit?: InputMaybe<Scalars['Int']>;
  eventId: Scalars['Int'];
  payload: EventEditAttributes;
};


export type MutationEditExpenseArgs = {
  expenseId: Scalars['Int'];
  payload: ExpensesEditAttributes;
};


export type MutationEditFavoriteTherapistsArgs = {
  employeeId: Scalars['Int'];
  therapists?: Array<Scalars['Int']>;
};


export type MutationEditGdprConfigArgs = {
  payload: EditGdprConfigInput;
};


export type MutationEditGuardianArgs = {
  payload: EditGuardianInput;
};


export type MutationEditHolidayArgs = {
  holidayId: Scalars['Int'];
  holidayInput: HolidayEditInput;
};


export type MutationEditOrCreateAppPaymentConfigArgs = {
  payload: AppPaymentConfigInput;
};


export type MutationEditPatientArgs = {
  addressId?: InputMaybe<Scalars['Int']>;
  patientId: Scalars['Int'];
  patientInput: EditPatientInput;
};


export type MutationEditPatientEducatorNotesArgs = {
  payload: PatientEducatorInput;
};


export type MutationEditPatientPsychotherapyNotesArgs = {
  payload: PatientPsychotherapyInput;
};


export type MutationEditPatientSiNotesArgs = {
  payload: PatientSiInput;
};


export type MutationEditPatientSpeechtherapyNotesArgs = {
  payload: PatientSpeechTherapyInput;
};


export type MutationEditPracticeArgs = {
  payload: EditPracticeInput;
};


export type MutationEditRequestConsiderationArgs = {
  requestInput: RequestConsiderationInput;
};


export type MutationEditRoomArgs = {
  payload: EditRoomInput;
  roomId: Scalars['Int'];
};


export type MutationEditServiceArgs = {
  payload: EditServiceInput;
  serviceId: Scalars['Int'];
};


export type MutationEditUserSettingsArgs = {
  payload: UserInput;
};


export type MutationEditWorktimeConfigArgs = {
  config: WorkTimeConfigInput;
};


export type MutationEditWorktimeExceptionArgs = {
  exceptionInput: EditWorkTimeExceptionInput;
  worktimeExceptionId: Scalars['Int'];
};


export type MutationFinishCoupleTherapyArgs = {
  coupleId: Scalars['Int'];
  deleteCouple?: Scalars['Boolean'];
  finishDate?: InputMaybe<Scalars['ISODateTime']>;
};


export type MutationFinishPatientTherapyArgs = {
  deletePatient?: Scalars['Boolean'];
  finishDate?: InputMaybe<Scalars['ISODateTime']>;
  patientId: Scalars['Int'];
};


export type MutationGenerateEmployeeReportArgs = {
  after: Scalars['ISODateTime'];
  before: Scalars['ISODateTime'];
  employeeId: Scalars['Int'];
  language: Scalars['String'];
  timeZone: Scalars['String'];
};


export type MutationGenerateIncomeReportArgs = {
  after: Scalars['ISODateTime'];
  before: Scalars['ISODateTime'];
  coupleId?: InputMaybe<Scalars['Int']>;
  fileType: Scalars['String'];
  language: Scalars['String'];
  patientId?: InputMaybe<Scalars['Int']>;
  patientIds?: InputMaybe<Array<Scalars['Int']>>;
  paymentMethods?: InputMaybe<Array<Scalars['String']>>;
  serviceIds?: InputMaybe<Array<Scalars['Int']>>;
  statuses?: InputMaybe<Array<Scalars['String']>>;
  therapistIds?: InputMaybe<Array<Scalars['Int']>>;
  timeZone: Scalars['String'];
};


export type MutationGenerateMeetingHistoryReportArgs = {
  after: Scalars['ISODateTime'];
  before: Scalars['ISODateTime'];
  coupleId?: InputMaybe<Scalars['Int']>;
  language: Scalars['String'];
  patientId?: InputMaybe<Scalars['Int']>;
  timeZone: Scalars['String'];
};


export type MutationMarkGdprDocumentAsOpenedArgs = {
  token: Scalars['String'];
};


export type MutationMarkGdprDocumentAsSignedArgs = {
  token: Scalars['String'];
};


export type MutationPurchaseSmsPacketArgs = {
  payload: SmsPacketPurchaseInput;
};


export type MutationReactivateCoupleTherapyArgs = {
  coupleId: Scalars['Int'];
};


export type MutationReactivatePatientTherapyArgs = {
  patientId: Scalars['Int'];
};


export type MutationRejectMeetingsArgs = {
  meetingRequestIds: Array<Scalars['Int']>;
  sendSms?: Scalars['Boolean'];
};


export type MutationRemoveBillingInfoArgs = {
  deletedAt?: InputMaybe<Scalars['ISODateTime']>;
  id: Array<Scalars['Int']>;
};


export type MutationRemoveExpensesArgs = {
  expenseIds: Array<Scalars['Int']>;
  removeRelated?: Scalars['Boolean'];
};


export type MutationRemoveHolidaysArgs = {
  holidayIds: Array<Scalars['Int']>;
};


export type MutationRemoveWorktimeExceptionArgs = {
  worktimeExceptionId: Scalars['Int'];
};


export type MutationRemoveWorktimePresetArgs = {
  presetId: Scalars['Int'];
};


export type MutationSendDemoSmsArgs = {
  demoSmsInput: DemoSmsInput;
};


export type MutationSendEmployeeInvitationArgs = {
  employeeInput: EmployeeInvitationInput;
};


export type MutationSendGdprEmailArgs = {
  patientIds: Array<Scalars['Int']>;
};


export type MutationSendInvoicesArgs = {
  payload: Array<InvoiceSendInput>;
};


export type MutationSetPracticeLogoArgs = {
  payload: SetPracticeLogoInput;
};


export type MutationSetUserAvatarArgs = {
  payload: AvatarInput;
};


export type MutationShiftEventSeriesArgs = {
  eventId: Scalars['Int'];
  payload: EventSeriesEditAttributes;
};


export type MutationSynchronizeInvoiceArgs = {
  invoiceId: Scalars['Int'];
};


export type MutationUpdateInvoiceArgs = {
  invoiceId: Scalars['Int'];
  payload: InvoiceUpdateInput;
};


export type MutationUpdateInvoiceLineItemArgs = {
  invoiceLineItemId: Scalars['Int'];
  payload: InvoiceLineItemUpdateInput;
};


export type MutationUpdateOrCreateInvoiceConfigArgs = {
  payload?: InputMaybe<InvoiceConfigInput>;
};


export type MutationUpdateRequestConsiderationStatusesArgs = {
  note?: InputMaybe<Scalars['String']>;
  requestIds: Array<Scalars['Int']>;
  status: ConfirmationStatusEnum;
};


export type MutationUpdateSmsConfigArgs = {
  smsConfigInput: SmsConfigPartialInput;
};


export type MutationUpdateSmsTemplateArgs = {
  smsTemplateInput: SmsTemplateInput;
};


export type MutationUpsertOnlineRegistrationConfigArgs = {
  config: UpsertOnlineRegistrationConfig;
};

export type NewEventParticipantsInput = {
  eventId: Scalars['Int'];
  paidOn?: InputMaybe<Scalars['ISODate']>;
  participantId?: InputMaybe<Scalars['Int']>;
  participantIds?: InputMaybe<Array<Scalars['Int']>>;
  payment?: InputMaybe<EventPayment>;
  paymentMethod?: InputMaybe<EventPaymentMethods>;
  presence?: InputMaybe<EventPresences>;
};

export type OnlineRegistrationConfigType = {
  __typename?: 'OnlineRegistrationConfigType';
  exactSlotProposal: Scalars['Int'];
  id: Scalars['Int'];
  isPreciseSearch: Scalars['Boolean'];
  isRegistrationEnabled: Scalars['Boolean'];
  maximumPrecedingMinutes: Scalars['Int'];
  minimumPrecedingMinutes: Scalars['Int'];
  minutesBetweenMeetings: Scalars['Int'];
  practice: Practice;
  practiceSlug: Scalars['String'];
  privacyPolicyUrl?: Maybe<Scalars['String']>;
  roundSlotTimeTo: Scalars['Int'];
  termsOfUseUrl?: Maybe<Scalars['String']>;
};

export type OrderBy = {
  fieldName: Scalars['String'];
  order: Scalars['Int'];
};

export type Patient = {
  __typename?: 'Patient';
  active: Scalars['Boolean'];
  address?: Maybe<PatientAddress>;
  attachmentsList?: Maybe<Array<Attachment>>;
  billingInfo?: Maybe<BillingInfo>;
  birthday?: Maybe<Scalars['DateTime']>;
  color?: Maybe<Scalars['String']>;
  couples: Array<Couple>;
  createdAt: Scalars['ISODateTime'];
  deactivatedOn?: Maybe<Scalars['ISODateTime']>;
  deletedAt?: Maybe<Scalars['ISODateTime']>;
  description: Scalars['String'];
  educator?: Maybe<PatientEducatorType>;
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  fullName: Scalars['String'];
  groups: Array<Groups>;
  id: Scalars['Int'];
  idNumber?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  phoneNumber?: Maybe<Scalars['PhoneNumber']>;
  practiceId: Scalars['Int'];
  psychoTherapy?: Maybe<PatientPsychoTherapy>;
  secondPhoneNumber?: Maybe<Scalars['PhoneNumber']>;
  si?: Maybe<PatientSiType>;
  signedGdprConsent?: Maybe<Scalars['ISODateTime']>;
  smsNotificationsActive: Scalars['Boolean'];
  speechTherapy?: Maybe<PatientSpeechTherapy>;
  therapist?: Maybe<Employee>;
  therapists: Array<Employee>;
  updatedAt?: Maybe<Scalars['ISODateTime']>;
};

export type PatientAddress = {
  __typename?: 'PatientAddress';
  apartmentNumber?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISODateTime'];
  houseNumber?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  street?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type PatientAddressInput = {
  apartmentNumber?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  houseNumber?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type PatientEducatorInput = {
  diagnosisTherapyPlan?: InputMaybe<Scalars['String']>;
  generalAim?: InputMaybe<Scalars['String']>;
  generalInfo?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  medicalHistory?: InputMaybe<Scalars['String']>;
  otherNotes?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['Int']>;
};

export type PatientEducatorType = {
  __typename?: 'PatientEducatorType';
  diagnosisTherapyPlan?: Maybe<Scalars['String']>;
  generalAim?: Maybe<Scalars['String']>;
  generalInfo?: Maybe<Scalars['String']>;
  medicalHistory?: Maybe<Scalars['String']>;
  otherNotes?: Maybe<Scalars['String']>;
  pk: Scalars['Int'];
};

export type PatientInput = {
  address?: InputMaybe<PatientAddressInput>;
  attachments?: InputMaybe<AttachmentsGroupInput>;
  billingInfo?: InputMaybe<BillingInfoInput>;
  birthday?: InputMaybe<Scalars['ISODateTime']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['PhoneNumber']>;
  practiceId?: InputMaybe<Scalars['Int']>;
  therapistId?: InputMaybe<Scalars['Int']>;
  therapistIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type PatientPagination = {
  __typename?: 'PatientPagination';
  count: Scalars['Int'];
  data: Array<Patient>;
  pageTotals: Scalars['JSON'];
  totals: Scalars['JSON'];
};

export type PatientPsychoTherapy = {
  __typename?: 'PatientPsychoTherapy';
  diagnosis?: Maybe<Scalars['String']>;
  expectations?: Maybe<Scalars['String']>;
  medicalHistory?: Maybe<Scalars['String']>;
  occupation?: Maybe<Scalars['String']>;
  otherNotes?: Maybe<Scalars['String']>;
  pk: Scalars['Int'];
  triggerForTherapy?: Maybe<Scalars['String']>;
};

export type PatientPsychotherapyInput = {
  diagnosis?: InputMaybe<Scalars['String']>;
  expectations?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  medicalHistory?: InputMaybe<Scalars['String']>;
  occupation?: InputMaybe<Scalars['String']>;
  otherNotes?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['Int']>;
  triggerForTherapy?: InputMaybe<Scalars['String']>;
};

export type PatientSiInput = {
  diagnosisTherapyPlan?: InputMaybe<Scalars['String']>;
  generalAim?: InputMaybe<Scalars['String']>;
  generalInfo?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  medicalHistory?: InputMaybe<Scalars['String']>;
  otherNotes?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['Int']>;
  sensoricDiet?: InputMaybe<Scalars['String']>;
  siDiagnosis?: InputMaybe<Scalars['String']>;
  therapyHints?: InputMaybe<Scalars['String']>;
};

export type PatientSiType = {
  __typename?: 'PatientSIType';
  diagnosisTherapyPlan?: Maybe<Scalars['String']>;
  generalAim?: Maybe<Scalars['String']>;
  generalInfo?: Maybe<Scalars['String']>;
  medicalHistory?: Maybe<Scalars['String']>;
  otherNotes?: Maybe<Scalars['String']>;
  pk: Scalars['Int'];
  sensoricDiet?: Maybe<Scalars['String']>;
  siDiagnosis?: Maybe<Scalars['String']>;
  therapyHints?: Maybe<Scalars['String']>;
};

export type PatientSpeechTherapy = {
  __typename?: 'PatientSpeechTherapy';
  articulationExamination?: Maybe<Scalars['String']>;
  diagnosisTherapyPlan?: Maybe<Scalars['String']>;
  generalAim?: Maybe<Scalars['String']>;
  generalInfo?: Maybe<Scalars['String']>;
  medicalHistory?: Maybe<Scalars['String']>;
  otherNotes?: Maybe<Scalars['String']>;
  pk: Scalars['Int'];
  speechExamination?: Maybe<Scalars['String']>;
};

export type PatientSpeechTherapyInput = {
  articulationExamination?: InputMaybe<Scalars['String']>;
  diagnosisTherapyPlan?: InputMaybe<Scalars['String']>;
  generalAim?: InputMaybe<Scalars['String']>;
  generalInfo?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  medicalHistory?: InputMaybe<Scalars['String']>;
  otherNotes?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['Int']>;
  speechExamination?: InputMaybe<Scalars['String']>;
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  isEnabled: Scalars['Boolean'];
  method: EventPaymentMethods;
};

export type PaymentMethodInput = {
  isEnabled: Scalars['Boolean'];
  method: EventPaymentMethods;
};

export type Practice = {
  __typename?: 'Practice';
  billingAddress: Address;
  billingInfo?: Maybe<BillingInfo>;
  contactDetails: ContactDetails;
  id: Scalars['Int'];
  invoiceConfig?: Maybe<InvoiceConfig>;
  invoicingEnabled: Scalars['Boolean'];
  logo?: Maybe<PracticeLogo>;
  name: Scalars['String'];
  practiceBranches: Array<PracticeBranch>;
  restrictedAccess: Scalars['Boolean'];
  servicesPerTherapist: Scalars['Boolean'];
  shortName: Scalars['String'];
};

export type PracticeAddress = {
  city: Scalars['String'];
  houseNumber: Scalars['String'];
  street: Scalars['String'];
  zipCode: Scalars['String'];
};

export type PracticeBranch = {
  __typename?: 'PracticeBranch';
  branchAddress?: Maybe<Address>;
  contactDetails?: Maybe<ContactDetails>;
  id: Scalars['Int'];
  name: Scalars['String'];
  shortName: Scalars['String'];
};

/** PracticeData(registration_config: Optional[registration.types.OnlineRegistrationConfigType], practice: Optional[practices.types.Practice], services: list[services.types.ServiceType], therapists: list[practices.types.Employee], branches: list[practices.types.PracticeBranch]) */
export type PracticeData = {
  __typename?: 'PracticeData';
  branches: Array<PracticeBranch>;
  practice?: Maybe<Practice>;
  registrationConfig?: Maybe<OnlineRegistrationConfigType>;
  services: Array<ServiceType>;
  therapists: Array<Employee>;
};

export type PracticeExpense = {
  __typename?: 'PracticeExpense';
  amount: Scalars['Float'];
  author?: Maybe<Employee>;
  date: Scalars['Date'];
  id: Scalars['Int'];
  name: Scalars['String'];
  note: Scalars['String'];
  practice: Practice;
  recurring?: Maybe<RecurringExpense>;
};

export type PracticeExpensePagination = {
  __typename?: 'PracticeExpensePagination';
  count: Scalars['Int'];
  data: Array<PracticeExpense>;
  pageTotals: Scalars['JSON'];
  totals: Scalars['JSON'];
};

export type PracticeIncome = {
  __typename?: 'PracticeIncome';
  amount: Scalars['Float'];
  date: Scalars['ISODateTime'];
  id: Scalars['Int'];
  paidOn?: Maybe<Scalars['ISODate']>;
  participants: Array<EventParticipants>;
  paymentMethod?: Maybe<Scalars['String']>;
  serviceName: Scalars['String'];
  services: Array<ServiceType>;
  status: EventPayment;
  therapists: Array<Employee>;
};

export type PracticeIncomePagination = {
  __typename?: 'PracticeIncomePagination';
  count: Scalars['Int'];
  data: Array<PracticeIncome>;
  pageTotals: Scalars['JSON'];
  totals: Scalars['JSON'];
};

export type PracticeLogo = {
  __typename?: 'PracticeLogo';
  url: Scalars['String'];
};

export type Przelewy24Config = {
  __typename?: 'Przelewy24Config';
  crc: Scalars['String'];
  invitationLink: Scalars['String'];
  isEnabled: Scalars['Boolean'];
  merchantId: Scalars['Int'];
  practice: Practice;
};

export type Przelewy24ConfigInput = {
  bankAccount: Scalars['String'];
  businessType: Scalars['Int'];
  companyAddress: Scalars['String'];
  companyCity: Scalars['String'];
  companyName: Scalars['String'];
  companyPostalCode: Scalars['String'];
  contactAddress: Scalars['String'];
  contactCity: Scalars['String'];
  contactPersonEmail: Scalars['String'];
  contactPersonName: Scalars['String'];
  contactPersonPhone: Scalars['String'];
  contactPostalCode: Scalars['String'];
  country: Scalars['String'];
  email: Scalars['String'];
  invoiceEmail: Scalars['String'];
  krs?: InputMaybe<Scalars['String']>;
  nip?: InputMaybe<Scalars['String']>;
  pesel?: InputMaybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  regon?: InputMaybe<Scalars['String']>;
  servicesDescription: Scalars['String'];
  technicalPersonEmail: Scalars['String'];
  technicalPersonName: Scalars['String'];
  technicalPersonPhone: Scalars['String'];
};

export type Przelewy24Order = {
  __typename?: 'Przelewy24Order';
  amount: Scalars['Int'];
  category: Scalars['String'];
  createdAt: Scalars['String'];
  currency: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['Int'];
  merchantId: Scalars['Int'];
  orderId?: Maybe<Scalars['String']>;
  posId: Scalars['Int'];
  practiceId?: Maybe<Scalars['Int']>;
  sessionId: Scalars['String'];
  status: Scalars['String'];
  token?: Maybe<Scalars['String']>;
  updatedAt: Scalars['String'];
};

export type Przelewy24OrderInput = {
  amount: Scalars['Int'];
  category: Scalars['String'];
  description: Scalars['String'];
  smsPacketSize?: InputMaybe<Scalars['Int']>;
};

export type Przelewy24OrderRegister = {
  __typename?: 'Przelewy24OrderRegister';
  link: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  appPaymentConfig?: Maybe<AppPaymentConfig>;
  billingInfo: Array<BillingInfo>;
  billingInfoDetails: BillingInfo;
  billingInfoFromVatId: BillingInfoFromVatId;
  collidingEvents: Array<EventOutput>;
  coupleMeetingsHeld: Scalars['Int'];
  couplePaginatedQuery: CouplePagination;
  coupleUpcomingEvents: Array<Event>;
  employee: Employee;
  employeeInvitationInfo: EmployeeInvitationInfo;
  employeeStatistics: EmployeeStatistics;
  employees: Array<Employee>;
  event?: Maybe<Event>;
  events: Array<Event>;
  eventsWithSorting: Array<Event>;
  favoriteTherapists: Array<FavoriteTherapist>;
  getAvailablePractices: Array<Practice>;
  getCurrentPracticeDetails: Practice;
  getDaysOccupancy: Array<DayOccupancy>;
  getEmployeeByUserId?: Maybe<Employee>;
  getEmployeeList: Array<Employee>;
  getGdprConfig: GdprConfigType;
  getGdprDocument: GdprDocumentType;
  getGuardians: Array<Guardian>;
  getInvoiceEvents: InvoiceEvents;
  getMeetingRequest: MeetingRequestType;
  getMeetingRequests: Array<MeetingRequestType>;
  getOnlineRegistrationConfigByPracticeId: OnlineRegistrationConfigType;
  getOnlineRegistrationConfigBySlug: OnlineRegistrationConfigType;
  getPaginatedMeetingRequests: MeetingRequestTypePagination;
  getPracticeData: PracticeData;
  getRoomsList: Array<RoomListEntry>;
  /**
   * get free time slots in practice to register new events
   *
   * Parameters:
   * one_slot: gets you one earliest slot per day per therapist
   * earliest_slot_per_therapist: gets you only one, earliest slot per therapist from given date range
   * sort_and_limit: sorts fetched slots by their date from earliest to latest and limits them by provided number
   * show_empty_dates: if True in response there will be dates with empty slots when in given date therapist wont be able to be booked
   * search_engine: if True get_time_slots dont respect online registration config and available_in_online_registration fields
   * custom_break_between_meetings: takes priority over declared break between meetings value in config or search_engine presets (value in minutes)
   */
  getTimeSlots: Array<AvailableSlots>;
  getUserAvatar?: Maybe<Avatar>;
  holidayReasons: Array<HolidayReasonType>;
  incomeStatistics: IncomeStatistics;
  invoice: Invoice;
  invoiceConfig?: Maybe<InvoiceConfig>;
  invoices: InvoicePagination;
  makeMigrate: Scalars['Boolean'];
  paginatedEmployees: EmployeePagination;
  paginatedEvents: EventPagination;
  paginatedExpenses: PracticeExpensePagination;
  paginatedHolidays: HolidayTypePagination;
  paginatedIncomes: PracticeIncomePagination;
  paginatedPatients: PatientPagination;
  paginatedRequestConsiderations: RequestConsiderationTypePagination;
  paginatedRooms: RoomPagination;
  paginatedSentSmss: SentSmsPagination;
  paginatedServices: ServiceTypePagination;
  paginatedServicesBreakdown: ServiceBreakdownTypePagination;
  patientDetails: Patient;
  patientMeetingsHeld: Scalars['Int'];
  patientUpcomingEvents: Array<Event>;
  patientsPerService: PatientPagination;
  practicePaymentMethods: Array<PaymentMethod>;
  przelewy24Config?: Maybe<Przelewy24Config>;
  przelewy24Order?: Maybe<Przelewy24Order>;
  serviceStatistics: ServiceStatistics;
  servicesList: Array<ServiceListEntry>;
  smsConfig: SmsConfig;
  smsPackets: Array<SmsPacket>;
  smsTemplates: SmsTemplates;
  testOldConnection: Scalars['Boolean'];
  workTimePreset: Array<WorkTimePresetType>;
  workTimePresets: Array<WorkTimePresetType>;
};


export type QueryBillingInfoDetailsArgs = {
  id: Scalars['Int'];
};


export type QueryBillingInfoFromVatIdArgs = {
  vatId?: InputMaybe<Scalars['String']>;
};


export type QueryCollidingEventsArgs = {
  after: Scalars['ISODateTime'];
  before: Scalars['ISODateTime'];
};


export type QueryCoupleMeetingsHeldArgs = {
  coupleId: Scalars['Int'];
};


export type QueryCouplePaginatedQueryArgs = {
  assignedTo?: InputMaybe<Array<Scalars['Int']>>;
  limit: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  page: Scalars['Int'];
  searchPhrase?: InputMaybe<Scalars['String']>;
  showDeactivated?: Scalars['Boolean'];
  therapistId: Scalars['Int'];
};


export type QueryCoupleUpcomingEventsArgs = {
  after: Scalars['ISODateTime'];
  coupleId: Scalars['Int'];
};


export type QueryEmployeeArgs = {
  id: Scalars['Int'];
};


export type QueryEmployeeInvitationInfoArgs = {
  invitationUuid: Scalars['String'];
};


export type QueryEmployeeStatisticsArgs = {
  after: Scalars['ISODateTime'];
  before: Scalars['ISODateTime'];
  employeeId: Scalars['Int'];
  practiceBranchId?: InputMaybe<Scalars['Int']>;
};


export type QueryEmployeesArgs = {
  ids?: Array<Scalars['Int']>;
};


export type QueryEventArgs = {
  eventId: Scalars['Int'];
};


export type QueryEventsArgs = {
  after: Scalars['ISODateTime'];
  before: Scalars['ISODateTime'];
  coupleId?: InputMaybe<Scalars['Int']>;
  employeeIds?: Array<Scalars['Int']>;
  hasInvoice?: InputMaybe<Scalars['Boolean']>;
  heldMeetings?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<OrderBy>;
  paid?: InputMaybe<Scalars['Boolean']>;
  patientId?: InputMaybe<Scalars['Int']>;
  practiceBranchId?: InputMaybe<Scalars['Int']>;
  serviceId?: InputMaybe<Scalars['Int']>;
};


export type QueryEventsWithSortingArgs = {
  after: Scalars['ISODateTime'];
  before: Scalars['ISODateTime'];
  coupleId?: InputMaybe<Scalars['Int']>;
  employeeIds?: Array<Scalars['Int']>;
  hasInvoice?: InputMaybe<Scalars['Boolean']>;
  heldMeetings?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<OrderBy>;
  paid?: InputMaybe<Scalars['Boolean']>;
  patientId?: InputMaybe<Scalars['Int']>;
  practiceBranchId?: InputMaybe<Scalars['Int']>;
  serviceId?: InputMaybe<Scalars['Int']>;
};


export type QueryFavoriteTherapistsArgs = {
  employeeId?: InputMaybe<Scalars['Int']>;
};


export type QueryGetDaysOccupancyArgs = {
  after: Scalars['ISODateTime'];
  before: Scalars['ISODateTime'];
  employeeIds?: Array<Scalars['Int']>;
  practiceBranchId: Scalars['Int'];
};


export type QueryGetEmployeeByUserIdArgs = {
  userId: Scalars['String'];
};


export type QueryGetEmployeeListArgs = {
  ids?: Array<Scalars['Int']>;
};


export type QueryGetGdprDocumentArgs = {
  token: Scalars['String'];
};


export type QueryGetGuardiansArgs = {
  patientId: Scalars['Int'];
};


export type QueryGetInvoiceEventsArgs = {
  after: Scalars['ISODate'];
  before: Scalars['ISODate'];
};


export type QueryGetMeetingRequestArgs = {
  meetingRequestId: Scalars['Int'];
};


export type QueryGetOnlineRegistrationConfigBySlugArgs = {
  practiceSlug: Scalars['String'];
};


export type QueryGetPaginatedMeetingRequestsArgs = {
  after: Scalars['ISODateTime'];
  before: Scalars['ISODateTime'];
  limit: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  page: Scalars['Int'];
  patients?: InputMaybe<Array<Scalars['String']>>;
  results?: InputMaybe<Array<MeetingRequestResult>>;
  services?: InputMaybe<Array<Scalars['Int']>>;
  therapists?: InputMaybe<Array<Scalars['Int']>>;
};


export type QueryGetPracticeDataArgs = {
  practiceSlug: Scalars['String'];
};


export type QueryGetRoomsListArgs = {
  date?: InputMaybe<Scalars['DateTime']>;
  serviceId?: InputMaybe<Scalars['Int']>;
};


export type QueryGetTimeSlotsArgs = {
  customBreakBetweenMeetings?: InputMaybe<Scalars['Int']>;
  earliestSlotPerTherapist?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  oneSlot?: InputMaybe<Scalars['Boolean']>;
  practiceBranchId?: InputMaybe<Scalars['Int']>;
  practiceId: Scalars['Int'];
  searchEngine?: InputMaybe<Scalars['Boolean']>;
  serviceIds?: InputMaybe<Array<Scalars['Int']>>;
  showEmptyDates?: InputMaybe<Scalars['Boolean']>;
  sortAndLimit?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['DateTime'];
  therapistIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type QueryHolidayReasonsArgs = {
  holidayKind?: InputMaybe<HolidayKindEnum>;
};


export type QueryIncomeStatisticsArgs = {
  after: Scalars['ISODateTime'];
  before: Scalars['ISODateTime'];
  practiceBranchId?: InputMaybe<Scalars['Int']>;
};


export type QueryInvoiceArgs = {
  invoiceId: Scalars['Int'];
};


export type QueryInvoicesArgs = {
  after: Scalars['ISODate'];
  before: Scalars['ISODate'];
  limit: Scalars['Int'];
  orderBy?: InputMaybe<Array<OrderBy>>;
  page: Scalars['Int'];
  practiceBranchId: Scalars['Int'];
  searchPhrase?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<ExternalInvoiceStatus>>;
  tab: InvoiceTab;
};


export type QueryMakeMigrateArgs = {
  legacyPracticeName?: InputMaybe<Scalars['String']>;
  newPracticeBranchId: Scalars['Int'];
  newPracticeId: Scalars['Int'];
  skipEvents?: InputMaybe<Scalars['Boolean']>;
  therapistId?: InputMaybe<Scalars['Int']>;
};


export type QueryPaginatedEmployeesArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
  limit: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  page: Scalars['Int'];
  practiceBranchId: Scalars['Int'];
  role?: InputMaybe<Scalars['String']>;
  searchPhrase?: InputMaybe<Scalars['String']>;
};


export type QueryPaginatedEventsArgs = {
  after: Scalars['ISODateTime'];
  before: Scalars['ISODateTime'];
  coupleId?: InputMaybe<Scalars['Int']>;
  employeeIds?: Array<Scalars['Int']>;
  limit: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  page: Scalars['Int'];
  patientId?: InputMaybe<Scalars['Int']>;
  serviceId?: InputMaybe<Scalars['Int']>;
};


export type QueryPaginatedExpensesArgs = {
  addedBy?: InputMaybe<Array<Scalars['Int']>>;
  after: Scalars['Date'];
  amountMax?: InputMaybe<Scalars['Float']>;
  amountMin?: InputMaybe<Scalars['Float']>;
  before: Scalars['Date'];
  limit: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  page: Scalars['Int'];
  practiceBranch?: InputMaybe<Scalars['Int']>;
};


export type QueryPaginatedHolidaysArgs = {
  after: Scalars['ISODateTime'];
  before: Scalars['ISODateTime'];
  employees?: InputMaybe<Array<Scalars['Int']>>;
  holidayKinds?: InputMaybe<Array<HolidayKindEnum>>;
  limit: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  page: Scalars['Int'];
  practiceBranch?: InputMaybe<Scalars['Int']>;
};


export type QueryPaginatedIncomesArgs = {
  after: Scalars['ISODateTime'];
  amountMax?: InputMaybe<Scalars['Float']>;
  amountMin?: InputMaybe<Scalars['Float']>;
  before: Scalars['ISODateTime'];
  limit: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  page: Scalars['Int'];
  patients?: InputMaybe<Array<Scalars['Int']>>;
  paymentMethods?: InputMaybe<Array<Scalars['String']>>;
  practiceBranch?: InputMaybe<Scalars['Int']>;
  services?: InputMaybe<Array<Scalars['Int']>>;
  statuses?: InputMaybe<Array<EventPayment>>;
  therapists?: InputMaybe<Array<Scalars['Int']>>;
};


export type QueryPaginatedPatientsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  assignedTo?: InputMaybe<Array<Scalars['Int']>>;
  limit: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  page: Scalars['Int'];
  searchPhrase?: InputMaybe<Scalars['String']>;
};


export type QueryPaginatedRequestConsiderationsArgs = {
  after: Scalars['DateTime'];
  before: Scalars['DateTime'];
  considerationType?: InputMaybe<ConsiderationTypeEnum>;
  consideredBy?: InputMaybe<Array<Scalars['Int']>>;
  limit: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  page: Scalars['Int'];
  statuses?: InputMaybe<Array<ConfirmationStatusEnum>>;
};


export type QueryPaginatedRoomsArgs = {
  limit: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  page: Scalars['Int'];
};


export type QueryPaginatedSentSmssArgs = {
  after: Scalars['ISODateTime'];
  before: Scalars['ISODateTime'];
  limit?: InputMaybe<Scalars['Int']>;
  locationId?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  page: Scalars['Int'];
  searchPhrase?: InputMaybe<Scalars['String']>;
};


export type QueryPaginatedServicesArgs = {
  assignedTo?: InputMaybe<Array<Scalars['Int']>>;
  durations?: InputMaybe<FloatRangeInput>;
  limit: Scalars['Int'];
  names?: InputMaybe<Array<Scalars['String']>>;
  online?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<OrderBy>;
  page: Scalars['Int'];
  practiceBranchId: Scalars['Int'];
  prices?: InputMaybe<FloatRangeInput>;
  searchPhrase?: InputMaybe<Scalars['String']>;
};


export type QueryPaginatedServicesBreakdownArgs = {
  after: Scalars['ISODateTime'];
  before: Scalars['ISODateTime'];
  employeeId: Scalars['Int'];
  limit: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  page: Scalars['Int'];
  practiceBranchId?: InputMaybe<Scalars['Int']>;
};


export type QueryPatientDetailsArgs = {
  patientId: Scalars['Int'];
};


export type QueryPatientMeetingsHeldArgs = {
  patientId: Scalars['Int'];
};


export type QueryPatientUpcomingEventsArgs = {
  after: Scalars['ISODateTime'];
  patientId: Scalars['Int'];
};


export type QueryPatientsPerServiceArgs = {
  employeeId: Scalars['Int'];
  practiceBranchId?: InputMaybe<Scalars['Int']>;
  serviceId: Scalars['Int'];
};


export type QueryPracticePaymentMethodsArgs = {
  enabledFilter: Scalars['Boolean'];
  practiceId: Scalars['Int'];
};


export type QueryPrzelewy24OrderArgs = {
  sessionId: Scalars['String'];
};


export type QueryServiceStatisticsArgs = {
  after: Scalars['ISODateTime'];
  before: Scalars['ISODateTime'];
  practiceBranchId?: InputMaybe<Scalars['Int']>;
};


export type QueryServicesListArgs = {
  orderBy?: InputMaybe<OrderBy>;
};


export type QuerySmsTemplatesArgs = {
  language?: InputMaybe<SmsTemplateLanguageEnum>;
  templateType: SmsTemplateTypeEnum;
};


export type QueryWorkTimePresetArgs = {
  presetId: Scalars['Int'];
};


export type QueryWorkTimePresetsArgs = {
  employeeIds: Array<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type RecurringExpense = {
  __typename?: 'RecurringExpense';
  recurringPeriod: RecurringExpenseEnum;
  startDate: Scalars['Date'];
};

/** An enumeration. */
export enum RecurringExpenseEnum {
  OneMonth = 'ONE_MONTH',
  OneWeek = 'ONE_WEEK',
  TwoWeeks = 'TWO_WEEKS'
}

export type RecurringExpenseInput = {
  recurringPeriod?: InputMaybe<RecurringExpenseEnum>;
};

/** An enumeration. */
export enum ReminderSendingTimeEnum {
  FixedPeriodBefore = 'FIXED_PERIOD_BEFORE',
  FixedTimeBefore = 'FIXED_TIME_BEFORE'
}

export type ReportResult = {
  __typename?: 'ReportResult';
  url: Scalars['String'];
};

export type RequestConsiderationInput = {
  considerationNote?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  requestType: Scalars['Int'];
  status?: InputMaybe<ConfirmationStatusEnum>;
};

export type RequestConsiderationType = {
  __typename?: 'RequestConsiderationType';
  considerationNote: Scalars['String'];
  consideredAt?: Maybe<Scalars['ISODateTime']>;
  consideredBy?: Maybe<Employee>;
  contentObject: HolidayType;
  status: ConfirmationStatusEnum;
};

export type RequestConsiderationTypePagination = {
  __typename?: 'RequestConsiderationTypePagination';
  count: Scalars['Int'];
  data: Array<RequestConsiderationType>;
  pageTotals: Scalars['JSON'];
  totals: Scalars['JSON'];
};

export type Role = {
  __typename?: 'Role';
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type Room = {
  __typename?: 'Room';
  availableOnline: Scalars['Boolean'];
  comments?: Maybe<Scalars['String']>;
  excludedServices: Array<ServiceType>;
  id: Scalars['Int'];
  name: Scalars['String'];
  practiceBranch: PracticeBranch;
  preferredBy: Array<Employee>;
  slug: Scalars['String'];
};

export type RoomInput = {
  availableOnline: Scalars['Boolean'];
  comments?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type RoomInputWithPracticeBranch = {
  availableOnline: Scalars['Boolean'];
  comments?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  practiceBranch: Scalars['Int'];
  slug: Scalars['String'];
};

export type RoomListEntry = {
  __typename?: 'RoomListEntry';
  availableOnline: Scalars['Boolean'];
  id: Scalars['Int'];
  name: Scalars['String'];
  preferredBy: Array<Scalars['Int']>;
  slug: Scalars['String'];
};

export type RoomPagination = {
  __typename?: 'RoomPagination';
  count: Scalars['Int'];
  data: Array<Room>;
  pageTotals: Scalars['JSON'];
  totals: Scalars['JSON'];
};

export type SmsBranchTemplate = {
  __typename?: 'SMSBranchTemplate';
  practiceBranch: PracticeBranch;
  text: Scalars['String'];
};

export type SmsConfig = {
  __typename?: 'SMSConfig';
  active: Scalars['Boolean'];
  customQuota: Scalars['Int'];
  daysBefore: DaysBeforeEnum;
  hoursBefore: HoursBeforeEnum;
  meetingCanceledActive: Scalars['Boolean'];
  newMeetingActive: Scalars['Boolean'];
  nonTherapistNotifyingTemplates: Array<Scalars['String']>;
  perPeriodQuota: Scalars['Int'];
  quota: Scalars['Int'];
  reminderPerBranchTemplate: Scalars['Boolean'];
  reminderSendingTime: ReminderSendingTimeEnum;
  sendingTime: Scalars['ISOTime'];
  timeChangeActive: Scalars['Boolean'];
};

export type SmsConfigPartialInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  daysBefore?: InputMaybe<DaysBeforeEnum>;
  hoursBefore?: InputMaybe<HoursBeforeEnum>;
  meetingCanceledActive?: InputMaybe<Scalars['Boolean']>;
  newMeetingActive?: InputMaybe<Scalars['Boolean']>;
  reminderPerBranchTemplate?: InputMaybe<Scalars['Boolean']>;
  reminderSendingTime?: InputMaybe<ReminderSendingTimeEnum>;
  sendingTime?: InputMaybe<Scalars['ISOTime']>;
  therapistNotifyingSettings?: InputMaybe<TherapistNotifyingSettings>;
  timeChangeActive?: InputMaybe<Scalars['Boolean']>;
};

export type SmsPacket = {
  __typename?: 'SMSPacket';
  price: Scalars['Float'];
  smsNumber: Scalars['Int'];
  tax: Scalars['Float'];
};

export type SmsTemplate = {
  __typename?: 'SMSTemplate';
  text: Scalars['String'];
};

export type SmsTemplateError = {
  __typename?: 'SMSTemplateError';
  errors: Array<Scalars['String']>;
};

export type SmsTemplateInput = {
  language: SmsTemplateLanguageEnum;
  practiceBranchId?: InputMaybe<Scalars['Int']>;
  templateType?: SmsTemplateTypeEnum;
  text: Scalars['String'];
};

/** An enumeration. */
export enum SmsTemplateLanguageEnum {
  En = 'EN',
  Pl = 'PL'
}

export type SmsTemplateOrError = SmsTemplate | SmsTemplateError;

/** An enumeration. */
export enum SmsTemplateTypeEnum {
  MeetingCanceled = 'MEETING_CANCELED',
  MeetingNew = 'MEETING_NEW',
  MeetingReminder = 'MEETING_REMINDER',
  MeetingRescheduled = 'MEETING_RESCHEDULED'
}

export type SmsTemplates = {
  __typename?: 'SMSTemplates';
  branchesTemplates: Array<SmsBranchTemplate>;
  practiceTemplateText: Scalars['String'];
};

export type SentSms = {
  __typename?: 'SentSMS';
  details?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  patient?: Maybe<Patient>;
  phoneNumber: Scalars['PhoneNumber'];
  quota: Scalars['Int'];
  sentAt: Scalars['ISODateTime'];
  status: SentSmsStatus;
  text: Scalars['String'];
};

export type SentSmsPagination = {
  __typename?: 'SentSMSPagination';
  count: Scalars['Int'];
  data: Array<SentSms>;
  pageTotals: Scalars['JSON'];
  totals: Scalars['JSON'];
};

/** An enumeration. */
export enum SentSmsStatus {
  Expired = 'EXPIRED',
  Failure = 'FAILURE',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export type ServiceBreakdownType = {
  __typename?: 'ServiceBreakdownType';
  amount: Scalars['Float'];
  count: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['String'];
  time: Scalars['TimeDeltaMinutes'];
};

export type ServiceBreakdownTypePagination = {
  __typename?: 'ServiceBreakdownTypePagination';
  count: Scalars['Int'];
  data: Array<ServiceBreakdownType>;
  pageTotals: Scalars['JSON'];
  totals: Scalars['JSON'];
};

export type ServiceInput = {
  assignedTo: Array<Scalars['Int']>;
  availableInOnlineRegistration?: InputMaybe<Scalars['Boolean']>;
  availableOnline?: InputMaybe<Scalars['Boolean']>;
  comments?: InputMaybe<Scalars['String']>;
  duration: Scalars['TimeDeltaMinutes'];
  name: Scalars['String'];
  price: Scalars['Float'];
};

export type ServiceListEntry = {
  __typename?: 'ServiceListEntry';
  assignedTo: Array<Scalars['Int']>;
  availableInOnlineRegistration: Scalars['Boolean'];
  duration: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  price: Scalars['Float'];
};

export type ServiceStatistics = {
  __typename?: 'ServiceStatistics';
  meetings: MeetingStatistics;
  previousPeriodDates: DatePeriod;
  services: Array<ComparisonItem>;
};

export type ServiceType = {
  __typename?: 'ServiceType';
  assignedTo: Array<Employee>;
  availableInOnlineRegistration: Scalars['Boolean'];
  availableOnline: Scalars['Boolean'];
  comments?: Maybe<Scalars['String']>;
  duration: Scalars['TimeDeltaMinutes'];
  id: Scalars['Int'];
  name: Scalars['String'];
  practiceBranch: PracticeBranch;
  price: Scalars['Float'];
};

export type ServiceTypePagination = {
  __typename?: 'ServiceTypePagination';
  count: Scalars['Int'];
  data: Array<ServiceType>;
  pageTotals: Scalars['JSON'];
  totals: Scalars['JSON'];
};

export type ServicesBreakdown = {
  __typename?: 'ServicesBreakdown';
  services: Array<ServicesBreakdownItem>;
  totalPrice: Scalars['Float'];
  totalTime: Scalars['TimeDeltaMinutes'];
};

export type ServicesBreakdownItem = {
  __typename?: 'ServicesBreakdownItem';
  id: Scalars['Int'];
  meetingsDurationMinutes: Scalars['TimeDeltaMinutes'];
  meetingsHeld: Scalars['Int'];
  meetingsIncome: Scalars['Float'];
  name: Scalars['String'];
};

export type SetPracticeLogoInput = {
  file: Scalars['Upload'];
};

export type SmsPacketPurchaseInput = {
  smsNumber: Scalars['Int'];
};

export type TherapistNotifyingSettings = {
  meetingCanceled?: InputMaybe<Scalars['Boolean']>;
  meetingNew?: InputMaybe<Scalars['Boolean']>;
  meetingReminder?: InputMaybe<Scalars['Boolean']>;
  meetingRescheduled?: InputMaybe<Scalars['Boolean']>;
};

/** UpsertOnlineRegistrationConfig(practice_slug: str, is_registration_enabled: bool, minutes_between_meetings: int, privacy_policy_url: Optional[str], terms_of_use_url: Optional[str], minimum_preceding_minutes: int, maximum_preceding_minutes: int, round_slot_time_to: int, is_precise_search: bool, exact_slot_proposal: int) */
export type UpsertOnlineRegistrationConfig = {
  exactSlotProposal: Scalars['Int'];
  isPreciseSearch: Scalars['Boolean'];
  isRegistrationEnabled: Scalars['Boolean'];
  maximumPrecedingMinutes: Scalars['Int'];
  minimumPrecedingMinutes: Scalars['Int'];
  minutesBetweenMeetings: Scalars['Int'];
  practiceSlug: Scalars['String'];
  privacyPolicyUrl?: InputMaybe<Scalars['String']>;
  roundSlotTimeTo: Scalars['Int'];
  termsOfUseUrl?: InputMaybe<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  avatar?: Maybe<Avatar>;
  dateJoined: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  fullName: Scalars['String'];
  id: Scalars['String'];
  lastName: Scalars['String'];
  lastSeen?: Maybe<Scalars['DateTime']>;
};

export type UserInput = {
  email?: InputMaybe<Scalars['String']>;
  employeePhoneNumber: Scalars['PhoneNumber'];
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
};

export type WebhookType = {
  __typename?: 'WebhookType';
  accountId: Scalars['Int'];
  active: Scalars['Boolean'];
  apiToken: Scalars['String'];
  id: Scalars['Int'];
  kind: Scalars['String'];
  url: Scalars['String'];
};

export type WebhooksType = {
  __typename?: 'WebhooksType';
  webhooks: Array<WebhookType>;
};

export type WorkDayType = {
  __typename?: 'WorkDayType';
  day: Scalars['Int'];
  workTime: WorkTimeType;
};

export type WorkTimeConfigInput = {
  automaticEventCancellationTime?: InputMaybe<CancellationTimeEum>;
  holidayConsiderationRequired?: InputMaybe<Scalars['Boolean']>;
};

export type WorkTimeConfigType = {
  __typename?: 'WorkTimeConfigType';
  automaticEventCancellationTime: CancellationTimeEum;
  holidayConsiderationRequired?: Maybe<Scalars['Boolean']>;
};

export type WorkTimeExceptionInput = {
  dates: Array<Scalars['ISODate']>;
  endDate?: InputMaybe<Scalars['Date']>;
  presetId: Scalars['Int'];
  startDate?: InputMaybe<Scalars['Date']>;
  workTimes: Array<WorkTimeInput>;
};

export type WorkTimeExceptionType = {
  __typename?: 'WorkTimeExceptionType';
  dates: Array<Scalars['ISODate']>;
  presetId: Scalars['Int'];
  startDate: Scalars['Time'];
  workTimes: Array<WorkTimeType>;
};

export type WorkTimeInput = {
  day: Scalars['Int'];
  endTime: Scalars['Time'];
  startTime: Scalars['Time'];
};

export type WorkTimePresetInput = {
  employeeId: Scalars['Int'];
  endDate?: InputMaybe<Scalars['ISODate']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['ISODate']>;
  workTimes?: InputMaybe<Array<WorkTimeInput>>;
};

export type WorkTimePresetType = {
  __typename?: 'WorkTimePresetType';
  employee: Employee;
  endDate?: Maybe<Scalars['Date']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  startDate?: Maybe<Scalars['Date']>;
  workDays: Array<WorkDayType>;
};

export type WorkTimeType = {
  __typename?: 'WorkTimeType';
  endTime: Scalars['Time'];
  startTime: Scalars['Time'];
};

export type DeleteAttachmentsMutationVariables = Exact<{
  attachmentIds: Array<Scalars['Int']>;
}>;


export type DeleteAttachmentsMutation = { __typename?: 'Mutation', deleteAttachments: number };

export type BillingInfoFragmentFragment = { __typename?: 'BillingInfo', id: number, name?: string | null, taxNo?: string | null, street?: string | null, postCode?: string | null, city?: string | null, country?: string | null, email?: string | null, phone?: any | null, bank?: string | null, bankAccount?: string | null };

export type AddBillingInfoMutationVariables = Exact<{
  model: Scalars['String'];
  patientId?: InputMaybe<Scalars['Int']>;
  payload: BillingInfoInput;
}>;


export type AddBillingInfoMutation = { __typename?: 'Mutation', addBillingInfo: { __typename?: 'BillingInfo', id: number } };

export type EditBillingInfoMutationVariables = Exact<{
  id: Scalars['Int'];
  payload: BillingInfoInput;
}>;


export type EditBillingInfoMutation = { __typename?: 'Mutation', editBillingInfo: { __typename?: 'BillingInfo', id: number, name?: string | null, taxNo?: string | null, street?: string | null, postCode?: string | null, city?: string | null, country?: string | null, email?: string | null, phone?: any | null, bank?: string | null, bankAccount?: string | null } };

export type RemoveBillingInfosMutationVariables = Exact<{
  id: Array<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['ISODateTime']>;
}>;


export type RemoveBillingInfosMutation = { __typename?: 'Mutation', removeBillingInfo: boolean };

export type GetBillingInfoDetailsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetBillingInfoDetailsQuery = { __typename?: 'Query', billingInfoDetails: { __typename?: 'BillingInfo', id: number, name?: string | null, taxNo?: string | null, street?: string | null, postCode?: string | null, city?: string | null, country?: string | null, email?: string | null, phone?: any | null, bank?: string | null, bankAccount?: string | null } };

export type AddCoupleMutationVariables = Exact<{
  payload: CoupleInput;
}>;


export type AddCoupleMutation = { __typename?: 'Mutation', addCouple: { __typename?: 'Couple', id: number, therapists: Array<{ __typename?: 'Employee', id: number }> } };

export type EditCoupleMutationVariables = Exact<{
  coupleId: Scalars['Int'];
  payload: CoupleInput;
}>;


export type EditCoupleMutation = { __typename?: 'Mutation', editCouple: boolean };

export type FinishCouplesTherapyMutationVariables = Exact<{
  coupleId: Scalars['Int'];
  finishDate?: InputMaybe<Scalars['ISODateTime']>;
  deleteCouple?: InputMaybe<Scalars['Boolean']>;
}>;


export type FinishCouplesTherapyMutation = { __typename?: 'Mutation', finishCoupleTherapy: boolean };

export type ReactivateCoupleTherapyMutationVariables = Exact<{
  coupleId: Scalars['Int'];
}>;


export type ReactivateCoupleTherapyMutation = { __typename?: 'Mutation', reactivateCoupleTherapy: boolean };

export type GetCoupleMeetingsHeldQueryVariables = Exact<{
  coupleId: Scalars['Int'];
}>;


export type GetCoupleMeetingsHeldQuery = { __typename?: 'Query', coupleMeetingsHeld: number };

export type GetPaginatedCouplesQueryVariables = Exact<{
  therapistId: Scalars['Int'];
  limit: Scalars['Int'];
  page: Scalars['Int'];
  searchPhrase?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<OrderBy>;
  assignedTo?: InputMaybe<Array<Scalars['Int']>>;
  showDeactivated?: Scalars['Boolean'];
}>;


export type GetPaginatedCouplesQuery = { __typename?: 'Query', couplePaginatedQuery: { __typename?: 'CouplePagination', count: number, data: Array<{ __typename?: 'Couple', id: number, coupleName: string, deactivatedOn?: any | null, patients: Array<{ __typename?: 'Patient', id: number, firstName: string, lastName: string, phoneNumber?: any | null, secondPhoneNumber?: any | null, email?: string | null }>, therapists: Array<{ __typename?: 'Employee', id: number, color?: string | null, fullName?: string | null, user?: { __typename?: 'User', firstName: string } | null }> }> } };

export type EmployeeBaseFragment = { __typename?: 'Employee', id: number, color?: string | null, practiceBranchId: number, acceptedInvitation: boolean, phoneNumber?: any | null, acronym?: string | null, email?: string | null, fullName?: string | null, firstName: string, lastName: string, roles: Array<{ __typename?: 'Role', name: string, slug: string }> };

export type EmployeeDetailFragment = { __typename?: 'Employee', availableInOnlineRegistration: boolean, id: number, color?: string | null, practiceBranchId: number, acceptedInvitation: boolean, phoneNumber?: any | null, acronym?: string | null, email?: string | null, fullName?: string | null, firstName: string, lastName: string, user?: { __typename?: 'User', fullName: string, firstName: string, lastName: string, id: string, lastLogin?: any | null } | null, preferredRooms: Array<{ __typename?: 'Room', id: number, name: string }>, roles: Array<{ __typename?: 'Role', name: string, slug: string }> };

export type CreateEmployeeMutationVariables = Exact<{
  payload: CreateEmployeeInput;
}>;


export type CreateEmployeeMutation = { __typename?: 'Mutation', createEmployee: boolean };

export type DeactivateEmployeeMutationVariables = Exact<{
  employeeId: Scalars['Int'];
}>;


export type DeactivateEmployeeMutation = { __typename?: 'Mutation', deactivateEmployee: boolean };

export type EditEmployeeMutationVariables = Exact<{
  employeeId: Scalars['Int'];
  payload: EditEmployeeInput;
}>;


export type EditEmployeeMutation = { __typename?: 'Mutation', editEmployee: boolean };

export type EditEmployeeFavoriteTherapistsMutationVariables = Exact<{
  employeeId: Scalars['Int'];
  therapists?: InputMaybe<Array<Scalars['Int']>>;
}>;


export type EditEmployeeFavoriteTherapistsMutation = { __typename?: 'Mutation', editFavoriteTherapists: boolean };

export type SendEmployeeInvitationMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type SendEmployeeInvitationMutation = { __typename?: 'Mutation', sendEmployeeInvitation: boolean };

export type GetEmployeeFavoriteTherapistsQueryVariables = Exact<{
  employeeId?: InputMaybe<Scalars['Int']>;
}>;


export type GetEmployeeFavoriteTherapistsQuery = { __typename?: 'Query', favoriteTherapists: Array<{ __typename?: 'FavoriteTherapist', id: number, fullName: string, color?: string | null, acronym?: string | null }> };

export type EmployeeInvitationInfoQueryVariables = Exact<{
  invitationUUID: Scalars['String'];
}>;


export type EmployeeInvitationInfoQuery = { __typename?: 'Query', employeeInvitationInfo: { __typename?: 'EmployeeInvitationInfo', practiceName: string, invitedEmail: string } };

export type GetAllEmployeesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllEmployeesQuery = { __typename?: 'Query', employees: Array<{ __typename?: 'Employee', id: number, color?: string | null, practiceBranchId: number, acceptedInvitation: boolean, phoneNumber?: any | null, acronym?: string | null, email?: string | null, fullName?: string | null, firstName: string, lastName: string, roles: Array<{ __typename?: 'Role', name: string, slug: string }> }> };

export type GetEmployeeQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetEmployeeQuery = { __typename?: 'Query', employee: { __typename?: 'Employee', availableInOnlineRegistration: boolean, id: number, color?: string | null, practiceBranchId: number, acceptedInvitation: boolean, phoneNumber?: any | null, acronym?: string | null, email?: string | null, fullName?: string | null, firstName: string, lastName: string, user?: { __typename?: 'User', fullName: string, firstName: string, lastName: string, id: string, lastLogin?: any | null } | null, preferredRooms: Array<{ __typename?: 'Room', id: number, name: string }>, roles: Array<{ __typename?: 'Role', name: string, slug: string }> } };

export type GetEmployeeByUserIdQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type GetEmployeeByUserIdQuery = { __typename?: 'Query', getEmployeeByUserId?: { __typename?: 'Employee', acronym?: string | null, color?: string | null, id: number, phoneNumber?: any | null, practiceBranchId: number, practiceId: number, user?: { __typename?: 'User', dateJoined: string, email: string, firstName: string, fullName: string, id: string, lastName: string } | null, roles: Array<{ __typename?: 'Role', name: string, slug: string }> } | null };

export type GetEmployeeListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEmployeeListQuery = { __typename?: 'Query', getEmployeeList: Array<{ __typename?: 'Employee', id: number, acronym?: string | null, color?: string | null, email?: string | null, fullName?: string | null, roles: Array<{ __typename?: 'Role', name: string, slug: string }> }> };

export type GetEmployeesTableQueryVariables = Exact<{
  limit: Scalars['Int'];
  page: Scalars['Int'];
  practiceBranchId: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  searchPhrase?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
}>;


export type GetEmployeesTableQuery = { __typename?: 'Query', paginatedEmployees: { __typename?: 'EmployeePagination', count: number, data: Array<{ __typename?: 'Employee', id: number, fullName?: string | null, acronym?: string | null, email?: string | null, phoneNumber?: any | null, color?: string | null, acceptedInvitation: boolean, availableInOnlineRegistration: boolean, roles: Array<{ __typename?: 'Role', name: string, slug: string }>, practiceBranch: { __typename?: 'PracticeBranch', id: number, name: string } }> } };

export type EventDataFragment = { __typename?: 'Event', id: number, end: any, duration: any, note?: string | null, start: any, paidOn?: any | null, name: string, locked: boolean, shifted: boolean, attachments: Array<{ __typename?: 'EventAttachments', url: string, name: string, id: number, createdAt: any }>, couple?: { __typename?: 'Couple', id: number, coupleName: string, deletedAt?: any | null, createdAt: any, deactivatedOn?: any | null, smsNotificationsActive: boolean, patients: Array<{ __typename?: 'Patient', id: number, firstName: string, lastName: string, fullName: string, phoneNumber?: any | null, secondPhoneNumber?: any | null, email?: string | null, active: boolean, therapists: Array<{ __typename?: 'Employee', id: number, email?: string | null, phoneNumber?: any | null, fullName?: string | null, acronym?: string | null, color?: string | null, user?: { __typename?: 'User', firstName: string, lastName: string } | null }> }>, therapists: Array<{ __typename?: 'Employee', id: number, email?: string | null, phoneNumber?: any | null, fullName?: string | null, acronym?: string | null, color?: string | null, user?: { __typename?: 'User', firstName: string, lastName: string } | null }> } | null, period?: { __typename?: 'EventPeriod', id: number, dows: Array<number>, start: any, end?: any | null, interval: number, duration: any, name: string } | null, groupPresence?: { __typename?: 'EventGroupPresence', name: string, value: string } | null, therapists: Array<{ __typename?: 'Employee', id: number, email?: string | null, phoneNumber?: any | null, acronym?: string | null, color?: string | null, fullName?: string | null, user?: { __typename?: 'User', firstName: string, lastName: string } | null }>, room: { __typename?: 'Room', id: number, name: string, availableOnline: boolean, comments?: string | null, slug: string, practiceBranch: { __typename?: 'PracticeBranch', name: string, shortName: string, id: number } }, services: Array<{ __typename?: 'ServiceType', id: number, name: string, price: number, availableOnline: boolean, practiceBranch: { __typename?: 'PracticeBranch', name: string, shortName: string, id: number } }>, participants?: Array<{ __typename?: 'EventParticipants', id: number, payment: EventPayment, presence?: { __typename?: 'EventPresence', name: string, value: string } | null, paymentMethod?: { __typename?: 'EventPatientPaymentMethod', name: string, value: string } | null, patient?: { __typename?: 'Patient', id: number, firstName: string, lastName: string, fullName: string, phoneNumber?: any | null, secondPhoneNumber?: any | null, description: string, birthday?: any | null, email?: string | null, deactivatedOn?: any | null, createdAt: any, active: boolean, deletedAt?: any | null, therapists: Array<{ __typename?: 'Employee', id: number, fullName?: string | null, color?: string | null, acronym?: string | null }> } | null }> | null };

export type InitialCalendarEventFragment = { __typename?: 'Event', id: number, start: any, end: any, name: string, locked: boolean, cancelled: boolean, shifted: boolean, duration: any, paidOn?: any | null, serviceName: string, serviceNameWithPrice: string, groupPresenceName?: string | null, periodId?: number | null, therapistIds: Array<number>, therapistColor: string, serviceIds: Array<number>, roomId: number, hasNote: boolean, couple?: { __typename?: 'Couple', id: number, coupleName: string } | null, participants?: Array<{ __typename?: 'EventParticipants', id: number, presenceName?: string | null, payment: EventPayment, paymentMethodName?: string | null, patient?: { __typename?: 'Patient', id: number, fullName: string, therapists: Array<{ __typename?: 'Employee', id: number }> } | null }> | null };

export type AddPeriodicEventMutationVariables = Exact<{
  duration: Scalars['TimeDeltaMinutes'];
  patients: Array<Scalars['Int']>;
  services: Array<Scalars['Int']>;
  start: Scalars['ISODateTime'];
  therapistIds: Array<Scalars['Int']>;
  roomId: Scalars['Int'];
  end?: InputMaybe<Scalars['ISODateTime']>;
  name: Scalars['String'];
  interval: Scalars['Int'];
  dows: Array<Scalars['Int']>;
  coupleId?: InputMaybe<Scalars['Int']>;
}>;


export type AddPeriodicEventMutation = { __typename?: 'Mutation', addPeriodicEvent: { __typename?: 'EventPeriod', id: number } };

export type AddSingleEventMutationVariables = Exact<{
  duration: Scalars['TimeDeltaMinutes'];
  patients: Array<Scalars['Int']>;
  services: Array<Scalars['Int']>;
  start: Scalars['ISODateTime'];
  therapistIds: Array<Scalars['Int']>;
  roomId: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  coupleId?: InputMaybe<Scalars['Int']>;
}>;


export type AddSingleEventMutation = { __typename?: 'Mutation', addSingleEvent: { __typename?: 'Event', id: number } };

export type AddSingleEventWithCollisionsMutationVariables = Exact<{
  eventInput: EventInput;
  collisionLimit?: InputMaybe<Scalars['Int']>;
}>;


export type AddSingleEventWithCollisionsMutation = { __typename?: 'Mutation', addSingleEventWithCollisions: { __typename?: 'EventOutput', success: boolean, event?: { __typename?: 'Event', id: number } | null, collisions?: Array<{ __typename?: 'EventCollision', reason: Array<CollisionReason>, event: { __typename?: 'Event', id: number } }> | null } };

export type DeactivateRoomsMutationVariables = Exact<{
  roomIds: Array<Scalars['Int']>;
}>;


export type DeactivateRoomsMutation = { __typename?: 'Mutation', deactivateRooms: boolean };

export type DeleteEventAttachmentMutationVariables = Exact<{
  attachmentId: Scalars['Int'];
}>;


export type DeleteEventAttachmentMutation = { __typename?: 'Mutation', deleteEventAttachment: boolean };

export type DeleteEventSeriesMutationVariables = Exact<{
  eventPeriodId: Scalars['Int'];
  afterDate: Scalars['ISODateTime'];
}>;


export type DeleteEventSeriesMutation = { __typename?: 'Mutation', deleteEventSeries: boolean };

export type EditEventMutationVariables = Exact<{
  eventId: Scalars['Int'];
  payload: EventEditAttributes;
}>;


export type EditEventMutation = { __typename?: 'Mutation', editEvent: { __typename?: 'Event', id: number, start: any, end: any, name: string, locked: boolean, cancelled: boolean, shifted: boolean, duration: any, paidOn?: any | null, serviceName: string, serviceNameWithPrice: string, groupPresenceName?: string | null, periodId?: number | null, therapistIds: Array<number>, therapistColor: string, serviceIds: Array<number>, roomId: number, hasNote: boolean, couple?: { __typename?: 'Couple', id: number, coupleName: string } | null, participants?: Array<{ __typename?: 'EventParticipants', id: number, presenceName?: string | null, payment: EventPayment, paymentMethodName?: string | null, patient?: { __typename?: 'Patient', id: number, fullName: string, therapists: Array<{ __typename?: 'Employee', id: number }> } | null }> | null } };

export type EditEventPaymentStatusesMutationVariables = Exact<{
  eventIds: Array<Scalars['Int']>;
  paymentStatus: EventPayment;
  paidOn?: InputMaybe<Scalars['ISODate']>;
  paymentMethod?: InputMaybe<EventPaymentMethods>;
}>;


export type EditEventPaymentStatusesMutation = { __typename?: 'Mutation', editEventPaymentStatuses?: any | null };

export type EditEventSeriesMutationVariables = Exact<{
  payload: EventSeriesEditAttributes;
  eventId: Scalars['Int'];
}>;


export type EditEventSeriesMutation = { __typename?: 'Mutation', editEventSeries: boolean };

export type EditEventWithCollisionsMutationVariables = Exact<{
  eventId: Scalars['Int'];
  payload: EventEditAttributes;
  collisionLimit?: InputMaybe<Scalars['Int']>;
}>;


export type EditEventWithCollisionsMutation = { __typename?: 'Mutation', editEventWithCollisions: { __typename?: 'EventOutput', success: boolean, event?: { __typename?: 'Event', id: number } | null, collisions?: Array<{ __typename?: 'EventCollision', reason: Array<CollisionReason>, event: { __typename?: 'Event', id: number } }> | null } };

export type ShiftEventSeriesMutationVariables = Exact<{
  payload: EventSeriesEditAttributes;
  eventId: Scalars['Int'];
}>;


export type ShiftEventSeriesMutation = { __typename?: 'Mutation', shiftEventSeries: boolean };

export type ChangeEventIntoSeriesMutationVariables = Exact<{
  dows: Array<Scalars['Int']>;
  eventId: Scalars['Int'];
  interval: Scalars['Int'];
  end?: InputMaybe<Scalars['ISODateTime']>;
}>;


export type ChangeEventIntoSeriesMutation = { __typename?: 'Mutation', changeEventIntoEventSeries: boolean };

export type GetCoupleMeetingDetailsQueryVariables = Exact<{
  eventId: Scalars['Int'];
}>;


export type GetCoupleMeetingDetailsQuery = { __typename?: 'Query', event?: { __typename?: 'Event', id: number, start: any, note?: string | null, secretNote?: string | null, duration: any, paidOn?: any | null, locked: boolean, shifted: boolean, couple?: { __typename?: 'Couple', id: number, coupleName: string, therapists: Array<{ __typename?: 'Employee', id: number }> } | null, period?: { __typename?: 'EventPeriod', id: number } | null, groupPresence?: { __typename?: 'EventGroupPresence', name: string } | null, services: Array<{ __typename?: 'ServiceType', id: number }>, therapists: Array<{ __typename?: 'Employee', id: number }>, room: { __typename?: 'Room', id: number }, participants?: Array<{ __typename?: 'EventParticipants', id: number, payment: EventPayment, paymentMethodName?: string | null, patient?: { __typename?: 'Patient', id: number, fullName: string, phoneNumber?: any | null, email?: string | null, therapists: Array<{ __typename?: 'Employee', id: number }> } | null }> | null } | null };

export type GetCoupleUpcomingEventsQueryVariables = Exact<{
  after: Scalars['ISODateTime'];
  coupleId: Scalars['Int'];
}>;


export type GetCoupleUpcomingEventsQuery = { __typename?: 'Query', coupleUpcomingEvents: Array<{ __typename?: 'Event', id: number, start: any, end: any }> };

export type GetEventQueryVariables = Exact<{
  eventId: Scalars['Int'];
}>;


export type GetEventQuery = { __typename?: 'Query', event?: { __typename?: 'Event', secretNote?: string | null, nextEvent?: number | null, prevEvent?: number | null, id: number, end: any, duration: any, note?: string | null, start: any, paidOn?: any | null, name: string, locked: boolean, shifted: boolean, attachments: Array<{ __typename?: 'EventAttachments', url: string, name: string, id: number, createdAt: any }>, couple?: { __typename?: 'Couple', id: number, coupleName: string, deletedAt?: any | null, createdAt: any, deactivatedOn?: any | null, smsNotificationsActive: boolean, patients: Array<{ __typename?: 'Patient', id: number, firstName: string, lastName: string, fullName: string, phoneNumber?: any | null, secondPhoneNumber?: any | null, email?: string | null, active: boolean, therapists: Array<{ __typename?: 'Employee', id: number, email?: string | null, phoneNumber?: any | null, fullName?: string | null, acronym?: string | null, color?: string | null, user?: { __typename?: 'User', firstName: string, lastName: string } | null }> }>, therapists: Array<{ __typename?: 'Employee', id: number, email?: string | null, phoneNumber?: any | null, fullName?: string | null, acronym?: string | null, color?: string | null, user?: { __typename?: 'User', firstName: string, lastName: string } | null }> } | null, period?: { __typename?: 'EventPeriod', id: number, dows: Array<number>, start: any, end?: any | null, interval: number, duration: any, name: string } | null, groupPresence?: { __typename?: 'EventGroupPresence', name: string, value: string } | null, therapists: Array<{ __typename?: 'Employee', id: number, email?: string | null, phoneNumber?: any | null, acronym?: string | null, color?: string | null, fullName?: string | null, user?: { __typename?: 'User', firstName: string, lastName: string } | null }>, room: { __typename?: 'Room', id: number, name: string, availableOnline: boolean, comments?: string | null, slug: string, practiceBranch: { __typename?: 'PracticeBranch', name: string, shortName: string, id: number } }, services: Array<{ __typename?: 'ServiceType', id: number, name: string, price: number, availableOnline: boolean, practiceBranch: { __typename?: 'PracticeBranch', name: string, shortName: string, id: number } }>, participants?: Array<{ __typename?: 'EventParticipants', id: number, payment: EventPayment, presence?: { __typename?: 'EventPresence', name: string, value: string } | null, paymentMethod?: { __typename?: 'EventPatientPaymentMethod', name: string, value: string } | null, patient?: { __typename?: 'Patient', id: number, firstName: string, lastName: string, fullName: string, phoneNumber?: any | null, secondPhoneNumber?: any | null, description: string, birthday?: any | null, email?: string | null, deactivatedOn?: any | null, createdAt: any, active: boolean, deletedAt?: any | null, therapists: Array<{ __typename?: 'Employee', id: number, fullName?: string | null, color?: string | null, acronym?: string | null }> } | null }> | null } | null };

export type GetEventsQueryVariables = Exact<{
  after: Scalars['ISODateTime'];
  before: Scalars['ISODateTime'];
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  patientId?: InputMaybe<Scalars['Int']>;
  coupleId?: InputMaybe<Scalars['Int']>;
}>;


export type GetEventsQuery = { __typename?: 'Query', events: Array<{ __typename?: 'Event', id: number, end: any, duration: any, note?: string | null, start: any, paidOn?: any | null, name: string, locked: boolean, shifted: boolean, attachments: Array<{ __typename?: 'EventAttachments', url: string, name: string, id: number, createdAt: any }>, couple?: { __typename?: 'Couple', id: number, coupleName: string, deletedAt?: any | null, createdAt: any, deactivatedOn?: any | null, smsNotificationsActive: boolean, patients: Array<{ __typename?: 'Patient', id: number, firstName: string, lastName: string, fullName: string, phoneNumber?: any | null, secondPhoneNumber?: any | null, email?: string | null, active: boolean, therapists: Array<{ __typename?: 'Employee', id: number, email?: string | null, phoneNumber?: any | null, fullName?: string | null, acronym?: string | null, color?: string | null, user?: { __typename?: 'User', firstName: string, lastName: string } | null }> }>, therapists: Array<{ __typename?: 'Employee', id: number, email?: string | null, phoneNumber?: any | null, fullName?: string | null, acronym?: string | null, color?: string | null, user?: { __typename?: 'User', firstName: string, lastName: string } | null }> } | null, period?: { __typename?: 'EventPeriod', id: number, dows: Array<number>, start: any, end?: any | null, interval: number, duration: any, name: string } | null, groupPresence?: { __typename?: 'EventGroupPresence', name: string, value: string } | null, therapists: Array<{ __typename?: 'Employee', id: number, email?: string | null, phoneNumber?: any | null, acronym?: string | null, color?: string | null, fullName?: string | null, user?: { __typename?: 'User', firstName: string, lastName: string } | null }>, room: { __typename?: 'Room', id: number, name: string, availableOnline: boolean, comments?: string | null, slug: string, practiceBranch: { __typename?: 'PracticeBranch', name: string, shortName: string, id: number } }, services: Array<{ __typename?: 'ServiceType', id: number, name: string, price: number, availableOnline: boolean, practiceBranch: { __typename?: 'PracticeBranch', name: string, shortName: string, id: number } }>, participants?: Array<{ __typename?: 'EventParticipants', id: number, payment: EventPayment, presence?: { __typename?: 'EventPresence', name: string, value: string } | null, paymentMethod?: { __typename?: 'EventPatientPaymentMethod', name: string, value: string } | null, patient?: { __typename?: 'Patient', id: number, firstName: string, lastName: string, fullName: string, phoneNumber?: any | null, secondPhoneNumber?: any | null, description: string, birthday?: any | null, email?: string | null, deactivatedOn?: any | null, createdAt: any, active: boolean, deletedAt?: any | null, therapists: Array<{ __typename?: 'Employee', id: number, fullName?: string | null, color?: string | null, acronym?: string | null }> } | null }> | null }> };

export type GetEventsByServiceIdAndPracticeBranchIdQueryVariables = Exact<{
  after: Scalars['ISODateTime'];
  before: Scalars['ISODateTime'];
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  serviceId?: InputMaybe<Scalars['Int']>;
  practiceBranchId?: InputMaybe<Scalars['Int']>;
  patientId?: InputMaybe<Scalars['Int']>;
  coupleId?: InputMaybe<Scalars['Int']>;
  heldMeetings?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<OrderBy>;
}>;


export type GetEventsByServiceIdAndPracticeBranchIdQuery = { __typename?: 'Query', eventsWithSorting: Array<{ __typename?: 'Event', id: number, start: any, couple?: { __typename?: 'Couple', id: number, coupleName: string } | null, participants?: Array<{ __typename?: 'EventParticipants', id: number, payment: EventPayment, patient?: { __typename?: 'Patient', id: number, firstName: string, lastName: string } | null }> | null, services: Array<{ __typename?: 'ServiceType', id: number, price: number }> }> };

export type GetInitialCalendarQueryVariables = Exact<{
  after: Scalars['ISODateTime'];
  before: Scalars['ISODateTime'];
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  patientId?: InputMaybe<Scalars['Int']>;
  coupleId?: InputMaybe<Scalars['Int']>;
}>;


export type GetInitialCalendarQuery = { __typename?: 'Query', events: Array<{ __typename?: 'Event', id: number, start: any, end: any, name: string, locked: boolean, cancelled: boolean, shifted: boolean, duration: any, paidOn?: any | null, serviceName: string, serviceNameWithPrice: string, groupPresenceName?: string | null, periodId?: number | null, therapistIds: Array<number>, therapistColor: string, serviceIds: Array<number>, roomId: number, hasNote: boolean, couple?: { __typename?: 'Couple', id: number, coupleName: string } | null, participants?: Array<{ __typename?: 'EventParticipants', id: number, presenceName?: string | null, payment: EventPayment, paymentMethodName?: string | null, patient?: { __typename?: 'Patient', id: number, fullName: string, therapists: Array<{ __typename?: 'Employee', id: number }> } | null }> | null }> };

export type GetPaginatedEventsQueryVariables = Exact<{
  after: Scalars['ISODateTime'];
  before: Scalars['ISODateTime'];
  limit: Scalars['Int'];
  page: Scalars['Int'];
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  orderBy?: InputMaybe<OrderBy>;
  patientId?: InputMaybe<Scalars['Int']>;
  coupleId?: InputMaybe<Scalars['Int']>;
  serviceId?: InputMaybe<Scalars['Int']>;
}>;


export type GetPaginatedEventsQuery = { __typename?: 'Query', paginatedEvents: { __typename?: 'EventPagination', count: number, data: Array<{ __typename?: 'Event', id: number, end: any, duration: any, note?: string | null, start: any, paidOn?: any | null, name: string, locked: boolean, shifted: boolean, attachments: Array<{ __typename?: 'EventAttachments', url: string, name: string, id: number, createdAt: any }>, couple?: { __typename?: 'Couple', id: number, coupleName: string, deletedAt?: any | null, createdAt: any, deactivatedOn?: any | null, smsNotificationsActive: boolean, patients: Array<{ __typename?: 'Patient', id: number, firstName: string, lastName: string, fullName: string, phoneNumber?: any | null, secondPhoneNumber?: any | null, email?: string | null, active: boolean, therapists: Array<{ __typename?: 'Employee', id: number, email?: string | null, phoneNumber?: any | null, fullName?: string | null, acronym?: string | null, color?: string | null, user?: { __typename?: 'User', firstName: string, lastName: string } | null }> }>, therapists: Array<{ __typename?: 'Employee', id: number, email?: string | null, phoneNumber?: any | null, fullName?: string | null, acronym?: string | null, color?: string | null, user?: { __typename?: 'User', firstName: string, lastName: string } | null }> } | null, period?: { __typename?: 'EventPeriod', id: number, dows: Array<number>, start: any, end?: any | null, interval: number, duration: any, name: string } | null, groupPresence?: { __typename?: 'EventGroupPresence', name: string, value: string } | null, therapists: Array<{ __typename?: 'Employee', id: number, email?: string | null, phoneNumber?: any | null, acronym?: string | null, color?: string | null, fullName?: string | null, user?: { __typename?: 'User', firstName: string, lastName: string } | null }>, room: { __typename?: 'Room', id: number, name: string, availableOnline: boolean, comments?: string | null, slug: string, practiceBranch: { __typename?: 'PracticeBranch', name: string, shortName: string, id: number } }, services: Array<{ __typename?: 'ServiceType', id: number, name: string, price: number, availableOnline: boolean, practiceBranch: { __typename?: 'PracticeBranch', name: string, shortName: string, id: number } }>, participants?: Array<{ __typename?: 'EventParticipants', id: number, payment: EventPayment, presence?: { __typename?: 'EventPresence', name: string, value: string } | null, paymentMethod?: { __typename?: 'EventPatientPaymentMethod', name: string, value: string } | null, patient?: { __typename?: 'Patient', id: number, firstName: string, lastName: string, fullName: string, phoneNumber?: any | null, secondPhoneNumber?: any | null, description: string, birthday?: any | null, email?: string | null, deactivatedOn?: any | null, createdAt: any, active: boolean, deletedAt?: any | null, therapists: Array<{ __typename?: 'Employee', id: number, fullName?: string | null, color?: string | null, acronym?: string | null }> } | null }> | null }> } };

export type GetPatientMeetingDetailsQueryVariables = Exact<{
  eventId: Scalars['Int'];
}>;


export type GetPatientMeetingDetailsQuery = { __typename?: 'Query', event?: { __typename?: 'Event', id: number, start: any, note?: string | null, secretNote?: string | null, duration: any, paidOn?: any | null, locked: boolean, shifted: boolean, period?: { __typename?: 'EventPeriod', id: number } | null, services: Array<{ __typename?: 'ServiceType', id: number }>, therapists: Array<{ __typename?: 'Employee', id: number }>, room: { __typename?: 'Room', id: number }, participants?: Array<{ __typename?: 'EventParticipants', id: number, presenceName?: string | null, payment: EventPayment, paymentMethodName?: string | null, patient?: { __typename?: 'Patient', id: number, fullName: string, phoneNumber?: any | null, email?: string | null, description: string, therapists: Array<{ __typename?: 'Employee', id: number }> } | null }> | null } | null };

export type GetPatientUpcomingEventsQueryVariables = Exact<{
  after: Scalars['ISODateTime'];
  patientId: Scalars['Int'];
}>;


export type GetPatientUpcomingEventsQuery = { __typename?: 'Query', patientUpcomingEvents: Array<{ __typename?: 'Event', id: number, start: any, end: any }> };

export type GetWithoutPatientsMeetingDetailsQueryVariables = Exact<{
  eventId: Scalars['Int'];
}>;


export type GetWithoutPatientsMeetingDetailsQuery = { __typename?: 'Query', event?: { __typename?: 'Event', id: number, start: any, duration: any, name: string, locked: boolean, shifted: boolean, period?: { __typename?: 'EventPeriod', id: number } | null, therapists: Array<{ __typename?: 'Employee', id: number }>, room: { __typename?: 'Room', id: number } } | null };

export type AddExpenseMutationVariables = Exact<{
  practiceBranchId: Scalars['Int'];
  name: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  amount: Scalars['Float'];
  recurringPeriod?: InputMaybe<RecurringExpenseEnum>;
  date: Scalars['Date'];
}>;


export type AddExpenseMutation = { __typename?: 'Mutation', addExpense: { __typename?: 'ExpensesResult', expenses: Array<{ __typename?: 'PracticeExpense', id: number }> } };

export type EditExpenseMutationVariables = Exact<{
  expenseId: Scalars['Int'];
  payload: ExpensesEditAttributes;
}>;


export type EditExpenseMutation = { __typename?: 'Mutation', editExpense: boolean };

export type RemoveExpenseMutationVariables = Exact<{
  expenseIds: Array<Scalars['Int']>;
}>;


export type RemoveExpenseMutation = { __typename?: 'Mutation', removeExpenses: { __typename?: 'DeletedExpenses', success: boolean } };

export type GetExpensesQueryVariables = Exact<{
  after: Scalars['Date'];
  before: Scalars['Date'];
  limit: Scalars['Int'];
  page: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
}>;


export type GetExpensesQuery = { __typename?: 'Query', paginatedExpenses: { __typename?: 'PracticeExpensePagination', count: number, pageTotals: any, totals: any, data: Array<{ __typename?: 'PracticeExpense', id: number, name: string, amount: number, note: string, date: any, recurring?: { __typename?: 'RecurringExpense', recurringPeriod: RecurringExpenseEnum } | null, author?: { __typename?: 'Employee', fullName?: string | null, id: number } | null }> } };

export type EditGdprConfigMutationVariables = Exact<{
  payload: EditGdprConfigInput;
}>;


export type EditGdprConfigMutation = { __typename?: 'Mutation', editGdprConfig: boolean };

export type MarkGdprDocumentAsOpenedMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type MarkGdprDocumentAsOpenedMutation = { __typename?: 'Mutation', markGdprDocumentAsOpened: any };

export type SendGdprConsentMutationVariables = Exact<{
  patientIds: Array<Scalars['Int']>;
}>;


export type SendGdprConsentMutation = { __typename?: 'Mutation', sendGdprEmail: boolean };

export type SignGdprDocumentMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type SignGdprDocumentMutation = { __typename?: 'Mutation', markGdprDocumentAsSigned: any };

export type GetGdprConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGdprConfigQuery = { __typename?: 'Query', getGdprConfig: { __typename?: 'GDPRConfigType', id?: number | null, sendAutomatedGdprMails: boolean, documentCategory: string, documentCategoryChild: string, practiceBranchId: number } };

export type GetGdprDocumentQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type GetGdprDocumentQuery = { __typename?: 'Query', getGdprDocument: { __typename?: 'GDPRDocumentType', patientToken: string, documentType: string, practiceName: string, openedDate?: any | null, signedDate?: any | null, isSigned: boolean, patient: { __typename?: 'Patient', id: number, fullName: string } } };

export type CreateGuardianMutationVariables = Exact<{
  payload: CreateGuardianInput;
}>;


export type CreateGuardianMutation = { __typename?: 'Mutation', createGuardian: boolean };

export type DeactivateGuardianMutationVariables = Exact<{
  guardianId: Scalars['Int'];
  deactivatedAt?: InputMaybe<Scalars['ISODateTime']>;
}>;


export type DeactivateGuardianMutation = { __typename?: 'Mutation', deactivateGuardian: boolean };

export type EditGuardianMutationVariables = Exact<{
  payload: EditGuardianInput;
}>;


export type EditGuardianMutation = { __typename?: 'Mutation', editGuardian: boolean };

export type GetGuardiansQueryVariables = Exact<{
  patientId: Scalars['Int'];
}>;


export type GetGuardiansQuery = { __typename?: 'Query', getGuardians: Array<{ __typename?: 'Guardian', id: number, firstName: string, lastName: string, phoneNumber?: any | null, email?: string | null, address?: { __typename?: 'GuardianAddress', id: number, street?: string | null, houseNumber?: string | null, apartmentNumber?: string | null, zipCode?: string | null, city?: string | null, county?: string | null, country?: string | null } | null }> };

export type PaginatedHolidaysQueryVariables = Exact<{
  after: Scalars['ISODateTime'];
  before: Scalars['ISODateTime'];
  limit: Scalars['Int'];
  page: Scalars['Int'];
}>;


export type PaginatedHolidaysQuery = { __typename?: 'Query', paginatedHolidays: { __typename?: 'HolidayTypePagination', count: number, totals: any, pageTotals: any, data: Array<{ __typename?: 'HolidayType', id: number }> } };

export type GetIncomeQueryVariables = Exact<{
  after: Scalars['ISODateTime'];
  before: Scalars['ISODateTime'];
  limit: Scalars['Int'];
  page: Scalars['Int'];
  practiceBranch?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  therapists?: InputMaybe<Array<Scalars['Int']>>;
  services?: InputMaybe<Array<Scalars['Int']>>;
  statuses?: InputMaybe<Array<EventPayment>>;
  patients?: InputMaybe<Array<Scalars['Int']>>;
  paymentMethods?: InputMaybe<Array<Scalars['String']>>;
}>;


export type GetIncomeQuery = { __typename?: 'Query', paginatedIncomes: { __typename?: 'PracticeIncomePagination', count: number, pageTotals: any, totals: any, data: Array<{ __typename?: 'PracticeIncome', id: number, amount: number, date: any, serviceName: string, paidOn?: any | null, services: Array<{ __typename?: 'ServiceType', name: string }>, participants: Array<{ __typename?: 'EventParticipants', id: number, payment: EventPayment, paymentMethod?: { __typename?: 'EventPatientPaymentMethod', name: string } | null, patient?: { __typename?: 'Patient', fullName: string } | null }>, therapists: Array<{ __typename?: 'Employee', id: number, fullName?: string | null }> }> } };

export type DeleteInvoiceConfigMutationVariables = Exact<{
  deleteAccountOnFakturownia: Scalars['Boolean'];
}>;


export type DeleteInvoiceConfigMutation = { __typename?: 'Mutation', deleteInvoiceConfig: { __typename?: 'InvoicingAccountDeleteResponseType', code: string, message: string } };

export type GetInvoiceConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInvoiceConfigQuery = { __typename?: 'Query', invoiceConfig?: { __typename?: 'InvoiceConfig', id: number, active: boolean, apiToken?: string | null, subdomain: string } | null, getCurrentPracticeDetails: { __typename?: 'Practice', billingInfo?: { __typename?: 'BillingInfo', id: number } | null } };

export type UpdateOrCreateInvoiceConfigMutationVariables = Exact<{
  payload?: InputMaybe<InvoiceConfigInput>;
}>;


export type UpdateOrCreateInvoiceConfigMutation = { __typename?: 'Mutation', updateOrCreateInvoiceConfig: { __typename?: 'InvoiceConfig', id: number, active: boolean, apiToken?: string | null } };

export type InvoiceDetailFragment = { __typename?: 'Invoice', addClientTax: boolean, externalId: number, kind: string, patientEmails: Array<string>, issueDate: any, id: number, paymentTo: any, number: string, notes?: string | null, name?: string | null, sellDate: any, status: ExternalInvoiceStatus, totalPriceGross: number, totalPriceNet: number, totalPriceTax: number, externalInvoice?: { __typename?: 'ExternalInvoice', id: number, issueDate: any, number: string, paymentTo: any, sellDate: any, status: ExternalInvoiceStatus, viewUrl: string, paymentType?: ExternalInvoicePaymentType | null, sellerName?: string | null, sellerStreet?: string | null, sellerPostCode?: string | null, sellerCity?: string | null, sellerCountry?: string | null, sellerTaxNo?: string | null, sellerEmail?: string | null, sellerPhone?: string | null, sellerBank?: string | null, sellerBankAccount?: string | null, buyerName?: string | null, buyerStreet?: string | null, buyerPostCode?: string | null, buyerCity?: string | null, buyerEmail?: string | null, buyerTaxNo?: string | null, description?: string | null, paid?: number | null, unpaid?: number | null, priceGross?: number | null } | null, clientBillingInfo: { __typename?: 'BillingInfo', bank?: string | null, bankAccount?: string | null, city?: string | null, country?: string | null, email?: string | null, id: number, name?: string | null, postCode?: string | null, street?: string | null, taxNo?: string | null }, practiceBranch: { __typename?: 'PracticeBranch', id: number, name: string, shortName: string }, lineItems: Array<{ __typename?: 'InvoiceLineItem', externalId: number, id: number, itemPrice: number, name: string, quantity: number, tax: number, taxFree: boolean, taxNotApplicable: boolean, totalPriceGross: number, totalPriceNet: number, totalPriceTax: number }>, sentTo: Array<{ __typename?: 'InvoiceSentTo', id: number, emails: Array<string>, sentAt: any }> };

export type AddInvoiceMutationVariables = Exact<{
  payload: InvoiceInput;
}>;


export type AddInvoiceMutation = { __typename?: 'Mutation', createInvoice: { __typename?: 'Invoice', id: number } };

export type DeleteInvoiceMutationVariables = Exact<{
  invoiceId: Scalars['Int'];
}>;


export type DeleteInvoiceMutation = { __typename?: 'Mutation', deleteInvoice: boolean };

export type SendInvoicesMutationVariables = Exact<{
  payload: Array<InvoiceSendInput>;
}>;


export type SendInvoicesMutation = { __typename?: 'Mutation', sendInvoices: boolean };

export type SyncInvoiceMutationVariables = Exact<{
  invoiceId: Scalars['Int'];
}>;


export type SyncInvoiceMutation = { __typename?: 'Mutation', synchronizeInvoice: { __typename?: 'Invoice', addClientTax: boolean, externalId: number, kind: string, patientEmails: Array<string>, issueDate: any, id: number, paymentTo: any, number: string, notes?: string | null, name?: string | null, sellDate: any, status: ExternalInvoiceStatus, totalPriceGross: number, totalPriceNet: number, totalPriceTax: number, externalInvoice?: { __typename?: 'ExternalInvoice', id: number, issueDate: any, number: string, paymentTo: any, sellDate: any, status: ExternalInvoiceStatus, viewUrl: string, paymentType?: ExternalInvoicePaymentType | null, sellerName?: string | null, sellerStreet?: string | null, sellerPostCode?: string | null, sellerCity?: string | null, sellerCountry?: string | null, sellerTaxNo?: string | null, sellerEmail?: string | null, sellerPhone?: string | null, sellerBank?: string | null, sellerBankAccount?: string | null, buyerName?: string | null, buyerStreet?: string | null, buyerPostCode?: string | null, buyerCity?: string | null, buyerEmail?: string | null, buyerTaxNo?: string | null, description?: string | null, paid?: number | null, unpaid?: number | null, priceGross?: number | null } | null, clientBillingInfo: { __typename?: 'BillingInfo', bank?: string | null, bankAccount?: string | null, city?: string | null, country?: string | null, email?: string | null, id: number, name?: string | null, postCode?: string | null, street?: string | null, taxNo?: string | null }, practiceBranch: { __typename?: 'PracticeBranch', id: number, name: string, shortName: string }, lineItems: Array<{ __typename?: 'InvoiceLineItem', externalId: number, id: number, itemPrice: number, name: string, quantity: number, tax: number, taxFree: boolean, taxNotApplicable: boolean, totalPriceGross: number, totalPriceNet: number, totalPriceTax: number }>, sentTo: Array<{ __typename?: 'InvoiceSentTo', id: number, emails: Array<string>, sentAt: any }> } };

export type UpdateInvoiceMutationVariables = Exact<{
  invoiceId: Scalars['Int'];
  payload: InvoiceUpdateInput;
}>;


export type UpdateInvoiceMutation = { __typename?: 'Mutation', updateInvoice: { __typename?: 'Invoice', id: number, status: ExternalInvoiceStatus, externalInvoice?: { __typename?: 'ExternalInvoice', id: number, status: ExternalInvoiceStatus, paid?: number | null, unpaid?: number | null } | null } };

export type UpdateOrCreateWebhooksMutationVariables = Exact<{ [key: string]: never; }>;


export type UpdateOrCreateWebhooksMutation = { __typename?: 'Mutation', updateOrCreateWebhooks: { __typename?: 'WebhooksType', webhooks: Array<{ __typename?: 'WebhookType', id: number, kind: string, accountId: number, url: string, apiToken: string, active: boolean }> } };

export type GetBillingInfoFromVatIdQueryVariables = Exact<{
  vatId?: InputMaybe<Scalars['String']>;
}>;


export type GetBillingInfoFromVatIdQuery = { __typename?: 'Query', billingInfoFromVatId: { __typename?: 'BillingInfoFromVatId', name: string, city: string, email?: string | null, postCode: string, street: string } };

export type GetInvoiceQueryVariables = Exact<{
  invoiceId: Scalars['Int'];
}>;


export type GetInvoiceQuery = { __typename?: 'Query', invoice: { __typename?: 'Invoice', addClientTax: boolean, externalId: number, kind: string, patientEmails: Array<string>, issueDate: any, id: number, paymentTo: any, number: string, notes?: string | null, name?: string | null, sellDate: any, status: ExternalInvoiceStatus, totalPriceGross: number, totalPriceNet: number, totalPriceTax: number, externalInvoice?: { __typename?: 'ExternalInvoice', id: number, issueDate: any, number: string, paymentTo: any, sellDate: any, status: ExternalInvoiceStatus, viewUrl: string, paymentType?: ExternalInvoicePaymentType | null, sellerName?: string | null, sellerStreet?: string | null, sellerPostCode?: string | null, sellerCity?: string | null, sellerCountry?: string | null, sellerTaxNo?: string | null, sellerEmail?: string | null, sellerPhone?: string | null, sellerBank?: string | null, sellerBankAccount?: string | null, buyerName?: string | null, buyerStreet?: string | null, buyerPostCode?: string | null, buyerCity?: string | null, buyerEmail?: string | null, buyerTaxNo?: string | null, description?: string | null, paid?: number | null, unpaid?: number | null, priceGross?: number | null } | null, clientBillingInfo: { __typename?: 'BillingInfo', bank?: string | null, bankAccount?: string | null, city?: string | null, country?: string | null, email?: string | null, id: number, name?: string | null, postCode?: string | null, street?: string | null, taxNo?: string | null }, practiceBranch: { __typename?: 'PracticeBranch', id: number, name: string, shortName: string }, lineItems: Array<{ __typename?: 'InvoiceLineItem', externalId: number, id: number, itemPrice: number, name: string, quantity: number, tax: number, taxFree: boolean, taxNotApplicable: boolean, totalPriceGross: number, totalPriceNet: number, totalPriceTax: number }>, sentTo: Array<{ __typename?: 'InvoiceSentTo', id: number, emails: Array<string>, sentAt: any }> } };

export type InvoiceEventFragment = { __typename?: 'Event', id: number, hasInvoice: boolean, start: any, status: EventPayment, services: Array<{ __typename?: 'ServiceType', id: number, name: string, price: number }> };

export type GetInvoiceEventsQueryVariables = Exact<{
  after: Scalars['ISODateTime'];
  before: Scalars['ISODateTime'];
  patientId: Scalars['Int'];
}>;


export type GetInvoiceEventsQuery = { __typename?: 'Query', paid: Array<{ __typename?: 'Event', id: number, hasInvoice: boolean, start: any, status: EventPayment, services: Array<{ __typename?: 'ServiceType', id: number, name: string, price: number }> }>, unpaid: Array<{ __typename?: 'Event', id: number, hasInvoice: boolean, start: any, status: EventPayment, services: Array<{ __typename?: 'ServiceType', id: number, name: string, price: number }> }> };

export type GetInvoicesTableQueryVariables = Exact<{
  after: Scalars['ISODate'];
  before: Scalars['ISODate'];
  limit: Scalars['Int'];
  page: Scalars['Int'];
  practiceBranchId: Scalars['Int'];
  tab: InvoiceTab;
  orderBy?: InputMaybe<Array<OrderBy>>;
  statuses?: InputMaybe<Array<ExternalInvoiceStatus>>;
}>;


export type GetInvoicesTableQuery = { __typename?: 'Query', invoices: { __typename?: 'InvoicePagination', count: number, pageTotals: any, totals: any, data: Array<{ __typename?: 'Invoice', id: number, addClientTax: boolean, externalId: number, kind: string, name?: string | null, number: string, viewUrl?: string | null, notes?: string | null, paymentTo: any, sellDate: any, status: ExternalInvoiceStatus, totalPriceGross: number, totalPriceNet: number, totalPriceTax: number, patientEmails: Array<string>, createdAt: any, practiceBranch: { __typename?: 'PracticeBranch', id: number }, clientBillingInfo: { __typename?: 'BillingInfo', id: number, name?: string | null } }> } };

export type GetPatientBillingInfoQueryVariables = Exact<{
  patientId: Scalars['Int'];
}>;


export type GetPatientBillingInfoQuery = { __typename?: 'Query', patientDetails: { __typename?: 'Patient', id: number, fullName: string, email?: string | null, address?: { __typename?: 'PatientAddress', id: number, city?: string | null, zipCode?: string | null, street?: string | null } | null, billingInfo?: { __typename?: 'BillingInfo', id: number, bank?: string | null, bankAccount?: string | null, city?: string | null, country?: string | null, email?: string | null, name?: string | null, phone?: any | null, postCode?: string | null, street?: string | null, taxNo?: string | null } | null } };

export type GetPatientInvoiceDataQueryVariables = Exact<{
  after: Scalars['ISODateTime'];
  before: Scalars['ISODateTime'];
  patientId: Scalars['Int'];
}>;


export type GetPatientInvoiceDataQuery = { __typename?: 'Query', patientDetails: { __typename?: 'Patient', id: number, fullName: string, email?: string | null, address?: { __typename?: 'PatientAddress', id: number, city?: string | null, zipCode?: string | null, street?: string | null } | null, billingInfo?: { __typename?: 'BillingInfo', id: number, name?: string | null, street?: string | null, postCode?: string | null, city?: string | null, email?: string | null, taxNo?: string | null } | null }, paid: Array<{ __typename?: 'Event', id: number, hasInvoice: boolean, start: any, status: EventPayment, services: Array<{ __typename?: 'ServiceType', id: number, name: string, price: number }> }>, unpaid: Array<{ __typename?: 'Event', id: number, hasInvoice: boolean, start: any, status: EventPayment, services: Array<{ __typename?: 'ServiceType', id: number, name: string, price: number }> }> };

export type MakeMigrateQueryVariables = Exact<{
  new_practice_id: Scalars['Int'];
  new_practice_branch_id: Scalars['Int'];
  legacy_practice_name?: InputMaybe<Scalars['String']>;
}>;


export type MakeMigrateQuery = { __typename?: 'Query', makeMigrate: boolean };

export type AddPatientMutationVariables = Exact<{
  patientInput: PatientInput;
}>;


export type AddPatientMutation = { __typename?: 'Mutation', addPatient: { __typename?: 'Patient', id: number, therapist?: { __typename?: 'Employee', id: number } | null } };

export type EditPatientMutationVariables = Exact<{
  patientId: Scalars['Int'];
  addressId?: InputMaybe<Scalars['Int']>;
  patientInput: EditPatientInput;
}>;


export type EditPatientMutation = { __typename?: 'Mutation', editPatient: boolean };

export type FinishPatientsTherapyMutationVariables = Exact<{
  patientId: Scalars['Int'];
  finishDate?: InputMaybe<Scalars['ISODateTime']>;
  deletePatient?: InputMaybe<Scalars['Boolean']>;
}>;


export type FinishPatientsTherapyMutation = { __typename?: 'Mutation', finishPatientTherapy: boolean };

export type ReactivatePatientsTherapyMutationVariables = Exact<{
  patientId: Scalars['Int'];
}>;


export type ReactivatePatientsTherapyMutation = { __typename?: 'Mutation', reactivatePatientTherapy: boolean };

export type AddPatientEducatorNotesMutationVariables = Exact<{
  payload: PatientEducatorInput;
}>;


export type AddPatientEducatorNotesMutation = { __typename?: 'Mutation', addPatientEducatorNotes: number };

export type AddPatientPsychotherapyNotesMutationVariables = Exact<{
  payload: PatientPsychotherapyInput;
}>;


export type AddPatientPsychotherapyNotesMutation = { __typename?: 'Mutation', addPatientPsychotherapyNotes: number };

export type AddPatientSiNotesMutationVariables = Exact<{
  payload: PatientSiInput;
}>;


export type AddPatientSiNotesMutation = { __typename?: 'Mutation', addPatientSiNotes: number };

export type AddPatientSpeechTherapyNotesMutationVariables = Exact<{
  payload: PatientSpeechTherapyInput;
}>;


export type AddPatientSpeechTherapyNotesMutation = { __typename?: 'Mutation', addPatientSpeechtherapyNotes: number };

export type EditPatientEducatorNotesMutationVariables = Exact<{
  payload: PatientEducatorInput;
}>;


export type EditPatientEducatorNotesMutation = { __typename?: 'Mutation', editPatientEducatorNotes: number };

export type EditPatientPsychotherapyNotesMutationVariables = Exact<{
  payload: PatientPsychotherapyInput;
}>;


export type EditPatientPsychotherapyNotesMutation = { __typename?: 'Mutation', editPatientPsychotherapyNotes: number };

export type EditPatientSiNotesMutationVariables = Exact<{
  payload: PatientSiInput;
}>;


export type EditPatientSiNotesMutation = { __typename?: 'Mutation', editPatientSiNotes: number };

export type EditPatientSpeechTherapyNotesMutationVariables = Exact<{
  payload: PatientSpeechTherapyInput;
}>;


export type EditPatientSpeechTherapyNotesMutation = { __typename?: 'Mutation', editPatientSpeechtherapyNotes: number };

export type GetPatientDetailsQueryVariables = Exact<{
  patientId: Scalars['Int'];
}>;


export type GetPatientDetailsQuery = { __typename?: 'Query', patientDetails: { __typename?: 'Patient', id: number, firstName: string, lastName: string, fullName: string, phoneNumber?: any | null, email?: string | null, color?: string | null, deactivatedOn?: any | null, description: string, active: boolean, birthday?: any | null, createdAt: any, updatedAt?: any | null, deletedAt?: any | null, practiceId: number, idNumber?: string | null, secondPhoneNumber?: any | null, smsNotificationsActive: boolean, billingInfo?: { __typename?: 'BillingInfo', id: number } | null, attachmentsList?: Array<{ __typename?: 'Attachment', category: AttachmentCategoryEnum, url: string, name: string, id: number, createdAt: any }> | null, address?: { __typename?: 'PatientAddress', id: number, apartmentNumber?: string | null, city?: string | null, country?: string | null, county?: string | null, createdAt: any, houseNumber?: string | null, street?: string | null, zipCode?: string | null } | null, therapists: Array<{ __typename?: 'Employee', id: number, fullName?: string | null, email?: string | null, acronym?: string | null, color?: string | null, user?: { __typename?: 'User', fullName: string, id: string, firstName: string } | null }>, psychoTherapy?: { __typename?: 'PatientPsychoTherapy', diagnosis?: string | null, expectations?: string | null, medicalHistory?: string | null, occupation?: string | null, otherNotes?: string | null, triggerForTherapy?: string | null, id: number } | null, speechTherapy?: { __typename?: 'PatientSpeechTherapy', generalAim?: string | null, articulationExamination?: string | null, diagnosisTherapyPlan?: string | null, generalInfo?: string | null, medicalHistory?: string | null, otherNotes?: string | null, speechExamination?: string | null, id: number } | null, si?: { __typename?: 'PatientSIType', generalAim?: string | null, siDiagnosis?: string | null, therapyHints?: string | null, sensoricDiet?: string | null, diagnosisTherapyPlan?: string | null, generalInfo?: string | null, medicalHistory?: string | null, otherNotes?: string | null, id: number } | null, educator?: { __typename?: 'PatientEducatorType', generalAim?: string | null, diagnosisTherapyPlan?: string | null, generalInfo?: string | null, medicalHistory?: string | null, otherNotes?: string | null, id: number } | null, couples: Array<{ __typename?: 'Couple', coupleName: string, id: number, createdAt: any }>, groups: Array<{ __typename?: 'Groups', id: number, name: string }> } };

export type GetPatientsMeetingsHeldQueryVariables = Exact<{
  patientId: Scalars['Int'];
}>;


export type GetPatientsMeetingsHeldQuery = { __typename?: 'Query', patientMeetingsHeld: number };

export type PaginatedPatientsQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
  limit: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  page: Scalars['Int'];
  assignedTo?: InputMaybe<Array<Scalars['Int']>>;
  searchPhrase?: InputMaybe<Scalars['String']>;
}>;


export type PaginatedPatientsQuery = { __typename?: 'Query', paginatedPatients: { __typename?: 'PatientPagination', count: number, data: Array<{ __typename?: 'Patient', id: number, firstName: string, lastName: string, email?: string | null, active: boolean, signedGdprConsent?: any | null, phoneNumber?: any | null, therapists: Array<{ __typename?: 'Employee', id: number, acronym?: string | null, color?: string | null, fullName?: string | null }> }> } };

export type CreatePrzelewy24TransactionMutationVariables = Exact<{
  payload: Przelewy24OrderInput;
}>;


export type CreatePrzelewy24TransactionMutation = { __typename?: 'Mutation', createPrzelewy24Transaction: { __typename?: 'Przelewy24OrderRegister', link: string } };

export type EditOrCreateAppPaymentConfigMutationVariables = Exact<{
  payload: AppPaymentConfigInput;
}>;


export type EditOrCreateAppPaymentConfigMutation = { __typename?: 'Mutation', editOrCreateAppPaymentConfig: { __typename?: 'AppPaymentConfig', isEnabled: boolean, paymentMethods: Array<{ __typename?: 'PaymentMethod', isEnabled: boolean, method: EventPaymentMethods }> } };

export type GetPrzelewy24OrderQueryVariables = Exact<{
  sessionId: Scalars['String'];
}>;


export type GetPrzelewy24OrderQuery = { __typename?: 'Query', przelewy24Order?: { __typename?: 'Przelewy24Order', id: number, amount: number, category: string, createdAt: string, currency: string, description: string, orderId?: string | null, merchantId: number, posId: number, practiceId?: number | null, sessionId: string, token?: string | null, status: string, updatedAt: string } | null };

export type CreatePracticeMutationVariables = Exact<{
  payload: CreatePracticeInput;
}>;


export type CreatePracticeMutation = { __typename?: 'Mutation', createPractice: { __typename?: 'Practice', id: number, practiceBranches: Array<{ __typename?: 'PracticeBranch', id: number }> } };

export type DeletePracticeLogoMutationVariables = Exact<{ [key: string]: never; }>;


export type DeletePracticeLogoMutation = { __typename?: 'Mutation', deletePracticeLogo: boolean };

export type EditPracticeMutationVariables = Exact<{
  payload: EditPracticeInput;
}>;


export type EditPracticeMutation = { __typename?: 'Mutation', editPractice: boolean };

export type SetPracticeLogoMutationVariables = Exact<{
  payload: SetPracticeLogoInput;
}>;


export type SetPracticeLogoMutation = { __typename?: 'Mutation', setPracticeLogo: boolean };

export type GetAvailablePracticesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvailablePracticesQuery = { __typename?: 'Query', getAvailablePractices: Array<{ __typename?: 'Practice', id: number, name: string, shortName: string, restrictedAccess: boolean, servicesPerTherapist: boolean, billingAddress: { __typename?: 'Address', apartmentNumber?: string | null, city: string, country: string, county?: string | null, zipCode: string, street: string, houseNumber: string }, logo?: { __typename?: 'PracticeLogo', url: string } | null }> };

export type GetCurrentPracticeDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentPracticeDetailsQuery = { __typename?: 'Query', getCurrentPracticeDetails: { __typename?: 'Practice', id: number, name: string, shortName: string, invoicingEnabled: boolean, contactDetails: { __typename?: 'ContactDetails', id: number, email: string, phone: any }, billingAddress: { __typename?: 'Address', id: number, apartmentNumber?: string | null, city: string, country: string, county?: string | null, houseNumber: string, street: string, zipCode: string }, billingInfo?: { __typename?: 'BillingInfo', id: number, bank?: string | null, bankAccount?: string | null, city?: string | null, country?: string | null, email?: string | null, name?: string | null, phone?: any | null, postCode?: string | null, street?: string | null, taxNo?: string | null } | null, logo?: { __typename?: 'PracticeLogo', url: string } | null } };

export type AddPrzelewy24ConfigMutationVariables = Exact<{
  payload: Przelewy24ConfigInput;
}>;


export type AddPrzelewy24ConfigMutation = { __typename?: 'Mutation', addPrzelewy24Config: { __typename?: 'Przelewy24Config', invitationLink: string, isEnabled: boolean, crc: string, merchantId: number } };

export type AppPaymentConfigQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type AppPaymentConfigQueryQuery = { __typename?: 'Query', appPaymentConfig?: { __typename?: 'AppPaymentConfig', isEnabled: boolean, paymentMethods: Array<{ __typename?: 'PaymentMethod', isEnabled: boolean, method: EventPaymentMethods }> } | null };

export type Przelewy24ConfigQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type Przelewy24ConfigQueryQuery = { __typename?: 'Query', przelewy24Config?: { __typename?: 'Przelewy24Config', crc: string, invitationLink: string, isEnabled: boolean, merchantId: number } | null };

export type ConfirmMeetingRequestMutationVariables = Exact<{
  payload: ConfirmMeetingPayload;
}>;


export type ConfirmMeetingRequestMutation = { __typename?: 'Mutation', confirmMeeting: { __typename?: 'BookMeetingResponse', success: boolean } };

export type DeleteMeetingRequestsMutationVariables = Exact<{
  meetingRequestIds: Array<Scalars['Int']>;
}>;


export type DeleteMeetingRequestsMutation = { __typename?: 'Mutation', deleteMeetings: boolean };

export type RejectMeetingRequestsMutationVariables = Exact<{
  meetingRequestIds: Array<Scalars['Int']>;
  sendSms?: Scalars['Boolean'];
}>;


export type RejectMeetingRequestsMutation = { __typename?: 'Mutation', rejectMeetings: boolean };

export type SetOnlineRegistrationConfigMutationVariables = Exact<{
  config: UpsertOnlineRegistrationConfig;
}>;


export type SetOnlineRegistrationConfigMutation = { __typename?: 'Mutation', upsertOnlineRegistrationConfig: { __typename?: 'OnlineRegistrationConfigType', id: number, practiceSlug: string, minutesBetweenMeetings: number, isRegistrationEnabled: boolean, termsOfUseUrl?: string | null, privacyPolicyUrl?: string | null, roundSlotTimeTo: number, minimumPrecedingMinutes: number, maximumPrecedingMinutes: number, practice: { __typename?: 'Practice', id: number } } };

export type GetMeetingRequestQueryVariables = Exact<{
  meetingRequestId: Scalars['Int'];
}>;


export type GetMeetingRequestQuery = { __typename?: 'Query', getMeetingRequest: { __typename?: 'MeetingRequestType', id: number, practiceBranch: { __typename?: 'PracticeBranch', id: number, name: string, branchAddress?: { __typename?: 'Address', id: number, street: string, houseNumber: string, apartmentNumber?: string | null } | null }, lookalikePatients: Array<{ __typename?: 'Patient', id: number, fullName: string, phoneNumber?: any | null, email?: string | null }> } };

export type GetMeetingRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeetingRequestsQuery = { __typename?: 'Query', getMeetingRequests: Array<{ __typename?: 'MeetingRequestType', id: number, firstName: string, lastName: string, start: any, createdAt: any, service: { __typename?: 'ServiceType', id: number, name: string, price: number }, therapist: { __typename?: 'Employee', id: number, fullName?: string | null } }> };

export type GetOnlineRegistrationConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOnlineRegistrationConfigQuery = { __typename?: 'Query', getOnlineRegistrationConfigByPracticeId: { __typename?: 'OnlineRegistrationConfigType', id: number, practiceSlug: string, minutesBetweenMeetings: number, isRegistrationEnabled: boolean, termsOfUseUrl?: string | null, privacyPolicyUrl?: string | null, minimumPrecedingMinutes: number, maximumPrecedingMinutes: number, roundSlotTimeTo: number, isPreciseSearch: boolean, exactSlotProposal: number } };

export type GetPaginatedMeetingRequestsQueryVariables = Exact<{
  after: Scalars['ISODateTime'];
  before: Scalars['ISODateTime'];
  limit: Scalars['Int'];
  page: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  patients?: InputMaybe<Array<Scalars['String']>>;
  therapists?: InputMaybe<Array<Scalars['Int']>>;
  services?: InputMaybe<Array<Scalars['Int']>>;
  results?: InputMaybe<Array<MeetingRequestResult>>;
}>;


export type GetPaginatedMeetingRequestsQuery = { __typename?: 'Query', getPaginatedMeetingRequests: { __typename?: 'MeetingRequestTypePagination', count: number, data: Array<{ __typename?: 'MeetingRequestType', id: number, phoneNumber: string, email: string, firstName: string, lastName: string, start: any, createdAt: any, rejectedAt?: any | null, confirmedAt?: any | null, service: { __typename?: 'ServiceType', id: number, name: string, duration: any, price: number }, therapist: { __typename?: 'Employee', id: number, fullName?: string | null } }> } };

export type GetPaymentMethodsRegistrationQueryVariables = Exact<{
  practiceId: Scalars['Int'];
  enabledFilter: Scalars['Boolean'];
}>;


export type GetPaymentMethodsRegistrationQuery = { __typename?: 'Query', practicePaymentMethods: Array<{ __typename?: 'PaymentMethod', isEnabled: boolean, method: EventPaymentMethods }> };

export type GenerateIncomeReportMutationVariables = Exact<{
  after: Scalars['ISODateTime'];
  before: Scalars['ISODateTime'];
  language: Scalars['String'];
  timeZone: Scalars['String'];
  patientId?: InputMaybe<Scalars['Int']>;
  coupleId?: InputMaybe<Scalars['Int']>;
  patientIds?: InputMaybe<Array<Scalars['Int']>>;
  serviceIds?: InputMaybe<Array<Scalars['Int']>>;
  therapistIds?: InputMaybe<Array<Scalars['Int']>>;
  statuses?: InputMaybe<Array<Scalars['String']>>;
  paymentMethods?: InputMaybe<Array<Scalars['String']>>;
  fileType: Scalars['String'];
}>;


export type GenerateIncomeReportMutation = { __typename?: 'Mutation', generateIncomeReport: boolean };

export type GenerateEmployeeReportMutationVariables = Exact<{
  employeeId: Scalars['Int'];
  after: Scalars['ISODateTime'];
  before: Scalars['ISODateTime'];
  language: Scalars['String'];
  timeZone: Scalars['String'];
}>;


export type GenerateEmployeeReportMutation = { __typename?: 'Mutation', generateEmployeeReport: { __typename?: 'ReportResult', url: string } };

export type GenerateMeetingHistoryReportMutationVariables = Exact<{
  after: Scalars['ISODateTime'];
  before: Scalars['ISODateTime'];
  language: Scalars['String'];
  timeZone: Scalars['String'];
  patientId?: InputMaybe<Scalars['Int']>;
  coupleId?: InputMaybe<Scalars['Int']>;
}>;


export type GenerateMeetingHistoryReportMutation = { __typename?: 'Mutation', generateMeetingHistoryReport: { __typename?: 'ReportResult', url: string } };

export type GetEmployeesStatisticsQueryVariables = Exact<{
  employeeId: Scalars['Int'];
  after: Scalars['ISODateTime'];
  before: Scalars['ISODateTime'];
  practiceBranchId?: InputMaybe<Scalars['Int']>;
}>;


export type GetEmployeesStatisticsQuery = { __typename?: 'Query', employeeStatistics: { __typename?: 'EmployeeStatistics', meetingsHeld: number, meetingsCancelled: number, meetingsScheduled: number, meetingsHeldRate: number, servicesBreakdown: { __typename?: 'ServicesBreakdown', totalPrice: number, totalTime: any, services: Array<{ __typename?: 'ServicesBreakdownItem', id: number, name: string, meetingsHeld: number, meetingsDurationMinutes: any, meetingsIncome: number }> } } };

export type GetIncomeStatisticsQueryVariables = Exact<{
  after: Scalars['ISODateTime'];
  before: Scalars['ISODateTime'];
  practiceBranchId?: InputMaybe<Scalars['Int']>;
}>;


export type GetIncomeStatisticsQuery = { __typename?: 'Query', incomeStatistics: { __typename?: 'IncomeStatistics', income: number, prevIncome: number, lostIncome: number, unpaidIncome: number, previousPeriodDates: { __typename?: 'DatePeriod', start: any, end: any } } };

export type GetServicesStatisticsQueryVariables = Exact<{
  after: Scalars['ISODateTime'];
  before: Scalars['ISODateTime'];
  practiceBranchId?: InputMaybe<Scalars['Int']>;
}>;


export type GetServicesStatisticsQuery = { __typename?: 'Query', serviceStatistics: { __typename?: 'ServiceStatistics', meetings: { __typename?: 'MeetingStatistics', meetingsHeld: { __typename?: 'ComparisonItem', current: number, prev: number }, meetingsSheduled: { __typename?: 'ComparisonItem', current: number, prev: number }, meetingsCancelled: { __typename?: 'ComparisonItem', current: number, prev: number }, patientsNumbers: { __typename?: 'ComparisonItem', current: number, prev: number }, therapiesFinished: { __typename?: 'ComparisonItem', current: number, prev: number }, therapiesNew: { __typename?: 'ComparisonItem', current: number, prev: number } }, services: Array<{ __typename?: 'ComparisonItem', name?: string | null, current: number, prev: number, price?: number | null }>, previousPeriodDates: { __typename?: 'DatePeriod', start: any, end: any } } };

export type AddRoomMutationVariables = Exact<{
  payload: AddRoomInput;
}>;


export type AddRoomMutation = { __typename?: 'Mutation', addRoom: { __typename?: 'Room', id: number } };

export type EditRoomMutationVariables = Exact<{
  roomId: Scalars['Int'];
  payload: EditRoomInput;
}>;


export type EditRoomMutation = { __typename?: 'Mutation', editRoom: boolean };

export type GetPaginatedRoomsQueryVariables = Exact<{
  page: Scalars['Int'];
  limit: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
}>;


export type GetPaginatedRoomsQuery = { __typename?: 'Query', paginatedRooms: { __typename?: 'RoomPagination', count: number, totals: any, pageTotals: any, data: Array<{ __typename?: 'Room', id: number, name: string, availableOnline: boolean, comments?: string | null, slug: string, preferredBy: Array<{ __typename?: 'Employee', id: number, color?: string | null, fullName?: string | null, acronym?: string | null }>, excludedServices: Array<{ __typename?: 'ServiceType', id: number, name: string, price: number }> }> } };

export type GetRoomsListQueryVariables = Exact<{
  serviceId?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['DateTime']>;
}>;


export type GetRoomsListQuery = { __typename?: 'Query', getRoomsList: Array<{ __typename?: 'RoomListEntry', id: number, name: string, slug: string, availableOnline: boolean, preferredBy: Array<number> }> };

export type CreateServiceMutationVariables = Exact<{
  payload: ServiceInput;
}>;


export type CreateServiceMutation = { __typename?: 'Mutation', createService: { __typename?: 'ServiceType', id: number } };

export type DeactivateServicesMutationVariables = Exact<{
  serviceIds: Array<Scalars['Int']>;
}>;


export type DeactivateServicesMutation = { __typename?: 'Mutation', deactivateServices: boolean };

export type EditServiceMutationVariables = Exact<{
  serviceId: Scalars['Int'];
  payload: EditServiceInput;
}>;


export type EditServiceMutation = { __typename?: 'Mutation', editService: boolean };

export type GetPaginatedServicesQueryVariables = Exact<{
  limit: Scalars['Int'];
  page: Scalars['Int'];
  searchPhrase?: InputMaybe<Scalars['String']>;
  practiceBranchId: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
}>;


export type GetPaginatedServicesQuery = { __typename?: 'Query', paginatedServices: { __typename?: 'ServiceTypePagination', count: number, pageTotals: any, data: Array<{ __typename?: 'ServiceType', id: number, name: string, price: number, duration: any, comments?: string | null, availableInOnlineRegistration: boolean, availableOnline: boolean, assignedTo: Array<{ __typename?: 'Employee', fullName?: string | null, color?: string | null, id: number, acronym?: string | null }> }> } };

export type GetPaginatedServicesBreakdownQueryVariables = Exact<{
  after: Scalars['ISODateTime'];
  before: Scalars['ISODateTime'];
  limit: Scalars['Int'];
  page: Scalars['Int'];
  employeeId: Scalars['Int'];
  practiceBranchId?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
}>;


export type GetPaginatedServicesBreakdownQuery = { __typename?: 'Query', paginatedServicesBreakdown: { __typename?: 'ServiceBreakdownTypePagination', count: number, pageTotals: any, data: Array<{ __typename?: 'ServiceBreakdownType', id: number, name: string, count: number, amount: number, time: any }> } };

export type GetServicesQueryVariables = Exact<{
  limit: Scalars['Int'];
  page: Scalars['Int'];
  practiceBranchId: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  names?: InputMaybe<Array<Scalars['String']>>;
  prices?: InputMaybe<FloatRangeInput>;
  durations?: InputMaybe<FloatRangeInput>;
  assignedTo?: InputMaybe<Array<Scalars['Int']>>;
  online?: InputMaybe<Scalars['Boolean']>;
  searchPhrase?: InputMaybe<Scalars['String']>;
}>;


export type GetServicesQuery = { __typename?: 'Query', paginatedServices: { __typename?: 'ServiceTypePagination', count: number, data: Array<{ __typename?: 'ServiceType', id: number, name: string, price: number, duration: any, availableOnline: boolean, comments?: string | null, availableInOnlineRegistration: boolean, assignedTo: Array<{ __typename?: 'Employee', id: number, acronym?: string | null, color?: string | null, user?: { __typename?: 'User', firstName: string } | null }> }> } };

export type GetServicesListQueryVariables = Exact<{
  orderBy?: InputMaybe<OrderBy>;
}>;


export type GetServicesListQuery = { __typename?: 'Query', servicesList: Array<{ __typename?: 'ServiceListEntry', id: number, name: string, price: number, assignedTo: Array<number>, duration: string, availableInOnlineRegistration: boolean }> };

export type GetTimeSlotsQueryVariables = Exact<{
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  practiceId: Scalars['Int'];
  serviceIds?: InputMaybe<Array<Scalars['Int']>>;
  practiceBranchId?: InputMaybe<Scalars['Int']>;
  therapistIds?: InputMaybe<Array<Scalars['Int']>>;
  oneSlot?: InputMaybe<Scalars['Boolean']>;
  earliestSlotPerTherapist?: InputMaybe<Scalars['Boolean']>;
  sortAndLimit?: InputMaybe<Scalars['Int']>;
  showEmptyDates?: InputMaybe<Scalars['Boolean']>;
  searchEngine?: InputMaybe<Scalars['Boolean']>;
  customBreakBetweenMeetings?: InputMaybe<Scalars['Int']>;
}>;


export type GetTimeSlotsQuery = { __typename?: 'Query', getTimeSlots: Array<{ __typename?: 'AvailableSlots', id: string, slots: Array<any>, therapistId: number, date: string, serviceId: number, serviceName: string }> };

export type PurchaseSmsPacketMutationVariables = Exact<{
  payload: SmsPacketPurchaseInput;
}>;


export type PurchaseSmsPacketMutation = { __typename?: 'Mutation', purchaseSmsPacket: { __typename?: 'Przelewy24OrderRegister', link: string } };

export type SendSmsMutationVariables = Exact<{
  phoneNumber: Scalars['PhoneNumber'];
  templateType: SmsTemplateTypeEnum;
  practiceBranchId?: InputMaybe<Scalars['Int']>;
}>;


export type SendSmsMutation = { __typename?: 'Mutation', sendDemoSms: { __typename?: 'DemoSMSResponse', quota: number, status: string, text: string, details?: string | null } };

export type UpdateSmsConfigMutationVariables = Exact<{
  values: SmsConfigPartialInput;
}>;


export type UpdateSmsConfigMutation = { __typename?: 'Mutation', updateSmsConfig: { __typename?: 'SMSConfig', active: boolean, daysBefore: DaysBeforeEnum, hoursBefore: HoursBeforeEnum, newMeetingActive: boolean, quota: number, reminderPerBranchTemplate: boolean, meetingCanceledActive: boolean, sendingTime: any, reminderSendingTime: ReminderSendingTimeEnum, timeChangeActive: boolean } };

export type UpdateSmsTemplateMutationVariables = Exact<{
  language: SmsTemplateLanguageEnum;
  templateType?: InputMaybe<SmsTemplateTypeEnum>;
  text: Scalars['String'];
  practiceBranchId?: InputMaybe<Scalars['Int']>;
}>;


export type UpdateSmsTemplateMutation = { __typename?: 'Mutation', updateSmsTemplate: { __typename?: 'SMSTemplate', text: string } | { __typename?: 'SMSTemplateError' } };

export type GetSmsConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSmsConfigQuery = { __typename?: 'Query', smsConfig: { __typename?: 'SMSConfig', active: boolean, hoursBefore: HoursBeforeEnum, daysBefore: DaysBeforeEnum, newMeetingActive: boolean, quota: number, perPeriodQuota: number, customQuota: number, reminderPerBranchTemplate: boolean, reminderSendingTime: ReminderSendingTimeEnum, sendingTime: any, timeChangeActive: boolean, meetingCanceledActive: boolean, nonTherapistNotifyingTemplates: Array<string> } };

export type GetSmsHistoryQueryVariables = Exact<{
  after: Scalars['ISODateTime'];
  before: Scalars['ISODateTime'];
  limit: Scalars['Int'];
  page: Scalars['Int'];
  orderBy?: InputMaybe<OrderBy>;
  searchPhrase?: InputMaybe<Scalars['String']>;
}>;


export type GetSmsHistoryQuery = { __typename?: 'Query', paginatedSentSmss: { __typename?: 'SentSMSPagination', count: number, data: Array<{ __typename?: 'SentSMS', id: number, details?: string | null, phoneNumber: any, sentAt: any, status: SentSmsStatus, quota: number, text: string, patient?: { __typename?: 'Patient', id: number, fullName: string } | null }> } };

export type GetSmsPacketsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSmsPacketsQuery = { __typename?: 'Query', smsPackets: Array<{ __typename?: 'SMSPacket', smsNumber: number, tax: number, price: number }> };

export type GetSmsTemplatesQueryVariables = Exact<{
  templateType: SmsTemplateTypeEnum;
  language?: InputMaybe<SmsTemplateLanguageEnum>;
}>;


export type GetSmsTemplatesQuery = { __typename?: 'Query', smsTemplates: { __typename?: 'SMSTemplates', practiceTemplateText: string, branchesTemplates: Array<{ __typename?: 'SMSBranchTemplate', text: string, practiceBranch: { __typename?: 'PracticeBranch', id: number, name: string, shortName: string } }> } };

export type DeleteUserAvatarMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteUserAvatarMutation = { __typename?: 'Mutation', deleteUserAvatar: boolean };

export type EditUserSettingsMutationVariables = Exact<{
  payload: UserInput;
}>;


export type EditUserSettingsMutation = { __typename?: 'Mutation', editUserSettings: boolean };

export type SetUserAvatarMutationVariables = Exact<{
  payload: AvatarInput;
}>;


export type SetUserAvatarMutation = { __typename?: 'Mutation', setUserAvatar: boolean };

export type GetUserAvatarQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserAvatarQuery = { __typename?: 'Query', getUserAvatar?: { __typename?: 'Avatar', contentType: string, url: string } | null };

export type WorkTimePresetFieldsFragment = { __typename?: 'WorkTimePresetType', id: number, name: string, startDate?: any | null, endDate?: any | null, workDays: Array<{ __typename?: 'WorkDayType', day: number, workTime: { __typename?: 'WorkTimeType', startTime: any, endTime: any } }> };

export type AddWorktimeExceptionMutationVariables = Exact<{
  input: WorkTimeExceptionInput;
}>;


export type AddWorktimeExceptionMutation = { __typename?: 'Mutation', addWorktimeException: { __typename?: 'WorkTimeExceptionType', presetId: number, startDate: any, dates: Array<any>, workTimes: Array<{ __typename?: 'WorkTimeType', startTime: any, endTime: any }> } };

export type AddWorktimePresetMutationVariables = Exact<{
  input: WorkTimePresetInput;
}>;


export type AddWorktimePresetMutation = { __typename?: 'Mutation', addWorktimePreset: boolean };

export type EditWorktimeConfigMutationVariables = Exact<{
  input: WorkTimeConfigInput;
}>;


export type EditWorktimeConfigMutation = { __typename?: 'Mutation', editWorktimeConfig: { __typename?: 'WorkTimeConfigType', holidayConsiderationRequired?: boolean | null, automaticEventCancellationTime: CancellationTimeEum } };

export type EditWorktimeExceptionMutationVariables = Exact<{
  worktimeExceptionId: Scalars['Int'];
  input: EditWorkTimeExceptionInput;
}>;


export type EditWorktimeExceptionMutation = { __typename?: 'Mutation', editWorktimeException: { __typename?: 'WorkTimeExceptionType', presetId: number, startDate: any, dates: Array<any>, workTimes: Array<{ __typename?: 'WorkTimeType', startTime: any, endTime: any }> } };

export type RemoveWorktimeExceptionMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RemoveWorktimeExceptionMutation = { __typename?: 'Mutation', removeWorktimeException: boolean };

export type RemoveWorktimePresetMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RemoveWorktimePresetMutation = { __typename?: 'Mutation', removeWorktimePreset: boolean };

export type WorkTimePresetQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type WorkTimePresetQuery = { __typename?: 'Query', workTimePreset: Array<{ __typename?: 'WorkTimePresetType', id: number, name: string, startDate?: any | null, endDate?: any | null, workDays: Array<{ __typename?: 'WorkDayType', day: number, workTime: { __typename?: 'WorkTimeType', startTime: any, endTime: any } }> }> };

export type WorkTimePresetsQueryVariables = Exact<{
  employeeIds: Array<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
}>;


export type WorkTimePresetsQuery = { __typename?: 'Query', workTimePresets: Array<{ __typename?: 'WorkTimePresetType', id: number, name: string, startDate?: any | null, endDate?: any | null, workDays: Array<{ __typename?: 'WorkDayType', day: number, workTime: { __typename?: 'WorkTimeType', startTime: any, endTime: any } }> }> };

export const BillingInfoFragment = gql`
    fragment BillingInfoFragment on BillingInfo {
  id
  name
  taxNo
  street
  postCode
  city
  country
  email
  phone
  bank
  bankAccount
}
    `;
export const EmployeeBase = gql`
    fragment EmployeeBase on Employee {
  id
  color
  practiceBranchId
  acceptedInvitation
  phoneNumber
  acronym
  email
  fullName
  firstName
  lastName
  roles {
    name
    slug
  }
}
    `;
export const EmployeeDetail = gql`
    fragment EmployeeDetail on Employee {
  ...EmployeeBase
  availableInOnlineRegistration
  user {
    fullName
    firstName
    lastLogin: lastSeen
    lastName
    id
  }
  preferredRooms: preferredRoom {
    id
    name
  }
}
    ${EmployeeBase}`;
export const EventData = gql`
    fragment EventData on Event {
  id
  end
  attachments {
    url
    name
    id
    createdAt
  }
  couple {
    id
    coupleName
    deletedAt
    createdAt
    deactivatedOn
    smsNotificationsActive
    patients {
      id
      firstName
      lastName
      fullName
      phoneNumber
      secondPhoneNumber
      email
      active
      therapists {
        id
        email
        phoneNumber
        fullName
        acronym
        color
        user {
          firstName
          lastName
        }
      }
    }
    therapists {
      id
      email
      phoneNumber
      fullName
      acronym
      color
      user {
        firstName
        lastName
      }
    }
  }
  period {
    id
    dows
    start
    end
    interval
    duration
    name
  }
  duration
  groupPresence {
    name
    value
  }
  note
  start
  duration
  paidOn
  name
  locked
  shifted
  therapists {
    id
    email
    phoneNumber
    acronym
    color
    user {
      firstName
      lastName
    }
    fullName
  }
  room {
    id
    name
    availableOnline
    comments
    slug
    practiceBranch {
      name
      shortName
      id
    }
  }
  services {
    id
    name
    price
    availableOnline
    practiceBranch {
      name
      shortName
      id
    }
  }
  participants {
    id
    payment
    presence {
      name
      value
    }
    paymentMethod {
      name
      value
    }
    patient {
      id
      firstName
      lastName
      fullName
      phoneNumber
      secondPhoneNumber
      description
      birthday
      email
      deactivatedOn
      createdAt
      active
      deletedAt
      therapists {
        id
        fullName
        color
        acronym
      }
    }
  }
}
    `;
export const InitialCalendarEvent = gql`
    fragment InitialCalendarEvent on Event {
  id
  start
  end
  name
  locked
  cancelled
  shifted
  duration
  paidOn
  serviceName
  serviceNameWithPrice
  couple {
    id
    coupleName
  }
  groupPresenceName
  periodId
  therapistIds
  therapistColor
  serviceIds
  roomId
  hasNote
  participants {
    id
    presenceName
    payment
    paymentMethodName
    patient {
      id
      therapists {
        id
      }
      fullName
    }
  }
}
    `;
export const InvoiceDetail = gql`
    fragment InvoiceDetail on Invoice {
  externalInvoice {
    id
    issueDate
    number
    paymentTo
    sellDate
    status
    viewUrl
    paymentType
    sellerName
    sellerStreet
    sellerPostCode
    sellerCity
    sellerCountry
    sellerTaxNo
    sellerEmail
    sellerPhone
    sellerBank
    sellerBankAccount
    buyerName
    buyerStreet
    buyerPostCode
    buyerCity
    buyerEmail
    buyerTaxNo
    description
    paid
    unpaid
    priceGross
  }
  clientBillingInfo {
    bank
    bankAccount
    city
    country
    email
    id
    name
    postCode
    street
    taxNo
  }
  addClientTax
  externalId
  practiceBranch {
    id
    name
    shortName
  }
  lineItems {
    externalId
    id
    itemPrice
    name
    quantity
    tax
    taxFree
    taxNotApplicable
    totalPriceGross
    totalPriceNet
    totalPriceTax
  }
  kind
  patientEmails
  issueDate
  id
  paymentTo
  number
  notes
  name
  sellDate
  sentTo {
    id
    emails
    sentAt
  }
  status
  totalPriceGross
  totalPriceNet
  totalPriceTax
}
    `;
export const InvoiceEvent = gql`
    fragment InvoiceEvent on Event {
  id
  hasInvoice
  start
  services {
    id
    name
    price
  }
  status
}
    `;
export const WorkTimePresetFields = gql`
    fragment WorkTimePresetFields on WorkTimePresetType {
  id
  name
  startDate
  endDate
  workDays {
    day
    workTime {
      startTime
      endTime
    }
  }
}
    `;
export const DeleteAttachments = gql`
    mutation DeleteAttachments($attachmentIds: [Int!]!) {
  deleteAttachments(attachmentIds: $attachmentIds)
}
    `;
export const AddBillingInfo = gql`
    mutation AddBillingInfo($model: String!, $patientId: Int = null, $payload: BillingInfoInput!) {
  addBillingInfo(model: $model, patientId: $patientId, payload: $payload) {
    id
  }
}
    `;
export const EditBillingInfo = gql`
    mutation EditBillingInfo($id: Int!, $payload: BillingInfoInput!) {
  editBillingInfo(id: $id, payload: $payload) {
    ...BillingInfoFragment
  }
}
    ${BillingInfoFragment}`;
export const RemoveBillingInfos = gql`
    mutation RemoveBillingInfos($id: [Int!]!, $deletedAt: ISODateTime = null) {
  removeBillingInfo(id: $id, deletedAt: $deletedAt)
}
    `;
export const GetBillingInfoDetails = gql`
    query GetBillingInfoDetails($id: Int!) {
  billingInfoDetails(id: $id) {
    id
    name
    taxNo
    street
    postCode
    city
    country
    email
    phone
    bank
    bankAccount
  }
}
    `;
export const AddCouple = gql`
    mutation AddCouple($payload: CoupleInput!) {
  addCouple(payload: $payload) {
    id
    therapists {
      id
    }
  }
}
    `;
export const EditCouple = gql`
    mutation EditCouple($coupleId: Int!, $payload: CoupleInput!) {
  editCouple(coupleId: $coupleId, payload: $payload)
}
    `;
export const FinishCouplesTherapy = gql`
    mutation FinishCouplesTherapy($coupleId: Int!, $finishDate: ISODateTime = null, $deleteCouple: Boolean = false) {
  finishCoupleTherapy(
    coupleId: $coupleId
    finishDate: $finishDate
    deleteCouple: $deleteCouple
  )
}
    `;
export const ReactivateCoupleTherapy = gql`
    mutation ReactivateCoupleTherapy($coupleId: Int!) {
  reactivateCoupleTherapy(coupleId: $coupleId)
}
    `;
export const GetCoupleMeetingsHeld = gql`
    query GetCoupleMeetingsHeld($coupleId: Int!) {
  coupleMeetingsHeld(coupleId: $coupleId)
}
    `;
export const GetPaginatedCouples = gql`
    query GetPaginatedCouples($therapistId: Int!, $limit: Int!, $page: Int!, $searchPhrase: String, $orderBy: OrderBy, $assignedTo: [Int!], $showDeactivated: Boolean! = false) {
  couplePaginatedQuery(
    therapistId: $therapistId
    limit: $limit
    page: $page
    searchPhrase: $searchPhrase
    orderBy: $orderBy
    assignedTo: $assignedTo
    showDeactivated: $showDeactivated
  ) {
    count
    data {
      id
      coupleName
      deactivatedOn
      patients {
        id
        firstName
        lastName
        phoneNumber
        secondPhoneNumber
        email
      }
      therapists {
        id
        color
        fullName
        user {
          firstName
        }
      }
    }
  }
}
    `;
export const CreateEmployee = gql`
    mutation CreateEmployee($payload: CreateEmployeeInput!) {
  createEmployee(payload: $payload)
}
    `;
export const DeactivateEmployee = gql`
    mutation DeactivateEmployee($employeeId: Int!) {
  deactivateEmployee(employeeId: $employeeId)
}
    `;
export const EditEmployee = gql`
    mutation EditEmployee($employeeId: Int!, $payload: EditEmployeeInput!) {
  editEmployee(employeeId: $employeeId, payload: $payload)
}
    `;
export const EditEmployeeFavoriteTherapists = gql`
    mutation EditEmployeeFavoriteTherapists($employeeId: Int!, $therapists: [Int!] = []) {
  editFavoriteTherapists(employeeId: $employeeId, therapists: $therapists)
}
    `;
export const SendEmployeeInvitation = gql`
    mutation SendEmployeeInvitation($id: Int!) {
  sendEmployeeInvitation(employeeInput: {id: $id})
}
    `;
export const GetEmployeeFavoriteTherapists = gql`
    query GetEmployeeFavoriteTherapists($employeeId: Int) {
  favoriteTherapists(employeeId: $employeeId) {
    id
    fullName
    color
    acronym
  }
}
    `;
export const EmployeeInvitationInfo = gql`
    query EmployeeInvitationInfo($invitationUUID: String!) {
  employeeInvitationInfo(invitationUuid: $invitationUUID) {
    practiceName
    invitedEmail
  }
}
    `;
export const GetAllEmployees = gql`
    query GetAllEmployees {
  employees {
    ...EmployeeBase
  }
}
    ${EmployeeBase}`;
export const GetEmployee = gql`
    query GetEmployee($id: Int!) {
  employee(id: $id) {
    ...EmployeeDetail
  }
}
    ${EmployeeDetail}`;
export const GetEmployeeByUserId = gql`
    query GetEmployeeByUserId($userId: String!) {
  getEmployeeByUserId(userId: $userId) {
    acronym
    color
    id
    phoneNumber
    user {
      dateJoined
      email
      firstName
      fullName
      id
      lastName
    }
    practiceBranchId
    practiceId
    roles {
      name
      slug
    }
  }
}
    `;
export const GetEmployeeList = gql`
    query GetEmployeeList {
  getEmployeeList {
    id
    acronym
    color
    email
    roles {
      name
      slug
    }
    fullName
  }
}
    `;
export const GetEmployeesTable = gql`
    query GetEmployeesTable($limit: Int!, $page: Int!, $practiceBranchId: Int!, $orderBy: OrderBy, $searchPhrase: String, $role: String) {
  paginatedEmployees(
    limit: $limit
    page: $page
    orderBy: $orderBy
    practiceBranchId: $practiceBranchId
    searchPhrase: $searchPhrase
    role: $role
    all: true
  ) {
    count
    data {
      id
      fullName
      acronym
      email
      phoneNumber
      roles {
        name
        slug
      }
      color
      acceptedInvitation
      availableInOnlineRegistration
      practiceBranch {
        id
        name
      }
    }
  }
}
    `;
export const AddPeriodicEvent = gql`
    mutation AddPeriodicEvent($duration: TimeDeltaMinutes!, $patients: [Int!]!, $services: [Int!]!, $start: ISODateTime!, $therapistIds: [Int!]!, $roomId: Int!, $end: ISODateTime = null, $name: String!, $interval: Int!, $dows: [Int!]!, $coupleId: Int) {
  addPeriodicEvent(
    eventInput: {start: $start, roomId: $roomId, duration: $duration, name: $name, patients: $patients, services: $services, therapistIds: $therapistIds, end: $end, interval: $interval, dows: $dows, coupleId: $coupleId}
  ) {
    id
  }
}
    `;
export const AddSingleEvent = gql`
    mutation AddSingleEvent($duration: TimeDeltaMinutes!, $patients: [Int!]!, $services: [Int!]!, $start: ISODateTime!, $therapistIds: [Int!]!, $roomId: Int!, $name: String = "", $coupleId: Int) {
  addSingleEvent(
    eventInput: {start: $start, roomId: $roomId, duration: $duration, name: $name, patients: $patients, services: $services, therapistIds: $therapistIds, coupleId: $coupleId}
  ) {
    ... on Event {
      id
    }
  }
}
    `;
export const AddSingleEventWithCollisions = gql`
    mutation AddSingleEventWithCollisions($eventInput: EventInput!, $collisionLimit: Int = 5) {
  addSingleEventWithCollisions(
    eventInput: $eventInput
    collisionLimit: $collisionLimit
  ) {
    ... on EventOutput {
      success
      event {
        id
      }
      collisions {
        reason
        event {
          id
        }
      }
    }
  }
}
    `;
export const DeactivateRooms = gql`
    mutation DeactivateRooms($roomIds: [Int!]!) {
  deactivateRooms(roomIds: $roomIds)
}
    `;
export const DeleteEventAttachment = gql`
    mutation DeleteEventAttachment($attachmentId: Int!) {
  deleteEventAttachment(attachmentId: $attachmentId)
}
    `;
export const DeleteEventSeries = gql`
    mutation DeleteEventSeries($eventPeriodId: Int!, $afterDate: ISODateTime!) {
  deleteEventSeries(eventPeriodId: $eventPeriodId, afterDate: $afterDate)
}
    `;
export const EditEvent = gql`
    mutation EditEvent($eventId: Int!, $payload: EventEditAttributes!) {
  editEvent(eventId: $eventId, payload: $payload) {
    ...InitialCalendarEvent
  }
}
    ${InitialCalendarEvent}`;
export const EditEventPaymentStatuses = gql`
    mutation EditEventPaymentStatuses($eventIds: [Int!]!, $paymentStatus: EventPayment!, $paidOn: ISODate = null, $paymentMethod: EventPaymentMethods = null) {
  editEventPaymentStatuses(
    eventIds: $eventIds
    paymentStatus: $paymentStatus
    paidOn: $paidOn
    paymentMethod: $paymentMethod
  )
}
    `;
export const EditEventSeries = gql`
    mutation EditEventSeries($payload: EventSeriesEditAttributes!, $eventId: Int!) {
  editEventSeries(eventId: $eventId, payload: $payload)
}
    `;
export const EditEventWithCollisions = gql`
    mutation EditEventWithCollisions($eventId: Int!, $payload: EventEditAttributes!, $collisionLimit: Int = 5) {
  editEventWithCollisions(
    eventId: $eventId
    payload: $payload
    collisionLimit: $collisionLimit
  ) {
    ... on EventOutput {
      success
      event {
        id
      }
      collisions {
        reason
        event {
          id
        }
      }
    }
  }
}
    `;
export const ShiftEventSeries = gql`
    mutation ShiftEventSeries($payload: EventSeriesEditAttributes!, $eventId: Int!) {
  shiftEventSeries(eventId: $eventId, payload: $payload)
}
    `;
export const ChangeEventIntoSeries = gql`
    mutation ChangeEventIntoSeries($dows: [Int!]!, $eventId: Int!, $interval: Int!, $end: ISODateTime = null) {
  changeEventIntoEventSeries(
    dows: $dows
    eventId: $eventId
    interval: $interval
    end: $end
  )
}
    `;
export const GetCoupleMeetingDetails = gql`
    query GetCoupleMeetingDetails($eventId: Int!) {
  event(eventId: $eventId) {
    id
    start
    note
    secretNote
    duration
    paidOn
    locked
    shifted
    couple {
      id
      coupleName
      therapists {
        id
      }
    }
    period {
      id
    }
    groupPresence {
      name
    }
    services {
      id
    }
    therapists {
      id
    }
    room {
      id
    }
    participants {
      id
      payment
      paymentMethodName
      patient {
        id
        fullName
        phoneNumber
        email
        therapists {
          id
        }
      }
    }
  }
}
    `;
export const GetCoupleUpcomingEvents = gql`
    query GetCoupleUpcomingEvents($after: ISODateTime!, $coupleId: Int!) {
  coupleUpcomingEvents(after: $after, coupleId: $coupleId) {
    id
    start
    end
  }
}
    `;
export const GetEvent = gql`
    query GetEvent($eventId: Int!) {
  event(eventId: $eventId) {
    ...EventData
    secretNote
    nextEvent
    prevEvent
  }
}
    ${EventData}`;
export const GetEvents = gql`
    query GetEvents($after: ISODateTime!, $before: ISODateTime!, $employeeIds: [Int!], $patientId: Int, $coupleId: Int) {
  events(
    after: $after
    before: $before
    employeeIds: $employeeIds
    patientId: $patientId
    coupleId: $coupleId
  ) {
    ...EventData
  }
}
    ${EventData}`;
export const GetEventsByServiceIdAndPracticeBranchId = gql`
    query GetEventsByServiceIdAndPracticeBranchId($after: ISODateTime!, $before: ISODateTime!, $employeeIds: [Int!], $serviceId: Int, $practiceBranchId: Int, $patientId: Int, $coupleId: Int, $heldMeetings: Boolean = false, $orderBy: OrderBy) {
  eventsWithSorting(
    after: $after
    before: $before
    employeeIds: $employeeIds
    serviceId: $serviceId
    practiceBranchId: $practiceBranchId
    patientId: $patientId
    coupleId: $coupleId
    heldMeetings: $heldMeetings
    orderBy: $orderBy
  ) {
    id
    couple {
      id
      coupleName
    }
    start
    participants {
      id
      payment
      patient {
        id
        firstName
        lastName
      }
    }
    services {
      id
      price
    }
  }
}
    `;
export const GetInitialCalendar = gql`
    query GetInitialCalendar($after: ISODateTime!, $before: ISODateTime!, $employeeIds: [Int!], $patientId: Int, $coupleId: Int) {
  events(
    after: $after
    before: $before
    employeeIds: $employeeIds
    patientId: $patientId
    coupleId: $coupleId
  ) {
    ...InitialCalendarEvent
  }
}
    ${InitialCalendarEvent}`;
export const GetPaginatedEvents = gql`
    query GetPaginatedEvents($after: ISODateTime!, $before: ISODateTime!, $limit: Int!, $page: Int!, $employeeIds: [Int!], $orderBy: OrderBy, $patientId: Int, $coupleId: Int, $serviceId: Int) {
  paginatedEvents(
    after: $after
    before: $before
    limit: $limit
    page: $page
    orderBy: $orderBy
    employeeIds: $employeeIds
    patientId: $patientId
    coupleId: $coupleId
    serviceId: $serviceId
  ) {
    count
    data {
      ...EventData
    }
  }
}
    ${EventData}`;
export const GetPatientMeetingDetails = gql`
    query GetPatientMeetingDetails($eventId: Int!) {
  event(eventId: $eventId) {
    id
    start
    note
    secretNote
    duration
    paidOn
    locked
    shifted
    period {
      id
    }
    services {
      id
    }
    therapists {
      id
    }
    room {
      id
    }
    participants {
      id
      presenceName
      payment
      paymentMethodName
      patient {
        id
        fullName
        phoneNumber
        email
        description
        therapists {
          id
        }
      }
    }
  }
}
    `;
export const GetPatientUpcomingEvents = gql`
    query GetPatientUpcomingEvents($after: ISODateTime!, $patientId: Int!) {
  patientUpcomingEvents(after: $after, patientId: $patientId) {
    id
    start
    end
  }
}
    `;
export const GetWithoutPatientsMeetingDetails = gql`
    query GetWithoutPatientsMeetingDetails($eventId: Int!) {
  event(eventId: $eventId) {
    id
    start
    duration
    name
    locked
    shifted
    period {
      id
    }
    therapists {
      id
    }
    room {
      id
    }
  }
}
    `;
export const AddExpense = gql`
    mutation AddExpense($practiceBranchId: Int!, $name: String!, $note: String, $amount: Float!, $recurringPeriod: RecurringExpenseEnum, $date: Date!) {
  addExpense(
    expenseInput: {practiceBranchId: $practiceBranchId, name: $name, note: $note, amount: $amount, date: $date, recurringPeriod: $recurringPeriod}
  ) {
    expenses {
      id
    }
  }
}
    `;
export const EditExpense = gql`
    mutation EditExpense($expenseId: Int!, $payload: ExpensesEditAttributes!) {
  editExpense(expenseId: $expenseId, payload: $payload)
}
    `;
export const RemoveExpense = gql`
    mutation RemoveExpense($expenseIds: [Int!]!) {
  removeExpenses(expenseIds: $expenseIds) {
    success
  }
}
    `;
export const GetExpenses = gql`
    query GetExpenses($after: Date!, $before: Date!, $limit: Int!, $page: Int!, $orderBy: OrderBy) {
  paginatedExpenses(
    after: $after
    before: $before
    limit: $limit
    page: $page
    orderBy: $orderBy
  ) {
    count
    pageTotals
    totals
    data {
      id
      name
      amount
      note
      date
      recurring {
        recurringPeriod
      }
      author {
        fullName
        id
      }
    }
  }
}
    `;
export const EditGdprConfig = gql`
    mutation EditGDPRConfig($payload: EditGDPRConfigInput!) {
  editGdprConfig(payload: $payload)
}
    `;
export const MarkGdprDocumentAsOpened = gql`
    mutation MarkGDPRDocumentAsOpened($token: String!) {
  markGdprDocumentAsOpened(token: $token)
}
    `;
export const SendGdprConsent = gql`
    mutation SendGDPRConsent($patientIds: [Int!]!) {
  sendGdprEmail(patientIds: $patientIds)
}
    `;
export const SignGdprDocument = gql`
    mutation SignGDPRDocument($token: String!) {
  markGdprDocumentAsSigned(token: $token)
}
    `;
export const GetGdprConfig = gql`
    query GetGDPRConfig {
  getGdprConfig {
    id
    sendAutomatedGdprMails
    documentCategory
    documentCategoryChild
    practiceBranchId
  }
}
    `;
export const GetGdprDocument = gql`
    query GetGDPRDocument($token: String!) {
  getGdprDocument(token: $token) {
    patientToken
    patient {
      id
      fullName
    }
    documentType
    practiceName
    openedDate
    signedDate
    isSigned
  }
}
    `;
export const CreateGuardian = gql`
    mutation CreateGuardian($payload: CreateGuardianInput!) {
  createGuardian(payload: $payload)
}
    `;
export const DeactivateGuardian = gql`
    mutation DeactivateGuardian($guardianId: Int!, $deactivatedAt: ISODateTime) {
  deactivateGuardian(guardianId: $guardianId, deactivatedAt: $deactivatedAt)
}
    `;
export const EditGuardian = gql`
    mutation EditGuardian($payload: EditGuardianInput!) {
  editGuardian(payload: $payload)
}
    `;
export const GetGuardians = gql`
    query GetGuardians($patientId: Int!) {
  getGuardians(patientId: $patientId) {
    id
    firstName
    lastName
    phoneNumber
    email
    address {
      id
      street
      houseNumber
      apartmentNumber
      zipCode
      city
      county
      country
    }
  }
}
    `;
export const PaginatedHolidays = gql`
    query PaginatedHolidays($after: ISODateTime!, $before: ISODateTime!, $limit: Int!, $page: Int!) {
  paginatedHolidays(after: $after, before: $before, limit: $limit, page: $page) {
    count
    data {
      id
    }
    totals
    pageTotals
  }
}
    `;
export const GetIncome = gql`
    query GetIncome($after: ISODateTime!, $before: ISODateTime!, $limit: Int!, $page: Int!, $practiceBranch: Int, $orderBy: OrderBy, $therapists: [Int!], $services: [Int!], $statuses: [EventPayment!], $patients: [Int!], $paymentMethods: [String!]) {
  paginatedIncomes(
    after: $after
    before: $before
    limit: $limit
    page: $page
    practiceBranch: $practiceBranch
    orderBy: $orderBy
    therapists: $therapists
    services: $services
    statuses: $statuses
    patients: $patients
    paymentMethods: $paymentMethods
  ) {
    count
    pageTotals
    totals
    data {
      id
      amount
      date
      serviceName
      paidOn
      services {
        name
      }
      participants {
        id
        paymentMethod {
          name
        }
        payment
        patient {
          fullName
        }
      }
      therapists {
        id
        fullName
      }
    }
  }
}
    `;
export const DeleteInvoiceConfig = gql`
    mutation DeleteInvoiceConfig($deleteAccountOnFakturownia: Boolean!) {
  deleteInvoiceConfig(deleteAccountOnFakturownia: $deleteAccountOnFakturownia) {
    code
    message
  }
}
    `;
export const GetInvoiceConfig = gql`
    query GetInvoiceConfig {
  invoiceConfig {
    id
    active
    apiToken
    subdomain
  }
  getCurrentPracticeDetails {
    billingInfo {
      id
    }
  }
}
    `;
export const UpdateOrCreateInvoiceConfig = gql`
    mutation UpdateOrCreateInvoiceConfig($payload: InvoiceConfigInput) {
  updateOrCreateInvoiceConfig(payload: $payload) {
    id
    active
    apiToken
  }
}
    `;
export const AddInvoice = gql`
    mutation AddInvoice($payload: InvoiceInput!) {
  createInvoice(payload: $payload) {
    id
  }
}
    `;
export const DeleteInvoice = gql`
    mutation DeleteInvoice($invoiceId: Int!) {
  deleteInvoice(invoiceId: $invoiceId)
}
    `;
export const SendInvoices = gql`
    mutation SendInvoices($payload: [InvoiceSendInput!]!) {
  sendInvoices(payload: $payload)
}
    `;
export const SyncInvoice = gql`
    mutation syncInvoice($invoiceId: Int!) {
  synchronizeInvoice(invoiceId: $invoiceId) {
    ...InvoiceDetail
  }
}
    ${InvoiceDetail}`;
export const UpdateInvoice = gql`
    mutation UpdateInvoice($invoiceId: Int!, $payload: InvoiceUpdateInput!) {
  updateInvoice(invoiceId: $invoiceId, payload: $payload) {
    id
    status
    externalInvoice {
      id
      status
      paid
      unpaid
    }
  }
}
    `;
export const UpdateOrCreateWebhooks = gql`
    mutation UpdateOrCreateWebhooks {
  updateOrCreateWebhooks {
    webhooks {
      id
      kind
      accountId
      url
      apiToken
      active
    }
  }
}
    `;
export const GetBillingInfoFromVatId = gql`
    query GetBillingInfoFromVatId($vatId: String) {
  billingInfoFromVatId(vatId: $vatId) {
    name
    city
    email
    postCode
    street
  }
}
    `;
export const GetInvoice = gql`
    query GetInvoice($invoiceId: Int!) {
  invoice(invoiceId: $invoiceId) {
    ...InvoiceDetail
  }
}
    ${InvoiceDetail}`;
export const GetInvoiceEvents = gql`
    query GetInvoiceEvents($after: ISODateTime!, $before: ISODateTime!, $patientId: Int!) {
  paid: events(after: $after, before: $before, patientId: $patientId, paid: true) {
    ...InvoiceEvent
  }
  unpaid: events(
    after: $after
    before: $before
    patientId: $patientId
    paid: false
  ) {
    ...InvoiceEvent
  }
}
    ${InvoiceEvent}`;
export const GetInvoicesTable = gql`
    query GetInvoicesTable($after: ISODate!, $before: ISODate!, $limit: Int!, $page: Int!, $practiceBranchId: Int!, $tab: InvoiceTab!, $orderBy: [OrderBy!], $statuses: [ExternalInvoiceStatus!]) {
  invoices(
    after: $after
    before: $before
    limit: $limit
    page: $page
    practiceBranchId: $practiceBranchId
    tab: $tab
    orderBy: $orderBy
    statuses: $statuses
  ) {
    count
    pageTotals
    totals
    data {
      id
      addClientTax
      externalId
      createdAt: issueDate
      kind
      name
      number
      viewUrl
      notes
      paymentTo
      sellDate
      status
      totalPriceGross
      totalPriceNet
      totalPriceTax
      patientEmails
      practiceBranch {
        id
      }
      clientBillingInfo {
        id
        name
      }
    }
  }
}
    `;
export const GetPatientBillingInfo = gql`
    query GetPatientBillingInfo($patientId: Int!) {
  patientDetails(patientId: $patientId) {
    id
    fullName
    email
    address {
      id
      city
      zipCode
      street
    }
    billingInfo {
      id
      bank
      bankAccount
      city
      country
      email
      name
      phone
      postCode
      street
      taxNo
    }
  }
}
    `;
export const GetPatientInvoiceData = gql`
    query GetPatientInvoiceData($after: ISODateTime!, $before: ISODateTime!, $patientId: Int!) {
  patientDetails(patientId: $patientId) {
    id
    fullName
    email
    address {
      id
      city
      zipCode
      street
    }
    billingInfo {
      id
      name
      street
      postCode
      city
      email
      taxNo
    }
  }
  paid: events(after: $after, before: $before, patientId: $patientId, paid: true) {
    ...InvoiceEvent
  }
  unpaid: events(
    after: $after
    before: $before
    patientId: $patientId
    paid: false
  ) {
    ...InvoiceEvent
  }
}
    ${InvoiceEvent}`;
export const MakeMigrate = gql`
    query makeMigrate($new_practice_id: Int!, $new_practice_branch_id: Int!, $legacy_practice_name: String) {
  makeMigrate(
    newPracticeId: $new_practice_id
    newPracticeBranchId: $new_practice_branch_id
    legacyPracticeName: $legacy_practice_name
  )
}
    `;
export const AddPatient = gql`
    mutation AddPatient($patientInput: PatientInput!) {
  addPatient(patientInput: $patientInput) {
    id
    therapist {
      id
    }
  }
}
    `;
export const EditPatient = gql`
    mutation EditPatient($patientId: Int!, $addressId: Int, $patientInput: EditPatientInput!) {
  editPatient(
    patientId: $patientId
    addressId: $addressId
    patientInput: $patientInput
  )
}
    `;
export const FinishPatientsTherapy = gql`
    mutation FinishPatientsTherapy($patientId: Int!, $finishDate: ISODateTime = null, $deletePatient: Boolean = false) {
  finishPatientTherapy(
    patientId: $patientId
    finishDate: $finishDate
    deletePatient: $deletePatient
  )
}
    `;
export const ReactivatePatientsTherapy = gql`
    mutation ReactivatePatientsTherapy($patientId: Int!) {
  reactivatePatientTherapy(patientId: $patientId)
}
    `;
export const AddPatientEducatorNotes = gql`
    mutation AddPatientEducatorNotes($payload: PatientEducatorInput!) {
  addPatientEducatorNotes(payload: $payload)
}
    `;
export const AddPatientPsychotherapyNotes = gql`
    mutation AddPatientPsychotherapyNotes($payload: PatientPsychotherapyInput!) {
  addPatientPsychotherapyNotes(payload: $payload)
}
    `;
export const AddPatientSiNotes = gql`
    mutation AddPatientSINotes($payload: PatientSIInput!) {
  addPatientSiNotes(payload: $payload)
}
    `;
export const AddPatientSpeechTherapyNotes = gql`
    mutation AddPatientSpeechTherapyNotes($payload: PatientSpeechTherapyInput!) {
  addPatientSpeechtherapyNotes(payload: $payload)
}
    `;
export const EditPatientEducatorNotes = gql`
    mutation EditPatientEducatorNotes($payload: PatientEducatorInput!) {
  editPatientEducatorNotes(payload: $payload)
}
    `;
export const EditPatientPsychotherapyNotes = gql`
    mutation EditPatientPsychotherapyNotes($payload: PatientPsychotherapyInput!) {
  editPatientPsychotherapyNotes(payload: $payload)
}
    `;
export const EditPatientSiNotes = gql`
    mutation EditPatientSINotes($payload: PatientSIInput!) {
  editPatientSiNotes(payload: $payload)
}
    `;
export const EditPatientSpeechTherapyNotes = gql`
    mutation EditPatientSpeechTherapyNotes($payload: PatientSpeechTherapyInput!) {
  editPatientSpeechtherapyNotes(payload: $payload)
}
    `;
export const GetPatientDetails = gql`
    query GetPatientDetails($patientId: Int!) {
  patientDetails(patientId: $patientId) {
    id
    firstName
    lastName
    fullName
    phoneNumber
    email
    color
    deactivatedOn
    description
    active
    birthday
    createdAt
    updatedAt
    deletedAt
    practiceId
    idNumber
    secondPhoneNumber
    smsNotificationsActive
    billingInfo {
      id
    }
    attachmentsList {
      category
      url
      name
      id
      createdAt
    }
    address {
      id
      apartmentNumber
      city
      country
      county
      createdAt
      houseNumber
      street
      zipCode
    }
    therapists {
      id
      fullName
      email
      acronym
      user {
        fullName
        id
        firstName
      }
      color
    }
    psychoTherapy {
      id: pk
      diagnosis
      expectations
      medicalHistory
      occupation
      otherNotes
      triggerForTherapy
    }
    speechTherapy {
      id: pk
      generalAim
      articulationExamination
      diagnosisTherapyPlan
      generalInfo
      medicalHistory
      otherNotes
      speechExamination
    }
    si {
      id: pk
      generalAim
      siDiagnosis
      therapyHints
      sensoricDiet
      diagnosisTherapyPlan
      generalInfo
      medicalHistory
      otherNotes
    }
    educator {
      id: pk
      generalAim
      diagnosisTherapyPlan
      generalInfo
      medicalHistory
      otherNotes
    }
    couples {
      coupleName
      id
      createdAt
    }
    groups {
      id
      name
    }
  }
}
    `;
export const GetPatientsMeetingsHeld = gql`
    query GetPatientsMeetingsHeld($patientId: Int!) {
  patientMeetingsHeld(patientId: $patientId)
}
    `;
export const PaginatedPatients = gql`
    query PaginatedPatients($active: Boolean, $limit: Int!, $orderBy: OrderBy, $page: Int!, $assignedTo: [Int!], $searchPhrase: String) {
  paginatedPatients(
    active: $active
    limit: $limit
    orderBy: $orderBy
    page: $page
    assignedTo: $assignedTo
    searchPhrase: $searchPhrase
  ) {
    count
    data {
      id
      firstName
      lastName
      email
      active
      signedGdprConsent
      phoneNumber
      therapists {
        id
        acronym
        color
        fullName
      }
    }
  }
}
    `;
export const CreatePrzelewy24Transaction = gql`
    mutation CreatePrzelewy24Transaction($payload: Przelewy24OrderInput!) {
  createPrzelewy24Transaction(payload: $payload) {
    link
  }
}
    `;
export const EditOrCreateAppPaymentConfig = gql`
    mutation EditOrCreateAppPaymentConfig($payload: AppPaymentConfigInput!) {
  editOrCreateAppPaymentConfig(payload: $payload) {
    isEnabled
    paymentMethods {
      isEnabled
      method
    }
  }
}
    `;
export const GetPrzelewy24Order = gql`
    query GetPrzelewy24Order($sessionId: String!) {
  przelewy24Order(sessionId: $sessionId) {
    id
    amount
    category
    createdAt
    currency
    description
    orderId
    merchantId
    posId
    practiceId
    sessionId
    token
    status
    updatedAt
  }
}
    `;
export const CreatePractice = gql`
    mutation CreatePractice($payload: CreatePracticeInput!) {
  createPractice(payload: $payload) {
    id
    practiceBranches {
      id
    }
  }
}
    `;
export const DeletePracticeLogo = gql`
    mutation DeletePracticeLogo {
  deletePracticeLogo
}
    `;
export const EditPractice = gql`
    mutation EditPractice($payload: EditPracticeInput!) {
  editPractice(payload: $payload)
}
    `;
export const SetPracticeLogo = gql`
    mutation SetPracticeLogo($payload: SetPracticeLogoInput!) {
  setPracticeLogo(payload: $payload)
}
    `;
export const GetAvailablePractices = gql`
    query GetAvailablePractices {
  getAvailablePractices {
    id
    name
    shortName
    billingAddress {
      apartmentNumber
      city
      country
      county
      zipCode
      street
      houseNumber
    }
    logo {
      url
    }
    restrictedAccess
    servicesPerTherapist
  }
}
    `;
export const GetCurrentPracticeDetails = gql`
    query GetCurrentPracticeDetails {
  getCurrentPracticeDetails {
    id
    name
    shortName
    contactDetails {
      id
      email
      phone
    }
    billingAddress {
      id
      apartmentNumber
      city
      country
      county
      houseNumber
      street
      zipCode
    }
    billingInfo {
      id
      bank
      bankAccount
      city
      country
      email
      name
      phone
      postCode
      street
      taxNo
    }
    logo {
      url
    }
    invoicingEnabled
  }
}
    `;
export const AddPrzelewy24Config = gql`
    mutation AddPrzelewy24Config($payload: Przelewy24ConfigInput!) {
  addPrzelewy24Config(payload: $payload) {
    invitationLink
    isEnabled
    crc
    merchantId
  }
}
    `;
export const AppPaymentConfigQuery = gql`
    query AppPaymentConfigQuery {
  appPaymentConfig {
    isEnabled
    paymentMethods {
      isEnabled
      method
    }
  }
}
    `;
export const Przelewy24ConfigQuery = gql`
    query Przelewy24ConfigQuery {
  przelewy24Config {
    crc
    invitationLink
    isEnabled
    merchantId
  }
}
    `;
export const ConfirmMeetingRequest = gql`
    mutation ConfirmMeetingRequest($payload: ConfirmMeetingPayload!) {
  confirmMeeting(payload: $payload) {
    success
  }
}
    `;
export const DeleteMeetingRequests = gql`
    mutation DeleteMeetingRequests($meetingRequestIds: [Int!]!) {
  deleteMeetings(meetingRequestIds: $meetingRequestIds)
}
    `;
export const RejectMeetingRequests = gql`
    mutation RejectMeetingRequests($meetingRequestIds: [Int!]!, $sendSms: Boolean! = true) {
  rejectMeetings(meetingRequestIds: $meetingRequestIds, sendSms: $sendSms)
}
    `;
export const SetOnlineRegistrationConfig = gql`
    mutation SetOnlineRegistrationConfig($config: UpsertOnlineRegistrationConfig!) {
  upsertOnlineRegistrationConfig(config: $config) {
    id
    practice {
      id
    }
    practiceSlug
    minutesBetweenMeetings
    isRegistrationEnabled
    termsOfUseUrl
    privacyPolicyUrl
    roundSlotTimeTo
    minimumPrecedingMinutes
    maximumPrecedingMinutes
  }
}
    `;
export const GetMeetingRequest = gql`
    query GetMeetingRequest($meetingRequestId: Int!) {
  getMeetingRequest(meetingRequestId: $meetingRequestId) {
    id
    practiceBranch {
      id
      name
      branchAddress {
        id
        street
        houseNumber
        apartmentNumber
      }
    }
    lookalikePatients {
      id
      fullName
      phoneNumber
      email
    }
  }
}
    `;
export const GetMeetingRequests = gql`
    query GetMeetingRequests {
  getMeetingRequests {
    id
    firstName
    lastName
    start
    createdAt
    service {
      id
      name
      price
    }
    therapist {
      id
      fullName
    }
  }
}
    `;
export const GetOnlineRegistrationConfig = gql`
    query GetOnlineRegistrationConfig {
  getOnlineRegistrationConfigByPracticeId {
    id
    practiceSlug
    minutesBetweenMeetings
    isRegistrationEnabled
    termsOfUseUrl
    privacyPolicyUrl
    minimumPrecedingMinutes
    maximumPrecedingMinutes
    roundSlotTimeTo
    isPreciseSearch
    exactSlotProposal
  }
}
    `;
export const GetPaginatedMeetingRequests = gql`
    query GetPaginatedMeetingRequests($after: ISODateTime!, $before: ISODateTime!, $limit: Int!, $page: Int!, $orderBy: OrderBy = null, $patients: [String!] = null, $therapists: [Int!] = null, $services: [Int!] = null, $results: [MeetingRequestResult!] = null) {
  getPaginatedMeetingRequests(
    after: $after
    before: $before
    limit: $limit
    page: $page
    orderBy: $orderBy
    patients: $patients
    therapists: $therapists
    services: $services
    results: $results
  ) {
    count
    data {
      id
      service {
        id
        name
        duration
        price
      }
      therapist {
        id
        fullName
      }
      phoneNumber
      email
      firstName
      lastName
      start
      createdAt
      rejectedAt
      confirmedAt
    }
  }
}
    `;
export const GetPaymentMethodsRegistration = gql`
    query GetPaymentMethodsRegistration($practiceId: Int!, $enabledFilter: Boolean!) {
  practicePaymentMethods(practiceId: $practiceId, enabledFilter: $enabledFilter) {
    isEnabled
    method
  }
}
    `;
export const GenerateIncomeReport = gql`
    mutation GenerateIncomeReport($after: ISODateTime!, $before: ISODateTime!, $language: String!, $timeZone: String!, $patientId: Int, $coupleId: Int, $patientIds: [Int!], $serviceIds: [Int!], $therapistIds: [Int!], $statuses: [String!], $paymentMethods: [String!], $fileType: String!) {
  generateIncomeReport(
    after: $after
    before: $before
    language: $language
    timeZone: $timeZone
    patientId: $patientId
    coupleId: $coupleId
    patientIds: $patientIds
    serviceIds: $serviceIds
    therapistIds: $therapistIds
    statuses: $statuses
    paymentMethods: $paymentMethods
    fileType: $fileType
  )
}
    `;
export const GenerateEmployeeReport = gql`
    mutation GenerateEmployeeReport($employeeId: Int!, $after: ISODateTime!, $before: ISODateTime!, $language: String!, $timeZone: String!) {
  generateEmployeeReport(
    employeeId: $employeeId
    after: $after
    before: $before
    language: $language
    timeZone: $timeZone
  ) {
    url
  }
}
    `;
export const GenerateMeetingHistoryReport = gql`
    mutation GenerateMeetingHistoryReport($after: ISODateTime!, $before: ISODateTime!, $language: String!, $timeZone: String!, $patientId: Int, $coupleId: Int) {
  generateMeetingHistoryReport(
    after: $after
    before: $before
    language: $language
    timeZone: $timeZone
    patientId: $patientId
    coupleId: $coupleId
  ) {
    url
  }
}
    `;
export const GetEmployeesStatistics = gql`
    query getEmployeesStatistics($employeeId: Int!, $after: ISODateTime!, $before: ISODateTime!, $practiceBranchId: Int) {
  employeeStatistics(
    employeeId: $employeeId
    after: $after
    before: $before
    practiceBranchId: $practiceBranchId
  ) {
    meetingsHeld
    meetingsCancelled
    meetingsScheduled
    meetingsHeldRate
    servicesBreakdown {
      totalPrice
      totalTime
      services {
        id
        name
        meetingsHeld
        meetingsDurationMinutes
        meetingsIncome
      }
    }
  }
}
    `;
export const GetIncomeStatistics = gql`
    query getIncomeStatistics($after: ISODateTime!, $before: ISODateTime!, $practiceBranchId: Int) {
  incomeStatistics(
    after: $after
    before: $before
    practiceBranchId: $practiceBranchId
  ) {
    income
    prevIncome
    lostIncome
    unpaidIncome
    previousPeriodDates {
      start
      end
    }
  }
}
    `;
export const GetServicesStatistics = gql`
    query getServicesStatistics($after: ISODateTime!, $before: ISODateTime!, $practiceBranchId: Int) {
  serviceStatistics(
    after: $after
    before: $before
    practiceBranchId: $practiceBranchId
  ) {
    meetings {
      meetingsHeld {
        current
        prev
      }
      meetingsSheduled {
        current
        prev
      }
      meetingsCancelled {
        current
        prev
      }
      patientsNumbers {
        current
        prev
      }
      therapiesFinished {
        current
        prev
      }
      therapiesNew {
        current
        prev
      }
    }
    services {
      name
      current
      prev
      price
    }
    previousPeriodDates {
      start
      end
    }
  }
}
    `;
export const AddRoom = gql`
    mutation AddRoom($payload: AddRoomInput!) {
  addRoom(payload: $payload) {
    id
  }
}
    `;
export const EditRoom = gql`
    mutation EditRoom($roomId: Int!, $payload: EditRoomInput!) {
  editRoom(roomId: $roomId, payload: $payload)
}
    `;
export const GetPaginatedRooms = gql`
    query GetPaginatedRooms($page: Int!, $limit: Int!, $orderBy: OrderBy = null) {
  paginatedRooms(page: $page, limit: $limit, orderBy: $orderBy) {
    count
    totals
    pageTotals
    data {
      id
      name
      availableOnline
      comments
      slug
      preferredBy {
        id
        color
        fullName
        acronym
      }
      excludedServices {
        id
        name
        price
      }
    }
  }
}
    `;
export const GetRoomsList = gql`
    query GetRoomsList($serviceId: Int, $date: DateTime) {
  getRoomsList(serviceId: $serviceId, date: $date) {
    id
    name
    slug
    availableOnline
    preferredBy
  }
}
    `;
export const CreateService = gql`
    mutation CreateService($payload: ServiceInput!) {
  createService(payload: $payload) {
    id
  }
}
    `;
export const DeactivateServices = gql`
    mutation DeactivateServices($serviceIds: [Int!]!) {
  deactivateServices(serviceIds: $serviceIds)
}
    `;
export const EditService = gql`
    mutation EditService($serviceId: Int!, $payload: EditServiceInput!) {
  editService(serviceId: $serviceId, payload: $payload)
}
    `;
export const GetPaginatedServices = gql`
    query GetPaginatedServices($limit: Int!, $page: Int!, $searchPhrase: String, $practiceBranchId: Int!, $orderBy: OrderBy) {
  paginatedServices(
    limit: $limit
    page: $page
    searchPhrase: $searchPhrase
    practiceBranchId: $practiceBranchId
    orderBy: $orderBy
  ) {
    count
    pageTotals
    data {
      id
      name
      price
      duration
      comments
      availableInOnlineRegistration
      availableOnline
      assignedTo {
        fullName
        color
        id
        acronym
      }
    }
  }
}
    `;
export const GetPaginatedServicesBreakdown = gql`
    query GetPaginatedServicesBreakdown($after: ISODateTime!, $before: ISODateTime!, $limit: Int!, $page: Int!, $employeeId: Int!, $practiceBranchId: Int, $orderBy: OrderBy) {
  paginatedServicesBreakdown(
    after: $after
    before: $before
    limit: $limit
    page: $page
    employeeId: $employeeId
    practiceBranchId: $practiceBranchId
    orderBy: $orderBy
  ) {
    count
    pageTotals
    data {
      id
      name
      count
      amount
      time
    }
  }
}
    `;
export const GetServices = gql`
    query GetServices($limit: Int!, $page: Int!, $practiceBranchId: Int!, $orderBy: OrderBy, $names: [String!], $prices: FloatRangeInput, $durations: FloatRangeInput, $assignedTo: [Int!], $online: Boolean, $searchPhrase: String = "") {
  paginatedServices(
    limit: $limit
    page: $page
    orderBy: $orderBy
    practiceBranchId: $practiceBranchId
    names: $names
    prices: $prices
    durations: $durations
    assignedTo: $assignedTo
    online: $online
    searchPhrase: $searchPhrase
  ) {
    count
    data {
      id
      name
      price
      duration
      availableOnline
      comments
      availableInOnlineRegistration
      assignedTo {
        id
        acronym
        color
        user {
          firstName
        }
      }
    }
  }
}
    `;
export const GetServicesList = gql`
    query GetServicesList($orderBy: OrderBy) {
  servicesList(orderBy: $orderBy) {
    id
    name
    price
    assignedTo
    duration
    availableInOnlineRegistration
  }
}
    `;
export const GetTimeSlots = gql`
    query GetTimeSlots($startDate: DateTime!, $endDate: DateTime!, $practiceId: Int!, $serviceIds: [Int!] = null, $practiceBranchId: Int = null, $therapistIds: [Int!] = null, $oneSlot: Boolean = false, $earliestSlotPerTherapist: Boolean = false, $sortAndLimit: Int = null, $showEmptyDates: Boolean = true, $searchEngine: Boolean = true, $customBreakBetweenMeetings: Int = null) {
  getTimeSlots(
    startDate: $startDate
    endDate: $endDate
    practiceId: $practiceId
    serviceIds: $serviceIds
    practiceBranchId: $practiceBranchId
    therapistIds: $therapistIds
    oneSlot: $oneSlot
    earliestSlotPerTherapist: $earliestSlotPerTherapist
    sortAndLimit: $sortAndLimit
    showEmptyDates: $showEmptyDates
    searchEngine: $searchEngine
    customBreakBetweenMeetings: $customBreakBetweenMeetings
  ) {
    id
    slots
    therapistId
    date
    serviceId
    serviceName
  }
}
    `;
export const PurchaseSmsPacket = gql`
    mutation purchaseSmsPacket($payload: SmsPacketPurchaseInput!) {
  purchaseSmsPacket(payload: $payload) {
    link
  }
}
    `;
export const SendSms = gql`
    mutation SendSms($phoneNumber: PhoneNumber!, $templateType: SMSTemplateTypeEnum!, $practiceBranchId: Int) {
  sendDemoSms(
    demoSmsInput: {phoneNumber: $phoneNumber, templateType: $templateType, practiceBranchId: $practiceBranchId}
  ) {
    quota
    status
    text
    details
  }
}
    `;
export const UpdateSmsConfig = gql`
    mutation UpdateSmsConfig($values: SMSConfigPartialInput!) {
  updateSmsConfig(smsConfigInput: $values) {
    active
    daysBefore
    hoursBefore
    newMeetingActive
    quota
    reminderPerBranchTemplate
    meetingCanceledActive
    sendingTime
    reminderSendingTime
    timeChangeActive
  }
}
    `;
export const UpdateSmsTemplate = gql`
    mutation UpdateSmsTemplate($language: SMSTemplateLanguageEnum!, $templateType: SMSTemplateTypeEnum, $text: String!, $practiceBranchId: Int) {
  updateSmsTemplate(
    smsTemplateInput: {language: $language, text: $text, practiceBranchId: $practiceBranchId, templateType: $templateType}
  ) {
    ... on SMSTemplate {
      text
    }
  }
}
    `;
export const GetSmsConfig = gql`
    query GetSmsConfig {
  smsConfig {
    active
    hoursBefore
    daysBefore
    newMeetingActive
    quota
    perPeriodQuota
    customQuota
    reminderPerBranchTemplate
    reminderSendingTime
    sendingTime
    timeChangeActive
    meetingCanceledActive
    nonTherapistNotifyingTemplates
  }
}
    `;
export const GetSmsHistory = gql`
    query GetSmsHistory($after: ISODateTime!, $before: ISODateTime!, $limit: Int!, $page: Int!, $orderBy: OrderBy, $searchPhrase: String = "") {
  paginatedSentSmss(
    after: $after
    before: $before
    limit: $limit
    page: $page
    orderBy: $orderBy
    searchPhrase: $searchPhrase
  ) {
    count
    data {
      id
      details
      phoneNumber
      sentAt
      status
      quota
      text
      patient {
        id
        fullName
      }
    }
  }
}
    `;
export const GetSmsPackets = gql`
    query GetSmsPackets {
  smsPackets {
    smsNumber
    tax
    price
  }
}
    `;
export const GetSmsTemplates = gql`
    query GetSmsTemplates($templateType: SMSTemplateTypeEnum!, $language: SMSTemplateLanguageEnum) {
  smsTemplates(templateType: $templateType, language: $language) {
    branchesTemplates {
      practiceBranch {
        id
        name
        shortName
      }
      text
    }
    practiceTemplateText
  }
}
    `;
export const DeleteUserAvatar = gql`
    mutation DeleteUserAvatar {
  deleteUserAvatar
}
    `;
export const EditUserSettings = gql`
    mutation EditUserSettings($payload: UserInput!) {
  editUserSettings(payload: $payload)
}
    `;
export const SetUserAvatar = gql`
    mutation SetUserAvatar($payload: AvatarInput!) {
  setUserAvatar(payload: $payload)
}
    `;
export const GetUserAvatar = gql`
    query GetUserAvatar {
  getUserAvatar {
    contentType
    url
  }
}
    `;
export const AddWorktimeException = gql`
    mutation AddWorktimeException($input: WorkTimeExceptionInput!) {
  addWorktimeException(exceptionInput: $input) {
    presetId
    startDate
    workTimes {
      startTime
      endTime
    }
    dates
  }
}
    `;
export const AddWorktimePreset = gql`
    mutation addWorktimePreset($input: WorkTimePresetInput!) {
  addWorktimePreset(presetInput: $input)
}
    `;
export const EditWorktimeConfig = gql`
    mutation EditWorktimeConfig($input: WorkTimeConfigInput!) {
  editWorktimeConfig(config: $input) {
    holidayConsiderationRequired
    automaticEventCancellationTime
  }
}
    `;
export const EditWorktimeException = gql`
    mutation EditWorktimeException($worktimeExceptionId: Int!, $input: EditWorkTimeExceptionInput!) {
  editWorktimeException(
    worktimeExceptionId: $worktimeExceptionId
    exceptionInput: $input
  ) {
    presetId
    startDate
    workTimes {
      startTime
      endTime
    }
    dates
  }
}
    `;
export const RemoveWorktimeException = gql`
    mutation RemoveWorktimeException($id: Int!) {
  removeWorktimeException(worktimeExceptionId: $id)
}
    `;
export const RemoveWorktimePreset = gql`
    mutation RemoveWorktimePreset($id: Int!) {
  removeWorktimePreset(presetId: $id)
}
    `;
export const WorkTimePreset = gql`
    query WorkTimePreset($id: Int!) {
  workTimePreset(presetId: $id) {
    ...WorkTimePresetFields
  }
}
    ${WorkTimePresetFields}`;
export const WorkTimePresets = gql`
    query WorkTimePresets($employeeIds: [Int!]!, $name: String) {
  workTimePresets(employeeIds: $employeeIds, name: $name) {
    ...WorkTimePresetFields
  }
}
    ${WorkTimePresetFields}`;
export const BillingInfoFragmentFragmentDoc = gql`
    fragment BillingInfoFragment on BillingInfo {
  id
  name
  taxNo
  street
  postCode
  city
  country
  email
  phone
  bank
  bankAccount
}
    `;
export const EmployeeBaseFragmentDoc = gql`
    fragment EmployeeBase on Employee {
  id
  color
  practiceBranchId
  acceptedInvitation
  phoneNumber
  acronym
  email
  fullName
  firstName
  lastName
  roles {
    name
    slug
  }
}
    `;
export const EmployeeDetailFragmentDoc = gql`
    fragment EmployeeDetail on Employee {
  ...EmployeeBase
  availableInOnlineRegistration
  user {
    fullName
    firstName
    lastLogin: lastSeen
    lastName
    id
  }
  preferredRooms: preferredRoom {
    id
    name
  }
}
    ${EmployeeBaseFragmentDoc}`;
export const EventDataFragmentDoc = gql`
    fragment EventData on Event {
  id
  end
  attachments {
    url
    name
    id
    createdAt
  }
  couple {
    id
    coupleName
    deletedAt
    createdAt
    deactivatedOn
    smsNotificationsActive
    patients {
      id
      firstName
      lastName
      fullName
      phoneNumber
      secondPhoneNumber
      email
      active
      therapists {
        id
        email
        phoneNumber
        fullName
        acronym
        color
        user {
          firstName
          lastName
        }
      }
    }
    therapists {
      id
      email
      phoneNumber
      fullName
      acronym
      color
      user {
        firstName
        lastName
      }
    }
  }
  period {
    id
    dows
    start
    end
    interval
    duration
    name
  }
  duration
  groupPresence {
    name
    value
  }
  note
  start
  duration
  paidOn
  name
  locked
  shifted
  therapists {
    id
    email
    phoneNumber
    acronym
    color
    user {
      firstName
      lastName
    }
    fullName
  }
  room {
    id
    name
    availableOnline
    comments
    slug
    practiceBranch {
      name
      shortName
      id
    }
  }
  services {
    id
    name
    price
    availableOnline
    practiceBranch {
      name
      shortName
      id
    }
  }
  participants {
    id
    payment
    presence {
      name
      value
    }
    paymentMethod {
      name
      value
    }
    patient {
      id
      firstName
      lastName
      fullName
      phoneNumber
      secondPhoneNumber
      description
      birthday
      email
      deactivatedOn
      createdAt
      active
      deletedAt
      therapists {
        id
        fullName
        color
        acronym
      }
    }
  }
}
    `;
export const InitialCalendarEventFragmentDoc = gql`
    fragment InitialCalendarEvent on Event {
  id
  start
  end
  name
  locked
  cancelled
  shifted
  duration
  paidOn
  serviceName
  serviceNameWithPrice
  couple {
    id
    coupleName
  }
  groupPresenceName
  periodId
  therapistIds
  therapistColor
  serviceIds
  roomId
  hasNote
  participants {
    id
    presenceName
    payment
    paymentMethodName
    patient {
      id
      therapists {
        id
      }
      fullName
    }
  }
}
    `;
export const InvoiceDetailFragmentDoc = gql`
    fragment InvoiceDetail on Invoice {
  externalInvoice {
    id
    issueDate
    number
    paymentTo
    sellDate
    status
    viewUrl
    paymentType
    sellerName
    sellerStreet
    sellerPostCode
    sellerCity
    sellerCountry
    sellerTaxNo
    sellerEmail
    sellerPhone
    sellerBank
    sellerBankAccount
    buyerName
    buyerStreet
    buyerPostCode
    buyerCity
    buyerEmail
    buyerTaxNo
    description
    paid
    unpaid
    priceGross
  }
  clientBillingInfo {
    bank
    bankAccount
    city
    country
    email
    id
    name
    postCode
    street
    taxNo
  }
  addClientTax
  externalId
  practiceBranch {
    id
    name
    shortName
  }
  lineItems {
    externalId
    id
    itemPrice
    name
    quantity
    tax
    taxFree
    taxNotApplicable
    totalPriceGross
    totalPriceNet
    totalPriceTax
  }
  kind
  patientEmails
  issueDate
  id
  paymentTo
  number
  notes
  name
  sellDate
  sentTo {
    id
    emails
    sentAt
  }
  status
  totalPriceGross
  totalPriceNet
  totalPriceTax
}
    `;
export const InvoiceEventFragmentDoc = gql`
    fragment InvoiceEvent on Event {
  id
  hasInvoice
  start
  services {
    id
    name
    price
  }
  status
}
    `;
export const WorkTimePresetFieldsFragmentDoc = gql`
    fragment WorkTimePresetFields on WorkTimePresetType {
  id
  name
  startDate
  endDate
  workDays {
    day
    workTime {
      startTime
      endTime
    }
  }
}
    `;
export const DeleteAttachmentsDocument = gql`
    mutation DeleteAttachments($attachmentIds: [Int!]!) {
  deleteAttachments(attachmentIds: $attachmentIds)
}
    `;

/**
 * __useDeleteAttachmentsMutation__
 *
 * To run a mutation, you first call `useDeleteAttachmentsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAttachmentsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteAttachmentsMutation({
 *   variables: {
 *     attachmentIds: // value for 'attachmentIds'
 *   },
 * });
 */
export function useDeleteAttachmentsMutation(options: VueApolloComposable.UseMutationOptions<DeleteAttachmentsMutation, DeleteAttachmentsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteAttachmentsMutation, DeleteAttachmentsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteAttachmentsMutation, DeleteAttachmentsMutationVariables>(DeleteAttachmentsDocument, options);
}
export type DeleteAttachmentsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteAttachmentsMutation, DeleteAttachmentsMutationVariables>;
export const AddBillingInfoDocument = gql`
    mutation AddBillingInfo($model: String!, $patientId: Int = null, $payload: BillingInfoInput!) {
  addBillingInfo(model: $model, patientId: $patientId, payload: $payload) {
    id
  }
}
    `;

/**
 * __useAddBillingInfoMutation__
 *
 * To run a mutation, you first call `useAddBillingInfoMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddBillingInfoMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddBillingInfoMutation({
 *   variables: {
 *     model: // value for 'model'
 *     patientId: // value for 'patientId'
 *     payload: // value for 'payload'
 *   },
 * });
 */
export function useAddBillingInfoMutation(options: VueApolloComposable.UseMutationOptions<AddBillingInfoMutation, AddBillingInfoMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddBillingInfoMutation, AddBillingInfoMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddBillingInfoMutation, AddBillingInfoMutationVariables>(AddBillingInfoDocument, options);
}
export type AddBillingInfoMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddBillingInfoMutation, AddBillingInfoMutationVariables>;
export const EditBillingInfoDocument = gql`
    mutation EditBillingInfo($id: Int!, $payload: BillingInfoInput!) {
  editBillingInfo(id: $id, payload: $payload) {
    ...BillingInfoFragment
  }
}
    ${BillingInfoFragmentFragmentDoc}`;

/**
 * __useEditBillingInfoMutation__
 *
 * To run a mutation, you first call `useEditBillingInfoMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEditBillingInfoMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEditBillingInfoMutation({
 *   variables: {
 *     id: // value for 'id'
 *     payload: // value for 'payload'
 *   },
 * });
 */
export function useEditBillingInfoMutation(options: VueApolloComposable.UseMutationOptions<EditBillingInfoMutation, EditBillingInfoMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EditBillingInfoMutation, EditBillingInfoMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<EditBillingInfoMutation, EditBillingInfoMutationVariables>(EditBillingInfoDocument, options);
}
export type EditBillingInfoMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EditBillingInfoMutation, EditBillingInfoMutationVariables>;
export const RemoveBillingInfosDocument = gql`
    mutation RemoveBillingInfos($id: [Int!]!, $deletedAt: ISODateTime = null) {
  removeBillingInfo(id: $id, deletedAt: $deletedAt)
}
    `;

/**
 * __useRemoveBillingInfosMutation__
 *
 * To run a mutation, you first call `useRemoveBillingInfosMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveBillingInfosMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveBillingInfosMutation({
 *   variables: {
 *     id: // value for 'id'
 *     deletedAt: // value for 'deletedAt'
 *   },
 * });
 */
export function useRemoveBillingInfosMutation(options: VueApolloComposable.UseMutationOptions<RemoveBillingInfosMutation, RemoveBillingInfosMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RemoveBillingInfosMutation, RemoveBillingInfosMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RemoveBillingInfosMutation, RemoveBillingInfosMutationVariables>(RemoveBillingInfosDocument, options);
}
export type RemoveBillingInfosMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RemoveBillingInfosMutation, RemoveBillingInfosMutationVariables>;
export const GetBillingInfoDetailsDocument = gql`
    query GetBillingInfoDetails($id: Int!) {
  billingInfoDetails(id: $id) {
    id
    name
    taxNo
    street
    postCode
    city
    country
    email
    phone
    bank
    bankAccount
  }
}
    `;

/**
 * __useGetBillingInfoDetailsQuery__
 *
 * To run a query within a Vue component, call `useGetBillingInfoDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillingInfoDetailsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetBillingInfoDetailsQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetBillingInfoDetailsQuery(variables: GetBillingInfoDetailsQueryVariables | VueCompositionApi.Ref<GetBillingInfoDetailsQueryVariables> | ReactiveFunction<GetBillingInfoDetailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetBillingInfoDetailsQuery, GetBillingInfoDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetBillingInfoDetailsQuery, GetBillingInfoDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetBillingInfoDetailsQuery, GetBillingInfoDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetBillingInfoDetailsQuery, GetBillingInfoDetailsQueryVariables>(GetBillingInfoDetailsDocument, variables, options);
}
export function useGetBillingInfoDetailsLazyQuery(variables: GetBillingInfoDetailsQueryVariables | VueCompositionApi.Ref<GetBillingInfoDetailsQueryVariables> | ReactiveFunction<GetBillingInfoDetailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetBillingInfoDetailsQuery, GetBillingInfoDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetBillingInfoDetailsQuery, GetBillingInfoDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetBillingInfoDetailsQuery, GetBillingInfoDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetBillingInfoDetailsQuery, GetBillingInfoDetailsQueryVariables>(GetBillingInfoDetailsDocument, variables, options);
}
export type GetBillingInfoDetailsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetBillingInfoDetailsQuery, GetBillingInfoDetailsQueryVariables>;
export const AddCoupleDocument = gql`
    mutation AddCouple($payload: CoupleInput!) {
  addCouple(payload: $payload) {
    id
    therapists {
      id
    }
  }
}
    `;

/**
 * __useAddCoupleMutation__
 *
 * To run a mutation, you first call `useAddCoupleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddCoupleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddCoupleMutation({
 *   variables: {
 *     payload: // value for 'payload'
 *   },
 * });
 */
export function useAddCoupleMutation(options: VueApolloComposable.UseMutationOptions<AddCoupleMutation, AddCoupleMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddCoupleMutation, AddCoupleMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddCoupleMutation, AddCoupleMutationVariables>(AddCoupleDocument, options);
}
export type AddCoupleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddCoupleMutation, AddCoupleMutationVariables>;
export const EditCoupleDocument = gql`
    mutation EditCouple($coupleId: Int!, $payload: CoupleInput!) {
  editCouple(coupleId: $coupleId, payload: $payload)
}
    `;

/**
 * __useEditCoupleMutation__
 *
 * To run a mutation, you first call `useEditCoupleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEditCoupleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEditCoupleMutation({
 *   variables: {
 *     coupleId: // value for 'coupleId'
 *     payload: // value for 'payload'
 *   },
 * });
 */
export function useEditCoupleMutation(options: VueApolloComposable.UseMutationOptions<EditCoupleMutation, EditCoupleMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EditCoupleMutation, EditCoupleMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<EditCoupleMutation, EditCoupleMutationVariables>(EditCoupleDocument, options);
}
export type EditCoupleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EditCoupleMutation, EditCoupleMutationVariables>;
export const FinishCouplesTherapyDocument = gql`
    mutation FinishCouplesTherapy($coupleId: Int!, $finishDate: ISODateTime = null, $deleteCouple: Boolean = false) {
  finishCoupleTherapy(
    coupleId: $coupleId
    finishDate: $finishDate
    deleteCouple: $deleteCouple
  )
}
    `;

/**
 * __useFinishCouplesTherapyMutation__
 *
 * To run a mutation, you first call `useFinishCouplesTherapyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useFinishCouplesTherapyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useFinishCouplesTherapyMutation({
 *   variables: {
 *     coupleId: // value for 'coupleId'
 *     finishDate: // value for 'finishDate'
 *     deleteCouple: // value for 'deleteCouple'
 *   },
 * });
 */
export function useFinishCouplesTherapyMutation(options: VueApolloComposable.UseMutationOptions<FinishCouplesTherapyMutation, FinishCouplesTherapyMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<FinishCouplesTherapyMutation, FinishCouplesTherapyMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<FinishCouplesTherapyMutation, FinishCouplesTherapyMutationVariables>(FinishCouplesTherapyDocument, options);
}
export type FinishCouplesTherapyMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<FinishCouplesTherapyMutation, FinishCouplesTherapyMutationVariables>;
export const ReactivateCoupleTherapyDocument = gql`
    mutation ReactivateCoupleTherapy($coupleId: Int!) {
  reactivateCoupleTherapy(coupleId: $coupleId)
}
    `;

/**
 * __useReactivateCoupleTherapyMutation__
 *
 * To run a mutation, you first call `useReactivateCoupleTherapyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReactivateCoupleTherapyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReactivateCoupleTherapyMutation({
 *   variables: {
 *     coupleId: // value for 'coupleId'
 *   },
 * });
 */
export function useReactivateCoupleTherapyMutation(options: VueApolloComposable.UseMutationOptions<ReactivateCoupleTherapyMutation, ReactivateCoupleTherapyMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ReactivateCoupleTherapyMutation, ReactivateCoupleTherapyMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ReactivateCoupleTherapyMutation, ReactivateCoupleTherapyMutationVariables>(ReactivateCoupleTherapyDocument, options);
}
export type ReactivateCoupleTherapyMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ReactivateCoupleTherapyMutation, ReactivateCoupleTherapyMutationVariables>;
export const GetCoupleMeetingsHeldDocument = gql`
    query GetCoupleMeetingsHeld($coupleId: Int!) {
  coupleMeetingsHeld(coupleId: $coupleId)
}
    `;

/**
 * __useGetCoupleMeetingsHeldQuery__
 *
 * To run a query within a Vue component, call `useGetCoupleMeetingsHeldQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoupleMeetingsHeldQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCoupleMeetingsHeldQuery({
 *   coupleId: // value for 'coupleId'
 * });
 */
export function useGetCoupleMeetingsHeldQuery(variables: GetCoupleMeetingsHeldQueryVariables | VueCompositionApi.Ref<GetCoupleMeetingsHeldQueryVariables> | ReactiveFunction<GetCoupleMeetingsHeldQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCoupleMeetingsHeldQuery, GetCoupleMeetingsHeldQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCoupleMeetingsHeldQuery, GetCoupleMeetingsHeldQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCoupleMeetingsHeldQuery, GetCoupleMeetingsHeldQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCoupleMeetingsHeldQuery, GetCoupleMeetingsHeldQueryVariables>(GetCoupleMeetingsHeldDocument, variables, options);
}
export function useGetCoupleMeetingsHeldLazyQuery(variables: GetCoupleMeetingsHeldQueryVariables | VueCompositionApi.Ref<GetCoupleMeetingsHeldQueryVariables> | ReactiveFunction<GetCoupleMeetingsHeldQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCoupleMeetingsHeldQuery, GetCoupleMeetingsHeldQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCoupleMeetingsHeldQuery, GetCoupleMeetingsHeldQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCoupleMeetingsHeldQuery, GetCoupleMeetingsHeldQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetCoupleMeetingsHeldQuery, GetCoupleMeetingsHeldQueryVariables>(GetCoupleMeetingsHeldDocument, variables, options);
}
export type GetCoupleMeetingsHeldQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCoupleMeetingsHeldQuery, GetCoupleMeetingsHeldQueryVariables>;
export const GetPaginatedCouplesDocument = gql`
    query GetPaginatedCouples($therapistId: Int!, $limit: Int!, $page: Int!, $searchPhrase: String, $orderBy: OrderBy, $assignedTo: [Int!], $showDeactivated: Boolean! = false) {
  couplePaginatedQuery(
    therapistId: $therapistId
    limit: $limit
    page: $page
    searchPhrase: $searchPhrase
    orderBy: $orderBy
    assignedTo: $assignedTo
    showDeactivated: $showDeactivated
  ) {
    count
    data {
      id
      coupleName
      deactivatedOn
      patients {
        id
        firstName
        lastName
        phoneNumber
        secondPhoneNumber
        email
      }
      therapists {
        id
        color
        fullName
        user {
          firstName
        }
      }
    }
  }
}
    `;

/**
 * __useGetPaginatedCouplesQuery__
 *
 * To run a query within a Vue component, call `useGetPaginatedCouplesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedCouplesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPaginatedCouplesQuery({
 *   therapistId: // value for 'therapistId'
 *   limit: // value for 'limit'
 *   page: // value for 'page'
 *   searchPhrase: // value for 'searchPhrase'
 *   orderBy: // value for 'orderBy'
 *   assignedTo: // value for 'assignedTo'
 *   showDeactivated: // value for 'showDeactivated'
 * });
 */
export function useGetPaginatedCouplesQuery(variables: GetPaginatedCouplesQueryVariables | VueCompositionApi.Ref<GetPaginatedCouplesQueryVariables> | ReactiveFunction<GetPaginatedCouplesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPaginatedCouplesQuery, GetPaginatedCouplesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPaginatedCouplesQuery, GetPaginatedCouplesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPaginatedCouplesQuery, GetPaginatedCouplesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPaginatedCouplesQuery, GetPaginatedCouplesQueryVariables>(GetPaginatedCouplesDocument, variables, options);
}
export function useGetPaginatedCouplesLazyQuery(variables: GetPaginatedCouplesQueryVariables | VueCompositionApi.Ref<GetPaginatedCouplesQueryVariables> | ReactiveFunction<GetPaginatedCouplesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPaginatedCouplesQuery, GetPaginatedCouplesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPaginatedCouplesQuery, GetPaginatedCouplesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPaginatedCouplesQuery, GetPaginatedCouplesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetPaginatedCouplesQuery, GetPaginatedCouplesQueryVariables>(GetPaginatedCouplesDocument, variables, options);
}
export type GetPaginatedCouplesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPaginatedCouplesQuery, GetPaginatedCouplesQueryVariables>;
export const CreateEmployeeDocument = gql`
    mutation CreateEmployee($payload: CreateEmployeeInput!) {
  createEmployee(payload: $payload)
}
    `;

/**
 * __useCreateEmployeeMutation__
 *
 * To run a mutation, you first call `useCreateEmployeeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmployeeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateEmployeeMutation({
 *   variables: {
 *     payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateEmployeeMutation(options: VueApolloComposable.UseMutationOptions<CreateEmployeeMutation, CreateEmployeeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateEmployeeMutation, CreateEmployeeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateEmployeeMutation, CreateEmployeeMutationVariables>(CreateEmployeeDocument, options);
}
export type CreateEmployeeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateEmployeeMutation, CreateEmployeeMutationVariables>;
export const DeactivateEmployeeDocument = gql`
    mutation DeactivateEmployee($employeeId: Int!) {
  deactivateEmployee(employeeId: $employeeId)
}
    `;

/**
 * __useDeactivateEmployeeMutation__
 *
 * To run a mutation, you first call `useDeactivateEmployeeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateEmployeeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeactivateEmployeeMutation({
 *   variables: {
 *     employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useDeactivateEmployeeMutation(options: VueApolloComposable.UseMutationOptions<DeactivateEmployeeMutation, DeactivateEmployeeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeactivateEmployeeMutation, DeactivateEmployeeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeactivateEmployeeMutation, DeactivateEmployeeMutationVariables>(DeactivateEmployeeDocument, options);
}
export type DeactivateEmployeeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeactivateEmployeeMutation, DeactivateEmployeeMutationVariables>;
export const EditEmployeeDocument = gql`
    mutation EditEmployee($employeeId: Int!, $payload: EditEmployeeInput!) {
  editEmployee(employeeId: $employeeId, payload: $payload)
}
    `;

/**
 * __useEditEmployeeMutation__
 *
 * To run a mutation, you first call `useEditEmployeeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEditEmployeeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEditEmployeeMutation({
 *   variables: {
 *     employeeId: // value for 'employeeId'
 *     payload: // value for 'payload'
 *   },
 * });
 */
export function useEditEmployeeMutation(options: VueApolloComposable.UseMutationOptions<EditEmployeeMutation, EditEmployeeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EditEmployeeMutation, EditEmployeeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<EditEmployeeMutation, EditEmployeeMutationVariables>(EditEmployeeDocument, options);
}
export type EditEmployeeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EditEmployeeMutation, EditEmployeeMutationVariables>;
export const EditEmployeeFavoriteTherapistsDocument = gql`
    mutation EditEmployeeFavoriteTherapists($employeeId: Int!, $therapists: [Int!] = []) {
  editFavoriteTherapists(employeeId: $employeeId, therapists: $therapists)
}
    `;

/**
 * __useEditEmployeeFavoriteTherapistsMutation__
 *
 * To run a mutation, you first call `useEditEmployeeFavoriteTherapistsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEditEmployeeFavoriteTherapistsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEditEmployeeFavoriteTherapistsMutation({
 *   variables: {
 *     employeeId: // value for 'employeeId'
 *     therapists: // value for 'therapists'
 *   },
 * });
 */
export function useEditEmployeeFavoriteTherapistsMutation(options: VueApolloComposable.UseMutationOptions<EditEmployeeFavoriteTherapistsMutation, EditEmployeeFavoriteTherapistsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EditEmployeeFavoriteTherapistsMutation, EditEmployeeFavoriteTherapistsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<EditEmployeeFavoriteTherapistsMutation, EditEmployeeFavoriteTherapistsMutationVariables>(EditEmployeeFavoriteTherapistsDocument, options);
}
export type EditEmployeeFavoriteTherapistsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EditEmployeeFavoriteTherapistsMutation, EditEmployeeFavoriteTherapistsMutationVariables>;
export const SendEmployeeInvitationDocument = gql`
    mutation SendEmployeeInvitation($id: Int!) {
  sendEmployeeInvitation(employeeInput: {id: $id})
}
    `;

/**
 * __useSendEmployeeInvitationMutation__
 *
 * To run a mutation, you first call `useSendEmployeeInvitationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSendEmployeeInvitationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSendEmployeeInvitationMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useSendEmployeeInvitationMutation(options: VueApolloComposable.UseMutationOptions<SendEmployeeInvitationMutation, SendEmployeeInvitationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SendEmployeeInvitationMutation, SendEmployeeInvitationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SendEmployeeInvitationMutation, SendEmployeeInvitationMutationVariables>(SendEmployeeInvitationDocument, options);
}
export type SendEmployeeInvitationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SendEmployeeInvitationMutation, SendEmployeeInvitationMutationVariables>;
export const GetEmployeeFavoriteTherapistsDocument = gql`
    query GetEmployeeFavoriteTherapists($employeeId: Int) {
  favoriteTherapists(employeeId: $employeeId) {
    id
    fullName
    color
    acronym
  }
}
    `;

/**
 * __useGetEmployeeFavoriteTherapistsQuery__
 *
 * To run a query within a Vue component, call `useGetEmployeeFavoriteTherapistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeFavoriteTherapistsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetEmployeeFavoriteTherapistsQuery({
 *   employeeId: // value for 'employeeId'
 * });
 */
export function useGetEmployeeFavoriteTherapistsQuery(variables: GetEmployeeFavoriteTherapistsQueryVariables | VueCompositionApi.Ref<GetEmployeeFavoriteTherapistsQueryVariables> | ReactiveFunction<GetEmployeeFavoriteTherapistsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetEmployeeFavoriteTherapistsQuery, GetEmployeeFavoriteTherapistsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetEmployeeFavoriteTherapistsQuery, GetEmployeeFavoriteTherapistsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetEmployeeFavoriteTherapistsQuery, GetEmployeeFavoriteTherapistsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetEmployeeFavoriteTherapistsQuery, GetEmployeeFavoriteTherapistsQueryVariables>(GetEmployeeFavoriteTherapistsDocument, variables, options);
}
export function useGetEmployeeFavoriteTherapistsLazyQuery(variables: GetEmployeeFavoriteTherapistsQueryVariables | VueCompositionApi.Ref<GetEmployeeFavoriteTherapistsQueryVariables> | ReactiveFunction<GetEmployeeFavoriteTherapistsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetEmployeeFavoriteTherapistsQuery, GetEmployeeFavoriteTherapistsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetEmployeeFavoriteTherapistsQuery, GetEmployeeFavoriteTherapistsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetEmployeeFavoriteTherapistsQuery, GetEmployeeFavoriteTherapistsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetEmployeeFavoriteTherapistsQuery, GetEmployeeFavoriteTherapistsQueryVariables>(GetEmployeeFavoriteTherapistsDocument, variables, options);
}
export type GetEmployeeFavoriteTherapistsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetEmployeeFavoriteTherapistsQuery, GetEmployeeFavoriteTherapistsQueryVariables>;
export const EmployeeInvitationInfoDocument = gql`
    query EmployeeInvitationInfo($invitationUUID: String!) {
  employeeInvitationInfo(invitationUuid: $invitationUUID) {
    practiceName
    invitedEmail
  }
}
    `;

/**
 * __useEmployeeInvitationInfoQuery__
 *
 * To run a query within a Vue component, call `useEmployeeInvitationInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeInvitationInfoQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useEmployeeInvitationInfoQuery({
 *   invitationUUID: // value for 'invitationUUID'
 * });
 */
export function useEmployeeInvitationInfoQuery(variables: EmployeeInvitationInfoQueryVariables | VueCompositionApi.Ref<EmployeeInvitationInfoQueryVariables> | ReactiveFunction<EmployeeInvitationInfoQueryVariables>, options: VueApolloComposable.UseQueryOptions<EmployeeInvitationInfoQuery, EmployeeInvitationInfoQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<EmployeeInvitationInfoQuery, EmployeeInvitationInfoQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<EmployeeInvitationInfoQuery, EmployeeInvitationInfoQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<EmployeeInvitationInfoQuery, EmployeeInvitationInfoQueryVariables>(EmployeeInvitationInfoDocument, variables, options);
}
export function useEmployeeInvitationInfoLazyQuery(variables: EmployeeInvitationInfoQueryVariables | VueCompositionApi.Ref<EmployeeInvitationInfoQueryVariables> | ReactiveFunction<EmployeeInvitationInfoQueryVariables>, options: VueApolloComposable.UseQueryOptions<EmployeeInvitationInfoQuery, EmployeeInvitationInfoQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<EmployeeInvitationInfoQuery, EmployeeInvitationInfoQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<EmployeeInvitationInfoQuery, EmployeeInvitationInfoQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<EmployeeInvitationInfoQuery, EmployeeInvitationInfoQueryVariables>(EmployeeInvitationInfoDocument, variables, options);
}
export type EmployeeInvitationInfoQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<EmployeeInvitationInfoQuery, EmployeeInvitationInfoQueryVariables>;
export const GetAllEmployeesDocument = gql`
    query GetAllEmployees {
  employees {
    ...EmployeeBase
  }
}
    ${EmployeeBaseFragmentDoc}`;

/**
 * __useGetAllEmployeesQuery__
 *
 * To run a query within a Vue component, call `useGetAllEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllEmployeesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllEmployeesQuery();
 */
export function useGetAllEmployeesQuery(options: VueApolloComposable.UseQueryOptions<GetAllEmployeesQuery, GetAllEmployeesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAllEmployeesQuery, GetAllEmployeesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAllEmployeesQuery, GetAllEmployeesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetAllEmployeesQuery, GetAllEmployeesQueryVariables>(GetAllEmployeesDocument, {}, options);
}
export function useGetAllEmployeesLazyQuery(options: VueApolloComposable.UseQueryOptions<GetAllEmployeesQuery, GetAllEmployeesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAllEmployeesQuery, GetAllEmployeesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAllEmployeesQuery, GetAllEmployeesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetAllEmployeesQuery, GetAllEmployeesQueryVariables>(GetAllEmployeesDocument, {}, options);
}
export type GetAllEmployeesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetAllEmployeesQuery, GetAllEmployeesQueryVariables>;
export const GetEmployeeDocument = gql`
    query GetEmployee($id: Int!) {
  employee(id: $id) {
    ...EmployeeDetail
  }
}
    ${EmployeeDetailFragmentDoc}`;

/**
 * __useGetEmployeeQuery__
 *
 * To run a query within a Vue component, call `useGetEmployeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetEmployeeQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetEmployeeQuery(variables: GetEmployeeQueryVariables | VueCompositionApi.Ref<GetEmployeeQueryVariables> | ReactiveFunction<GetEmployeeQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetEmployeeQuery, GetEmployeeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetEmployeeQuery, GetEmployeeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetEmployeeQuery, GetEmployeeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetEmployeeQuery, GetEmployeeQueryVariables>(GetEmployeeDocument, variables, options);
}
export function useGetEmployeeLazyQuery(variables: GetEmployeeQueryVariables | VueCompositionApi.Ref<GetEmployeeQueryVariables> | ReactiveFunction<GetEmployeeQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetEmployeeQuery, GetEmployeeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetEmployeeQuery, GetEmployeeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetEmployeeQuery, GetEmployeeQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetEmployeeQuery, GetEmployeeQueryVariables>(GetEmployeeDocument, variables, options);
}
export type GetEmployeeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetEmployeeQuery, GetEmployeeQueryVariables>;
export const GetEmployeeByUserIdDocument = gql`
    query GetEmployeeByUserId($userId: String!) {
  getEmployeeByUserId(userId: $userId) {
    acronym
    color
    id
    phoneNumber
    user {
      dateJoined
      email
      firstName
      fullName
      id
      lastName
    }
    practiceBranchId
    practiceId
    roles {
      name
      slug
    }
  }
}
    `;

/**
 * __useGetEmployeeByUserIdQuery__
 *
 * To run a query within a Vue component, call `useGetEmployeeByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeByUserIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetEmployeeByUserIdQuery({
 *   userId: // value for 'userId'
 * });
 */
export function useGetEmployeeByUserIdQuery(variables: GetEmployeeByUserIdQueryVariables | VueCompositionApi.Ref<GetEmployeeByUserIdQueryVariables> | ReactiveFunction<GetEmployeeByUserIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetEmployeeByUserIdQuery, GetEmployeeByUserIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetEmployeeByUserIdQuery, GetEmployeeByUserIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetEmployeeByUserIdQuery, GetEmployeeByUserIdQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetEmployeeByUserIdQuery, GetEmployeeByUserIdQueryVariables>(GetEmployeeByUserIdDocument, variables, options);
}
export function useGetEmployeeByUserIdLazyQuery(variables: GetEmployeeByUserIdQueryVariables | VueCompositionApi.Ref<GetEmployeeByUserIdQueryVariables> | ReactiveFunction<GetEmployeeByUserIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetEmployeeByUserIdQuery, GetEmployeeByUserIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetEmployeeByUserIdQuery, GetEmployeeByUserIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetEmployeeByUserIdQuery, GetEmployeeByUserIdQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetEmployeeByUserIdQuery, GetEmployeeByUserIdQueryVariables>(GetEmployeeByUserIdDocument, variables, options);
}
export type GetEmployeeByUserIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetEmployeeByUserIdQuery, GetEmployeeByUserIdQueryVariables>;
export const GetEmployeeListDocument = gql`
    query GetEmployeeList {
  getEmployeeList {
    id
    acronym
    color
    email
    roles {
      name
      slug
    }
    fullName
  }
}
    `;

/**
 * __useGetEmployeeListQuery__
 *
 * To run a query within a Vue component, call `useGetEmployeeListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetEmployeeListQuery();
 */
export function useGetEmployeeListQuery(options: VueApolloComposable.UseQueryOptions<GetEmployeeListQuery, GetEmployeeListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetEmployeeListQuery, GetEmployeeListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetEmployeeListQuery, GetEmployeeListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetEmployeeListQuery, GetEmployeeListQueryVariables>(GetEmployeeListDocument, {}, options);
}
export function useGetEmployeeListLazyQuery(options: VueApolloComposable.UseQueryOptions<GetEmployeeListQuery, GetEmployeeListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetEmployeeListQuery, GetEmployeeListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetEmployeeListQuery, GetEmployeeListQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetEmployeeListQuery, GetEmployeeListQueryVariables>(GetEmployeeListDocument, {}, options);
}
export type GetEmployeeListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetEmployeeListQuery, GetEmployeeListQueryVariables>;
export const GetEmployeesTableDocument = gql`
    query GetEmployeesTable($limit: Int!, $page: Int!, $practiceBranchId: Int!, $orderBy: OrderBy, $searchPhrase: String, $role: String) {
  paginatedEmployees(
    limit: $limit
    page: $page
    orderBy: $orderBy
    practiceBranchId: $practiceBranchId
    searchPhrase: $searchPhrase
    role: $role
    all: true
  ) {
    count
    data {
      id
      fullName
      acronym
      email
      phoneNumber
      roles {
        name
        slug
      }
      color
      acceptedInvitation
      availableInOnlineRegistration
      practiceBranch {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetEmployeesTableQuery__
 *
 * To run a query within a Vue component, call `useGetEmployeesTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeesTableQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetEmployeesTableQuery({
 *   limit: // value for 'limit'
 *   page: // value for 'page'
 *   practiceBranchId: // value for 'practiceBranchId'
 *   orderBy: // value for 'orderBy'
 *   searchPhrase: // value for 'searchPhrase'
 *   role: // value for 'role'
 * });
 */
export function useGetEmployeesTableQuery(variables: GetEmployeesTableQueryVariables | VueCompositionApi.Ref<GetEmployeesTableQueryVariables> | ReactiveFunction<GetEmployeesTableQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetEmployeesTableQuery, GetEmployeesTableQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetEmployeesTableQuery, GetEmployeesTableQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetEmployeesTableQuery, GetEmployeesTableQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetEmployeesTableQuery, GetEmployeesTableQueryVariables>(GetEmployeesTableDocument, variables, options);
}
export function useGetEmployeesTableLazyQuery(variables: GetEmployeesTableQueryVariables | VueCompositionApi.Ref<GetEmployeesTableQueryVariables> | ReactiveFunction<GetEmployeesTableQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetEmployeesTableQuery, GetEmployeesTableQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetEmployeesTableQuery, GetEmployeesTableQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetEmployeesTableQuery, GetEmployeesTableQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetEmployeesTableQuery, GetEmployeesTableQueryVariables>(GetEmployeesTableDocument, variables, options);
}
export type GetEmployeesTableQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetEmployeesTableQuery, GetEmployeesTableQueryVariables>;
export const AddPeriodicEventDocument = gql`
    mutation AddPeriodicEvent($duration: TimeDeltaMinutes!, $patients: [Int!]!, $services: [Int!]!, $start: ISODateTime!, $therapistIds: [Int!]!, $roomId: Int!, $end: ISODateTime = null, $name: String!, $interval: Int!, $dows: [Int!]!, $coupleId: Int) {
  addPeriodicEvent(
    eventInput: {start: $start, roomId: $roomId, duration: $duration, name: $name, patients: $patients, services: $services, therapistIds: $therapistIds, end: $end, interval: $interval, dows: $dows, coupleId: $coupleId}
  ) {
    id
  }
}
    `;

/**
 * __useAddPeriodicEventMutation__
 *
 * To run a mutation, you first call `useAddPeriodicEventMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddPeriodicEventMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddPeriodicEventMutation({
 *   variables: {
 *     duration: // value for 'duration'
 *     patients: // value for 'patients'
 *     services: // value for 'services'
 *     start: // value for 'start'
 *     therapistIds: // value for 'therapistIds'
 *     roomId: // value for 'roomId'
 *     end: // value for 'end'
 *     name: // value for 'name'
 *     interval: // value for 'interval'
 *     dows: // value for 'dows'
 *     coupleId: // value for 'coupleId'
 *   },
 * });
 */
export function useAddPeriodicEventMutation(options: VueApolloComposable.UseMutationOptions<AddPeriodicEventMutation, AddPeriodicEventMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddPeriodicEventMutation, AddPeriodicEventMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddPeriodicEventMutation, AddPeriodicEventMutationVariables>(AddPeriodicEventDocument, options);
}
export type AddPeriodicEventMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddPeriodicEventMutation, AddPeriodicEventMutationVariables>;
export const AddSingleEventDocument = gql`
    mutation AddSingleEvent($duration: TimeDeltaMinutes!, $patients: [Int!]!, $services: [Int!]!, $start: ISODateTime!, $therapistIds: [Int!]!, $roomId: Int!, $name: String = "", $coupleId: Int) {
  addSingleEvent(
    eventInput: {start: $start, roomId: $roomId, duration: $duration, name: $name, patients: $patients, services: $services, therapistIds: $therapistIds, coupleId: $coupleId}
  ) {
    ... on Event {
      id
    }
  }
}
    `;

/**
 * __useAddSingleEventMutation__
 *
 * To run a mutation, you first call `useAddSingleEventMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddSingleEventMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddSingleEventMutation({
 *   variables: {
 *     duration: // value for 'duration'
 *     patients: // value for 'patients'
 *     services: // value for 'services'
 *     start: // value for 'start'
 *     therapistIds: // value for 'therapistIds'
 *     roomId: // value for 'roomId'
 *     name: // value for 'name'
 *     coupleId: // value for 'coupleId'
 *   },
 * });
 */
export function useAddSingleEventMutation(options: VueApolloComposable.UseMutationOptions<AddSingleEventMutation, AddSingleEventMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddSingleEventMutation, AddSingleEventMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddSingleEventMutation, AddSingleEventMutationVariables>(AddSingleEventDocument, options);
}
export type AddSingleEventMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddSingleEventMutation, AddSingleEventMutationVariables>;
export const AddSingleEventWithCollisionsDocument = gql`
    mutation AddSingleEventWithCollisions($eventInput: EventInput!, $collisionLimit: Int = 5) {
  addSingleEventWithCollisions(
    eventInput: $eventInput
    collisionLimit: $collisionLimit
  ) {
    ... on EventOutput {
      success
      event {
        id
      }
      collisions {
        reason
        event {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useAddSingleEventWithCollisionsMutation__
 *
 * To run a mutation, you first call `useAddSingleEventWithCollisionsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddSingleEventWithCollisionsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddSingleEventWithCollisionsMutation({
 *   variables: {
 *     eventInput: // value for 'eventInput'
 *     collisionLimit: // value for 'collisionLimit'
 *   },
 * });
 */
export function useAddSingleEventWithCollisionsMutation(options: VueApolloComposable.UseMutationOptions<AddSingleEventWithCollisionsMutation, AddSingleEventWithCollisionsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddSingleEventWithCollisionsMutation, AddSingleEventWithCollisionsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddSingleEventWithCollisionsMutation, AddSingleEventWithCollisionsMutationVariables>(AddSingleEventWithCollisionsDocument, options);
}
export type AddSingleEventWithCollisionsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddSingleEventWithCollisionsMutation, AddSingleEventWithCollisionsMutationVariables>;
export const DeactivateRoomsDocument = gql`
    mutation DeactivateRooms($roomIds: [Int!]!) {
  deactivateRooms(roomIds: $roomIds)
}
    `;

/**
 * __useDeactivateRoomsMutation__
 *
 * To run a mutation, you first call `useDeactivateRoomsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateRoomsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeactivateRoomsMutation({
 *   variables: {
 *     roomIds: // value for 'roomIds'
 *   },
 * });
 */
export function useDeactivateRoomsMutation(options: VueApolloComposable.UseMutationOptions<DeactivateRoomsMutation, DeactivateRoomsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeactivateRoomsMutation, DeactivateRoomsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeactivateRoomsMutation, DeactivateRoomsMutationVariables>(DeactivateRoomsDocument, options);
}
export type DeactivateRoomsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeactivateRoomsMutation, DeactivateRoomsMutationVariables>;
export const DeleteEventAttachmentDocument = gql`
    mutation DeleteEventAttachment($attachmentId: Int!) {
  deleteEventAttachment(attachmentId: $attachmentId)
}
    `;

/**
 * __useDeleteEventAttachmentMutation__
 *
 * To run a mutation, you first call `useDeleteEventAttachmentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventAttachmentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteEventAttachmentMutation({
 *   variables: {
 *     attachmentId: // value for 'attachmentId'
 *   },
 * });
 */
export function useDeleteEventAttachmentMutation(options: VueApolloComposable.UseMutationOptions<DeleteEventAttachmentMutation, DeleteEventAttachmentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteEventAttachmentMutation, DeleteEventAttachmentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteEventAttachmentMutation, DeleteEventAttachmentMutationVariables>(DeleteEventAttachmentDocument, options);
}
export type DeleteEventAttachmentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteEventAttachmentMutation, DeleteEventAttachmentMutationVariables>;
export const DeleteEventSeriesDocument = gql`
    mutation DeleteEventSeries($eventPeriodId: Int!, $afterDate: ISODateTime!) {
  deleteEventSeries(eventPeriodId: $eventPeriodId, afterDate: $afterDate)
}
    `;

/**
 * __useDeleteEventSeriesMutation__
 *
 * To run a mutation, you first call `useDeleteEventSeriesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventSeriesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteEventSeriesMutation({
 *   variables: {
 *     eventPeriodId: // value for 'eventPeriodId'
 *     afterDate: // value for 'afterDate'
 *   },
 * });
 */
export function useDeleteEventSeriesMutation(options: VueApolloComposable.UseMutationOptions<DeleteEventSeriesMutation, DeleteEventSeriesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteEventSeriesMutation, DeleteEventSeriesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteEventSeriesMutation, DeleteEventSeriesMutationVariables>(DeleteEventSeriesDocument, options);
}
export type DeleteEventSeriesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteEventSeriesMutation, DeleteEventSeriesMutationVariables>;
export const EditEventDocument = gql`
    mutation EditEvent($eventId: Int!, $payload: EventEditAttributes!) {
  editEvent(eventId: $eventId, payload: $payload) {
    ...InitialCalendarEvent
  }
}
    ${InitialCalendarEventFragmentDoc}`;

/**
 * __useEditEventMutation__
 *
 * To run a mutation, you first call `useEditEventMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEditEventMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEditEventMutation({
 *   variables: {
 *     eventId: // value for 'eventId'
 *     payload: // value for 'payload'
 *   },
 * });
 */
export function useEditEventMutation(options: VueApolloComposable.UseMutationOptions<EditEventMutation, EditEventMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EditEventMutation, EditEventMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<EditEventMutation, EditEventMutationVariables>(EditEventDocument, options);
}
export type EditEventMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EditEventMutation, EditEventMutationVariables>;
export const EditEventPaymentStatusesDocument = gql`
    mutation EditEventPaymentStatuses($eventIds: [Int!]!, $paymentStatus: EventPayment!, $paidOn: ISODate = null, $paymentMethod: EventPaymentMethods = null) {
  editEventPaymentStatuses(
    eventIds: $eventIds
    paymentStatus: $paymentStatus
    paidOn: $paidOn
    paymentMethod: $paymentMethod
  )
}
    `;

/**
 * __useEditEventPaymentStatusesMutation__
 *
 * To run a mutation, you first call `useEditEventPaymentStatusesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEditEventPaymentStatusesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEditEventPaymentStatusesMutation({
 *   variables: {
 *     eventIds: // value for 'eventIds'
 *     paymentStatus: // value for 'paymentStatus'
 *     paidOn: // value for 'paidOn'
 *     paymentMethod: // value for 'paymentMethod'
 *   },
 * });
 */
export function useEditEventPaymentStatusesMutation(options: VueApolloComposable.UseMutationOptions<EditEventPaymentStatusesMutation, EditEventPaymentStatusesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EditEventPaymentStatusesMutation, EditEventPaymentStatusesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<EditEventPaymentStatusesMutation, EditEventPaymentStatusesMutationVariables>(EditEventPaymentStatusesDocument, options);
}
export type EditEventPaymentStatusesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EditEventPaymentStatusesMutation, EditEventPaymentStatusesMutationVariables>;
export const EditEventSeriesDocument = gql`
    mutation EditEventSeries($payload: EventSeriesEditAttributes!, $eventId: Int!) {
  editEventSeries(eventId: $eventId, payload: $payload)
}
    `;

/**
 * __useEditEventSeriesMutation__
 *
 * To run a mutation, you first call `useEditEventSeriesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEditEventSeriesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEditEventSeriesMutation({
 *   variables: {
 *     payload: // value for 'payload'
 *     eventId: // value for 'eventId'
 *   },
 * });
 */
export function useEditEventSeriesMutation(options: VueApolloComposable.UseMutationOptions<EditEventSeriesMutation, EditEventSeriesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EditEventSeriesMutation, EditEventSeriesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<EditEventSeriesMutation, EditEventSeriesMutationVariables>(EditEventSeriesDocument, options);
}
export type EditEventSeriesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EditEventSeriesMutation, EditEventSeriesMutationVariables>;
export const EditEventWithCollisionsDocument = gql`
    mutation EditEventWithCollisions($eventId: Int!, $payload: EventEditAttributes!, $collisionLimit: Int = 5) {
  editEventWithCollisions(
    eventId: $eventId
    payload: $payload
    collisionLimit: $collisionLimit
  ) {
    ... on EventOutput {
      success
      event {
        id
      }
      collisions {
        reason
        event {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useEditEventWithCollisionsMutation__
 *
 * To run a mutation, you first call `useEditEventWithCollisionsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEditEventWithCollisionsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEditEventWithCollisionsMutation({
 *   variables: {
 *     eventId: // value for 'eventId'
 *     payload: // value for 'payload'
 *     collisionLimit: // value for 'collisionLimit'
 *   },
 * });
 */
export function useEditEventWithCollisionsMutation(options: VueApolloComposable.UseMutationOptions<EditEventWithCollisionsMutation, EditEventWithCollisionsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EditEventWithCollisionsMutation, EditEventWithCollisionsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<EditEventWithCollisionsMutation, EditEventWithCollisionsMutationVariables>(EditEventWithCollisionsDocument, options);
}
export type EditEventWithCollisionsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EditEventWithCollisionsMutation, EditEventWithCollisionsMutationVariables>;
export const ShiftEventSeriesDocument = gql`
    mutation ShiftEventSeries($payload: EventSeriesEditAttributes!, $eventId: Int!) {
  shiftEventSeries(eventId: $eventId, payload: $payload)
}
    `;

/**
 * __useShiftEventSeriesMutation__
 *
 * To run a mutation, you first call `useShiftEventSeriesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useShiftEventSeriesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useShiftEventSeriesMutation({
 *   variables: {
 *     payload: // value for 'payload'
 *     eventId: // value for 'eventId'
 *   },
 * });
 */
export function useShiftEventSeriesMutation(options: VueApolloComposable.UseMutationOptions<ShiftEventSeriesMutation, ShiftEventSeriesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ShiftEventSeriesMutation, ShiftEventSeriesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ShiftEventSeriesMutation, ShiftEventSeriesMutationVariables>(ShiftEventSeriesDocument, options);
}
export type ShiftEventSeriesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ShiftEventSeriesMutation, ShiftEventSeriesMutationVariables>;
export const ChangeEventIntoSeriesDocument = gql`
    mutation ChangeEventIntoSeries($dows: [Int!]!, $eventId: Int!, $interval: Int!, $end: ISODateTime = null) {
  changeEventIntoEventSeries(
    dows: $dows
    eventId: $eventId
    interval: $interval
    end: $end
  )
}
    `;

/**
 * __useChangeEventIntoSeriesMutation__
 *
 * To run a mutation, you first call `useChangeEventIntoSeriesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useChangeEventIntoSeriesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useChangeEventIntoSeriesMutation({
 *   variables: {
 *     dows: // value for 'dows'
 *     eventId: // value for 'eventId'
 *     interval: // value for 'interval'
 *     end: // value for 'end'
 *   },
 * });
 */
export function useChangeEventIntoSeriesMutation(options: VueApolloComposable.UseMutationOptions<ChangeEventIntoSeriesMutation, ChangeEventIntoSeriesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ChangeEventIntoSeriesMutation, ChangeEventIntoSeriesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ChangeEventIntoSeriesMutation, ChangeEventIntoSeriesMutationVariables>(ChangeEventIntoSeriesDocument, options);
}
export type ChangeEventIntoSeriesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ChangeEventIntoSeriesMutation, ChangeEventIntoSeriesMutationVariables>;
export const GetCoupleMeetingDetailsDocument = gql`
    query GetCoupleMeetingDetails($eventId: Int!) {
  event(eventId: $eventId) {
    id
    start
    note
    secretNote
    duration
    paidOn
    locked
    shifted
    couple {
      id
      coupleName
      therapists {
        id
      }
    }
    period {
      id
    }
    groupPresence {
      name
    }
    services {
      id
    }
    therapists {
      id
    }
    room {
      id
    }
    participants {
      id
      payment
      paymentMethodName
      patient {
        id
        fullName
        phoneNumber
        email
        therapists {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetCoupleMeetingDetailsQuery__
 *
 * To run a query within a Vue component, call `useGetCoupleMeetingDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoupleMeetingDetailsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCoupleMeetingDetailsQuery({
 *   eventId: // value for 'eventId'
 * });
 */
export function useGetCoupleMeetingDetailsQuery(variables: GetCoupleMeetingDetailsQueryVariables | VueCompositionApi.Ref<GetCoupleMeetingDetailsQueryVariables> | ReactiveFunction<GetCoupleMeetingDetailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCoupleMeetingDetailsQuery, GetCoupleMeetingDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCoupleMeetingDetailsQuery, GetCoupleMeetingDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCoupleMeetingDetailsQuery, GetCoupleMeetingDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCoupleMeetingDetailsQuery, GetCoupleMeetingDetailsQueryVariables>(GetCoupleMeetingDetailsDocument, variables, options);
}
export function useGetCoupleMeetingDetailsLazyQuery(variables: GetCoupleMeetingDetailsQueryVariables | VueCompositionApi.Ref<GetCoupleMeetingDetailsQueryVariables> | ReactiveFunction<GetCoupleMeetingDetailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCoupleMeetingDetailsQuery, GetCoupleMeetingDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCoupleMeetingDetailsQuery, GetCoupleMeetingDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCoupleMeetingDetailsQuery, GetCoupleMeetingDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetCoupleMeetingDetailsQuery, GetCoupleMeetingDetailsQueryVariables>(GetCoupleMeetingDetailsDocument, variables, options);
}
export type GetCoupleMeetingDetailsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCoupleMeetingDetailsQuery, GetCoupleMeetingDetailsQueryVariables>;
export const GetCoupleUpcomingEventsDocument = gql`
    query GetCoupleUpcomingEvents($after: ISODateTime!, $coupleId: Int!) {
  coupleUpcomingEvents(after: $after, coupleId: $coupleId) {
    id
    start
    end
  }
}
    `;

/**
 * __useGetCoupleUpcomingEventsQuery__
 *
 * To run a query within a Vue component, call `useGetCoupleUpcomingEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoupleUpcomingEventsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCoupleUpcomingEventsQuery({
 *   after: // value for 'after'
 *   coupleId: // value for 'coupleId'
 * });
 */
export function useGetCoupleUpcomingEventsQuery(variables: GetCoupleUpcomingEventsQueryVariables | VueCompositionApi.Ref<GetCoupleUpcomingEventsQueryVariables> | ReactiveFunction<GetCoupleUpcomingEventsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCoupleUpcomingEventsQuery, GetCoupleUpcomingEventsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCoupleUpcomingEventsQuery, GetCoupleUpcomingEventsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCoupleUpcomingEventsQuery, GetCoupleUpcomingEventsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCoupleUpcomingEventsQuery, GetCoupleUpcomingEventsQueryVariables>(GetCoupleUpcomingEventsDocument, variables, options);
}
export function useGetCoupleUpcomingEventsLazyQuery(variables: GetCoupleUpcomingEventsQueryVariables | VueCompositionApi.Ref<GetCoupleUpcomingEventsQueryVariables> | ReactiveFunction<GetCoupleUpcomingEventsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCoupleUpcomingEventsQuery, GetCoupleUpcomingEventsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCoupleUpcomingEventsQuery, GetCoupleUpcomingEventsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCoupleUpcomingEventsQuery, GetCoupleUpcomingEventsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetCoupleUpcomingEventsQuery, GetCoupleUpcomingEventsQueryVariables>(GetCoupleUpcomingEventsDocument, variables, options);
}
export type GetCoupleUpcomingEventsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCoupleUpcomingEventsQuery, GetCoupleUpcomingEventsQueryVariables>;
export const GetEventDocument = gql`
    query GetEvent($eventId: Int!) {
  event(eventId: $eventId) {
    ...EventData
    secretNote
    nextEvent
    prevEvent
  }
}
    ${EventDataFragmentDoc}`;

/**
 * __useGetEventQuery__
 *
 * To run a query within a Vue component, call `useGetEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetEventQuery({
 *   eventId: // value for 'eventId'
 * });
 */
export function useGetEventQuery(variables: GetEventQueryVariables | VueCompositionApi.Ref<GetEventQueryVariables> | ReactiveFunction<GetEventQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetEventQuery, GetEventQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetEventQuery, GetEventQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetEventQuery, GetEventQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetEventQuery, GetEventQueryVariables>(GetEventDocument, variables, options);
}
export function useGetEventLazyQuery(variables: GetEventQueryVariables | VueCompositionApi.Ref<GetEventQueryVariables> | ReactiveFunction<GetEventQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetEventQuery, GetEventQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetEventQuery, GetEventQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetEventQuery, GetEventQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetEventQuery, GetEventQueryVariables>(GetEventDocument, variables, options);
}
export type GetEventQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetEventQuery, GetEventQueryVariables>;
export const GetEventsDocument = gql`
    query GetEvents($after: ISODateTime!, $before: ISODateTime!, $employeeIds: [Int!], $patientId: Int, $coupleId: Int) {
  events(
    after: $after
    before: $before
    employeeIds: $employeeIds
    patientId: $patientId
    coupleId: $coupleId
  ) {
    ...EventData
  }
}
    ${EventDataFragmentDoc}`;

/**
 * __useGetEventsQuery__
 *
 * To run a query within a Vue component, call `useGetEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetEventsQuery({
 *   after: // value for 'after'
 *   before: // value for 'before'
 *   employeeIds: // value for 'employeeIds'
 *   patientId: // value for 'patientId'
 *   coupleId: // value for 'coupleId'
 * });
 */
export function useGetEventsQuery(variables: GetEventsQueryVariables | VueCompositionApi.Ref<GetEventsQueryVariables> | ReactiveFunction<GetEventsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetEventsQuery, GetEventsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetEventsQuery, GetEventsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetEventsQuery, GetEventsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetEventsQuery, GetEventsQueryVariables>(GetEventsDocument, variables, options);
}
export function useGetEventsLazyQuery(variables: GetEventsQueryVariables | VueCompositionApi.Ref<GetEventsQueryVariables> | ReactiveFunction<GetEventsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetEventsQuery, GetEventsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetEventsQuery, GetEventsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetEventsQuery, GetEventsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetEventsQuery, GetEventsQueryVariables>(GetEventsDocument, variables, options);
}
export type GetEventsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetEventsQuery, GetEventsQueryVariables>;
export const GetEventsByServiceIdAndPracticeBranchIdDocument = gql`
    query GetEventsByServiceIdAndPracticeBranchId($after: ISODateTime!, $before: ISODateTime!, $employeeIds: [Int!], $serviceId: Int, $practiceBranchId: Int, $patientId: Int, $coupleId: Int, $heldMeetings: Boolean = false, $orderBy: OrderBy) {
  eventsWithSorting(
    after: $after
    before: $before
    employeeIds: $employeeIds
    serviceId: $serviceId
    practiceBranchId: $practiceBranchId
    patientId: $patientId
    coupleId: $coupleId
    heldMeetings: $heldMeetings
    orderBy: $orderBy
  ) {
    id
    couple {
      id
      coupleName
    }
    start
    participants {
      id
      payment
      patient {
        id
        firstName
        lastName
      }
    }
    services {
      id
      price
    }
  }
}
    `;

/**
 * __useGetEventsByServiceIdAndPracticeBranchIdQuery__
 *
 * To run a query within a Vue component, call `useGetEventsByServiceIdAndPracticeBranchIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventsByServiceIdAndPracticeBranchIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetEventsByServiceIdAndPracticeBranchIdQuery({
 *   after: // value for 'after'
 *   before: // value for 'before'
 *   employeeIds: // value for 'employeeIds'
 *   serviceId: // value for 'serviceId'
 *   practiceBranchId: // value for 'practiceBranchId'
 *   patientId: // value for 'patientId'
 *   coupleId: // value for 'coupleId'
 *   heldMeetings: // value for 'heldMeetings'
 *   orderBy: // value for 'orderBy'
 * });
 */
export function useGetEventsByServiceIdAndPracticeBranchIdQuery(variables: GetEventsByServiceIdAndPracticeBranchIdQueryVariables | VueCompositionApi.Ref<GetEventsByServiceIdAndPracticeBranchIdQueryVariables> | ReactiveFunction<GetEventsByServiceIdAndPracticeBranchIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetEventsByServiceIdAndPracticeBranchIdQuery, GetEventsByServiceIdAndPracticeBranchIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetEventsByServiceIdAndPracticeBranchIdQuery, GetEventsByServiceIdAndPracticeBranchIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetEventsByServiceIdAndPracticeBranchIdQuery, GetEventsByServiceIdAndPracticeBranchIdQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetEventsByServiceIdAndPracticeBranchIdQuery, GetEventsByServiceIdAndPracticeBranchIdQueryVariables>(GetEventsByServiceIdAndPracticeBranchIdDocument, variables, options);
}
export function useGetEventsByServiceIdAndPracticeBranchIdLazyQuery(variables: GetEventsByServiceIdAndPracticeBranchIdQueryVariables | VueCompositionApi.Ref<GetEventsByServiceIdAndPracticeBranchIdQueryVariables> | ReactiveFunction<GetEventsByServiceIdAndPracticeBranchIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetEventsByServiceIdAndPracticeBranchIdQuery, GetEventsByServiceIdAndPracticeBranchIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetEventsByServiceIdAndPracticeBranchIdQuery, GetEventsByServiceIdAndPracticeBranchIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetEventsByServiceIdAndPracticeBranchIdQuery, GetEventsByServiceIdAndPracticeBranchIdQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetEventsByServiceIdAndPracticeBranchIdQuery, GetEventsByServiceIdAndPracticeBranchIdQueryVariables>(GetEventsByServiceIdAndPracticeBranchIdDocument, variables, options);
}
export type GetEventsByServiceIdAndPracticeBranchIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetEventsByServiceIdAndPracticeBranchIdQuery, GetEventsByServiceIdAndPracticeBranchIdQueryVariables>;
export const GetInitialCalendarDocument = gql`
    query GetInitialCalendar($after: ISODateTime!, $before: ISODateTime!, $employeeIds: [Int!], $patientId: Int, $coupleId: Int) {
  events(
    after: $after
    before: $before
    employeeIds: $employeeIds
    patientId: $patientId
    coupleId: $coupleId
  ) {
    ...InitialCalendarEvent
  }
}
    ${InitialCalendarEventFragmentDoc}`;

/**
 * __useGetInitialCalendarQuery__
 *
 * To run a query within a Vue component, call `useGetInitialCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInitialCalendarQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetInitialCalendarQuery({
 *   after: // value for 'after'
 *   before: // value for 'before'
 *   employeeIds: // value for 'employeeIds'
 *   patientId: // value for 'patientId'
 *   coupleId: // value for 'coupleId'
 * });
 */
export function useGetInitialCalendarQuery(variables: GetInitialCalendarQueryVariables | VueCompositionApi.Ref<GetInitialCalendarQueryVariables> | ReactiveFunction<GetInitialCalendarQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetInitialCalendarQuery, GetInitialCalendarQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetInitialCalendarQuery, GetInitialCalendarQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetInitialCalendarQuery, GetInitialCalendarQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetInitialCalendarQuery, GetInitialCalendarQueryVariables>(GetInitialCalendarDocument, variables, options);
}
export function useGetInitialCalendarLazyQuery(variables: GetInitialCalendarQueryVariables | VueCompositionApi.Ref<GetInitialCalendarQueryVariables> | ReactiveFunction<GetInitialCalendarQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetInitialCalendarQuery, GetInitialCalendarQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetInitialCalendarQuery, GetInitialCalendarQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetInitialCalendarQuery, GetInitialCalendarQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetInitialCalendarQuery, GetInitialCalendarQueryVariables>(GetInitialCalendarDocument, variables, options);
}
export type GetInitialCalendarQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetInitialCalendarQuery, GetInitialCalendarQueryVariables>;
export const GetPaginatedEventsDocument = gql`
    query GetPaginatedEvents($after: ISODateTime!, $before: ISODateTime!, $limit: Int!, $page: Int!, $employeeIds: [Int!], $orderBy: OrderBy, $patientId: Int, $coupleId: Int, $serviceId: Int) {
  paginatedEvents(
    after: $after
    before: $before
    limit: $limit
    page: $page
    orderBy: $orderBy
    employeeIds: $employeeIds
    patientId: $patientId
    coupleId: $coupleId
    serviceId: $serviceId
  ) {
    count
    data {
      ...EventData
    }
  }
}
    ${EventDataFragmentDoc}`;

/**
 * __useGetPaginatedEventsQuery__
 *
 * To run a query within a Vue component, call `useGetPaginatedEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedEventsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPaginatedEventsQuery({
 *   after: // value for 'after'
 *   before: // value for 'before'
 *   limit: // value for 'limit'
 *   page: // value for 'page'
 *   employeeIds: // value for 'employeeIds'
 *   orderBy: // value for 'orderBy'
 *   patientId: // value for 'patientId'
 *   coupleId: // value for 'coupleId'
 *   serviceId: // value for 'serviceId'
 * });
 */
export function useGetPaginatedEventsQuery(variables: GetPaginatedEventsQueryVariables | VueCompositionApi.Ref<GetPaginatedEventsQueryVariables> | ReactiveFunction<GetPaginatedEventsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPaginatedEventsQuery, GetPaginatedEventsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPaginatedEventsQuery, GetPaginatedEventsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPaginatedEventsQuery, GetPaginatedEventsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPaginatedEventsQuery, GetPaginatedEventsQueryVariables>(GetPaginatedEventsDocument, variables, options);
}
export function useGetPaginatedEventsLazyQuery(variables: GetPaginatedEventsQueryVariables | VueCompositionApi.Ref<GetPaginatedEventsQueryVariables> | ReactiveFunction<GetPaginatedEventsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPaginatedEventsQuery, GetPaginatedEventsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPaginatedEventsQuery, GetPaginatedEventsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPaginatedEventsQuery, GetPaginatedEventsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetPaginatedEventsQuery, GetPaginatedEventsQueryVariables>(GetPaginatedEventsDocument, variables, options);
}
export type GetPaginatedEventsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPaginatedEventsQuery, GetPaginatedEventsQueryVariables>;
export const GetPatientMeetingDetailsDocument = gql`
    query GetPatientMeetingDetails($eventId: Int!) {
  event(eventId: $eventId) {
    id
    start
    note
    secretNote
    duration
    paidOn
    locked
    shifted
    period {
      id
    }
    services {
      id
    }
    therapists {
      id
    }
    room {
      id
    }
    participants {
      id
      presenceName
      payment
      paymentMethodName
      patient {
        id
        fullName
        phoneNumber
        email
        description
        therapists {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetPatientMeetingDetailsQuery__
 *
 * To run a query within a Vue component, call `useGetPatientMeetingDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientMeetingDetailsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPatientMeetingDetailsQuery({
 *   eventId: // value for 'eventId'
 * });
 */
export function useGetPatientMeetingDetailsQuery(variables: GetPatientMeetingDetailsQueryVariables | VueCompositionApi.Ref<GetPatientMeetingDetailsQueryVariables> | ReactiveFunction<GetPatientMeetingDetailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPatientMeetingDetailsQuery, GetPatientMeetingDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPatientMeetingDetailsQuery, GetPatientMeetingDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPatientMeetingDetailsQuery, GetPatientMeetingDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPatientMeetingDetailsQuery, GetPatientMeetingDetailsQueryVariables>(GetPatientMeetingDetailsDocument, variables, options);
}
export function useGetPatientMeetingDetailsLazyQuery(variables: GetPatientMeetingDetailsQueryVariables | VueCompositionApi.Ref<GetPatientMeetingDetailsQueryVariables> | ReactiveFunction<GetPatientMeetingDetailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPatientMeetingDetailsQuery, GetPatientMeetingDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPatientMeetingDetailsQuery, GetPatientMeetingDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPatientMeetingDetailsQuery, GetPatientMeetingDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetPatientMeetingDetailsQuery, GetPatientMeetingDetailsQueryVariables>(GetPatientMeetingDetailsDocument, variables, options);
}
export type GetPatientMeetingDetailsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPatientMeetingDetailsQuery, GetPatientMeetingDetailsQueryVariables>;
export const GetPatientUpcomingEventsDocument = gql`
    query GetPatientUpcomingEvents($after: ISODateTime!, $patientId: Int!) {
  patientUpcomingEvents(after: $after, patientId: $patientId) {
    id
    start
    end
  }
}
    `;

/**
 * __useGetPatientUpcomingEventsQuery__
 *
 * To run a query within a Vue component, call `useGetPatientUpcomingEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientUpcomingEventsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPatientUpcomingEventsQuery({
 *   after: // value for 'after'
 *   patientId: // value for 'patientId'
 * });
 */
export function useGetPatientUpcomingEventsQuery(variables: GetPatientUpcomingEventsQueryVariables | VueCompositionApi.Ref<GetPatientUpcomingEventsQueryVariables> | ReactiveFunction<GetPatientUpcomingEventsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPatientUpcomingEventsQuery, GetPatientUpcomingEventsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPatientUpcomingEventsQuery, GetPatientUpcomingEventsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPatientUpcomingEventsQuery, GetPatientUpcomingEventsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPatientUpcomingEventsQuery, GetPatientUpcomingEventsQueryVariables>(GetPatientUpcomingEventsDocument, variables, options);
}
export function useGetPatientUpcomingEventsLazyQuery(variables: GetPatientUpcomingEventsQueryVariables | VueCompositionApi.Ref<GetPatientUpcomingEventsQueryVariables> | ReactiveFunction<GetPatientUpcomingEventsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPatientUpcomingEventsQuery, GetPatientUpcomingEventsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPatientUpcomingEventsQuery, GetPatientUpcomingEventsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPatientUpcomingEventsQuery, GetPatientUpcomingEventsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetPatientUpcomingEventsQuery, GetPatientUpcomingEventsQueryVariables>(GetPatientUpcomingEventsDocument, variables, options);
}
export type GetPatientUpcomingEventsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPatientUpcomingEventsQuery, GetPatientUpcomingEventsQueryVariables>;
export const GetWithoutPatientsMeetingDetailsDocument = gql`
    query GetWithoutPatientsMeetingDetails($eventId: Int!) {
  event(eventId: $eventId) {
    id
    start
    duration
    name
    locked
    shifted
    period {
      id
    }
    therapists {
      id
    }
    room {
      id
    }
  }
}
    `;

/**
 * __useGetWithoutPatientsMeetingDetailsQuery__
 *
 * To run a query within a Vue component, call `useGetWithoutPatientsMeetingDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWithoutPatientsMeetingDetailsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetWithoutPatientsMeetingDetailsQuery({
 *   eventId: // value for 'eventId'
 * });
 */
export function useGetWithoutPatientsMeetingDetailsQuery(variables: GetWithoutPatientsMeetingDetailsQueryVariables | VueCompositionApi.Ref<GetWithoutPatientsMeetingDetailsQueryVariables> | ReactiveFunction<GetWithoutPatientsMeetingDetailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetWithoutPatientsMeetingDetailsQuery, GetWithoutPatientsMeetingDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetWithoutPatientsMeetingDetailsQuery, GetWithoutPatientsMeetingDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetWithoutPatientsMeetingDetailsQuery, GetWithoutPatientsMeetingDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetWithoutPatientsMeetingDetailsQuery, GetWithoutPatientsMeetingDetailsQueryVariables>(GetWithoutPatientsMeetingDetailsDocument, variables, options);
}
export function useGetWithoutPatientsMeetingDetailsLazyQuery(variables: GetWithoutPatientsMeetingDetailsQueryVariables | VueCompositionApi.Ref<GetWithoutPatientsMeetingDetailsQueryVariables> | ReactiveFunction<GetWithoutPatientsMeetingDetailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetWithoutPatientsMeetingDetailsQuery, GetWithoutPatientsMeetingDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetWithoutPatientsMeetingDetailsQuery, GetWithoutPatientsMeetingDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetWithoutPatientsMeetingDetailsQuery, GetWithoutPatientsMeetingDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetWithoutPatientsMeetingDetailsQuery, GetWithoutPatientsMeetingDetailsQueryVariables>(GetWithoutPatientsMeetingDetailsDocument, variables, options);
}
export type GetWithoutPatientsMeetingDetailsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetWithoutPatientsMeetingDetailsQuery, GetWithoutPatientsMeetingDetailsQueryVariables>;
export const AddExpenseDocument = gql`
    mutation AddExpense($practiceBranchId: Int!, $name: String!, $note: String, $amount: Float!, $recurringPeriod: RecurringExpenseEnum, $date: Date!) {
  addExpense(
    expenseInput: {practiceBranchId: $practiceBranchId, name: $name, note: $note, amount: $amount, date: $date, recurringPeriod: $recurringPeriod}
  ) {
    expenses {
      id
    }
  }
}
    `;

/**
 * __useAddExpenseMutation__
 *
 * To run a mutation, you first call `useAddExpenseMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddExpenseMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddExpenseMutation({
 *   variables: {
 *     practiceBranchId: // value for 'practiceBranchId'
 *     name: // value for 'name'
 *     note: // value for 'note'
 *     amount: // value for 'amount'
 *     recurringPeriod: // value for 'recurringPeriod'
 *     date: // value for 'date'
 *   },
 * });
 */
export function useAddExpenseMutation(options: VueApolloComposable.UseMutationOptions<AddExpenseMutation, AddExpenseMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddExpenseMutation, AddExpenseMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddExpenseMutation, AddExpenseMutationVariables>(AddExpenseDocument, options);
}
export type AddExpenseMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddExpenseMutation, AddExpenseMutationVariables>;
export const EditExpenseDocument = gql`
    mutation EditExpense($expenseId: Int!, $payload: ExpensesEditAttributes!) {
  editExpense(expenseId: $expenseId, payload: $payload)
}
    `;

/**
 * __useEditExpenseMutation__
 *
 * To run a mutation, you first call `useEditExpenseMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEditExpenseMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEditExpenseMutation({
 *   variables: {
 *     expenseId: // value for 'expenseId'
 *     payload: // value for 'payload'
 *   },
 * });
 */
export function useEditExpenseMutation(options: VueApolloComposable.UseMutationOptions<EditExpenseMutation, EditExpenseMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EditExpenseMutation, EditExpenseMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<EditExpenseMutation, EditExpenseMutationVariables>(EditExpenseDocument, options);
}
export type EditExpenseMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EditExpenseMutation, EditExpenseMutationVariables>;
export const RemoveExpenseDocument = gql`
    mutation RemoveExpense($expenseIds: [Int!]!) {
  removeExpenses(expenseIds: $expenseIds) {
    success
  }
}
    `;

/**
 * __useRemoveExpenseMutation__
 *
 * To run a mutation, you first call `useRemoveExpenseMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveExpenseMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveExpenseMutation({
 *   variables: {
 *     expenseIds: // value for 'expenseIds'
 *   },
 * });
 */
export function useRemoveExpenseMutation(options: VueApolloComposable.UseMutationOptions<RemoveExpenseMutation, RemoveExpenseMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RemoveExpenseMutation, RemoveExpenseMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RemoveExpenseMutation, RemoveExpenseMutationVariables>(RemoveExpenseDocument, options);
}
export type RemoveExpenseMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RemoveExpenseMutation, RemoveExpenseMutationVariables>;
export const GetExpensesDocument = gql`
    query GetExpenses($after: Date!, $before: Date!, $limit: Int!, $page: Int!, $orderBy: OrderBy) {
  paginatedExpenses(
    after: $after
    before: $before
    limit: $limit
    page: $page
    orderBy: $orderBy
  ) {
    count
    pageTotals
    totals
    data {
      id
      name
      amount
      note
      date
      recurring {
        recurringPeriod
      }
      author {
        fullName
        id
      }
    }
  }
}
    `;

/**
 * __useGetExpensesQuery__
 *
 * To run a query within a Vue component, call `useGetExpensesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExpensesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetExpensesQuery({
 *   after: // value for 'after'
 *   before: // value for 'before'
 *   limit: // value for 'limit'
 *   page: // value for 'page'
 *   orderBy: // value for 'orderBy'
 * });
 */
export function useGetExpensesQuery(variables: GetExpensesQueryVariables | VueCompositionApi.Ref<GetExpensesQueryVariables> | ReactiveFunction<GetExpensesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetExpensesQuery, GetExpensesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetExpensesQuery, GetExpensesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetExpensesQuery, GetExpensesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetExpensesQuery, GetExpensesQueryVariables>(GetExpensesDocument, variables, options);
}
export function useGetExpensesLazyQuery(variables: GetExpensesQueryVariables | VueCompositionApi.Ref<GetExpensesQueryVariables> | ReactiveFunction<GetExpensesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetExpensesQuery, GetExpensesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetExpensesQuery, GetExpensesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetExpensesQuery, GetExpensesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetExpensesQuery, GetExpensesQueryVariables>(GetExpensesDocument, variables, options);
}
export type GetExpensesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetExpensesQuery, GetExpensesQueryVariables>;
export const EditGdprConfigDocument = gql`
    mutation EditGDPRConfig($payload: EditGDPRConfigInput!) {
  editGdprConfig(payload: $payload)
}
    `;

/**
 * __useEditGdprConfigMutation__
 *
 * To run a mutation, you first call `useEditGdprConfigMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEditGdprConfigMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEditGdprConfigMutation({
 *   variables: {
 *     payload: // value for 'payload'
 *   },
 * });
 */
export function useEditGdprConfigMutation(options: VueApolloComposable.UseMutationOptions<EditGdprConfigMutation, EditGdprConfigMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EditGdprConfigMutation, EditGdprConfigMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<EditGdprConfigMutation, EditGdprConfigMutationVariables>(EditGdprConfigDocument, options);
}
export type EditGdprConfigMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EditGdprConfigMutation, EditGdprConfigMutationVariables>;
export const MarkGdprDocumentAsOpenedDocument = gql`
    mutation MarkGDPRDocumentAsOpened($token: String!) {
  markGdprDocumentAsOpened(token: $token)
}
    `;

/**
 * __useMarkGdprDocumentAsOpenedMutation__
 *
 * To run a mutation, you first call `useMarkGdprDocumentAsOpenedMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useMarkGdprDocumentAsOpenedMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useMarkGdprDocumentAsOpenedMutation({
 *   variables: {
 *     token: // value for 'token'
 *   },
 * });
 */
export function useMarkGdprDocumentAsOpenedMutation(options: VueApolloComposable.UseMutationOptions<MarkGdprDocumentAsOpenedMutation, MarkGdprDocumentAsOpenedMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<MarkGdprDocumentAsOpenedMutation, MarkGdprDocumentAsOpenedMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<MarkGdprDocumentAsOpenedMutation, MarkGdprDocumentAsOpenedMutationVariables>(MarkGdprDocumentAsOpenedDocument, options);
}
export type MarkGdprDocumentAsOpenedMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<MarkGdprDocumentAsOpenedMutation, MarkGdprDocumentAsOpenedMutationVariables>;
export const SendGdprConsentDocument = gql`
    mutation SendGDPRConsent($patientIds: [Int!]!) {
  sendGdprEmail(patientIds: $patientIds)
}
    `;

/**
 * __useSendGdprConsentMutation__
 *
 * To run a mutation, you first call `useSendGdprConsentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSendGdprConsentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSendGdprConsentMutation({
 *   variables: {
 *     patientIds: // value for 'patientIds'
 *   },
 * });
 */
export function useSendGdprConsentMutation(options: VueApolloComposable.UseMutationOptions<SendGdprConsentMutation, SendGdprConsentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SendGdprConsentMutation, SendGdprConsentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SendGdprConsentMutation, SendGdprConsentMutationVariables>(SendGdprConsentDocument, options);
}
export type SendGdprConsentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SendGdprConsentMutation, SendGdprConsentMutationVariables>;
export const SignGdprDocumentDocument = gql`
    mutation SignGDPRDocument($token: String!) {
  markGdprDocumentAsSigned(token: $token)
}
    `;

/**
 * __useSignGdprDocumentMutation__
 *
 * To run a mutation, you first call `useSignGdprDocumentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSignGdprDocumentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSignGdprDocumentMutation({
 *   variables: {
 *     token: // value for 'token'
 *   },
 * });
 */
export function useSignGdprDocumentMutation(options: VueApolloComposable.UseMutationOptions<SignGdprDocumentMutation, SignGdprDocumentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SignGdprDocumentMutation, SignGdprDocumentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SignGdprDocumentMutation, SignGdprDocumentMutationVariables>(SignGdprDocumentDocument, options);
}
export type SignGdprDocumentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SignGdprDocumentMutation, SignGdprDocumentMutationVariables>;
export const GetGdprConfigDocument = gql`
    query GetGDPRConfig {
  getGdprConfig {
    id
    sendAutomatedGdprMails
    documentCategory
    documentCategoryChild
    practiceBranchId
  }
}
    `;

/**
 * __useGetGdprConfigQuery__
 *
 * To run a query within a Vue component, call `useGetGdprConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGdprConfigQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetGdprConfigQuery();
 */
export function useGetGdprConfigQuery(options: VueApolloComposable.UseQueryOptions<GetGdprConfigQuery, GetGdprConfigQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetGdprConfigQuery, GetGdprConfigQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetGdprConfigQuery, GetGdprConfigQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetGdprConfigQuery, GetGdprConfigQueryVariables>(GetGdprConfigDocument, {}, options);
}
export function useGetGdprConfigLazyQuery(options: VueApolloComposable.UseQueryOptions<GetGdprConfigQuery, GetGdprConfigQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetGdprConfigQuery, GetGdprConfigQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetGdprConfigQuery, GetGdprConfigQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetGdprConfigQuery, GetGdprConfigQueryVariables>(GetGdprConfigDocument, {}, options);
}
export type GetGdprConfigQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetGdprConfigQuery, GetGdprConfigQueryVariables>;
export const GetGdprDocumentDocument = gql`
    query GetGDPRDocument($token: String!) {
  getGdprDocument(token: $token) {
    patientToken
    patient {
      id
      fullName
    }
    documentType
    practiceName
    openedDate
    signedDate
    isSigned
  }
}
    `;

/**
 * __useGetGdprDocumentQuery__
 *
 * To run a query within a Vue component, call `useGetGdprDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGdprDocumentQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetGdprDocumentQuery({
 *   token: // value for 'token'
 * });
 */
export function useGetGdprDocumentQuery(variables: GetGdprDocumentQueryVariables | VueCompositionApi.Ref<GetGdprDocumentQueryVariables> | ReactiveFunction<GetGdprDocumentQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetGdprDocumentQuery, GetGdprDocumentQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetGdprDocumentQuery, GetGdprDocumentQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetGdprDocumentQuery, GetGdprDocumentQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetGdprDocumentQuery, GetGdprDocumentQueryVariables>(GetGdprDocumentDocument, variables, options);
}
export function useGetGdprDocumentLazyQuery(variables: GetGdprDocumentQueryVariables | VueCompositionApi.Ref<GetGdprDocumentQueryVariables> | ReactiveFunction<GetGdprDocumentQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetGdprDocumentQuery, GetGdprDocumentQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetGdprDocumentQuery, GetGdprDocumentQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetGdprDocumentQuery, GetGdprDocumentQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetGdprDocumentQuery, GetGdprDocumentQueryVariables>(GetGdprDocumentDocument, variables, options);
}
export type GetGdprDocumentQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetGdprDocumentQuery, GetGdprDocumentQueryVariables>;
export const CreateGuardianDocument = gql`
    mutation CreateGuardian($payload: CreateGuardianInput!) {
  createGuardian(payload: $payload)
}
    `;

/**
 * __useCreateGuardianMutation__
 *
 * To run a mutation, you first call `useCreateGuardianMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateGuardianMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateGuardianMutation({
 *   variables: {
 *     payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateGuardianMutation(options: VueApolloComposable.UseMutationOptions<CreateGuardianMutation, CreateGuardianMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateGuardianMutation, CreateGuardianMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateGuardianMutation, CreateGuardianMutationVariables>(CreateGuardianDocument, options);
}
export type CreateGuardianMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateGuardianMutation, CreateGuardianMutationVariables>;
export const DeactivateGuardianDocument = gql`
    mutation DeactivateGuardian($guardianId: Int!, $deactivatedAt: ISODateTime) {
  deactivateGuardian(guardianId: $guardianId, deactivatedAt: $deactivatedAt)
}
    `;

/**
 * __useDeactivateGuardianMutation__
 *
 * To run a mutation, you first call `useDeactivateGuardianMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateGuardianMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeactivateGuardianMutation({
 *   variables: {
 *     guardianId: // value for 'guardianId'
 *     deactivatedAt: // value for 'deactivatedAt'
 *   },
 * });
 */
export function useDeactivateGuardianMutation(options: VueApolloComposable.UseMutationOptions<DeactivateGuardianMutation, DeactivateGuardianMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeactivateGuardianMutation, DeactivateGuardianMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeactivateGuardianMutation, DeactivateGuardianMutationVariables>(DeactivateGuardianDocument, options);
}
export type DeactivateGuardianMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeactivateGuardianMutation, DeactivateGuardianMutationVariables>;
export const EditGuardianDocument = gql`
    mutation EditGuardian($payload: EditGuardianInput!) {
  editGuardian(payload: $payload)
}
    `;

/**
 * __useEditGuardianMutation__
 *
 * To run a mutation, you first call `useEditGuardianMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEditGuardianMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEditGuardianMutation({
 *   variables: {
 *     payload: // value for 'payload'
 *   },
 * });
 */
export function useEditGuardianMutation(options: VueApolloComposable.UseMutationOptions<EditGuardianMutation, EditGuardianMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EditGuardianMutation, EditGuardianMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<EditGuardianMutation, EditGuardianMutationVariables>(EditGuardianDocument, options);
}
export type EditGuardianMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EditGuardianMutation, EditGuardianMutationVariables>;
export const GetGuardiansDocument = gql`
    query GetGuardians($patientId: Int!) {
  getGuardians(patientId: $patientId) {
    id
    firstName
    lastName
    phoneNumber
    email
    address {
      id
      street
      houseNumber
      apartmentNumber
      zipCode
      city
      county
      country
    }
  }
}
    `;

/**
 * __useGetGuardiansQuery__
 *
 * To run a query within a Vue component, call `useGetGuardiansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGuardiansQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetGuardiansQuery({
 *   patientId: // value for 'patientId'
 * });
 */
export function useGetGuardiansQuery(variables: GetGuardiansQueryVariables | VueCompositionApi.Ref<GetGuardiansQueryVariables> | ReactiveFunction<GetGuardiansQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetGuardiansQuery, GetGuardiansQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetGuardiansQuery, GetGuardiansQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetGuardiansQuery, GetGuardiansQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetGuardiansQuery, GetGuardiansQueryVariables>(GetGuardiansDocument, variables, options);
}
export function useGetGuardiansLazyQuery(variables: GetGuardiansQueryVariables | VueCompositionApi.Ref<GetGuardiansQueryVariables> | ReactiveFunction<GetGuardiansQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetGuardiansQuery, GetGuardiansQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetGuardiansQuery, GetGuardiansQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetGuardiansQuery, GetGuardiansQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetGuardiansQuery, GetGuardiansQueryVariables>(GetGuardiansDocument, variables, options);
}
export type GetGuardiansQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetGuardiansQuery, GetGuardiansQueryVariables>;
export const PaginatedHolidaysDocument = gql`
    query PaginatedHolidays($after: ISODateTime!, $before: ISODateTime!, $limit: Int!, $page: Int!) {
  paginatedHolidays(after: $after, before: $before, limit: $limit, page: $page) {
    count
    data {
      id
    }
    totals
    pageTotals
  }
}
    `;

/**
 * __usePaginatedHolidaysQuery__
 *
 * To run a query within a Vue component, call `usePaginatedHolidaysQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedHolidaysQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePaginatedHolidaysQuery({
 *   after: // value for 'after'
 *   before: // value for 'before'
 *   limit: // value for 'limit'
 *   page: // value for 'page'
 * });
 */
export function usePaginatedHolidaysQuery(variables: PaginatedHolidaysQueryVariables | VueCompositionApi.Ref<PaginatedHolidaysQueryVariables> | ReactiveFunction<PaginatedHolidaysQueryVariables>, options: VueApolloComposable.UseQueryOptions<PaginatedHolidaysQuery, PaginatedHolidaysQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PaginatedHolidaysQuery, PaginatedHolidaysQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PaginatedHolidaysQuery, PaginatedHolidaysQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<PaginatedHolidaysQuery, PaginatedHolidaysQueryVariables>(PaginatedHolidaysDocument, variables, options);
}
export function usePaginatedHolidaysLazyQuery(variables: PaginatedHolidaysQueryVariables | VueCompositionApi.Ref<PaginatedHolidaysQueryVariables> | ReactiveFunction<PaginatedHolidaysQueryVariables>, options: VueApolloComposable.UseQueryOptions<PaginatedHolidaysQuery, PaginatedHolidaysQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PaginatedHolidaysQuery, PaginatedHolidaysQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PaginatedHolidaysQuery, PaginatedHolidaysQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<PaginatedHolidaysQuery, PaginatedHolidaysQueryVariables>(PaginatedHolidaysDocument, variables, options);
}
export type PaginatedHolidaysQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<PaginatedHolidaysQuery, PaginatedHolidaysQueryVariables>;
export const GetIncomeDocument = gql`
    query GetIncome($after: ISODateTime!, $before: ISODateTime!, $limit: Int!, $page: Int!, $practiceBranch: Int, $orderBy: OrderBy, $therapists: [Int!], $services: [Int!], $statuses: [EventPayment!], $patients: [Int!], $paymentMethods: [String!]) {
  paginatedIncomes(
    after: $after
    before: $before
    limit: $limit
    page: $page
    practiceBranch: $practiceBranch
    orderBy: $orderBy
    therapists: $therapists
    services: $services
    statuses: $statuses
    patients: $patients
    paymentMethods: $paymentMethods
  ) {
    count
    pageTotals
    totals
    data {
      id
      amount
      date
      serviceName
      paidOn
      services {
        name
      }
      participants {
        id
        paymentMethod {
          name
        }
        payment
        patient {
          fullName
        }
      }
      therapists {
        id
        fullName
      }
    }
  }
}
    `;

/**
 * __useGetIncomeQuery__
 *
 * To run a query within a Vue component, call `useGetIncomeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIncomeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetIncomeQuery({
 *   after: // value for 'after'
 *   before: // value for 'before'
 *   limit: // value for 'limit'
 *   page: // value for 'page'
 *   practiceBranch: // value for 'practiceBranch'
 *   orderBy: // value for 'orderBy'
 *   therapists: // value for 'therapists'
 *   services: // value for 'services'
 *   statuses: // value for 'statuses'
 *   patients: // value for 'patients'
 *   paymentMethods: // value for 'paymentMethods'
 * });
 */
export function useGetIncomeQuery(variables: GetIncomeQueryVariables | VueCompositionApi.Ref<GetIncomeQueryVariables> | ReactiveFunction<GetIncomeQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetIncomeQuery, GetIncomeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetIncomeQuery, GetIncomeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetIncomeQuery, GetIncomeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetIncomeQuery, GetIncomeQueryVariables>(GetIncomeDocument, variables, options);
}
export function useGetIncomeLazyQuery(variables: GetIncomeQueryVariables | VueCompositionApi.Ref<GetIncomeQueryVariables> | ReactiveFunction<GetIncomeQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetIncomeQuery, GetIncomeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetIncomeQuery, GetIncomeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetIncomeQuery, GetIncomeQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetIncomeQuery, GetIncomeQueryVariables>(GetIncomeDocument, variables, options);
}
export type GetIncomeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetIncomeQuery, GetIncomeQueryVariables>;
export const DeleteInvoiceConfigDocument = gql`
    mutation DeleteInvoiceConfig($deleteAccountOnFakturownia: Boolean!) {
  deleteInvoiceConfig(deleteAccountOnFakturownia: $deleteAccountOnFakturownia) {
    code
    message
  }
}
    `;

/**
 * __useDeleteInvoiceConfigMutation__
 *
 * To run a mutation, you first call `useDeleteInvoiceConfigMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInvoiceConfigMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteInvoiceConfigMutation({
 *   variables: {
 *     deleteAccountOnFakturownia: // value for 'deleteAccountOnFakturownia'
 *   },
 * });
 */
export function useDeleteInvoiceConfigMutation(options: VueApolloComposable.UseMutationOptions<DeleteInvoiceConfigMutation, DeleteInvoiceConfigMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteInvoiceConfigMutation, DeleteInvoiceConfigMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteInvoiceConfigMutation, DeleteInvoiceConfigMutationVariables>(DeleteInvoiceConfigDocument, options);
}
export type DeleteInvoiceConfigMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteInvoiceConfigMutation, DeleteInvoiceConfigMutationVariables>;
export const GetInvoiceConfigDocument = gql`
    query GetInvoiceConfig {
  invoiceConfig {
    id
    active
    apiToken
    subdomain
  }
  getCurrentPracticeDetails {
    billingInfo {
      id
    }
  }
}
    `;

/**
 * __useGetInvoiceConfigQuery__
 *
 * To run a query within a Vue component, call `useGetInvoiceConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceConfigQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetInvoiceConfigQuery();
 */
export function useGetInvoiceConfigQuery(options: VueApolloComposable.UseQueryOptions<GetInvoiceConfigQuery, GetInvoiceConfigQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetInvoiceConfigQuery, GetInvoiceConfigQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetInvoiceConfigQuery, GetInvoiceConfigQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetInvoiceConfigQuery, GetInvoiceConfigQueryVariables>(GetInvoiceConfigDocument, {}, options);
}
export function useGetInvoiceConfigLazyQuery(options: VueApolloComposable.UseQueryOptions<GetInvoiceConfigQuery, GetInvoiceConfigQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetInvoiceConfigQuery, GetInvoiceConfigQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetInvoiceConfigQuery, GetInvoiceConfigQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetInvoiceConfigQuery, GetInvoiceConfigQueryVariables>(GetInvoiceConfigDocument, {}, options);
}
export type GetInvoiceConfigQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetInvoiceConfigQuery, GetInvoiceConfigQueryVariables>;
export const UpdateOrCreateInvoiceConfigDocument = gql`
    mutation UpdateOrCreateInvoiceConfig($payload: InvoiceConfigInput) {
  updateOrCreateInvoiceConfig(payload: $payload) {
    id
    active
    apiToken
  }
}
    `;

/**
 * __useUpdateOrCreateInvoiceConfigMutation__
 *
 * To run a mutation, you first call `useUpdateOrCreateInvoiceConfigMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrCreateInvoiceConfigMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateOrCreateInvoiceConfigMutation({
 *   variables: {
 *     payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateOrCreateInvoiceConfigMutation(options: VueApolloComposable.UseMutationOptions<UpdateOrCreateInvoiceConfigMutation, UpdateOrCreateInvoiceConfigMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateOrCreateInvoiceConfigMutation, UpdateOrCreateInvoiceConfigMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateOrCreateInvoiceConfigMutation, UpdateOrCreateInvoiceConfigMutationVariables>(UpdateOrCreateInvoiceConfigDocument, options);
}
export type UpdateOrCreateInvoiceConfigMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateOrCreateInvoiceConfigMutation, UpdateOrCreateInvoiceConfigMutationVariables>;
export const AddInvoiceDocument = gql`
    mutation AddInvoice($payload: InvoiceInput!) {
  createInvoice(payload: $payload) {
    id
  }
}
    `;

/**
 * __useAddInvoiceMutation__
 *
 * To run a mutation, you first call `useAddInvoiceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddInvoiceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddInvoiceMutation({
 *   variables: {
 *     payload: // value for 'payload'
 *   },
 * });
 */
export function useAddInvoiceMutation(options: VueApolloComposable.UseMutationOptions<AddInvoiceMutation, AddInvoiceMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddInvoiceMutation, AddInvoiceMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddInvoiceMutation, AddInvoiceMutationVariables>(AddInvoiceDocument, options);
}
export type AddInvoiceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddInvoiceMutation, AddInvoiceMutationVariables>;
export const DeleteInvoiceDocument = gql`
    mutation DeleteInvoice($invoiceId: Int!) {
  deleteInvoice(invoiceId: $invoiceId)
}
    `;

/**
 * __useDeleteInvoiceMutation__
 *
 * To run a mutation, you first call `useDeleteInvoiceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInvoiceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteInvoiceMutation({
 *   variables: {
 *     invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useDeleteInvoiceMutation(options: VueApolloComposable.UseMutationOptions<DeleteInvoiceMutation, DeleteInvoiceMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteInvoiceMutation, DeleteInvoiceMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteInvoiceMutation, DeleteInvoiceMutationVariables>(DeleteInvoiceDocument, options);
}
export type DeleteInvoiceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteInvoiceMutation, DeleteInvoiceMutationVariables>;
export const SendInvoicesDocument = gql`
    mutation SendInvoices($payload: [InvoiceSendInput!]!) {
  sendInvoices(payload: $payload)
}
    `;

/**
 * __useSendInvoicesMutation__
 *
 * To run a mutation, you first call `useSendInvoicesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSendInvoicesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSendInvoicesMutation({
 *   variables: {
 *     payload: // value for 'payload'
 *   },
 * });
 */
export function useSendInvoicesMutation(options: VueApolloComposable.UseMutationOptions<SendInvoicesMutation, SendInvoicesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SendInvoicesMutation, SendInvoicesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SendInvoicesMutation, SendInvoicesMutationVariables>(SendInvoicesDocument, options);
}
export type SendInvoicesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SendInvoicesMutation, SendInvoicesMutationVariables>;
export const SyncInvoiceDocument = gql`
    mutation syncInvoice($invoiceId: Int!) {
  synchronizeInvoice(invoiceId: $invoiceId) {
    ...InvoiceDetail
  }
}
    ${InvoiceDetailFragmentDoc}`;

/**
 * __useSyncInvoiceMutation__
 *
 * To run a mutation, you first call `useSyncInvoiceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSyncInvoiceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSyncInvoiceMutation({
 *   variables: {
 *     invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useSyncInvoiceMutation(options: VueApolloComposable.UseMutationOptions<SyncInvoiceMutation, SyncInvoiceMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SyncInvoiceMutation, SyncInvoiceMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SyncInvoiceMutation, SyncInvoiceMutationVariables>(SyncInvoiceDocument, options);
}
export type SyncInvoiceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SyncInvoiceMutation, SyncInvoiceMutationVariables>;
export const UpdateInvoiceDocument = gql`
    mutation UpdateInvoice($invoiceId: Int!, $payload: InvoiceUpdateInput!) {
  updateInvoice(invoiceId: $invoiceId, payload: $payload) {
    id
    status
    externalInvoice {
      id
      status
      paid
      unpaid
    }
  }
}
    `;

/**
 * __useUpdateInvoiceMutation__
 *
 * To run a mutation, you first call `useUpdateInvoiceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInvoiceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateInvoiceMutation({
 *   variables: {
 *     invoiceId: // value for 'invoiceId'
 *     payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateInvoiceMutation(options: VueApolloComposable.UseMutationOptions<UpdateInvoiceMutation, UpdateInvoiceMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>(UpdateInvoiceDocument, options);
}
export type UpdateInvoiceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>;
export const UpdateOrCreateWebhooksDocument = gql`
    mutation UpdateOrCreateWebhooks {
  updateOrCreateWebhooks {
    webhooks {
      id
      kind
      accountId
      url
      apiToken
      active
    }
  }
}
    `;

/**
 * __useUpdateOrCreateWebhooksMutation__
 *
 * To run a mutation, you first call `useUpdateOrCreateWebhooksMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrCreateWebhooksMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateOrCreateWebhooksMutation();
 */
export function useUpdateOrCreateWebhooksMutation(options: VueApolloComposable.UseMutationOptions<UpdateOrCreateWebhooksMutation, UpdateOrCreateWebhooksMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateOrCreateWebhooksMutation, UpdateOrCreateWebhooksMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateOrCreateWebhooksMutation, UpdateOrCreateWebhooksMutationVariables>(UpdateOrCreateWebhooksDocument, options);
}
export type UpdateOrCreateWebhooksMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateOrCreateWebhooksMutation, UpdateOrCreateWebhooksMutationVariables>;
export const GetBillingInfoFromVatIdDocument = gql`
    query GetBillingInfoFromVatId($vatId: String) {
  billingInfoFromVatId(vatId: $vatId) {
    name
    city
    email
    postCode
    street
  }
}
    `;

/**
 * __useGetBillingInfoFromVatIdQuery__
 *
 * To run a query within a Vue component, call `useGetBillingInfoFromVatIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillingInfoFromVatIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetBillingInfoFromVatIdQuery({
 *   vatId: // value for 'vatId'
 * });
 */
export function useGetBillingInfoFromVatIdQuery(variables: GetBillingInfoFromVatIdQueryVariables | VueCompositionApi.Ref<GetBillingInfoFromVatIdQueryVariables> | ReactiveFunction<GetBillingInfoFromVatIdQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetBillingInfoFromVatIdQuery, GetBillingInfoFromVatIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetBillingInfoFromVatIdQuery, GetBillingInfoFromVatIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetBillingInfoFromVatIdQuery, GetBillingInfoFromVatIdQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetBillingInfoFromVatIdQuery, GetBillingInfoFromVatIdQueryVariables>(GetBillingInfoFromVatIdDocument, variables, options);
}
export function useGetBillingInfoFromVatIdLazyQuery(variables: GetBillingInfoFromVatIdQueryVariables | VueCompositionApi.Ref<GetBillingInfoFromVatIdQueryVariables> | ReactiveFunction<GetBillingInfoFromVatIdQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetBillingInfoFromVatIdQuery, GetBillingInfoFromVatIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetBillingInfoFromVatIdQuery, GetBillingInfoFromVatIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetBillingInfoFromVatIdQuery, GetBillingInfoFromVatIdQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetBillingInfoFromVatIdQuery, GetBillingInfoFromVatIdQueryVariables>(GetBillingInfoFromVatIdDocument, variables, options);
}
export type GetBillingInfoFromVatIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetBillingInfoFromVatIdQuery, GetBillingInfoFromVatIdQueryVariables>;
export const GetInvoiceDocument = gql`
    query GetInvoice($invoiceId: Int!) {
  invoice(invoiceId: $invoiceId) {
    ...InvoiceDetail
  }
}
    ${InvoiceDetailFragmentDoc}`;

/**
 * __useGetInvoiceQuery__
 *
 * To run a query within a Vue component, call `useGetInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetInvoiceQuery({
 *   invoiceId: // value for 'invoiceId'
 * });
 */
export function useGetInvoiceQuery(variables: GetInvoiceQueryVariables | VueCompositionApi.Ref<GetInvoiceQueryVariables> | ReactiveFunction<GetInvoiceQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetInvoiceQuery, GetInvoiceQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetInvoiceQuery, GetInvoiceQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetInvoiceQuery, GetInvoiceQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetInvoiceQuery, GetInvoiceQueryVariables>(GetInvoiceDocument, variables, options);
}
export function useGetInvoiceLazyQuery(variables: GetInvoiceQueryVariables | VueCompositionApi.Ref<GetInvoiceQueryVariables> | ReactiveFunction<GetInvoiceQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetInvoiceQuery, GetInvoiceQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetInvoiceQuery, GetInvoiceQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetInvoiceQuery, GetInvoiceQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetInvoiceQuery, GetInvoiceQueryVariables>(GetInvoiceDocument, variables, options);
}
export type GetInvoiceQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetInvoiceQuery, GetInvoiceQueryVariables>;
export const GetInvoiceEventsDocument = gql`
    query GetInvoiceEvents($after: ISODateTime!, $before: ISODateTime!, $patientId: Int!) {
  paid: events(after: $after, before: $before, patientId: $patientId, paid: true) {
    ...InvoiceEvent
  }
  unpaid: events(
    after: $after
    before: $before
    patientId: $patientId
    paid: false
  ) {
    ...InvoiceEvent
  }
}
    ${InvoiceEventFragmentDoc}`;

/**
 * __useGetInvoiceEventsQuery__
 *
 * To run a query within a Vue component, call `useGetInvoiceEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceEventsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetInvoiceEventsQuery({
 *   after: // value for 'after'
 *   before: // value for 'before'
 *   patientId: // value for 'patientId'
 * });
 */
export function useGetInvoiceEventsQuery(variables: GetInvoiceEventsQueryVariables | VueCompositionApi.Ref<GetInvoiceEventsQueryVariables> | ReactiveFunction<GetInvoiceEventsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetInvoiceEventsQuery, GetInvoiceEventsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetInvoiceEventsQuery, GetInvoiceEventsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetInvoiceEventsQuery, GetInvoiceEventsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetInvoiceEventsQuery, GetInvoiceEventsQueryVariables>(GetInvoiceEventsDocument, variables, options);
}
export function useGetInvoiceEventsLazyQuery(variables: GetInvoiceEventsQueryVariables | VueCompositionApi.Ref<GetInvoiceEventsQueryVariables> | ReactiveFunction<GetInvoiceEventsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetInvoiceEventsQuery, GetInvoiceEventsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetInvoiceEventsQuery, GetInvoiceEventsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetInvoiceEventsQuery, GetInvoiceEventsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetInvoiceEventsQuery, GetInvoiceEventsQueryVariables>(GetInvoiceEventsDocument, variables, options);
}
export type GetInvoiceEventsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetInvoiceEventsQuery, GetInvoiceEventsQueryVariables>;
export const GetInvoicesTableDocument = gql`
    query GetInvoicesTable($after: ISODate!, $before: ISODate!, $limit: Int!, $page: Int!, $practiceBranchId: Int!, $tab: InvoiceTab!, $orderBy: [OrderBy!], $statuses: [ExternalInvoiceStatus!]) {
  invoices(
    after: $after
    before: $before
    limit: $limit
    page: $page
    practiceBranchId: $practiceBranchId
    tab: $tab
    orderBy: $orderBy
    statuses: $statuses
  ) {
    count
    pageTotals
    totals
    data {
      id
      addClientTax
      externalId
      createdAt: issueDate
      kind
      name
      number
      viewUrl
      notes
      paymentTo
      sellDate
      status
      totalPriceGross
      totalPriceNet
      totalPriceTax
      patientEmails
      practiceBranch {
        id
      }
      clientBillingInfo {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetInvoicesTableQuery__
 *
 * To run a query within a Vue component, call `useGetInvoicesTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicesTableQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetInvoicesTableQuery({
 *   after: // value for 'after'
 *   before: // value for 'before'
 *   limit: // value for 'limit'
 *   page: // value for 'page'
 *   practiceBranchId: // value for 'practiceBranchId'
 *   tab: // value for 'tab'
 *   orderBy: // value for 'orderBy'
 *   statuses: // value for 'statuses'
 * });
 */
export function useGetInvoicesTableQuery(variables: GetInvoicesTableQueryVariables | VueCompositionApi.Ref<GetInvoicesTableQueryVariables> | ReactiveFunction<GetInvoicesTableQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetInvoicesTableQuery, GetInvoicesTableQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetInvoicesTableQuery, GetInvoicesTableQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetInvoicesTableQuery, GetInvoicesTableQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetInvoicesTableQuery, GetInvoicesTableQueryVariables>(GetInvoicesTableDocument, variables, options);
}
export function useGetInvoicesTableLazyQuery(variables: GetInvoicesTableQueryVariables | VueCompositionApi.Ref<GetInvoicesTableQueryVariables> | ReactiveFunction<GetInvoicesTableQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetInvoicesTableQuery, GetInvoicesTableQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetInvoicesTableQuery, GetInvoicesTableQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetInvoicesTableQuery, GetInvoicesTableQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetInvoicesTableQuery, GetInvoicesTableQueryVariables>(GetInvoicesTableDocument, variables, options);
}
export type GetInvoicesTableQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetInvoicesTableQuery, GetInvoicesTableQueryVariables>;
export const GetPatientBillingInfoDocument = gql`
    query GetPatientBillingInfo($patientId: Int!) {
  patientDetails(patientId: $patientId) {
    id
    fullName
    email
    address {
      id
      city
      zipCode
      street
    }
    billingInfo {
      id
      bank
      bankAccount
      city
      country
      email
      name
      phone
      postCode
      street
      taxNo
    }
  }
}
    `;

/**
 * __useGetPatientBillingInfoQuery__
 *
 * To run a query within a Vue component, call `useGetPatientBillingInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientBillingInfoQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPatientBillingInfoQuery({
 *   patientId: // value for 'patientId'
 * });
 */
export function useGetPatientBillingInfoQuery(variables: GetPatientBillingInfoQueryVariables | VueCompositionApi.Ref<GetPatientBillingInfoQueryVariables> | ReactiveFunction<GetPatientBillingInfoQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPatientBillingInfoQuery, GetPatientBillingInfoQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPatientBillingInfoQuery, GetPatientBillingInfoQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPatientBillingInfoQuery, GetPatientBillingInfoQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPatientBillingInfoQuery, GetPatientBillingInfoQueryVariables>(GetPatientBillingInfoDocument, variables, options);
}
export function useGetPatientBillingInfoLazyQuery(variables: GetPatientBillingInfoQueryVariables | VueCompositionApi.Ref<GetPatientBillingInfoQueryVariables> | ReactiveFunction<GetPatientBillingInfoQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPatientBillingInfoQuery, GetPatientBillingInfoQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPatientBillingInfoQuery, GetPatientBillingInfoQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPatientBillingInfoQuery, GetPatientBillingInfoQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetPatientBillingInfoQuery, GetPatientBillingInfoQueryVariables>(GetPatientBillingInfoDocument, variables, options);
}
export type GetPatientBillingInfoQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPatientBillingInfoQuery, GetPatientBillingInfoQueryVariables>;
export const GetPatientInvoiceDataDocument = gql`
    query GetPatientInvoiceData($after: ISODateTime!, $before: ISODateTime!, $patientId: Int!) {
  patientDetails(patientId: $patientId) {
    id
    fullName
    email
    address {
      id
      city
      zipCode
      street
    }
    billingInfo {
      id
      name
      street
      postCode
      city
      email
      taxNo
    }
  }
  paid: events(after: $after, before: $before, patientId: $patientId, paid: true) {
    ...InvoiceEvent
  }
  unpaid: events(
    after: $after
    before: $before
    patientId: $patientId
    paid: false
  ) {
    ...InvoiceEvent
  }
}
    ${InvoiceEventFragmentDoc}`;

/**
 * __useGetPatientInvoiceDataQuery__
 *
 * To run a query within a Vue component, call `useGetPatientInvoiceDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientInvoiceDataQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPatientInvoiceDataQuery({
 *   after: // value for 'after'
 *   before: // value for 'before'
 *   patientId: // value for 'patientId'
 * });
 */
export function useGetPatientInvoiceDataQuery(variables: GetPatientInvoiceDataQueryVariables | VueCompositionApi.Ref<GetPatientInvoiceDataQueryVariables> | ReactiveFunction<GetPatientInvoiceDataQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPatientInvoiceDataQuery, GetPatientInvoiceDataQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPatientInvoiceDataQuery, GetPatientInvoiceDataQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPatientInvoiceDataQuery, GetPatientInvoiceDataQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPatientInvoiceDataQuery, GetPatientInvoiceDataQueryVariables>(GetPatientInvoiceDataDocument, variables, options);
}
export function useGetPatientInvoiceDataLazyQuery(variables: GetPatientInvoiceDataQueryVariables | VueCompositionApi.Ref<GetPatientInvoiceDataQueryVariables> | ReactiveFunction<GetPatientInvoiceDataQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPatientInvoiceDataQuery, GetPatientInvoiceDataQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPatientInvoiceDataQuery, GetPatientInvoiceDataQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPatientInvoiceDataQuery, GetPatientInvoiceDataQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetPatientInvoiceDataQuery, GetPatientInvoiceDataQueryVariables>(GetPatientInvoiceDataDocument, variables, options);
}
export type GetPatientInvoiceDataQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPatientInvoiceDataQuery, GetPatientInvoiceDataQueryVariables>;
export const MakeMigrateDocument = gql`
    query makeMigrate($new_practice_id: Int!, $new_practice_branch_id: Int!, $legacy_practice_name: String) {
  makeMigrate(
    newPracticeId: $new_practice_id
    newPracticeBranchId: $new_practice_branch_id
    legacyPracticeName: $legacy_practice_name
  )
}
    `;

/**
 * __useMakeMigrateQuery__
 *
 * To run a query within a Vue component, call `useMakeMigrateQuery` and pass it any options that fit your needs.
 * When your component renders, `useMakeMigrateQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMakeMigrateQuery({
 *   new_practice_id: // value for 'new_practice_id'
 *   new_practice_branch_id: // value for 'new_practice_branch_id'
 *   legacy_practice_name: // value for 'legacy_practice_name'
 * });
 */
export function useMakeMigrateQuery(variables: MakeMigrateQueryVariables | VueCompositionApi.Ref<MakeMigrateQueryVariables> | ReactiveFunction<MakeMigrateQueryVariables>, options: VueApolloComposable.UseQueryOptions<MakeMigrateQuery, MakeMigrateQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MakeMigrateQuery, MakeMigrateQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MakeMigrateQuery, MakeMigrateQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<MakeMigrateQuery, MakeMigrateQueryVariables>(MakeMigrateDocument, variables, options);
}
export function useMakeMigrateLazyQuery(variables: MakeMigrateQueryVariables | VueCompositionApi.Ref<MakeMigrateQueryVariables> | ReactiveFunction<MakeMigrateQueryVariables>, options: VueApolloComposable.UseQueryOptions<MakeMigrateQuery, MakeMigrateQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MakeMigrateQuery, MakeMigrateQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MakeMigrateQuery, MakeMigrateQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<MakeMigrateQuery, MakeMigrateQueryVariables>(MakeMigrateDocument, variables, options);
}
export type MakeMigrateQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<MakeMigrateQuery, MakeMigrateQueryVariables>;
export const AddPatientDocument = gql`
    mutation AddPatient($patientInput: PatientInput!) {
  addPatient(patientInput: $patientInput) {
    id
    therapist {
      id
    }
  }
}
    `;

/**
 * __useAddPatientMutation__
 *
 * To run a mutation, you first call `useAddPatientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddPatientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddPatientMutation({
 *   variables: {
 *     patientInput: // value for 'patientInput'
 *   },
 * });
 */
export function useAddPatientMutation(options: VueApolloComposable.UseMutationOptions<AddPatientMutation, AddPatientMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddPatientMutation, AddPatientMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddPatientMutation, AddPatientMutationVariables>(AddPatientDocument, options);
}
export type AddPatientMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddPatientMutation, AddPatientMutationVariables>;
export const EditPatientDocument = gql`
    mutation EditPatient($patientId: Int!, $addressId: Int, $patientInput: EditPatientInput!) {
  editPatient(
    patientId: $patientId
    addressId: $addressId
    patientInput: $patientInput
  )
}
    `;

/**
 * __useEditPatientMutation__
 *
 * To run a mutation, you first call `useEditPatientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEditPatientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEditPatientMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     addressId: // value for 'addressId'
 *     patientInput: // value for 'patientInput'
 *   },
 * });
 */
export function useEditPatientMutation(options: VueApolloComposable.UseMutationOptions<EditPatientMutation, EditPatientMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EditPatientMutation, EditPatientMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<EditPatientMutation, EditPatientMutationVariables>(EditPatientDocument, options);
}
export type EditPatientMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EditPatientMutation, EditPatientMutationVariables>;
export const FinishPatientsTherapyDocument = gql`
    mutation FinishPatientsTherapy($patientId: Int!, $finishDate: ISODateTime = null, $deletePatient: Boolean = false) {
  finishPatientTherapy(
    patientId: $patientId
    finishDate: $finishDate
    deletePatient: $deletePatient
  )
}
    `;

/**
 * __useFinishPatientsTherapyMutation__
 *
 * To run a mutation, you first call `useFinishPatientsTherapyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useFinishPatientsTherapyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useFinishPatientsTherapyMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     finishDate: // value for 'finishDate'
 *     deletePatient: // value for 'deletePatient'
 *   },
 * });
 */
export function useFinishPatientsTherapyMutation(options: VueApolloComposable.UseMutationOptions<FinishPatientsTherapyMutation, FinishPatientsTherapyMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<FinishPatientsTherapyMutation, FinishPatientsTherapyMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<FinishPatientsTherapyMutation, FinishPatientsTherapyMutationVariables>(FinishPatientsTherapyDocument, options);
}
export type FinishPatientsTherapyMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<FinishPatientsTherapyMutation, FinishPatientsTherapyMutationVariables>;
export const ReactivatePatientsTherapyDocument = gql`
    mutation ReactivatePatientsTherapy($patientId: Int!) {
  reactivatePatientTherapy(patientId: $patientId)
}
    `;

/**
 * __useReactivatePatientsTherapyMutation__
 *
 * To run a mutation, you first call `useReactivatePatientsTherapyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReactivatePatientsTherapyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReactivatePatientsTherapyMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *   },
 * });
 */
export function useReactivatePatientsTherapyMutation(options: VueApolloComposable.UseMutationOptions<ReactivatePatientsTherapyMutation, ReactivatePatientsTherapyMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ReactivatePatientsTherapyMutation, ReactivatePatientsTherapyMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ReactivatePatientsTherapyMutation, ReactivatePatientsTherapyMutationVariables>(ReactivatePatientsTherapyDocument, options);
}
export type ReactivatePatientsTherapyMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ReactivatePatientsTherapyMutation, ReactivatePatientsTherapyMutationVariables>;
export const AddPatientEducatorNotesDocument = gql`
    mutation AddPatientEducatorNotes($payload: PatientEducatorInput!) {
  addPatientEducatorNotes(payload: $payload)
}
    `;

/**
 * __useAddPatientEducatorNotesMutation__
 *
 * To run a mutation, you first call `useAddPatientEducatorNotesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddPatientEducatorNotesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddPatientEducatorNotesMutation({
 *   variables: {
 *     payload: // value for 'payload'
 *   },
 * });
 */
export function useAddPatientEducatorNotesMutation(options: VueApolloComposable.UseMutationOptions<AddPatientEducatorNotesMutation, AddPatientEducatorNotesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddPatientEducatorNotesMutation, AddPatientEducatorNotesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddPatientEducatorNotesMutation, AddPatientEducatorNotesMutationVariables>(AddPatientEducatorNotesDocument, options);
}
export type AddPatientEducatorNotesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddPatientEducatorNotesMutation, AddPatientEducatorNotesMutationVariables>;
export const AddPatientPsychotherapyNotesDocument = gql`
    mutation AddPatientPsychotherapyNotes($payload: PatientPsychotherapyInput!) {
  addPatientPsychotherapyNotes(payload: $payload)
}
    `;

/**
 * __useAddPatientPsychotherapyNotesMutation__
 *
 * To run a mutation, you first call `useAddPatientPsychotherapyNotesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddPatientPsychotherapyNotesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddPatientPsychotherapyNotesMutation({
 *   variables: {
 *     payload: // value for 'payload'
 *   },
 * });
 */
export function useAddPatientPsychotherapyNotesMutation(options: VueApolloComposable.UseMutationOptions<AddPatientPsychotherapyNotesMutation, AddPatientPsychotherapyNotesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddPatientPsychotherapyNotesMutation, AddPatientPsychotherapyNotesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddPatientPsychotherapyNotesMutation, AddPatientPsychotherapyNotesMutationVariables>(AddPatientPsychotherapyNotesDocument, options);
}
export type AddPatientPsychotherapyNotesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddPatientPsychotherapyNotesMutation, AddPatientPsychotherapyNotesMutationVariables>;
export const AddPatientSiNotesDocument = gql`
    mutation AddPatientSINotes($payload: PatientSIInput!) {
  addPatientSiNotes(payload: $payload)
}
    `;

/**
 * __useAddPatientSiNotesMutation__
 *
 * To run a mutation, you first call `useAddPatientSiNotesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddPatientSiNotesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddPatientSiNotesMutation({
 *   variables: {
 *     payload: // value for 'payload'
 *   },
 * });
 */
export function useAddPatientSiNotesMutation(options: VueApolloComposable.UseMutationOptions<AddPatientSiNotesMutation, AddPatientSiNotesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddPatientSiNotesMutation, AddPatientSiNotesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddPatientSiNotesMutation, AddPatientSiNotesMutationVariables>(AddPatientSiNotesDocument, options);
}
export type AddPatientSiNotesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddPatientSiNotesMutation, AddPatientSiNotesMutationVariables>;
export const AddPatientSpeechTherapyNotesDocument = gql`
    mutation AddPatientSpeechTherapyNotes($payload: PatientSpeechTherapyInput!) {
  addPatientSpeechtherapyNotes(payload: $payload)
}
    `;

/**
 * __useAddPatientSpeechTherapyNotesMutation__
 *
 * To run a mutation, you first call `useAddPatientSpeechTherapyNotesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddPatientSpeechTherapyNotesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddPatientSpeechTherapyNotesMutation({
 *   variables: {
 *     payload: // value for 'payload'
 *   },
 * });
 */
export function useAddPatientSpeechTherapyNotesMutation(options: VueApolloComposable.UseMutationOptions<AddPatientSpeechTherapyNotesMutation, AddPatientSpeechTherapyNotesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddPatientSpeechTherapyNotesMutation, AddPatientSpeechTherapyNotesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddPatientSpeechTherapyNotesMutation, AddPatientSpeechTherapyNotesMutationVariables>(AddPatientSpeechTherapyNotesDocument, options);
}
export type AddPatientSpeechTherapyNotesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddPatientSpeechTherapyNotesMutation, AddPatientSpeechTherapyNotesMutationVariables>;
export const EditPatientEducatorNotesDocument = gql`
    mutation EditPatientEducatorNotes($payload: PatientEducatorInput!) {
  editPatientEducatorNotes(payload: $payload)
}
    `;

/**
 * __useEditPatientEducatorNotesMutation__
 *
 * To run a mutation, you first call `useEditPatientEducatorNotesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEditPatientEducatorNotesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEditPatientEducatorNotesMutation({
 *   variables: {
 *     payload: // value for 'payload'
 *   },
 * });
 */
export function useEditPatientEducatorNotesMutation(options: VueApolloComposable.UseMutationOptions<EditPatientEducatorNotesMutation, EditPatientEducatorNotesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EditPatientEducatorNotesMutation, EditPatientEducatorNotesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<EditPatientEducatorNotesMutation, EditPatientEducatorNotesMutationVariables>(EditPatientEducatorNotesDocument, options);
}
export type EditPatientEducatorNotesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EditPatientEducatorNotesMutation, EditPatientEducatorNotesMutationVariables>;
export const EditPatientPsychotherapyNotesDocument = gql`
    mutation EditPatientPsychotherapyNotes($payload: PatientPsychotherapyInput!) {
  editPatientPsychotherapyNotes(payload: $payload)
}
    `;

/**
 * __useEditPatientPsychotherapyNotesMutation__
 *
 * To run a mutation, you first call `useEditPatientPsychotherapyNotesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEditPatientPsychotherapyNotesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEditPatientPsychotherapyNotesMutation({
 *   variables: {
 *     payload: // value for 'payload'
 *   },
 * });
 */
export function useEditPatientPsychotherapyNotesMutation(options: VueApolloComposable.UseMutationOptions<EditPatientPsychotherapyNotesMutation, EditPatientPsychotherapyNotesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EditPatientPsychotherapyNotesMutation, EditPatientPsychotherapyNotesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<EditPatientPsychotherapyNotesMutation, EditPatientPsychotherapyNotesMutationVariables>(EditPatientPsychotherapyNotesDocument, options);
}
export type EditPatientPsychotherapyNotesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EditPatientPsychotherapyNotesMutation, EditPatientPsychotherapyNotesMutationVariables>;
export const EditPatientSiNotesDocument = gql`
    mutation EditPatientSINotes($payload: PatientSIInput!) {
  editPatientSiNotes(payload: $payload)
}
    `;

/**
 * __useEditPatientSiNotesMutation__
 *
 * To run a mutation, you first call `useEditPatientSiNotesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEditPatientSiNotesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEditPatientSiNotesMutation({
 *   variables: {
 *     payload: // value for 'payload'
 *   },
 * });
 */
export function useEditPatientSiNotesMutation(options: VueApolloComposable.UseMutationOptions<EditPatientSiNotesMutation, EditPatientSiNotesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EditPatientSiNotesMutation, EditPatientSiNotesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<EditPatientSiNotesMutation, EditPatientSiNotesMutationVariables>(EditPatientSiNotesDocument, options);
}
export type EditPatientSiNotesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EditPatientSiNotesMutation, EditPatientSiNotesMutationVariables>;
export const EditPatientSpeechTherapyNotesDocument = gql`
    mutation EditPatientSpeechTherapyNotes($payload: PatientSpeechTherapyInput!) {
  editPatientSpeechtherapyNotes(payload: $payload)
}
    `;

/**
 * __useEditPatientSpeechTherapyNotesMutation__
 *
 * To run a mutation, you first call `useEditPatientSpeechTherapyNotesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEditPatientSpeechTherapyNotesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEditPatientSpeechTherapyNotesMutation({
 *   variables: {
 *     payload: // value for 'payload'
 *   },
 * });
 */
export function useEditPatientSpeechTherapyNotesMutation(options: VueApolloComposable.UseMutationOptions<EditPatientSpeechTherapyNotesMutation, EditPatientSpeechTherapyNotesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EditPatientSpeechTherapyNotesMutation, EditPatientSpeechTherapyNotesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<EditPatientSpeechTherapyNotesMutation, EditPatientSpeechTherapyNotesMutationVariables>(EditPatientSpeechTherapyNotesDocument, options);
}
export type EditPatientSpeechTherapyNotesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EditPatientSpeechTherapyNotesMutation, EditPatientSpeechTherapyNotesMutationVariables>;
export const GetPatientDetailsDocument = gql`
    query GetPatientDetails($patientId: Int!) {
  patientDetails(patientId: $patientId) {
    id
    firstName
    lastName
    fullName
    phoneNumber
    email
    color
    deactivatedOn
    description
    active
    birthday
    createdAt
    updatedAt
    deletedAt
    practiceId
    idNumber
    secondPhoneNumber
    smsNotificationsActive
    billingInfo {
      id
    }
    attachmentsList {
      category
      url
      name
      id
      createdAt
    }
    address {
      id
      apartmentNumber
      city
      country
      county
      createdAt
      houseNumber
      street
      zipCode
    }
    therapists {
      id
      fullName
      email
      acronym
      user {
        fullName
        id
        firstName
      }
      color
    }
    psychoTherapy {
      id: pk
      diagnosis
      expectations
      medicalHistory
      occupation
      otherNotes
      triggerForTherapy
    }
    speechTherapy {
      id: pk
      generalAim
      articulationExamination
      diagnosisTherapyPlan
      generalInfo
      medicalHistory
      otherNotes
      speechExamination
    }
    si {
      id: pk
      generalAim
      siDiagnosis
      therapyHints
      sensoricDiet
      diagnosisTherapyPlan
      generalInfo
      medicalHistory
      otherNotes
    }
    educator {
      id: pk
      generalAim
      diagnosisTherapyPlan
      generalInfo
      medicalHistory
      otherNotes
    }
    couples {
      coupleName
      id
      createdAt
    }
    groups {
      id
      name
    }
  }
}
    `;

/**
 * __useGetPatientDetailsQuery__
 *
 * To run a query within a Vue component, call `useGetPatientDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientDetailsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPatientDetailsQuery({
 *   patientId: // value for 'patientId'
 * });
 */
export function useGetPatientDetailsQuery(variables: GetPatientDetailsQueryVariables | VueCompositionApi.Ref<GetPatientDetailsQueryVariables> | ReactiveFunction<GetPatientDetailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPatientDetailsQuery, GetPatientDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPatientDetailsQuery, GetPatientDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPatientDetailsQuery, GetPatientDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPatientDetailsQuery, GetPatientDetailsQueryVariables>(GetPatientDetailsDocument, variables, options);
}
export function useGetPatientDetailsLazyQuery(variables: GetPatientDetailsQueryVariables | VueCompositionApi.Ref<GetPatientDetailsQueryVariables> | ReactiveFunction<GetPatientDetailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPatientDetailsQuery, GetPatientDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPatientDetailsQuery, GetPatientDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPatientDetailsQuery, GetPatientDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetPatientDetailsQuery, GetPatientDetailsQueryVariables>(GetPatientDetailsDocument, variables, options);
}
export type GetPatientDetailsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPatientDetailsQuery, GetPatientDetailsQueryVariables>;
export const GetPatientsMeetingsHeldDocument = gql`
    query GetPatientsMeetingsHeld($patientId: Int!) {
  patientMeetingsHeld(patientId: $patientId)
}
    `;

/**
 * __useGetPatientsMeetingsHeldQuery__
 *
 * To run a query within a Vue component, call `useGetPatientsMeetingsHeldQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientsMeetingsHeldQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPatientsMeetingsHeldQuery({
 *   patientId: // value for 'patientId'
 * });
 */
export function useGetPatientsMeetingsHeldQuery(variables: GetPatientsMeetingsHeldQueryVariables | VueCompositionApi.Ref<GetPatientsMeetingsHeldQueryVariables> | ReactiveFunction<GetPatientsMeetingsHeldQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPatientsMeetingsHeldQuery, GetPatientsMeetingsHeldQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPatientsMeetingsHeldQuery, GetPatientsMeetingsHeldQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPatientsMeetingsHeldQuery, GetPatientsMeetingsHeldQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPatientsMeetingsHeldQuery, GetPatientsMeetingsHeldQueryVariables>(GetPatientsMeetingsHeldDocument, variables, options);
}
export function useGetPatientsMeetingsHeldLazyQuery(variables: GetPatientsMeetingsHeldQueryVariables | VueCompositionApi.Ref<GetPatientsMeetingsHeldQueryVariables> | ReactiveFunction<GetPatientsMeetingsHeldQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPatientsMeetingsHeldQuery, GetPatientsMeetingsHeldQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPatientsMeetingsHeldQuery, GetPatientsMeetingsHeldQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPatientsMeetingsHeldQuery, GetPatientsMeetingsHeldQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetPatientsMeetingsHeldQuery, GetPatientsMeetingsHeldQueryVariables>(GetPatientsMeetingsHeldDocument, variables, options);
}
export type GetPatientsMeetingsHeldQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPatientsMeetingsHeldQuery, GetPatientsMeetingsHeldQueryVariables>;
export const PaginatedPatientsDocument = gql`
    query PaginatedPatients($active: Boolean, $limit: Int!, $orderBy: OrderBy, $page: Int!, $assignedTo: [Int!], $searchPhrase: String) {
  paginatedPatients(
    active: $active
    limit: $limit
    orderBy: $orderBy
    page: $page
    assignedTo: $assignedTo
    searchPhrase: $searchPhrase
  ) {
    count
    data {
      id
      firstName
      lastName
      email
      active
      signedGdprConsent
      phoneNumber
      therapists {
        id
        acronym
        color
        fullName
      }
    }
  }
}
    `;

/**
 * __usePaginatedPatientsQuery__
 *
 * To run a query within a Vue component, call `usePaginatedPatientsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedPatientsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePaginatedPatientsQuery({
 *   active: // value for 'active'
 *   limit: // value for 'limit'
 *   orderBy: // value for 'orderBy'
 *   page: // value for 'page'
 *   assignedTo: // value for 'assignedTo'
 *   searchPhrase: // value for 'searchPhrase'
 * });
 */
export function usePaginatedPatientsQuery(variables: PaginatedPatientsQueryVariables | VueCompositionApi.Ref<PaginatedPatientsQueryVariables> | ReactiveFunction<PaginatedPatientsQueryVariables>, options: VueApolloComposable.UseQueryOptions<PaginatedPatientsQuery, PaginatedPatientsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PaginatedPatientsQuery, PaginatedPatientsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PaginatedPatientsQuery, PaginatedPatientsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<PaginatedPatientsQuery, PaginatedPatientsQueryVariables>(PaginatedPatientsDocument, variables, options);
}
export function usePaginatedPatientsLazyQuery(variables: PaginatedPatientsQueryVariables | VueCompositionApi.Ref<PaginatedPatientsQueryVariables> | ReactiveFunction<PaginatedPatientsQueryVariables>, options: VueApolloComposable.UseQueryOptions<PaginatedPatientsQuery, PaginatedPatientsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PaginatedPatientsQuery, PaginatedPatientsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PaginatedPatientsQuery, PaginatedPatientsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<PaginatedPatientsQuery, PaginatedPatientsQueryVariables>(PaginatedPatientsDocument, variables, options);
}
export type PaginatedPatientsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<PaginatedPatientsQuery, PaginatedPatientsQueryVariables>;
export const CreatePrzelewy24TransactionDocument = gql`
    mutation CreatePrzelewy24Transaction($payload: Przelewy24OrderInput!) {
  createPrzelewy24Transaction(payload: $payload) {
    link
  }
}
    `;

/**
 * __useCreatePrzelewy24TransactionMutation__
 *
 * To run a mutation, you first call `useCreatePrzelewy24TransactionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreatePrzelewy24TransactionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreatePrzelewy24TransactionMutation({
 *   variables: {
 *     payload: // value for 'payload'
 *   },
 * });
 */
export function useCreatePrzelewy24TransactionMutation(options: VueApolloComposable.UseMutationOptions<CreatePrzelewy24TransactionMutation, CreatePrzelewy24TransactionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreatePrzelewy24TransactionMutation, CreatePrzelewy24TransactionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreatePrzelewy24TransactionMutation, CreatePrzelewy24TransactionMutationVariables>(CreatePrzelewy24TransactionDocument, options);
}
export type CreatePrzelewy24TransactionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreatePrzelewy24TransactionMutation, CreatePrzelewy24TransactionMutationVariables>;
export const EditOrCreateAppPaymentConfigDocument = gql`
    mutation EditOrCreateAppPaymentConfig($payload: AppPaymentConfigInput!) {
  editOrCreateAppPaymentConfig(payload: $payload) {
    isEnabled
    paymentMethods {
      isEnabled
      method
    }
  }
}
    `;

/**
 * __useEditOrCreateAppPaymentConfigMutation__
 *
 * To run a mutation, you first call `useEditOrCreateAppPaymentConfigMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEditOrCreateAppPaymentConfigMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEditOrCreateAppPaymentConfigMutation({
 *   variables: {
 *     payload: // value for 'payload'
 *   },
 * });
 */
export function useEditOrCreateAppPaymentConfigMutation(options: VueApolloComposable.UseMutationOptions<EditOrCreateAppPaymentConfigMutation, EditOrCreateAppPaymentConfigMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EditOrCreateAppPaymentConfigMutation, EditOrCreateAppPaymentConfigMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<EditOrCreateAppPaymentConfigMutation, EditOrCreateAppPaymentConfigMutationVariables>(EditOrCreateAppPaymentConfigDocument, options);
}
export type EditOrCreateAppPaymentConfigMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EditOrCreateAppPaymentConfigMutation, EditOrCreateAppPaymentConfigMutationVariables>;
export const GetPrzelewy24OrderDocument = gql`
    query GetPrzelewy24Order($sessionId: String!) {
  przelewy24Order(sessionId: $sessionId) {
    id
    amount
    category
    createdAt
    currency
    description
    orderId
    merchantId
    posId
    practiceId
    sessionId
    token
    status
    updatedAt
  }
}
    `;

/**
 * __useGetPrzelewy24OrderQuery__
 *
 * To run a query within a Vue component, call `useGetPrzelewy24OrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrzelewy24OrderQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPrzelewy24OrderQuery({
 *   sessionId: // value for 'sessionId'
 * });
 */
export function useGetPrzelewy24OrderQuery(variables: GetPrzelewy24OrderQueryVariables | VueCompositionApi.Ref<GetPrzelewy24OrderQueryVariables> | ReactiveFunction<GetPrzelewy24OrderQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPrzelewy24OrderQuery, GetPrzelewy24OrderQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPrzelewy24OrderQuery, GetPrzelewy24OrderQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPrzelewy24OrderQuery, GetPrzelewy24OrderQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPrzelewy24OrderQuery, GetPrzelewy24OrderQueryVariables>(GetPrzelewy24OrderDocument, variables, options);
}
export function useGetPrzelewy24OrderLazyQuery(variables: GetPrzelewy24OrderQueryVariables | VueCompositionApi.Ref<GetPrzelewy24OrderQueryVariables> | ReactiveFunction<GetPrzelewy24OrderQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPrzelewy24OrderQuery, GetPrzelewy24OrderQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPrzelewy24OrderQuery, GetPrzelewy24OrderQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPrzelewy24OrderQuery, GetPrzelewy24OrderQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetPrzelewy24OrderQuery, GetPrzelewy24OrderQueryVariables>(GetPrzelewy24OrderDocument, variables, options);
}
export type GetPrzelewy24OrderQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPrzelewy24OrderQuery, GetPrzelewy24OrderQueryVariables>;
export const CreatePracticeDocument = gql`
    mutation CreatePractice($payload: CreatePracticeInput!) {
  createPractice(payload: $payload) {
    id
    practiceBranches {
      id
    }
  }
}
    `;

/**
 * __useCreatePracticeMutation__
 *
 * To run a mutation, you first call `useCreatePracticeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreatePracticeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreatePracticeMutation({
 *   variables: {
 *     payload: // value for 'payload'
 *   },
 * });
 */
export function useCreatePracticeMutation(options: VueApolloComposable.UseMutationOptions<CreatePracticeMutation, CreatePracticeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreatePracticeMutation, CreatePracticeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreatePracticeMutation, CreatePracticeMutationVariables>(CreatePracticeDocument, options);
}
export type CreatePracticeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreatePracticeMutation, CreatePracticeMutationVariables>;
export const DeletePracticeLogoDocument = gql`
    mutation DeletePracticeLogo {
  deletePracticeLogo
}
    `;

/**
 * __useDeletePracticeLogoMutation__
 *
 * To run a mutation, you first call `useDeletePracticeLogoMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeletePracticeLogoMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeletePracticeLogoMutation();
 */
export function useDeletePracticeLogoMutation(options: VueApolloComposable.UseMutationOptions<DeletePracticeLogoMutation, DeletePracticeLogoMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeletePracticeLogoMutation, DeletePracticeLogoMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeletePracticeLogoMutation, DeletePracticeLogoMutationVariables>(DeletePracticeLogoDocument, options);
}
export type DeletePracticeLogoMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeletePracticeLogoMutation, DeletePracticeLogoMutationVariables>;
export const EditPracticeDocument = gql`
    mutation EditPractice($payload: EditPracticeInput!) {
  editPractice(payload: $payload)
}
    `;

/**
 * __useEditPracticeMutation__
 *
 * To run a mutation, you first call `useEditPracticeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEditPracticeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEditPracticeMutation({
 *   variables: {
 *     payload: // value for 'payload'
 *   },
 * });
 */
export function useEditPracticeMutation(options: VueApolloComposable.UseMutationOptions<EditPracticeMutation, EditPracticeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EditPracticeMutation, EditPracticeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<EditPracticeMutation, EditPracticeMutationVariables>(EditPracticeDocument, options);
}
export type EditPracticeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EditPracticeMutation, EditPracticeMutationVariables>;
export const SetPracticeLogoDocument = gql`
    mutation SetPracticeLogo($payload: SetPracticeLogoInput!) {
  setPracticeLogo(payload: $payload)
}
    `;

/**
 * __useSetPracticeLogoMutation__
 *
 * To run a mutation, you first call `useSetPracticeLogoMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetPracticeLogoMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetPracticeLogoMutation({
 *   variables: {
 *     payload: // value for 'payload'
 *   },
 * });
 */
export function useSetPracticeLogoMutation(options: VueApolloComposable.UseMutationOptions<SetPracticeLogoMutation, SetPracticeLogoMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SetPracticeLogoMutation, SetPracticeLogoMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SetPracticeLogoMutation, SetPracticeLogoMutationVariables>(SetPracticeLogoDocument, options);
}
export type SetPracticeLogoMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SetPracticeLogoMutation, SetPracticeLogoMutationVariables>;
export const GetAvailablePracticesDocument = gql`
    query GetAvailablePractices {
  getAvailablePractices {
    id
    name
    shortName
    billingAddress {
      apartmentNumber
      city
      country
      county
      zipCode
      street
      houseNumber
    }
    logo {
      url
    }
    restrictedAccess
    servicesPerTherapist
  }
}
    `;

/**
 * __useGetAvailablePracticesQuery__
 *
 * To run a query within a Vue component, call `useGetAvailablePracticesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailablePracticesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAvailablePracticesQuery();
 */
export function useGetAvailablePracticesQuery(options: VueApolloComposable.UseQueryOptions<GetAvailablePracticesQuery, GetAvailablePracticesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAvailablePracticesQuery, GetAvailablePracticesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAvailablePracticesQuery, GetAvailablePracticesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetAvailablePracticesQuery, GetAvailablePracticesQueryVariables>(GetAvailablePracticesDocument, {}, options);
}
export function useGetAvailablePracticesLazyQuery(options: VueApolloComposable.UseQueryOptions<GetAvailablePracticesQuery, GetAvailablePracticesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAvailablePracticesQuery, GetAvailablePracticesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAvailablePracticesQuery, GetAvailablePracticesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetAvailablePracticesQuery, GetAvailablePracticesQueryVariables>(GetAvailablePracticesDocument, {}, options);
}
export type GetAvailablePracticesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetAvailablePracticesQuery, GetAvailablePracticesQueryVariables>;
export const GetCurrentPracticeDetailsDocument = gql`
    query GetCurrentPracticeDetails {
  getCurrentPracticeDetails {
    id
    name
    shortName
    contactDetails {
      id
      email
      phone
    }
    billingAddress {
      id
      apartmentNumber
      city
      country
      county
      houseNumber
      street
      zipCode
    }
    billingInfo {
      id
      bank
      bankAccount
      city
      country
      email
      name
      phone
      postCode
      street
      taxNo
    }
    logo {
      url
    }
    invoicingEnabled
  }
}
    `;

/**
 * __useGetCurrentPracticeDetailsQuery__
 *
 * To run a query within a Vue component, call `useGetCurrentPracticeDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentPracticeDetailsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCurrentPracticeDetailsQuery();
 */
export function useGetCurrentPracticeDetailsQuery(options: VueApolloComposable.UseQueryOptions<GetCurrentPracticeDetailsQuery, GetCurrentPracticeDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCurrentPracticeDetailsQuery, GetCurrentPracticeDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCurrentPracticeDetailsQuery, GetCurrentPracticeDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCurrentPracticeDetailsQuery, GetCurrentPracticeDetailsQueryVariables>(GetCurrentPracticeDetailsDocument, {}, options);
}
export function useGetCurrentPracticeDetailsLazyQuery(options: VueApolloComposable.UseQueryOptions<GetCurrentPracticeDetailsQuery, GetCurrentPracticeDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCurrentPracticeDetailsQuery, GetCurrentPracticeDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCurrentPracticeDetailsQuery, GetCurrentPracticeDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetCurrentPracticeDetailsQuery, GetCurrentPracticeDetailsQueryVariables>(GetCurrentPracticeDetailsDocument, {}, options);
}
export type GetCurrentPracticeDetailsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCurrentPracticeDetailsQuery, GetCurrentPracticeDetailsQueryVariables>;
export const AddPrzelewy24ConfigDocument = gql`
    mutation AddPrzelewy24Config($payload: Przelewy24ConfigInput!) {
  addPrzelewy24Config(payload: $payload) {
    invitationLink
    isEnabled
    crc
    merchantId
  }
}
    `;

/**
 * __useAddPrzelewy24ConfigMutation__
 *
 * To run a mutation, you first call `useAddPrzelewy24ConfigMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddPrzelewy24ConfigMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddPrzelewy24ConfigMutation({
 *   variables: {
 *     payload: // value for 'payload'
 *   },
 * });
 */
export function useAddPrzelewy24ConfigMutation(options: VueApolloComposable.UseMutationOptions<AddPrzelewy24ConfigMutation, AddPrzelewy24ConfigMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddPrzelewy24ConfigMutation, AddPrzelewy24ConfigMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddPrzelewy24ConfigMutation, AddPrzelewy24ConfigMutationVariables>(AddPrzelewy24ConfigDocument, options);
}
export type AddPrzelewy24ConfigMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddPrzelewy24ConfigMutation, AddPrzelewy24ConfigMutationVariables>;
export const AppPaymentConfigQueryDocument = gql`
    query AppPaymentConfigQuery {
  appPaymentConfig {
    isEnabled
    paymentMethods {
      isEnabled
      method
    }
  }
}
    `;

/**
 * __useAppPaymentConfigQueryQuery__
 *
 * To run a query within a Vue component, call `useAppPaymentConfigQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppPaymentConfigQueryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAppPaymentConfigQueryQuery();
 */
export function useAppPaymentConfigQueryQuery(options: VueApolloComposable.UseQueryOptions<AppPaymentConfigQueryQuery, AppPaymentConfigQueryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AppPaymentConfigQueryQuery, AppPaymentConfigQueryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AppPaymentConfigQueryQuery, AppPaymentConfigQueryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AppPaymentConfigQueryQuery, AppPaymentConfigQueryQueryVariables>(AppPaymentConfigQueryDocument, {}, options);
}
export function useAppPaymentConfigQueryLazyQuery(options: VueApolloComposable.UseQueryOptions<AppPaymentConfigQueryQuery, AppPaymentConfigQueryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AppPaymentConfigQueryQuery, AppPaymentConfigQueryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AppPaymentConfigQueryQuery, AppPaymentConfigQueryQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AppPaymentConfigQueryQuery, AppPaymentConfigQueryQueryVariables>(AppPaymentConfigQueryDocument, {}, options);
}
export type AppPaymentConfigQueryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AppPaymentConfigQueryQuery, AppPaymentConfigQueryQueryVariables>;
export const Przelewy24ConfigQueryDocument = gql`
    query Przelewy24ConfigQuery {
  przelewy24Config {
    crc
    invitationLink
    isEnabled
    merchantId
  }
}
    `;

/**
 * __usePrzelewy24ConfigQueryQuery__
 *
 * To run a query within a Vue component, call `usePrzelewy24ConfigQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrzelewy24ConfigQueryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePrzelewy24ConfigQueryQuery();
 */
export function usePrzelewy24ConfigQueryQuery(options: VueApolloComposable.UseQueryOptions<Przelewy24ConfigQueryQuery, Przelewy24ConfigQueryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Przelewy24ConfigQueryQuery, Przelewy24ConfigQueryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Przelewy24ConfigQueryQuery, Przelewy24ConfigQueryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Przelewy24ConfigQueryQuery, Przelewy24ConfigQueryQueryVariables>(Przelewy24ConfigQueryDocument, {}, options);
}
export function usePrzelewy24ConfigQueryLazyQuery(options: VueApolloComposable.UseQueryOptions<Przelewy24ConfigQueryQuery, Przelewy24ConfigQueryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Przelewy24ConfigQueryQuery, Przelewy24ConfigQueryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Przelewy24ConfigQueryQuery, Przelewy24ConfigQueryQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Przelewy24ConfigQueryQuery, Przelewy24ConfigQueryQueryVariables>(Przelewy24ConfigQueryDocument, {}, options);
}
export type Przelewy24ConfigQueryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Przelewy24ConfigQueryQuery, Przelewy24ConfigQueryQueryVariables>;
export const ConfirmMeetingRequestDocument = gql`
    mutation ConfirmMeetingRequest($payload: ConfirmMeetingPayload!) {
  confirmMeeting(payload: $payload) {
    success
  }
}
    `;

/**
 * __useConfirmMeetingRequestMutation__
 *
 * To run a mutation, you first call `useConfirmMeetingRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useConfirmMeetingRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useConfirmMeetingRequestMutation({
 *   variables: {
 *     payload: // value for 'payload'
 *   },
 * });
 */
export function useConfirmMeetingRequestMutation(options: VueApolloComposable.UseMutationOptions<ConfirmMeetingRequestMutation, ConfirmMeetingRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ConfirmMeetingRequestMutation, ConfirmMeetingRequestMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ConfirmMeetingRequestMutation, ConfirmMeetingRequestMutationVariables>(ConfirmMeetingRequestDocument, options);
}
export type ConfirmMeetingRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ConfirmMeetingRequestMutation, ConfirmMeetingRequestMutationVariables>;
export const DeleteMeetingRequestsDocument = gql`
    mutation DeleteMeetingRequests($meetingRequestIds: [Int!]!) {
  deleteMeetings(meetingRequestIds: $meetingRequestIds)
}
    `;

/**
 * __useDeleteMeetingRequestsMutation__
 *
 * To run a mutation, you first call `useDeleteMeetingRequestsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMeetingRequestsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteMeetingRequestsMutation({
 *   variables: {
 *     meetingRequestIds: // value for 'meetingRequestIds'
 *   },
 * });
 */
export function useDeleteMeetingRequestsMutation(options: VueApolloComposable.UseMutationOptions<DeleteMeetingRequestsMutation, DeleteMeetingRequestsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteMeetingRequestsMutation, DeleteMeetingRequestsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteMeetingRequestsMutation, DeleteMeetingRequestsMutationVariables>(DeleteMeetingRequestsDocument, options);
}
export type DeleteMeetingRequestsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteMeetingRequestsMutation, DeleteMeetingRequestsMutationVariables>;
export const RejectMeetingRequestsDocument = gql`
    mutation RejectMeetingRequests($meetingRequestIds: [Int!]!, $sendSms: Boolean! = true) {
  rejectMeetings(meetingRequestIds: $meetingRequestIds, sendSms: $sendSms)
}
    `;

/**
 * __useRejectMeetingRequestsMutation__
 *
 * To run a mutation, you first call `useRejectMeetingRequestsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRejectMeetingRequestsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRejectMeetingRequestsMutation({
 *   variables: {
 *     meetingRequestIds: // value for 'meetingRequestIds'
 *     sendSms: // value for 'sendSms'
 *   },
 * });
 */
export function useRejectMeetingRequestsMutation(options: VueApolloComposable.UseMutationOptions<RejectMeetingRequestsMutation, RejectMeetingRequestsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RejectMeetingRequestsMutation, RejectMeetingRequestsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RejectMeetingRequestsMutation, RejectMeetingRequestsMutationVariables>(RejectMeetingRequestsDocument, options);
}
export type RejectMeetingRequestsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RejectMeetingRequestsMutation, RejectMeetingRequestsMutationVariables>;
export const SetOnlineRegistrationConfigDocument = gql`
    mutation SetOnlineRegistrationConfig($config: UpsertOnlineRegistrationConfig!) {
  upsertOnlineRegistrationConfig(config: $config) {
    id
    practice {
      id
    }
    practiceSlug
    minutesBetweenMeetings
    isRegistrationEnabled
    termsOfUseUrl
    privacyPolicyUrl
    roundSlotTimeTo
    minimumPrecedingMinutes
    maximumPrecedingMinutes
  }
}
    `;

/**
 * __useSetOnlineRegistrationConfigMutation__
 *
 * To run a mutation, you first call `useSetOnlineRegistrationConfigMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetOnlineRegistrationConfigMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetOnlineRegistrationConfigMutation({
 *   variables: {
 *     config: // value for 'config'
 *   },
 * });
 */
export function useSetOnlineRegistrationConfigMutation(options: VueApolloComposable.UseMutationOptions<SetOnlineRegistrationConfigMutation, SetOnlineRegistrationConfigMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SetOnlineRegistrationConfigMutation, SetOnlineRegistrationConfigMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SetOnlineRegistrationConfigMutation, SetOnlineRegistrationConfigMutationVariables>(SetOnlineRegistrationConfigDocument, options);
}
export type SetOnlineRegistrationConfigMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SetOnlineRegistrationConfigMutation, SetOnlineRegistrationConfigMutationVariables>;
export const GetMeetingRequestDocument = gql`
    query GetMeetingRequest($meetingRequestId: Int!) {
  getMeetingRequest(meetingRequestId: $meetingRequestId) {
    id
    practiceBranch {
      id
      name
      branchAddress {
        id
        street
        houseNumber
        apartmentNumber
      }
    }
    lookalikePatients {
      id
      fullName
      phoneNumber
      email
    }
  }
}
    `;

/**
 * __useGetMeetingRequestQuery__
 *
 * To run a query within a Vue component, call `useGetMeetingRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeetingRequestQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMeetingRequestQuery({
 *   meetingRequestId: // value for 'meetingRequestId'
 * });
 */
export function useGetMeetingRequestQuery(variables: GetMeetingRequestQueryVariables | VueCompositionApi.Ref<GetMeetingRequestQueryVariables> | ReactiveFunction<GetMeetingRequestQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMeetingRequestQuery, GetMeetingRequestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMeetingRequestQuery, GetMeetingRequestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMeetingRequestQuery, GetMeetingRequestQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMeetingRequestQuery, GetMeetingRequestQueryVariables>(GetMeetingRequestDocument, variables, options);
}
export function useGetMeetingRequestLazyQuery(variables: GetMeetingRequestQueryVariables | VueCompositionApi.Ref<GetMeetingRequestQueryVariables> | ReactiveFunction<GetMeetingRequestQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMeetingRequestQuery, GetMeetingRequestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMeetingRequestQuery, GetMeetingRequestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMeetingRequestQuery, GetMeetingRequestQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetMeetingRequestQuery, GetMeetingRequestQueryVariables>(GetMeetingRequestDocument, variables, options);
}
export type GetMeetingRequestQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMeetingRequestQuery, GetMeetingRequestQueryVariables>;
export const GetMeetingRequestsDocument = gql`
    query GetMeetingRequests {
  getMeetingRequests {
    id
    firstName
    lastName
    start
    createdAt
    service {
      id
      name
      price
    }
    therapist {
      id
      fullName
    }
  }
}
    `;

/**
 * __useGetMeetingRequestsQuery__
 *
 * To run a query within a Vue component, call `useGetMeetingRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeetingRequestsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMeetingRequestsQuery();
 */
export function useGetMeetingRequestsQuery(options: VueApolloComposable.UseQueryOptions<GetMeetingRequestsQuery, GetMeetingRequestsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMeetingRequestsQuery, GetMeetingRequestsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMeetingRequestsQuery, GetMeetingRequestsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMeetingRequestsQuery, GetMeetingRequestsQueryVariables>(GetMeetingRequestsDocument, {}, options);
}
export function useGetMeetingRequestsLazyQuery(options: VueApolloComposable.UseQueryOptions<GetMeetingRequestsQuery, GetMeetingRequestsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMeetingRequestsQuery, GetMeetingRequestsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMeetingRequestsQuery, GetMeetingRequestsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetMeetingRequestsQuery, GetMeetingRequestsQueryVariables>(GetMeetingRequestsDocument, {}, options);
}
export type GetMeetingRequestsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMeetingRequestsQuery, GetMeetingRequestsQueryVariables>;
export const GetOnlineRegistrationConfigDocument = gql`
    query GetOnlineRegistrationConfig {
  getOnlineRegistrationConfigByPracticeId {
    id
    practiceSlug
    minutesBetweenMeetings
    isRegistrationEnabled
    termsOfUseUrl
    privacyPolicyUrl
    minimumPrecedingMinutes
    maximumPrecedingMinutes
    roundSlotTimeTo
    isPreciseSearch
    exactSlotProposal
  }
}
    `;

/**
 * __useGetOnlineRegistrationConfigQuery__
 *
 * To run a query within a Vue component, call `useGetOnlineRegistrationConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOnlineRegistrationConfigQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetOnlineRegistrationConfigQuery();
 */
export function useGetOnlineRegistrationConfigQuery(options: VueApolloComposable.UseQueryOptions<GetOnlineRegistrationConfigQuery, GetOnlineRegistrationConfigQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetOnlineRegistrationConfigQuery, GetOnlineRegistrationConfigQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetOnlineRegistrationConfigQuery, GetOnlineRegistrationConfigQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetOnlineRegistrationConfigQuery, GetOnlineRegistrationConfigQueryVariables>(GetOnlineRegistrationConfigDocument, {}, options);
}
export function useGetOnlineRegistrationConfigLazyQuery(options: VueApolloComposable.UseQueryOptions<GetOnlineRegistrationConfigQuery, GetOnlineRegistrationConfigQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetOnlineRegistrationConfigQuery, GetOnlineRegistrationConfigQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetOnlineRegistrationConfigQuery, GetOnlineRegistrationConfigQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetOnlineRegistrationConfigQuery, GetOnlineRegistrationConfigQueryVariables>(GetOnlineRegistrationConfigDocument, {}, options);
}
export type GetOnlineRegistrationConfigQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetOnlineRegistrationConfigQuery, GetOnlineRegistrationConfigQueryVariables>;
export const GetPaginatedMeetingRequestsDocument = gql`
    query GetPaginatedMeetingRequests($after: ISODateTime!, $before: ISODateTime!, $limit: Int!, $page: Int!, $orderBy: OrderBy = null, $patients: [String!] = null, $therapists: [Int!] = null, $services: [Int!] = null, $results: [MeetingRequestResult!] = null) {
  getPaginatedMeetingRequests(
    after: $after
    before: $before
    limit: $limit
    page: $page
    orderBy: $orderBy
    patients: $patients
    therapists: $therapists
    services: $services
    results: $results
  ) {
    count
    data {
      id
      service {
        id
        name
        duration
        price
      }
      therapist {
        id
        fullName
      }
      phoneNumber
      email
      firstName
      lastName
      start
      createdAt
      rejectedAt
      confirmedAt
    }
  }
}
    `;

/**
 * __useGetPaginatedMeetingRequestsQuery__
 *
 * To run a query within a Vue component, call `useGetPaginatedMeetingRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedMeetingRequestsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPaginatedMeetingRequestsQuery({
 *   after: // value for 'after'
 *   before: // value for 'before'
 *   limit: // value for 'limit'
 *   page: // value for 'page'
 *   orderBy: // value for 'orderBy'
 *   patients: // value for 'patients'
 *   therapists: // value for 'therapists'
 *   services: // value for 'services'
 *   results: // value for 'results'
 * });
 */
export function useGetPaginatedMeetingRequestsQuery(variables: GetPaginatedMeetingRequestsQueryVariables | VueCompositionApi.Ref<GetPaginatedMeetingRequestsQueryVariables> | ReactiveFunction<GetPaginatedMeetingRequestsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPaginatedMeetingRequestsQuery, GetPaginatedMeetingRequestsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPaginatedMeetingRequestsQuery, GetPaginatedMeetingRequestsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPaginatedMeetingRequestsQuery, GetPaginatedMeetingRequestsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPaginatedMeetingRequestsQuery, GetPaginatedMeetingRequestsQueryVariables>(GetPaginatedMeetingRequestsDocument, variables, options);
}
export function useGetPaginatedMeetingRequestsLazyQuery(variables: GetPaginatedMeetingRequestsQueryVariables | VueCompositionApi.Ref<GetPaginatedMeetingRequestsQueryVariables> | ReactiveFunction<GetPaginatedMeetingRequestsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPaginatedMeetingRequestsQuery, GetPaginatedMeetingRequestsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPaginatedMeetingRequestsQuery, GetPaginatedMeetingRequestsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPaginatedMeetingRequestsQuery, GetPaginatedMeetingRequestsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetPaginatedMeetingRequestsQuery, GetPaginatedMeetingRequestsQueryVariables>(GetPaginatedMeetingRequestsDocument, variables, options);
}
export type GetPaginatedMeetingRequestsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPaginatedMeetingRequestsQuery, GetPaginatedMeetingRequestsQueryVariables>;
export const GetPaymentMethodsRegistrationDocument = gql`
    query GetPaymentMethodsRegistration($practiceId: Int!, $enabledFilter: Boolean!) {
  practicePaymentMethods(practiceId: $practiceId, enabledFilter: $enabledFilter) {
    isEnabled
    method
  }
}
    `;

/**
 * __useGetPaymentMethodsRegistrationQuery__
 *
 * To run a query within a Vue component, call `useGetPaymentMethodsRegistrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentMethodsRegistrationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPaymentMethodsRegistrationQuery({
 *   practiceId: // value for 'practiceId'
 *   enabledFilter: // value for 'enabledFilter'
 * });
 */
export function useGetPaymentMethodsRegistrationQuery(variables: GetPaymentMethodsRegistrationQueryVariables | VueCompositionApi.Ref<GetPaymentMethodsRegistrationQueryVariables> | ReactiveFunction<GetPaymentMethodsRegistrationQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPaymentMethodsRegistrationQuery, GetPaymentMethodsRegistrationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPaymentMethodsRegistrationQuery, GetPaymentMethodsRegistrationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPaymentMethodsRegistrationQuery, GetPaymentMethodsRegistrationQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPaymentMethodsRegistrationQuery, GetPaymentMethodsRegistrationQueryVariables>(GetPaymentMethodsRegistrationDocument, variables, options);
}
export function useGetPaymentMethodsRegistrationLazyQuery(variables: GetPaymentMethodsRegistrationQueryVariables | VueCompositionApi.Ref<GetPaymentMethodsRegistrationQueryVariables> | ReactiveFunction<GetPaymentMethodsRegistrationQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPaymentMethodsRegistrationQuery, GetPaymentMethodsRegistrationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPaymentMethodsRegistrationQuery, GetPaymentMethodsRegistrationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPaymentMethodsRegistrationQuery, GetPaymentMethodsRegistrationQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetPaymentMethodsRegistrationQuery, GetPaymentMethodsRegistrationQueryVariables>(GetPaymentMethodsRegistrationDocument, variables, options);
}
export type GetPaymentMethodsRegistrationQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPaymentMethodsRegistrationQuery, GetPaymentMethodsRegistrationQueryVariables>;
export const GenerateIncomeReportDocument = gql`
    mutation GenerateIncomeReport($after: ISODateTime!, $before: ISODateTime!, $language: String!, $timeZone: String!, $patientId: Int, $coupleId: Int, $patientIds: [Int!], $serviceIds: [Int!], $therapistIds: [Int!], $statuses: [String!], $paymentMethods: [String!], $fileType: String!) {
  generateIncomeReport(
    after: $after
    before: $before
    language: $language
    timeZone: $timeZone
    patientId: $patientId
    coupleId: $coupleId
    patientIds: $patientIds
    serviceIds: $serviceIds
    therapistIds: $therapistIds
    statuses: $statuses
    paymentMethods: $paymentMethods
    fileType: $fileType
  )
}
    `;

/**
 * __useGenerateIncomeReportMutation__
 *
 * To run a mutation, you first call `useGenerateIncomeReportMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useGenerateIncomeReportMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useGenerateIncomeReportMutation({
 *   variables: {
 *     after: // value for 'after'
 *     before: // value for 'before'
 *     language: // value for 'language'
 *     timeZone: // value for 'timeZone'
 *     patientId: // value for 'patientId'
 *     coupleId: // value for 'coupleId'
 *     patientIds: // value for 'patientIds'
 *     serviceIds: // value for 'serviceIds'
 *     therapistIds: // value for 'therapistIds'
 *     statuses: // value for 'statuses'
 *     paymentMethods: // value for 'paymentMethods'
 *     fileType: // value for 'fileType'
 *   },
 * });
 */
export function useGenerateIncomeReportMutation(options: VueApolloComposable.UseMutationOptions<GenerateIncomeReportMutation, GenerateIncomeReportMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<GenerateIncomeReportMutation, GenerateIncomeReportMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<GenerateIncomeReportMutation, GenerateIncomeReportMutationVariables>(GenerateIncomeReportDocument, options);
}
export type GenerateIncomeReportMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<GenerateIncomeReportMutation, GenerateIncomeReportMutationVariables>;
export const GenerateEmployeeReportDocument = gql`
    mutation GenerateEmployeeReport($employeeId: Int!, $after: ISODateTime!, $before: ISODateTime!, $language: String!, $timeZone: String!) {
  generateEmployeeReport(
    employeeId: $employeeId
    after: $after
    before: $before
    language: $language
    timeZone: $timeZone
  ) {
    url
  }
}
    `;

/**
 * __useGenerateEmployeeReportMutation__
 *
 * To run a mutation, you first call `useGenerateEmployeeReportMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useGenerateEmployeeReportMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useGenerateEmployeeReportMutation({
 *   variables: {
 *     employeeId: // value for 'employeeId'
 *     after: // value for 'after'
 *     before: // value for 'before'
 *     language: // value for 'language'
 *     timeZone: // value for 'timeZone'
 *   },
 * });
 */
export function useGenerateEmployeeReportMutation(options: VueApolloComposable.UseMutationOptions<GenerateEmployeeReportMutation, GenerateEmployeeReportMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<GenerateEmployeeReportMutation, GenerateEmployeeReportMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<GenerateEmployeeReportMutation, GenerateEmployeeReportMutationVariables>(GenerateEmployeeReportDocument, options);
}
export type GenerateEmployeeReportMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<GenerateEmployeeReportMutation, GenerateEmployeeReportMutationVariables>;
export const GenerateMeetingHistoryReportDocument = gql`
    mutation GenerateMeetingHistoryReport($after: ISODateTime!, $before: ISODateTime!, $language: String!, $timeZone: String!, $patientId: Int, $coupleId: Int) {
  generateMeetingHistoryReport(
    after: $after
    before: $before
    language: $language
    timeZone: $timeZone
    patientId: $patientId
    coupleId: $coupleId
  ) {
    url
  }
}
    `;

/**
 * __useGenerateMeetingHistoryReportMutation__
 *
 * To run a mutation, you first call `useGenerateMeetingHistoryReportMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useGenerateMeetingHistoryReportMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useGenerateMeetingHistoryReportMutation({
 *   variables: {
 *     after: // value for 'after'
 *     before: // value for 'before'
 *     language: // value for 'language'
 *     timeZone: // value for 'timeZone'
 *     patientId: // value for 'patientId'
 *     coupleId: // value for 'coupleId'
 *   },
 * });
 */
export function useGenerateMeetingHistoryReportMutation(options: VueApolloComposable.UseMutationOptions<GenerateMeetingHistoryReportMutation, GenerateMeetingHistoryReportMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<GenerateMeetingHistoryReportMutation, GenerateMeetingHistoryReportMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<GenerateMeetingHistoryReportMutation, GenerateMeetingHistoryReportMutationVariables>(GenerateMeetingHistoryReportDocument, options);
}
export type GenerateMeetingHistoryReportMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<GenerateMeetingHistoryReportMutation, GenerateMeetingHistoryReportMutationVariables>;
export const GetEmployeesStatisticsDocument = gql`
    query getEmployeesStatistics($employeeId: Int!, $after: ISODateTime!, $before: ISODateTime!, $practiceBranchId: Int) {
  employeeStatistics(
    employeeId: $employeeId
    after: $after
    before: $before
    practiceBranchId: $practiceBranchId
  ) {
    meetingsHeld
    meetingsCancelled
    meetingsScheduled
    meetingsHeldRate
    servicesBreakdown {
      totalPrice
      totalTime
      services {
        id
        name
        meetingsHeld
        meetingsDurationMinutes
        meetingsIncome
      }
    }
  }
}
    `;

/**
 * __useGetEmployeesStatisticsQuery__
 *
 * To run a query within a Vue component, call `useGetEmployeesStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeesStatisticsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetEmployeesStatisticsQuery({
 *   employeeId: // value for 'employeeId'
 *   after: // value for 'after'
 *   before: // value for 'before'
 *   practiceBranchId: // value for 'practiceBranchId'
 * });
 */
export function useGetEmployeesStatisticsQuery(variables: GetEmployeesStatisticsQueryVariables | VueCompositionApi.Ref<GetEmployeesStatisticsQueryVariables> | ReactiveFunction<GetEmployeesStatisticsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetEmployeesStatisticsQuery, GetEmployeesStatisticsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetEmployeesStatisticsQuery, GetEmployeesStatisticsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetEmployeesStatisticsQuery, GetEmployeesStatisticsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetEmployeesStatisticsQuery, GetEmployeesStatisticsQueryVariables>(GetEmployeesStatisticsDocument, variables, options);
}
export function useGetEmployeesStatisticsLazyQuery(variables: GetEmployeesStatisticsQueryVariables | VueCompositionApi.Ref<GetEmployeesStatisticsQueryVariables> | ReactiveFunction<GetEmployeesStatisticsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetEmployeesStatisticsQuery, GetEmployeesStatisticsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetEmployeesStatisticsQuery, GetEmployeesStatisticsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetEmployeesStatisticsQuery, GetEmployeesStatisticsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetEmployeesStatisticsQuery, GetEmployeesStatisticsQueryVariables>(GetEmployeesStatisticsDocument, variables, options);
}
export type GetEmployeesStatisticsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetEmployeesStatisticsQuery, GetEmployeesStatisticsQueryVariables>;
export const GetIncomeStatisticsDocument = gql`
    query getIncomeStatistics($after: ISODateTime!, $before: ISODateTime!, $practiceBranchId: Int) {
  incomeStatistics(
    after: $after
    before: $before
    practiceBranchId: $practiceBranchId
  ) {
    income
    prevIncome
    lostIncome
    unpaidIncome
    previousPeriodDates {
      start
      end
    }
  }
}
    `;

/**
 * __useGetIncomeStatisticsQuery__
 *
 * To run a query within a Vue component, call `useGetIncomeStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIncomeStatisticsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetIncomeStatisticsQuery({
 *   after: // value for 'after'
 *   before: // value for 'before'
 *   practiceBranchId: // value for 'practiceBranchId'
 * });
 */
export function useGetIncomeStatisticsQuery(variables: GetIncomeStatisticsQueryVariables | VueCompositionApi.Ref<GetIncomeStatisticsQueryVariables> | ReactiveFunction<GetIncomeStatisticsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetIncomeStatisticsQuery, GetIncomeStatisticsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetIncomeStatisticsQuery, GetIncomeStatisticsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetIncomeStatisticsQuery, GetIncomeStatisticsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetIncomeStatisticsQuery, GetIncomeStatisticsQueryVariables>(GetIncomeStatisticsDocument, variables, options);
}
export function useGetIncomeStatisticsLazyQuery(variables: GetIncomeStatisticsQueryVariables | VueCompositionApi.Ref<GetIncomeStatisticsQueryVariables> | ReactiveFunction<GetIncomeStatisticsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetIncomeStatisticsQuery, GetIncomeStatisticsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetIncomeStatisticsQuery, GetIncomeStatisticsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetIncomeStatisticsQuery, GetIncomeStatisticsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetIncomeStatisticsQuery, GetIncomeStatisticsQueryVariables>(GetIncomeStatisticsDocument, variables, options);
}
export type GetIncomeStatisticsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetIncomeStatisticsQuery, GetIncomeStatisticsQueryVariables>;
export const GetServicesStatisticsDocument = gql`
    query getServicesStatistics($after: ISODateTime!, $before: ISODateTime!, $practiceBranchId: Int) {
  serviceStatistics(
    after: $after
    before: $before
    practiceBranchId: $practiceBranchId
  ) {
    meetings {
      meetingsHeld {
        current
        prev
      }
      meetingsSheduled {
        current
        prev
      }
      meetingsCancelled {
        current
        prev
      }
      patientsNumbers {
        current
        prev
      }
      therapiesFinished {
        current
        prev
      }
      therapiesNew {
        current
        prev
      }
    }
    services {
      name
      current
      prev
      price
    }
    previousPeriodDates {
      start
      end
    }
  }
}
    `;

/**
 * __useGetServicesStatisticsQuery__
 *
 * To run a query within a Vue component, call `useGetServicesStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServicesStatisticsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetServicesStatisticsQuery({
 *   after: // value for 'after'
 *   before: // value for 'before'
 *   practiceBranchId: // value for 'practiceBranchId'
 * });
 */
export function useGetServicesStatisticsQuery(variables: GetServicesStatisticsQueryVariables | VueCompositionApi.Ref<GetServicesStatisticsQueryVariables> | ReactiveFunction<GetServicesStatisticsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetServicesStatisticsQuery, GetServicesStatisticsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetServicesStatisticsQuery, GetServicesStatisticsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetServicesStatisticsQuery, GetServicesStatisticsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetServicesStatisticsQuery, GetServicesStatisticsQueryVariables>(GetServicesStatisticsDocument, variables, options);
}
export function useGetServicesStatisticsLazyQuery(variables: GetServicesStatisticsQueryVariables | VueCompositionApi.Ref<GetServicesStatisticsQueryVariables> | ReactiveFunction<GetServicesStatisticsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetServicesStatisticsQuery, GetServicesStatisticsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetServicesStatisticsQuery, GetServicesStatisticsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetServicesStatisticsQuery, GetServicesStatisticsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetServicesStatisticsQuery, GetServicesStatisticsQueryVariables>(GetServicesStatisticsDocument, variables, options);
}
export type GetServicesStatisticsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetServicesStatisticsQuery, GetServicesStatisticsQueryVariables>;
export const AddRoomDocument = gql`
    mutation AddRoom($payload: AddRoomInput!) {
  addRoom(payload: $payload) {
    id
  }
}
    `;

/**
 * __useAddRoomMutation__
 *
 * To run a mutation, you first call `useAddRoomMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddRoomMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddRoomMutation({
 *   variables: {
 *     payload: // value for 'payload'
 *   },
 * });
 */
export function useAddRoomMutation(options: VueApolloComposable.UseMutationOptions<AddRoomMutation, AddRoomMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddRoomMutation, AddRoomMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddRoomMutation, AddRoomMutationVariables>(AddRoomDocument, options);
}
export type AddRoomMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddRoomMutation, AddRoomMutationVariables>;
export const EditRoomDocument = gql`
    mutation EditRoom($roomId: Int!, $payload: EditRoomInput!) {
  editRoom(roomId: $roomId, payload: $payload)
}
    `;

/**
 * __useEditRoomMutation__
 *
 * To run a mutation, you first call `useEditRoomMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEditRoomMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEditRoomMutation({
 *   variables: {
 *     roomId: // value for 'roomId'
 *     payload: // value for 'payload'
 *   },
 * });
 */
export function useEditRoomMutation(options: VueApolloComposable.UseMutationOptions<EditRoomMutation, EditRoomMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EditRoomMutation, EditRoomMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<EditRoomMutation, EditRoomMutationVariables>(EditRoomDocument, options);
}
export type EditRoomMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EditRoomMutation, EditRoomMutationVariables>;
export const GetPaginatedRoomsDocument = gql`
    query GetPaginatedRooms($page: Int!, $limit: Int!, $orderBy: OrderBy = null) {
  paginatedRooms(page: $page, limit: $limit, orderBy: $orderBy) {
    count
    totals
    pageTotals
    data {
      id
      name
      availableOnline
      comments
      slug
      preferredBy {
        id
        color
        fullName
        acronym
      }
      excludedServices {
        id
        name
        price
      }
    }
  }
}
    `;

/**
 * __useGetPaginatedRoomsQuery__
 *
 * To run a query within a Vue component, call `useGetPaginatedRoomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedRoomsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPaginatedRoomsQuery({
 *   page: // value for 'page'
 *   limit: // value for 'limit'
 *   orderBy: // value for 'orderBy'
 * });
 */
export function useGetPaginatedRoomsQuery(variables: GetPaginatedRoomsQueryVariables | VueCompositionApi.Ref<GetPaginatedRoomsQueryVariables> | ReactiveFunction<GetPaginatedRoomsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPaginatedRoomsQuery, GetPaginatedRoomsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPaginatedRoomsQuery, GetPaginatedRoomsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPaginatedRoomsQuery, GetPaginatedRoomsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPaginatedRoomsQuery, GetPaginatedRoomsQueryVariables>(GetPaginatedRoomsDocument, variables, options);
}
export function useGetPaginatedRoomsLazyQuery(variables: GetPaginatedRoomsQueryVariables | VueCompositionApi.Ref<GetPaginatedRoomsQueryVariables> | ReactiveFunction<GetPaginatedRoomsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPaginatedRoomsQuery, GetPaginatedRoomsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPaginatedRoomsQuery, GetPaginatedRoomsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPaginatedRoomsQuery, GetPaginatedRoomsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetPaginatedRoomsQuery, GetPaginatedRoomsQueryVariables>(GetPaginatedRoomsDocument, variables, options);
}
export type GetPaginatedRoomsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPaginatedRoomsQuery, GetPaginatedRoomsQueryVariables>;
export const GetRoomsListDocument = gql`
    query GetRoomsList($serviceId: Int, $date: DateTime) {
  getRoomsList(serviceId: $serviceId, date: $date) {
    id
    name
    slug
    availableOnline
    preferredBy
  }
}
    `;

/**
 * __useGetRoomsListQuery__
 *
 * To run a query within a Vue component, call `useGetRoomsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoomsListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetRoomsListQuery({
 *   serviceId: // value for 'serviceId'
 *   date: // value for 'date'
 * });
 */
export function useGetRoomsListQuery(variables: GetRoomsListQueryVariables | VueCompositionApi.Ref<GetRoomsListQueryVariables> | ReactiveFunction<GetRoomsListQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetRoomsListQuery, GetRoomsListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetRoomsListQuery, GetRoomsListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetRoomsListQuery, GetRoomsListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetRoomsListQuery, GetRoomsListQueryVariables>(GetRoomsListDocument, variables, options);
}
export function useGetRoomsListLazyQuery(variables: GetRoomsListQueryVariables | VueCompositionApi.Ref<GetRoomsListQueryVariables> | ReactiveFunction<GetRoomsListQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetRoomsListQuery, GetRoomsListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetRoomsListQuery, GetRoomsListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetRoomsListQuery, GetRoomsListQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetRoomsListQuery, GetRoomsListQueryVariables>(GetRoomsListDocument, variables, options);
}
export type GetRoomsListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetRoomsListQuery, GetRoomsListQueryVariables>;
export const CreateServiceDocument = gql`
    mutation CreateService($payload: ServiceInput!) {
  createService(payload: $payload) {
    id
  }
}
    `;

/**
 * __useCreateServiceMutation__
 *
 * To run a mutation, you first call `useCreateServiceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateServiceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateServiceMutation({
 *   variables: {
 *     payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateServiceMutation(options: VueApolloComposable.UseMutationOptions<CreateServiceMutation, CreateServiceMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateServiceMutation, CreateServiceMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateServiceMutation, CreateServiceMutationVariables>(CreateServiceDocument, options);
}
export type CreateServiceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateServiceMutation, CreateServiceMutationVariables>;
export const DeactivateServicesDocument = gql`
    mutation DeactivateServices($serviceIds: [Int!]!) {
  deactivateServices(serviceIds: $serviceIds)
}
    `;

/**
 * __useDeactivateServicesMutation__
 *
 * To run a mutation, you first call `useDeactivateServicesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateServicesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeactivateServicesMutation({
 *   variables: {
 *     serviceIds: // value for 'serviceIds'
 *   },
 * });
 */
export function useDeactivateServicesMutation(options: VueApolloComposable.UseMutationOptions<DeactivateServicesMutation, DeactivateServicesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeactivateServicesMutation, DeactivateServicesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeactivateServicesMutation, DeactivateServicesMutationVariables>(DeactivateServicesDocument, options);
}
export type DeactivateServicesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeactivateServicesMutation, DeactivateServicesMutationVariables>;
export const EditServiceDocument = gql`
    mutation EditService($serviceId: Int!, $payload: EditServiceInput!) {
  editService(serviceId: $serviceId, payload: $payload)
}
    `;

/**
 * __useEditServiceMutation__
 *
 * To run a mutation, you first call `useEditServiceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEditServiceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEditServiceMutation({
 *   variables: {
 *     serviceId: // value for 'serviceId'
 *     payload: // value for 'payload'
 *   },
 * });
 */
export function useEditServiceMutation(options: VueApolloComposable.UseMutationOptions<EditServiceMutation, EditServiceMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EditServiceMutation, EditServiceMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<EditServiceMutation, EditServiceMutationVariables>(EditServiceDocument, options);
}
export type EditServiceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EditServiceMutation, EditServiceMutationVariables>;
export const GetPaginatedServicesDocument = gql`
    query GetPaginatedServices($limit: Int!, $page: Int!, $searchPhrase: String, $practiceBranchId: Int!, $orderBy: OrderBy) {
  paginatedServices(
    limit: $limit
    page: $page
    searchPhrase: $searchPhrase
    practiceBranchId: $practiceBranchId
    orderBy: $orderBy
  ) {
    count
    pageTotals
    data {
      id
      name
      price
      duration
      comments
      availableInOnlineRegistration
      availableOnline
      assignedTo {
        fullName
        color
        id
        acronym
      }
    }
  }
}
    `;

/**
 * __useGetPaginatedServicesQuery__
 *
 * To run a query within a Vue component, call `useGetPaginatedServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedServicesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPaginatedServicesQuery({
 *   limit: // value for 'limit'
 *   page: // value for 'page'
 *   searchPhrase: // value for 'searchPhrase'
 *   practiceBranchId: // value for 'practiceBranchId'
 *   orderBy: // value for 'orderBy'
 * });
 */
export function useGetPaginatedServicesQuery(variables: GetPaginatedServicesQueryVariables | VueCompositionApi.Ref<GetPaginatedServicesQueryVariables> | ReactiveFunction<GetPaginatedServicesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPaginatedServicesQuery, GetPaginatedServicesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPaginatedServicesQuery, GetPaginatedServicesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPaginatedServicesQuery, GetPaginatedServicesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPaginatedServicesQuery, GetPaginatedServicesQueryVariables>(GetPaginatedServicesDocument, variables, options);
}
export function useGetPaginatedServicesLazyQuery(variables: GetPaginatedServicesQueryVariables | VueCompositionApi.Ref<GetPaginatedServicesQueryVariables> | ReactiveFunction<GetPaginatedServicesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPaginatedServicesQuery, GetPaginatedServicesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPaginatedServicesQuery, GetPaginatedServicesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPaginatedServicesQuery, GetPaginatedServicesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetPaginatedServicesQuery, GetPaginatedServicesQueryVariables>(GetPaginatedServicesDocument, variables, options);
}
export type GetPaginatedServicesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPaginatedServicesQuery, GetPaginatedServicesQueryVariables>;
export const GetPaginatedServicesBreakdownDocument = gql`
    query GetPaginatedServicesBreakdown($after: ISODateTime!, $before: ISODateTime!, $limit: Int!, $page: Int!, $employeeId: Int!, $practiceBranchId: Int, $orderBy: OrderBy) {
  paginatedServicesBreakdown(
    after: $after
    before: $before
    limit: $limit
    page: $page
    employeeId: $employeeId
    practiceBranchId: $practiceBranchId
    orderBy: $orderBy
  ) {
    count
    pageTotals
    data {
      id
      name
      count
      amount
      time
    }
  }
}
    `;

/**
 * __useGetPaginatedServicesBreakdownQuery__
 *
 * To run a query within a Vue component, call `useGetPaginatedServicesBreakdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedServicesBreakdownQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPaginatedServicesBreakdownQuery({
 *   after: // value for 'after'
 *   before: // value for 'before'
 *   limit: // value for 'limit'
 *   page: // value for 'page'
 *   employeeId: // value for 'employeeId'
 *   practiceBranchId: // value for 'practiceBranchId'
 *   orderBy: // value for 'orderBy'
 * });
 */
export function useGetPaginatedServicesBreakdownQuery(variables: GetPaginatedServicesBreakdownQueryVariables | VueCompositionApi.Ref<GetPaginatedServicesBreakdownQueryVariables> | ReactiveFunction<GetPaginatedServicesBreakdownQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPaginatedServicesBreakdownQuery, GetPaginatedServicesBreakdownQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPaginatedServicesBreakdownQuery, GetPaginatedServicesBreakdownQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPaginatedServicesBreakdownQuery, GetPaginatedServicesBreakdownQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPaginatedServicesBreakdownQuery, GetPaginatedServicesBreakdownQueryVariables>(GetPaginatedServicesBreakdownDocument, variables, options);
}
export function useGetPaginatedServicesBreakdownLazyQuery(variables: GetPaginatedServicesBreakdownQueryVariables | VueCompositionApi.Ref<GetPaginatedServicesBreakdownQueryVariables> | ReactiveFunction<GetPaginatedServicesBreakdownQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPaginatedServicesBreakdownQuery, GetPaginatedServicesBreakdownQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPaginatedServicesBreakdownQuery, GetPaginatedServicesBreakdownQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPaginatedServicesBreakdownQuery, GetPaginatedServicesBreakdownQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetPaginatedServicesBreakdownQuery, GetPaginatedServicesBreakdownQueryVariables>(GetPaginatedServicesBreakdownDocument, variables, options);
}
export type GetPaginatedServicesBreakdownQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPaginatedServicesBreakdownQuery, GetPaginatedServicesBreakdownQueryVariables>;
export const GetServicesDocument = gql`
    query GetServices($limit: Int!, $page: Int!, $practiceBranchId: Int!, $orderBy: OrderBy, $names: [String!], $prices: FloatRangeInput, $durations: FloatRangeInput, $assignedTo: [Int!], $online: Boolean, $searchPhrase: String = "") {
  paginatedServices(
    limit: $limit
    page: $page
    orderBy: $orderBy
    practiceBranchId: $practiceBranchId
    names: $names
    prices: $prices
    durations: $durations
    assignedTo: $assignedTo
    online: $online
    searchPhrase: $searchPhrase
  ) {
    count
    data {
      id
      name
      price
      duration
      availableOnline
      comments
      availableInOnlineRegistration
      assignedTo {
        id
        acronym
        color
        user {
          firstName
        }
      }
    }
  }
}
    `;

/**
 * __useGetServicesQuery__
 *
 * To run a query within a Vue component, call `useGetServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServicesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetServicesQuery({
 *   limit: // value for 'limit'
 *   page: // value for 'page'
 *   practiceBranchId: // value for 'practiceBranchId'
 *   orderBy: // value for 'orderBy'
 *   names: // value for 'names'
 *   prices: // value for 'prices'
 *   durations: // value for 'durations'
 *   assignedTo: // value for 'assignedTo'
 *   online: // value for 'online'
 *   searchPhrase: // value for 'searchPhrase'
 * });
 */
export function useGetServicesQuery(variables: GetServicesQueryVariables | VueCompositionApi.Ref<GetServicesQueryVariables> | ReactiveFunction<GetServicesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetServicesQuery, GetServicesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetServicesQuery, GetServicesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetServicesQuery, GetServicesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetServicesQuery, GetServicesQueryVariables>(GetServicesDocument, variables, options);
}
export function useGetServicesLazyQuery(variables: GetServicesQueryVariables | VueCompositionApi.Ref<GetServicesQueryVariables> | ReactiveFunction<GetServicesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetServicesQuery, GetServicesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetServicesQuery, GetServicesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetServicesQuery, GetServicesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetServicesQuery, GetServicesQueryVariables>(GetServicesDocument, variables, options);
}
export type GetServicesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetServicesQuery, GetServicesQueryVariables>;
export const GetServicesListDocument = gql`
    query GetServicesList($orderBy: OrderBy) {
  servicesList(orderBy: $orderBy) {
    id
    name
    price
    assignedTo
    duration
    availableInOnlineRegistration
  }
}
    `;

/**
 * __useGetServicesListQuery__
 *
 * To run a query within a Vue component, call `useGetServicesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServicesListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetServicesListQuery({
 *   orderBy: // value for 'orderBy'
 * });
 */
export function useGetServicesListQuery(variables: GetServicesListQueryVariables | VueCompositionApi.Ref<GetServicesListQueryVariables> | ReactiveFunction<GetServicesListQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetServicesListQuery, GetServicesListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetServicesListQuery, GetServicesListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetServicesListQuery, GetServicesListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetServicesListQuery, GetServicesListQueryVariables>(GetServicesListDocument, variables, options);
}
export function useGetServicesListLazyQuery(variables: GetServicesListQueryVariables | VueCompositionApi.Ref<GetServicesListQueryVariables> | ReactiveFunction<GetServicesListQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetServicesListQuery, GetServicesListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetServicesListQuery, GetServicesListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetServicesListQuery, GetServicesListQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetServicesListQuery, GetServicesListQueryVariables>(GetServicesListDocument, variables, options);
}
export type GetServicesListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetServicesListQuery, GetServicesListQueryVariables>;
export const GetTimeSlotsDocument = gql`
    query GetTimeSlots($startDate: DateTime!, $endDate: DateTime!, $practiceId: Int!, $serviceIds: [Int!] = null, $practiceBranchId: Int = null, $therapistIds: [Int!] = null, $oneSlot: Boolean = false, $earliestSlotPerTherapist: Boolean = false, $sortAndLimit: Int = null, $showEmptyDates: Boolean = true, $searchEngine: Boolean = true, $customBreakBetweenMeetings: Int = null) {
  getTimeSlots(
    startDate: $startDate
    endDate: $endDate
    practiceId: $practiceId
    serviceIds: $serviceIds
    practiceBranchId: $practiceBranchId
    therapistIds: $therapistIds
    oneSlot: $oneSlot
    earliestSlotPerTherapist: $earliestSlotPerTherapist
    sortAndLimit: $sortAndLimit
    showEmptyDates: $showEmptyDates
    searchEngine: $searchEngine
    customBreakBetweenMeetings: $customBreakBetweenMeetings
  ) {
    id
    slots
    therapistId
    date
    serviceId
    serviceName
  }
}
    `;

/**
 * __useGetTimeSlotsQuery__
 *
 * To run a query within a Vue component, call `useGetTimeSlotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimeSlotsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTimeSlotsQuery({
 *   startDate: // value for 'startDate'
 *   endDate: // value for 'endDate'
 *   practiceId: // value for 'practiceId'
 *   serviceIds: // value for 'serviceIds'
 *   practiceBranchId: // value for 'practiceBranchId'
 *   therapistIds: // value for 'therapistIds'
 *   oneSlot: // value for 'oneSlot'
 *   earliestSlotPerTherapist: // value for 'earliestSlotPerTherapist'
 *   sortAndLimit: // value for 'sortAndLimit'
 *   showEmptyDates: // value for 'showEmptyDates'
 *   searchEngine: // value for 'searchEngine'
 *   customBreakBetweenMeetings: // value for 'customBreakBetweenMeetings'
 * });
 */
export function useGetTimeSlotsQuery(variables: GetTimeSlotsQueryVariables | VueCompositionApi.Ref<GetTimeSlotsQueryVariables> | ReactiveFunction<GetTimeSlotsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTimeSlotsQuery, GetTimeSlotsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTimeSlotsQuery, GetTimeSlotsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTimeSlotsQuery, GetTimeSlotsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTimeSlotsQuery, GetTimeSlotsQueryVariables>(GetTimeSlotsDocument, variables, options);
}
export function useGetTimeSlotsLazyQuery(variables: GetTimeSlotsQueryVariables | VueCompositionApi.Ref<GetTimeSlotsQueryVariables> | ReactiveFunction<GetTimeSlotsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTimeSlotsQuery, GetTimeSlotsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTimeSlotsQuery, GetTimeSlotsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTimeSlotsQuery, GetTimeSlotsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetTimeSlotsQuery, GetTimeSlotsQueryVariables>(GetTimeSlotsDocument, variables, options);
}
export type GetTimeSlotsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTimeSlotsQuery, GetTimeSlotsQueryVariables>;
export const PurchaseSmsPacketDocument = gql`
    mutation purchaseSmsPacket($payload: SmsPacketPurchaseInput!) {
  purchaseSmsPacket(payload: $payload) {
    link
  }
}
    `;

/**
 * __usePurchaseSmsPacketMutation__
 *
 * To run a mutation, you first call `usePurchaseSmsPacketMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseSmsPacketMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePurchaseSmsPacketMutation({
 *   variables: {
 *     payload: // value for 'payload'
 *   },
 * });
 */
export function usePurchaseSmsPacketMutation(options: VueApolloComposable.UseMutationOptions<PurchaseSmsPacketMutation, PurchaseSmsPacketMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<PurchaseSmsPacketMutation, PurchaseSmsPacketMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<PurchaseSmsPacketMutation, PurchaseSmsPacketMutationVariables>(PurchaseSmsPacketDocument, options);
}
export type PurchaseSmsPacketMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<PurchaseSmsPacketMutation, PurchaseSmsPacketMutationVariables>;
export const SendSmsDocument = gql`
    mutation SendSms($phoneNumber: PhoneNumber!, $templateType: SMSTemplateTypeEnum!, $practiceBranchId: Int) {
  sendDemoSms(
    demoSmsInput: {phoneNumber: $phoneNumber, templateType: $templateType, practiceBranchId: $practiceBranchId}
  ) {
    quota
    status
    text
    details
  }
}
    `;

/**
 * __useSendSmsMutation__
 *
 * To run a mutation, you first call `useSendSmsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSendSmsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSendSmsMutation({
 *   variables: {
 *     phoneNumber: // value for 'phoneNumber'
 *     templateType: // value for 'templateType'
 *     practiceBranchId: // value for 'practiceBranchId'
 *   },
 * });
 */
export function useSendSmsMutation(options: VueApolloComposable.UseMutationOptions<SendSmsMutation, SendSmsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SendSmsMutation, SendSmsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SendSmsMutation, SendSmsMutationVariables>(SendSmsDocument, options);
}
export type SendSmsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SendSmsMutation, SendSmsMutationVariables>;
export const UpdateSmsConfigDocument = gql`
    mutation UpdateSmsConfig($values: SMSConfigPartialInput!) {
  updateSmsConfig(smsConfigInput: $values) {
    active
    daysBefore
    hoursBefore
    newMeetingActive
    quota
    reminderPerBranchTemplate
    meetingCanceledActive
    sendingTime
    reminderSendingTime
    timeChangeActive
  }
}
    `;

/**
 * __useUpdateSmsConfigMutation__
 *
 * To run a mutation, you first call `useUpdateSmsConfigMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSmsConfigMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateSmsConfigMutation({
 *   variables: {
 *     values: // value for 'values'
 *   },
 * });
 */
export function useUpdateSmsConfigMutation(options: VueApolloComposable.UseMutationOptions<UpdateSmsConfigMutation, UpdateSmsConfigMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateSmsConfigMutation, UpdateSmsConfigMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateSmsConfigMutation, UpdateSmsConfigMutationVariables>(UpdateSmsConfigDocument, options);
}
export type UpdateSmsConfigMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateSmsConfigMutation, UpdateSmsConfigMutationVariables>;
export const UpdateSmsTemplateDocument = gql`
    mutation UpdateSmsTemplate($language: SMSTemplateLanguageEnum!, $templateType: SMSTemplateTypeEnum, $text: String!, $practiceBranchId: Int) {
  updateSmsTemplate(
    smsTemplateInput: {language: $language, text: $text, practiceBranchId: $practiceBranchId, templateType: $templateType}
  ) {
    ... on SMSTemplate {
      text
    }
  }
}
    `;

/**
 * __useUpdateSmsTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateSmsTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSmsTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateSmsTemplateMutation({
 *   variables: {
 *     language: // value for 'language'
 *     templateType: // value for 'templateType'
 *     text: // value for 'text'
 *     practiceBranchId: // value for 'practiceBranchId'
 *   },
 * });
 */
export function useUpdateSmsTemplateMutation(options: VueApolloComposable.UseMutationOptions<UpdateSmsTemplateMutation, UpdateSmsTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateSmsTemplateMutation, UpdateSmsTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateSmsTemplateMutation, UpdateSmsTemplateMutationVariables>(UpdateSmsTemplateDocument, options);
}
export type UpdateSmsTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateSmsTemplateMutation, UpdateSmsTemplateMutationVariables>;
export const GetSmsConfigDocument = gql`
    query GetSmsConfig {
  smsConfig {
    active
    hoursBefore
    daysBefore
    newMeetingActive
    quota
    perPeriodQuota
    customQuota
    reminderPerBranchTemplate
    reminderSendingTime
    sendingTime
    timeChangeActive
    meetingCanceledActive
    nonTherapistNotifyingTemplates
  }
}
    `;

/**
 * __useGetSmsConfigQuery__
 *
 * To run a query within a Vue component, call `useGetSmsConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSmsConfigQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSmsConfigQuery();
 */
export function useGetSmsConfigQuery(options: VueApolloComposable.UseQueryOptions<GetSmsConfigQuery, GetSmsConfigQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetSmsConfigQuery, GetSmsConfigQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetSmsConfigQuery, GetSmsConfigQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetSmsConfigQuery, GetSmsConfigQueryVariables>(GetSmsConfigDocument, {}, options);
}
export function useGetSmsConfigLazyQuery(options: VueApolloComposable.UseQueryOptions<GetSmsConfigQuery, GetSmsConfigQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetSmsConfigQuery, GetSmsConfigQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetSmsConfigQuery, GetSmsConfigQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetSmsConfigQuery, GetSmsConfigQueryVariables>(GetSmsConfigDocument, {}, options);
}
export type GetSmsConfigQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetSmsConfigQuery, GetSmsConfigQueryVariables>;
export const GetSmsHistoryDocument = gql`
    query GetSmsHistory($after: ISODateTime!, $before: ISODateTime!, $limit: Int!, $page: Int!, $orderBy: OrderBy, $searchPhrase: String = "") {
  paginatedSentSmss(
    after: $after
    before: $before
    limit: $limit
    page: $page
    orderBy: $orderBy
    searchPhrase: $searchPhrase
  ) {
    count
    data {
      id
      details
      phoneNumber
      sentAt
      status
      quota
      text
      patient {
        id
        fullName
      }
    }
  }
}
    `;

/**
 * __useGetSmsHistoryQuery__
 *
 * To run a query within a Vue component, call `useGetSmsHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSmsHistoryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSmsHistoryQuery({
 *   after: // value for 'after'
 *   before: // value for 'before'
 *   limit: // value for 'limit'
 *   page: // value for 'page'
 *   orderBy: // value for 'orderBy'
 *   searchPhrase: // value for 'searchPhrase'
 * });
 */
export function useGetSmsHistoryQuery(variables: GetSmsHistoryQueryVariables | VueCompositionApi.Ref<GetSmsHistoryQueryVariables> | ReactiveFunction<GetSmsHistoryQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetSmsHistoryQuery, GetSmsHistoryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetSmsHistoryQuery, GetSmsHistoryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetSmsHistoryQuery, GetSmsHistoryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetSmsHistoryQuery, GetSmsHistoryQueryVariables>(GetSmsHistoryDocument, variables, options);
}
export function useGetSmsHistoryLazyQuery(variables: GetSmsHistoryQueryVariables | VueCompositionApi.Ref<GetSmsHistoryQueryVariables> | ReactiveFunction<GetSmsHistoryQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetSmsHistoryQuery, GetSmsHistoryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetSmsHistoryQuery, GetSmsHistoryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetSmsHistoryQuery, GetSmsHistoryQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetSmsHistoryQuery, GetSmsHistoryQueryVariables>(GetSmsHistoryDocument, variables, options);
}
export type GetSmsHistoryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetSmsHistoryQuery, GetSmsHistoryQueryVariables>;
export const GetSmsPacketsDocument = gql`
    query GetSmsPackets {
  smsPackets {
    smsNumber
    tax
    price
  }
}
    `;

/**
 * __useGetSmsPacketsQuery__
 *
 * To run a query within a Vue component, call `useGetSmsPacketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSmsPacketsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSmsPacketsQuery();
 */
export function useGetSmsPacketsQuery(options: VueApolloComposable.UseQueryOptions<GetSmsPacketsQuery, GetSmsPacketsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetSmsPacketsQuery, GetSmsPacketsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetSmsPacketsQuery, GetSmsPacketsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetSmsPacketsQuery, GetSmsPacketsQueryVariables>(GetSmsPacketsDocument, {}, options);
}
export function useGetSmsPacketsLazyQuery(options: VueApolloComposable.UseQueryOptions<GetSmsPacketsQuery, GetSmsPacketsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetSmsPacketsQuery, GetSmsPacketsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetSmsPacketsQuery, GetSmsPacketsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetSmsPacketsQuery, GetSmsPacketsQueryVariables>(GetSmsPacketsDocument, {}, options);
}
export type GetSmsPacketsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetSmsPacketsQuery, GetSmsPacketsQueryVariables>;
export const GetSmsTemplatesDocument = gql`
    query GetSmsTemplates($templateType: SMSTemplateTypeEnum!, $language: SMSTemplateLanguageEnum) {
  smsTemplates(templateType: $templateType, language: $language) {
    branchesTemplates {
      practiceBranch {
        id
        name
        shortName
      }
      text
    }
    practiceTemplateText
  }
}
    `;

/**
 * __useGetSmsTemplatesQuery__
 *
 * To run a query within a Vue component, call `useGetSmsTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSmsTemplatesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSmsTemplatesQuery({
 *   templateType: // value for 'templateType'
 *   language: // value for 'language'
 * });
 */
export function useGetSmsTemplatesQuery(variables: GetSmsTemplatesQueryVariables | VueCompositionApi.Ref<GetSmsTemplatesQueryVariables> | ReactiveFunction<GetSmsTemplatesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetSmsTemplatesQuery, GetSmsTemplatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetSmsTemplatesQuery, GetSmsTemplatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetSmsTemplatesQuery, GetSmsTemplatesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetSmsTemplatesQuery, GetSmsTemplatesQueryVariables>(GetSmsTemplatesDocument, variables, options);
}
export function useGetSmsTemplatesLazyQuery(variables: GetSmsTemplatesQueryVariables | VueCompositionApi.Ref<GetSmsTemplatesQueryVariables> | ReactiveFunction<GetSmsTemplatesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetSmsTemplatesQuery, GetSmsTemplatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetSmsTemplatesQuery, GetSmsTemplatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetSmsTemplatesQuery, GetSmsTemplatesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetSmsTemplatesQuery, GetSmsTemplatesQueryVariables>(GetSmsTemplatesDocument, variables, options);
}
export type GetSmsTemplatesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetSmsTemplatesQuery, GetSmsTemplatesQueryVariables>;
export const DeleteUserAvatarDocument = gql`
    mutation DeleteUserAvatar {
  deleteUserAvatar
}
    `;

/**
 * __useDeleteUserAvatarMutation__
 *
 * To run a mutation, you first call `useDeleteUserAvatarMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserAvatarMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteUserAvatarMutation();
 */
export function useDeleteUserAvatarMutation(options: VueApolloComposable.UseMutationOptions<DeleteUserAvatarMutation, DeleteUserAvatarMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteUserAvatarMutation, DeleteUserAvatarMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteUserAvatarMutation, DeleteUserAvatarMutationVariables>(DeleteUserAvatarDocument, options);
}
export type DeleteUserAvatarMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteUserAvatarMutation, DeleteUserAvatarMutationVariables>;
export const EditUserSettingsDocument = gql`
    mutation EditUserSettings($payload: UserInput!) {
  editUserSettings(payload: $payload)
}
    `;

/**
 * __useEditUserSettingsMutation__
 *
 * To run a mutation, you first call `useEditUserSettingsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEditUserSettingsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEditUserSettingsMutation({
 *   variables: {
 *     payload: // value for 'payload'
 *   },
 * });
 */
export function useEditUserSettingsMutation(options: VueApolloComposable.UseMutationOptions<EditUserSettingsMutation, EditUserSettingsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EditUserSettingsMutation, EditUserSettingsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<EditUserSettingsMutation, EditUserSettingsMutationVariables>(EditUserSettingsDocument, options);
}
export type EditUserSettingsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EditUserSettingsMutation, EditUserSettingsMutationVariables>;
export const SetUserAvatarDocument = gql`
    mutation SetUserAvatar($payload: AvatarInput!) {
  setUserAvatar(payload: $payload)
}
    `;

/**
 * __useSetUserAvatarMutation__
 *
 * To run a mutation, you first call `useSetUserAvatarMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetUserAvatarMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetUserAvatarMutation({
 *   variables: {
 *     payload: // value for 'payload'
 *   },
 * });
 */
export function useSetUserAvatarMutation(options: VueApolloComposable.UseMutationOptions<SetUserAvatarMutation, SetUserAvatarMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SetUserAvatarMutation, SetUserAvatarMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SetUserAvatarMutation, SetUserAvatarMutationVariables>(SetUserAvatarDocument, options);
}
export type SetUserAvatarMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SetUserAvatarMutation, SetUserAvatarMutationVariables>;
export const GetUserAvatarDocument = gql`
    query GetUserAvatar {
  getUserAvatar {
    contentType
    url
  }
}
    `;

/**
 * __useGetUserAvatarQuery__
 *
 * To run a query within a Vue component, call `useGetUserAvatarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAvatarQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetUserAvatarQuery();
 */
export function useGetUserAvatarQuery(options: VueApolloComposable.UseQueryOptions<GetUserAvatarQuery, GetUserAvatarQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetUserAvatarQuery, GetUserAvatarQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetUserAvatarQuery, GetUserAvatarQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetUserAvatarQuery, GetUserAvatarQueryVariables>(GetUserAvatarDocument, {}, options);
}
export function useGetUserAvatarLazyQuery(options: VueApolloComposable.UseQueryOptions<GetUserAvatarQuery, GetUserAvatarQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetUserAvatarQuery, GetUserAvatarQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetUserAvatarQuery, GetUserAvatarQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetUserAvatarQuery, GetUserAvatarQueryVariables>(GetUserAvatarDocument, {}, options);
}
export type GetUserAvatarQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetUserAvatarQuery, GetUserAvatarQueryVariables>;
export const AddWorktimeExceptionDocument = gql`
    mutation AddWorktimeException($input: WorkTimeExceptionInput!) {
  addWorktimeException(exceptionInput: $input) {
    presetId
    startDate
    workTimes {
      startTime
      endTime
    }
    dates
  }
}
    `;

/**
 * __useAddWorktimeExceptionMutation__
 *
 * To run a mutation, you first call `useAddWorktimeExceptionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddWorktimeExceptionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddWorktimeExceptionMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAddWorktimeExceptionMutation(options: VueApolloComposable.UseMutationOptions<AddWorktimeExceptionMutation, AddWorktimeExceptionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddWorktimeExceptionMutation, AddWorktimeExceptionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddWorktimeExceptionMutation, AddWorktimeExceptionMutationVariables>(AddWorktimeExceptionDocument, options);
}
export type AddWorktimeExceptionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddWorktimeExceptionMutation, AddWorktimeExceptionMutationVariables>;
export const AddWorktimePresetDocument = gql`
    mutation addWorktimePreset($input: WorkTimePresetInput!) {
  addWorktimePreset(presetInput: $input)
}
    `;

/**
 * __useAddWorktimePresetMutation__
 *
 * To run a mutation, you first call `useAddWorktimePresetMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddWorktimePresetMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddWorktimePresetMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAddWorktimePresetMutation(options: VueApolloComposable.UseMutationOptions<AddWorktimePresetMutation, AddWorktimePresetMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddWorktimePresetMutation, AddWorktimePresetMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddWorktimePresetMutation, AddWorktimePresetMutationVariables>(AddWorktimePresetDocument, options);
}
export type AddWorktimePresetMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddWorktimePresetMutation, AddWorktimePresetMutationVariables>;
export const EditWorktimeConfigDocument = gql`
    mutation EditWorktimeConfig($input: WorkTimeConfigInput!) {
  editWorktimeConfig(config: $input) {
    holidayConsiderationRequired
    automaticEventCancellationTime
  }
}
    `;

/**
 * __useEditWorktimeConfigMutation__
 *
 * To run a mutation, you first call `useEditWorktimeConfigMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEditWorktimeConfigMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEditWorktimeConfigMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useEditWorktimeConfigMutation(options: VueApolloComposable.UseMutationOptions<EditWorktimeConfigMutation, EditWorktimeConfigMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EditWorktimeConfigMutation, EditWorktimeConfigMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<EditWorktimeConfigMutation, EditWorktimeConfigMutationVariables>(EditWorktimeConfigDocument, options);
}
export type EditWorktimeConfigMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EditWorktimeConfigMutation, EditWorktimeConfigMutationVariables>;
export const EditWorktimeExceptionDocument = gql`
    mutation EditWorktimeException($worktimeExceptionId: Int!, $input: EditWorkTimeExceptionInput!) {
  editWorktimeException(
    worktimeExceptionId: $worktimeExceptionId
    exceptionInput: $input
  ) {
    presetId
    startDate
    workTimes {
      startTime
      endTime
    }
    dates
  }
}
    `;

/**
 * __useEditWorktimeExceptionMutation__
 *
 * To run a mutation, you first call `useEditWorktimeExceptionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEditWorktimeExceptionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEditWorktimeExceptionMutation({
 *   variables: {
 *     worktimeExceptionId: // value for 'worktimeExceptionId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useEditWorktimeExceptionMutation(options: VueApolloComposable.UseMutationOptions<EditWorktimeExceptionMutation, EditWorktimeExceptionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EditWorktimeExceptionMutation, EditWorktimeExceptionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<EditWorktimeExceptionMutation, EditWorktimeExceptionMutationVariables>(EditWorktimeExceptionDocument, options);
}
export type EditWorktimeExceptionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EditWorktimeExceptionMutation, EditWorktimeExceptionMutationVariables>;
export const RemoveWorktimeExceptionDocument = gql`
    mutation RemoveWorktimeException($id: Int!) {
  removeWorktimeException(worktimeExceptionId: $id)
}
    `;

/**
 * __useRemoveWorktimeExceptionMutation__
 *
 * To run a mutation, you first call `useRemoveWorktimeExceptionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveWorktimeExceptionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveWorktimeExceptionMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useRemoveWorktimeExceptionMutation(options: VueApolloComposable.UseMutationOptions<RemoveWorktimeExceptionMutation, RemoveWorktimeExceptionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RemoveWorktimeExceptionMutation, RemoveWorktimeExceptionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RemoveWorktimeExceptionMutation, RemoveWorktimeExceptionMutationVariables>(RemoveWorktimeExceptionDocument, options);
}
export type RemoveWorktimeExceptionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RemoveWorktimeExceptionMutation, RemoveWorktimeExceptionMutationVariables>;
export const RemoveWorktimePresetDocument = gql`
    mutation RemoveWorktimePreset($id: Int!) {
  removeWorktimePreset(presetId: $id)
}
    `;

/**
 * __useRemoveWorktimePresetMutation__
 *
 * To run a mutation, you first call `useRemoveWorktimePresetMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveWorktimePresetMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveWorktimePresetMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useRemoveWorktimePresetMutation(options: VueApolloComposable.UseMutationOptions<RemoveWorktimePresetMutation, RemoveWorktimePresetMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RemoveWorktimePresetMutation, RemoveWorktimePresetMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RemoveWorktimePresetMutation, RemoveWorktimePresetMutationVariables>(RemoveWorktimePresetDocument, options);
}
export type RemoveWorktimePresetMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RemoveWorktimePresetMutation, RemoveWorktimePresetMutationVariables>;
export const WorkTimePresetDocument = gql`
    query WorkTimePreset($id: Int!) {
  workTimePreset(presetId: $id) {
    ...WorkTimePresetFields
  }
}
    ${WorkTimePresetFieldsFragmentDoc}`;

/**
 * __useWorkTimePresetQuery__
 *
 * To run a query within a Vue component, call `useWorkTimePresetQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkTimePresetQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useWorkTimePresetQuery({
 *   id: // value for 'id'
 * });
 */
export function useWorkTimePresetQuery(variables: WorkTimePresetQueryVariables | VueCompositionApi.Ref<WorkTimePresetQueryVariables> | ReactiveFunction<WorkTimePresetQueryVariables>, options: VueApolloComposable.UseQueryOptions<WorkTimePresetQuery, WorkTimePresetQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<WorkTimePresetQuery, WorkTimePresetQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<WorkTimePresetQuery, WorkTimePresetQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<WorkTimePresetQuery, WorkTimePresetQueryVariables>(WorkTimePresetDocument, variables, options);
}
export function useWorkTimePresetLazyQuery(variables: WorkTimePresetQueryVariables | VueCompositionApi.Ref<WorkTimePresetQueryVariables> | ReactiveFunction<WorkTimePresetQueryVariables>, options: VueApolloComposable.UseQueryOptions<WorkTimePresetQuery, WorkTimePresetQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<WorkTimePresetQuery, WorkTimePresetQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<WorkTimePresetQuery, WorkTimePresetQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<WorkTimePresetQuery, WorkTimePresetQueryVariables>(WorkTimePresetDocument, variables, options);
}
export type WorkTimePresetQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<WorkTimePresetQuery, WorkTimePresetQueryVariables>;
export const WorkTimePresetsDocument = gql`
    query WorkTimePresets($employeeIds: [Int!]!, $name: String) {
  workTimePresets(employeeIds: $employeeIds, name: $name) {
    ...WorkTimePresetFields
  }
}
    ${WorkTimePresetFieldsFragmentDoc}`;

/**
 * __useWorkTimePresetsQuery__
 *
 * To run a query within a Vue component, call `useWorkTimePresetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkTimePresetsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useWorkTimePresetsQuery({
 *   employeeIds: // value for 'employeeIds'
 *   name: // value for 'name'
 * });
 */
export function useWorkTimePresetsQuery(variables: WorkTimePresetsQueryVariables | VueCompositionApi.Ref<WorkTimePresetsQueryVariables> | ReactiveFunction<WorkTimePresetsQueryVariables>, options: VueApolloComposable.UseQueryOptions<WorkTimePresetsQuery, WorkTimePresetsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<WorkTimePresetsQuery, WorkTimePresetsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<WorkTimePresetsQuery, WorkTimePresetsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<WorkTimePresetsQuery, WorkTimePresetsQueryVariables>(WorkTimePresetsDocument, variables, options);
}
export function useWorkTimePresetsLazyQuery(variables: WorkTimePresetsQueryVariables | VueCompositionApi.Ref<WorkTimePresetsQueryVariables> | ReactiveFunction<WorkTimePresetsQueryVariables>, options: VueApolloComposable.UseQueryOptions<WorkTimePresetsQuery, WorkTimePresetsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<WorkTimePresetsQuery, WorkTimePresetsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<WorkTimePresetsQuery, WorkTimePresetsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<WorkTimePresetsQuery, WorkTimePresetsQueryVariables>(WorkTimePresetsDocument, variables, options);
}
export type WorkTimePresetsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<WorkTimePresetsQuery, WorkTimePresetsQueryVariables>;